import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: any; output: any; }
  /** A field whose value is a hex color code: https://en.wikipedia.org/wiki/Web_colors. */
  HexColorCode: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** Either an Int, Float, String, or Boolean */
  NumberStringBoolean: { input: any; output: any; }
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: { input: any; output: any; }
};

export type AffectedRowsOutput = {
  __typename?: 'AffectedRowsOutput';
  count: Scalars['Int']['output'];
};

export type Aggregate = {
  from: Scalars['String']['input'];
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  primaryColumnUUID: Scalars['String']['input'];
  select?: InputMaybe<Array<AggregateSelect>>;
  where?: InputMaybe<Array<AggregateWhere>>;
};

export type AggregateAnalyticsDashboard = {
  __typename?: 'AggregateAnalyticsDashboard';
  _avg?: Maybe<AnalyticsDashboardAvgAggregate>;
  _count?: Maybe<AnalyticsDashboardCountAggregate>;
  _max?: Maybe<AnalyticsDashboardMaxAggregate>;
  _min?: Maybe<AnalyticsDashboardMinAggregate>;
  _sum?: Maybe<AnalyticsDashboardSumAggregate>;
};

export type AggregateAnalyticsDashboardChart = {
  __typename?: 'AggregateAnalyticsDashboardChart';
  _avg?: Maybe<AnalyticsDashboardChartAvgAggregate>;
  _count?: Maybe<AnalyticsDashboardChartCountAggregate>;
  _max?: Maybe<AnalyticsDashboardChartMaxAggregate>;
  _min?: Maybe<AnalyticsDashboardChartMinAggregate>;
  _sum?: Maybe<AnalyticsDashboardChartSumAggregate>;
};

export type AggregateAnalyticsDashboardFiltersSource = {
  __typename?: 'AggregateAnalyticsDashboardFiltersSource';
  _avg?: Maybe<AnalyticsDashboardFiltersSourceAvgAggregate>;
  _count?: Maybe<AnalyticsDashboardFiltersSourceCountAggregate>;
  _max?: Maybe<AnalyticsDashboardFiltersSourceMaxAggregate>;
  _min?: Maybe<AnalyticsDashboardFiltersSourceMinAggregate>;
  _sum?: Maybe<AnalyticsDashboardFiltersSourceSumAggregate>;
};

export type AggregateDataSource = {
  __typename?: 'AggregateDataSource';
  _avg?: Maybe<DataSourceAvgAggregate>;
  _count?: Maybe<DataSourceCountAggregate>;
  _max?: Maybe<DataSourceMaxAggregate>;
  _min?: Maybe<DataSourceMinAggregate>;
  _sum?: Maybe<DataSourceSumAggregate>;
};

export type AggregateDataSourceCell = {
  __typename?: 'AggregateDataSourceCell';
  _avg?: Maybe<DataSourceCellAvgAggregate>;
  _count?: Maybe<DataSourceCellCountAggregate>;
  _max?: Maybe<DataSourceCellMaxAggregate>;
  _min?: Maybe<DataSourceCellMinAggregate>;
  _sum?: Maybe<DataSourceCellSumAggregate>;
};

export type AggregateDataSourceVersion = {
  __typename?: 'AggregateDataSourceVersion';
  _avg?: Maybe<DataSourceVersionAvgAggregate>;
  _count?: Maybe<DataSourceVersionCountAggregate>;
  _max?: Maybe<DataSourceVersionMaxAggregate>;
  _min?: Maybe<DataSourceVersionMinAggregate>;
  _sum?: Maybe<DataSourceVersionSumAggregate>;
};

export type AggregateDataSourceVersionOrigin = {
  __typename?: 'AggregateDataSourceVersionOrigin';
  _avg?: Maybe<DataSourceVersionOriginAvgAggregate>;
  _count?: Maybe<DataSourceVersionOriginCountAggregate>;
  _max?: Maybe<DataSourceVersionOriginMaxAggregate>;
  _min?: Maybe<DataSourceVersionOriginMinAggregate>;
  _sum?: Maybe<DataSourceVersionOriginSumAggregate>;
};

export type AggregateLookup = {
  __typename?: 'AggregateLookup';
  _avg?: Maybe<LookupAvgAggregate>;
  _count?: Maybe<LookupCountAggregate>;
  _max?: Maybe<LookupMaxAggregate>;
  _min?: Maybe<LookupMinAggregate>;
  _sum?: Maybe<LookupSumAggregate>;
};

export type AggregateNote = {
  __typename?: 'AggregateNote';
  _avg?: Maybe<NoteAvgAggregate>;
  _count?: Maybe<NoteCountAggregate>;
  _max?: Maybe<NoteMaxAggregate>;
  _min?: Maybe<NoteMinAggregate>;
  _sum?: Maybe<NoteSumAggregate>;
};

export type AggregateProposalTemplate = {
  __typename?: 'AggregateProposalTemplate';
  _avg?: Maybe<ProposalTemplateAvgAggregate>;
  _count?: Maybe<ProposalTemplateCountAggregate>;
  _max?: Maybe<ProposalTemplateMaxAggregate>;
  _min?: Maybe<ProposalTemplateMinAggregate>;
  _sum?: Maybe<ProposalTemplateSumAggregate>;
};

export type AggregateSelect = {
  aggregate?: InputMaybe<Scalars['String']['input']>;
  as?: InputMaybe<Scalars['String']['input']>;
  columnUUID?: InputMaybe<Scalars['String']['input']>;
  compareWith?: InputMaybe<Scalars['String']['input']>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  fieldUUID?: InputMaybe<Scalars['String']['input']>;
  proposal?: InputMaybe<AggregateSelectProposal>;
  thresholds?: InputMaybe<Array<Scalars['Float']['input']>>;
  transform?: InputMaybe<AggregateTransform>;
  valueType?: InputMaybe<AggregateSelectValueType>;
};

export enum AggregateSelectProposal {
  CreatedAt = 'created_at',
  Id = 'id',
  InteractionDuration = 'interaction_duration',
  UpdatedAt = 'updated_at',
  VersionId = 'version_id'
}

export enum AggregateSelectValueType {
  Boolean = 'boolean',
  Numeric = 'numeric',
  Range = 'range',
  String = 'string'
}

export enum AggregateTransform {
  Date = 'date'
}

export type AggregateUserProposalAccess = {
  __typename?: 'AggregateUserProposalAccess';
  _avg?: Maybe<UserProposalAccessAvgAggregate>;
  _count?: Maybe<UserProposalAccessCountAggregate>;
  _max?: Maybe<UserProposalAccessMaxAggregate>;
  _min?: Maybe<UserProposalAccessMinAggregate>;
  _sum?: Maybe<UserProposalAccessSumAggregate>;
};

export type AggregateWhere = {
  columnUUID?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['NumberStringBoolean']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
};

export type AggregationBucket = {
  __typename?: 'AggregationBucket';
  doc_count: Scalars['Int']['output'];
  key: Scalars['Float']['output'];
};

export type AnalyticsDashboard = {
  __typename?: 'AnalyticsDashboard';
  _count?: Maybe<AnalyticsDashboardCount>;
  charts: Array<AnalyticsDashboardChart>;
  content: Scalars['String']['output'];
  filtersSources: Array<AnalyticsDashboardFiltersSource>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  restricted: Scalars['Boolean']['output'];
};


export type AnalyticsDashboardChartsArgs = {
  cursor?: InputMaybe<AnalyticsDashboardChartWhereUniqueInput>;
  distinct?: InputMaybe<Array<AnalyticsDashboardChartScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AnalyticsDashboardChartOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnalyticsDashboardChartWhereInput>;
};


export type AnalyticsDashboardFiltersSourcesArgs = {
  cursor?: InputMaybe<AnalyticsDashboardFiltersSourceWhereUniqueInput>;
  distinct?: InputMaybe<Array<AnalyticsDashboardFiltersSourceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AnalyticsDashboardFiltersSourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnalyticsDashboardFiltersSourceWhereInput>;
};

export type AnalyticsDashboardAvgAggregate = {
  __typename?: 'AnalyticsDashboardAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type AnalyticsDashboardAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type AnalyticsDashboardChart = {
  __typename?: 'AnalyticsDashboardChart';
  dashboardDefinition: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pageId: Scalars['String']['output'];
  showTable: Scalars['Boolean']['output'];
  sqlQuery: Scalars['String']['output'];
  tableColumns: Scalars['JSON']['output'];
  templateId: Scalars['Int']['output'];
};

export type AnalyticsDashboardChartAvgAggregate = {
  __typename?: 'AnalyticsDashboardChartAvgAggregate';
  dashboardId?: Maybe<Scalars['Float']['output']>;
  templateId?: Maybe<Scalars['Float']['output']>;
};

export type AnalyticsDashboardChartAvgOrderByAggregateInput = {
  templateId?: InputMaybe<SortOrder>;
};

export type AnalyticsDashboardChartCountAggregate = {
  __typename?: 'AnalyticsDashboardChartCountAggregate';
  _all: Scalars['Int']['output'];
  dashboardDefinition: Scalars['Int']['output'];
  dashboardId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  pageId: Scalars['Int']['output'];
  showTable: Scalars['Int']['output'];
  sqlQuery: Scalars['Int']['output'];
  tableColumns: Scalars['Int']['output'];
  templateId: Scalars['Int']['output'];
};

export type AnalyticsDashboardChartCountOrderByAggregateInput = {
  dashboardDefinition?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pageId?: InputMaybe<SortOrder>;
  showTable?: InputMaybe<SortOrder>;
  sqlQuery?: InputMaybe<SortOrder>;
  tableColumns?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
};

export type AnalyticsDashboardChartCreateInput = {
  dashboardDefinition?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  showTable?: InputMaybe<Scalars['Boolean']['input']>;
  sqlQuery?: InputMaybe<Scalars['String']['input']>;
  tableColumns: Scalars['JSON']['input'];
  templateId: Scalars['Int']['input'];
};

export type AnalyticsDashboardChartCreateManyDashboardInput = {
  dashboardDefinition?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  showTable?: InputMaybe<Scalars['Boolean']['input']>;
  sqlQuery?: InputMaybe<Scalars['String']['input']>;
  tableColumns: Scalars['JSON']['input'];
  templateId: Scalars['Int']['input'];
};

export type AnalyticsDashboardChartCreateManyDashboardInputEnvelope = {
  data: Array<AnalyticsDashboardChartCreateManyDashboardInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnalyticsDashboardChartCreateManyInput = {
  dashboardDefinition?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  showTable?: InputMaybe<Scalars['Boolean']['input']>;
  sqlQuery?: InputMaybe<Scalars['String']['input']>;
  tableColumns: Scalars['JSON']['input'];
  templateId: Scalars['Int']['input'];
};

export type AnalyticsDashboardChartCreateNestedManyWithoutDashboardInput = {
  connect?: InputMaybe<Array<AnalyticsDashboardChartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalyticsDashboardChartCreateOrConnectWithoutDashboardInput>>;
  create?: InputMaybe<Array<AnalyticsDashboardChartCreateWithoutDashboardInput>>;
  createMany?: InputMaybe<AnalyticsDashboardChartCreateManyDashboardInputEnvelope>;
};

export type AnalyticsDashboardChartCreateOrConnectWithoutDashboardInput = {
  create: AnalyticsDashboardChartCreateWithoutDashboardInput;
  where: AnalyticsDashboardChartWhereUniqueInput;
};

export type AnalyticsDashboardChartCreateWithoutDashboardInput = {
  dashboardDefinition?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  showTable?: InputMaybe<Scalars['Boolean']['input']>;
  sqlQuery?: InputMaybe<Scalars['String']['input']>;
  tableColumns: Scalars['JSON']['input'];
  templateId: Scalars['Int']['input'];
};

export type AnalyticsDashboardChartGroupBy = {
  __typename?: 'AnalyticsDashboardChartGroupBy';
  _avg?: Maybe<AnalyticsDashboardChartAvgAggregate>;
  _count?: Maybe<AnalyticsDashboardChartCountAggregate>;
  _max?: Maybe<AnalyticsDashboardChartMaxAggregate>;
  _min?: Maybe<AnalyticsDashboardChartMinAggregate>;
  _sum?: Maybe<AnalyticsDashboardChartSumAggregate>;
  dashboardDefinition: Scalars['String']['output'];
  dashboardId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pageId: Scalars['String']['output'];
  showTable: Scalars['Boolean']['output'];
  sqlQuery: Scalars['String']['output'];
  tableColumns: Scalars['JSON']['output'];
  templateId: Scalars['Int']['output'];
};

export type AnalyticsDashboardChartListRelationFilter = {
  every?: InputMaybe<AnalyticsDashboardChartWhereInput>;
  none?: InputMaybe<AnalyticsDashboardChartWhereInput>;
  some?: InputMaybe<AnalyticsDashboardChartWhereInput>;
};

export type AnalyticsDashboardChartMaxAggregate = {
  __typename?: 'AnalyticsDashboardChartMaxAggregate';
  dashboardDefinition?: Maybe<Scalars['String']['output']>;
  dashboardId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pageId?: Maybe<Scalars['String']['output']>;
  showTable?: Maybe<Scalars['Boolean']['output']>;
  sqlQuery?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsDashboardChartMaxOrderByAggregateInput = {
  dashboardDefinition?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pageId?: InputMaybe<SortOrder>;
  showTable?: InputMaybe<SortOrder>;
  sqlQuery?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
};

export type AnalyticsDashboardChartMinAggregate = {
  __typename?: 'AnalyticsDashboardChartMinAggregate';
  dashboardDefinition?: Maybe<Scalars['String']['output']>;
  dashboardId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pageId?: Maybe<Scalars['String']['output']>;
  showTable?: Maybe<Scalars['Boolean']['output']>;
  sqlQuery?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsDashboardChartMinOrderByAggregateInput = {
  dashboardDefinition?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pageId?: InputMaybe<SortOrder>;
  showTable?: InputMaybe<SortOrder>;
  sqlQuery?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
};

export type AnalyticsDashboardChartOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum AnalyticsDashboardChartOrderByRelevanceFieldEnum {
  DashboardDefinition = 'dashboardDefinition',
  Id = 'id',
  Name = 'name',
  PageId = 'pageId',
  SqlQuery = 'sqlQuery'
}

export type AnalyticsDashboardChartOrderByRelevanceInput = {
  fields: Array<AnalyticsDashboardChartOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type AnalyticsDashboardChartOrderByWithAggregationInput = {
  _avg?: InputMaybe<AnalyticsDashboardChartAvgOrderByAggregateInput>;
  _count?: InputMaybe<AnalyticsDashboardChartCountOrderByAggregateInput>;
  _max?: InputMaybe<AnalyticsDashboardChartMaxOrderByAggregateInput>;
  _min?: InputMaybe<AnalyticsDashboardChartMinOrderByAggregateInput>;
  _sum?: InputMaybe<AnalyticsDashboardChartSumOrderByAggregateInput>;
  dashboardDefinition?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pageId?: InputMaybe<SortOrder>;
  showTable?: InputMaybe<SortOrder>;
  sqlQuery?: InputMaybe<SortOrder>;
  tableColumns?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
};

export type AnalyticsDashboardChartOrderByWithRelationInput = {
  _relevance?: InputMaybe<AnalyticsDashboardChartOrderByRelevanceInput>;
  dashboardDefinition?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pageId?: InputMaybe<SortOrder>;
  showTable?: InputMaybe<SortOrder>;
  sqlQuery?: InputMaybe<SortOrder>;
  tableColumns?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
};

export enum AnalyticsDashboardChartScalarFieldEnum {
  DashboardDefinition = 'dashboardDefinition',
  DashboardId = 'dashboardId',
  Id = 'id',
  Name = 'name',
  PageId = 'pageId',
  ShowTable = 'showTable',
  SqlQuery = 'sqlQuery',
  TableColumns = 'tableColumns',
  TemplateId = 'templateId'
}

export type AnalyticsDashboardChartScalarWhereInput = {
  AND?: InputMaybe<Array<AnalyticsDashboardChartScalarWhereInput>>;
  NOT?: InputMaybe<Array<AnalyticsDashboardChartScalarWhereInput>>;
  OR?: InputMaybe<Array<AnalyticsDashboardChartScalarWhereInput>>;
  dashboardDefinition?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  pageId?: InputMaybe<StringFilter>;
  showTable?: InputMaybe<BoolFilter>;
  sqlQuery?: InputMaybe<StringFilter>;
  tableColumns?: InputMaybe<JsonFilter>;
  templateId?: InputMaybe<IntFilter>;
};

export type AnalyticsDashboardChartScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<AnalyticsDashboardChartScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<AnalyticsDashboardChartScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<AnalyticsDashboardChartScalarWhereWithAggregatesInput>>;
  dashboardDefinition?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  pageId?: InputMaybe<StringWithAggregatesFilter>;
  showTable?: InputMaybe<BoolWithAggregatesFilter>;
  sqlQuery?: InputMaybe<StringWithAggregatesFilter>;
  tableColumns?: InputMaybe<JsonWithAggregatesFilter>;
  templateId?: InputMaybe<IntWithAggregatesFilter>;
};

export type AnalyticsDashboardChartSumAggregate = {
  __typename?: 'AnalyticsDashboardChartSumAggregate';
  dashboardId?: Maybe<Scalars['Int']['output']>;
  templateId?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsDashboardChartSumOrderByAggregateInput = {
  templateId?: InputMaybe<SortOrder>;
};

export type AnalyticsDashboardChartUpdateInput = {
  dashboardDefinition?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pageId?: InputMaybe<StringFieldUpdateOperationsInput>;
  showTable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sqlQuery?: InputMaybe<StringFieldUpdateOperationsInput>;
  tableColumns?: InputMaybe<Scalars['JSON']['input']>;
  templateId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type AnalyticsDashboardChartUpdateManyMutationInput = {
  dashboardDefinition?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pageId?: InputMaybe<StringFieldUpdateOperationsInput>;
  showTable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sqlQuery?: InputMaybe<StringFieldUpdateOperationsInput>;
  tableColumns?: InputMaybe<Scalars['JSON']['input']>;
  templateId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type AnalyticsDashboardChartUpdateManyWithWhereWithoutDashboardInput = {
  data: AnalyticsDashboardChartUpdateManyMutationInput;
  where: AnalyticsDashboardChartScalarWhereInput;
};

export type AnalyticsDashboardChartUpdateManyWithoutDashboardNestedInput = {
  connect?: InputMaybe<Array<AnalyticsDashboardChartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalyticsDashboardChartCreateOrConnectWithoutDashboardInput>>;
  create?: InputMaybe<Array<AnalyticsDashboardChartCreateWithoutDashboardInput>>;
  createMany?: InputMaybe<AnalyticsDashboardChartCreateManyDashboardInputEnvelope>;
  delete?: InputMaybe<Array<AnalyticsDashboardChartWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnalyticsDashboardChartScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnalyticsDashboardChartWhereUniqueInput>>;
  set?: InputMaybe<Array<AnalyticsDashboardChartWhereUniqueInput>>;
  update?: InputMaybe<Array<AnalyticsDashboardChartUpdateWithWhereUniqueWithoutDashboardInput>>;
  updateMany?: InputMaybe<Array<AnalyticsDashboardChartUpdateManyWithWhereWithoutDashboardInput>>;
  upsert?: InputMaybe<Array<AnalyticsDashboardChartUpsertWithWhereUniqueWithoutDashboardInput>>;
};

export type AnalyticsDashboardChartUpdateWithWhereUniqueWithoutDashboardInput = {
  data: AnalyticsDashboardChartUpdateWithoutDashboardInput;
  where: AnalyticsDashboardChartWhereUniqueInput;
};

export type AnalyticsDashboardChartUpdateWithoutDashboardInput = {
  dashboardDefinition?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pageId?: InputMaybe<StringFieldUpdateOperationsInput>;
  showTable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sqlQuery?: InputMaybe<StringFieldUpdateOperationsInput>;
  tableColumns?: InputMaybe<Scalars['JSON']['input']>;
  templateId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type AnalyticsDashboardChartUpsertWithWhereUniqueWithoutDashboardInput = {
  create: AnalyticsDashboardChartCreateWithoutDashboardInput;
  update: AnalyticsDashboardChartUpdateWithoutDashboardInput;
  where: AnalyticsDashboardChartWhereUniqueInput;
};

export type AnalyticsDashboardChartWhereInput = {
  AND?: InputMaybe<Array<AnalyticsDashboardChartWhereInput>>;
  NOT?: InputMaybe<Array<AnalyticsDashboardChartWhereInput>>;
  OR?: InputMaybe<Array<AnalyticsDashboardChartWhereInput>>;
  dashboardDefinition?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  pageId?: InputMaybe<StringFilter>;
  showTable?: InputMaybe<BoolFilter>;
  sqlQuery?: InputMaybe<StringFilter>;
  tableColumns?: InputMaybe<JsonFilter>;
  templateId?: InputMaybe<IntFilter>;
};

export type AnalyticsDashboardChartWhereUniqueInput = {
  AND?: InputMaybe<Array<AnalyticsDashboardChartWhereInput>>;
  NOT?: InputMaybe<Array<AnalyticsDashboardChartWhereInput>>;
  OR?: InputMaybe<Array<AnalyticsDashboardChartWhereInput>>;
  dashboardDefinition?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
  pageId?: InputMaybe<StringFilter>;
  showTable?: InputMaybe<BoolFilter>;
  sqlQuery?: InputMaybe<StringFilter>;
  tableColumns?: InputMaybe<JsonFilter>;
  templateId?: InputMaybe<IntFilter>;
};

export type AnalyticsDashboardCount = {
  __typename?: 'AnalyticsDashboardCount';
  charts: Scalars['Int']['output'];
  filtersSources: Scalars['Int']['output'];
};


export type AnalyticsDashboardCountChartsArgs = {
  where?: InputMaybe<AnalyticsDashboardChartWhereInput>;
};


export type AnalyticsDashboardCountFiltersSourcesArgs = {
  where?: InputMaybe<AnalyticsDashboardFiltersSourceWhereInput>;
};

export type AnalyticsDashboardCountAggregate = {
  __typename?: 'AnalyticsDashboardCountAggregate';
  _all: Scalars['Int']['output'];
  content: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  restricted: Scalars['Int']['output'];
};

export type AnalyticsDashboardCountOrderByAggregateInput = {
  content?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  restricted?: InputMaybe<SortOrder>;
};

export type AnalyticsDashboardCreateInput = {
  charts?: InputMaybe<AnalyticsDashboardChartCreateNestedManyWithoutDashboardInput>;
  content: Scalars['String']['input'];
  filtersSources?: InputMaybe<AnalyticsDashboardFiltersSourceCreateNestedManyWithoutDashboardInput>;
  name: Scalars['String']['input'];
  restricted: Scalars['Boolean']['input'];
};

export type AnalyticsDashboardCreateManyInput = {
  content: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  restricted: Scalars['Boolean']['input'];
};

export type AnalyticsDashboardFiltersSource = {
  __typename?: 'AnalyticsDashboardFiltersSource';
  addEmptyOption: Scalars['Boolean']['output'];
  analyticsPage?: Maybe<ProposalAnalyticsPage>;
  fieldId?: Maybe<Scalars['String']['output']>;
  filterKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  pageId?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['Int']['output']>;
  type: FiltersSourceType;
};

export type AnalyticsDashboardFiltersSourceAvgAggregate = {
  __typename?: 'AnalyticsDashboardFiltersSourceAvgAggregate';
  dashboardId?: Maybe<Scalars['Float']['output']>;
  templateId?: Maybe<Scalars['Float']['output']>;
};

export type AnalyticsDashboardFiltersSourceAvgOrderByAggregateInput = {
  templateId?: InputMaybe<SortOrder>;
};

export type AnalyticsDashboardFiltersSourceCountAggregate = {
  __typename?: 'AnalyticsDashboardFiltersSourceCountAggregate';
  _all: Scalars['Int']['output'];
  addEmptyOption: Scalars['Int']['output'];
  dashboardId: Scalars['Int']['output'];
  fieldId: Scalars['Int']['output'];
  filterKey: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  pageId: Scalars['Int']['output'];
  templateId: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
};

export type AnalyticsDashboardFiltersSourceCountOrderByAggregateInput = {
  addEmptyOption?: InputMaybe<SortOrder>;
  fieldId?: InputMaybe<SortOrder>;
  filterKey?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pageId?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type AnalyticsDashboardFiltersSourceCreateInput = {
  addEmptyOption?: InputMaybe<Scalars['Boolean']['input']>;
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterKey: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  pageId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['Int']['input']>;
  type: FiltersSourceType;
};

export type AnalyticsDashboardFiltersSourceCreateManyDashboardInput = {
  addEmptyOption?: InputMaybe<Scalars['Boolean']['input']>;
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterKey: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  pageId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['Int']['input']>;
  type: FiltersSourceType;
};

export type AnalyticsDashboardFiltersSourceCreateManyDashboardInputEnvelope = {
  data: Array<AnalyticsDashboardFiltersSourceCreateManyDashboardInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnalyticsDashboardFiltersSourceCreateManyInput = {
  addEmptyOption?: InputMaybe<Scalars['Boolean']['input']>;
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterKey: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  pageId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['Int']['input']>;
  type: FiltersSourceType;
};

export type AnalyticsDashboardFiltersSourceCreateNestedManyWithoutDashboardInput = {
  connect?: InputMaybe<Array<AnalyticsDashboardFiltersSourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalyticsDashboardFiltersSourceCreateOrConnectWithoutDashboardInput>>;
  create?: InputMaybe<Array<AnalyticsDashboardFiltersSourceCreateWithoutDashboardInput>>;
  createMany?: InputMaybe<AnalyticsDashboardFiltersSourceCreateManyDashboardInputEnvelope>;
};

export type AnalyticsDashboardFiltersSourceCreateOrConnectWithoutDashboardInput = {
  create: AnalyticsDashboardFiltersSourceCreateWithoutDashboardInput;
  where: AnalyticsDashboardFiltersSourceWhereUniqueInput;
};

export type AnalyticsDashboardFiltersSourceCreateWithoutDashboardInput = {
  addEmptyOption?: InputMaybe<Scalars['Boolean']['input']>;
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterKey: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  pageId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['Int']['input']>;
  type: FiltersSourceType;
};

export type AnalyticsDashboardFiltersSourceGroupBy = {
  __typename?: 'AnalyticsDashboardFiltersSourceGroupBy';
  _avg?: Maybe<AnalyticsDashboardFiltersSourceAvgAggregate>;
  _count?: Maybe<AnalyticsDashboardFiltersSourceCountAggregate>;
  _max?: Maybe<AnalyticsDashboardFiltersSourceMaxAggregate>;
  _min?: Maybe<AnalyticsDashboardFiltersSourceMinAggregate>;
  _sum?: Maybe<AnalyticsDashboardFiltersSourceSumAggregate>;
  addEmptyOption: Scalars['Boolean']['output'];
  dashboardId: Scalars['Int']['output'];
  fieldId?: Maybe<Scalars['String']['output']>;
  filterKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  pageId?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['Int']['output']>;
  type: FiltersSourceType;
};

export type AnalyticsDashboardFiltersSourceListRelationFilter = {
  every?: InputMaybe<AnalyticsDashboardFiltersSourceWhereInput>;
  none?: InputMaybe<AnalyticsDashboardFiltersSourceWhereInput>;
  some?: InputMaybe<AnalyticsDashboardFiltersSourceWhereInput>;
};

export type AnalyticsDashboardFiltersSourceMaxAggregate = {
  __typename?: 'AnalyticsDashboardFiltersSourceMaxAggregate';
  addEmptyOption?: Maybe<Scalars['Boolean']['output']>;
  dashboardId?: Maybe<Scalars['Int']['output']>;
  fieldId?: Maybe<Scalars['String']['output']>;
  filterKey?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  pageId?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<FiltersSourceType>;
};

export type AnalyticsDashboardFiltersSourceMaxOrderByAggregateInput = {
  addEmptyOption?: InputMaybe<SortOrder>;
  fieldId?: InputMaybe<SortOrder>;
  filterKey?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pageId?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type AnalyticsDashboardFiltersSourceMinAggregate = {
  __typename?: 'AnalyticsDashboardFiltersSourceMinAggregate';
  addEmptyOption?: Maybe<Scalars['Boolean']['output']>;
  dashboardId?: Maybe<Scalars['Int']['output']>;
  fieldId?: Maybe<Scalars['String']['output']>;
  filterKey?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  pageId?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<FiltersSourceType>;
};

export type AnalyticsDashboardFiltersSourceMinOrderByAggregateInput = {
  addEmptyOption?: InputMaybe<SortOrder>;
  fieldId?: InputMaybe<SortOrder>;
  filterKey?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pageId?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type AnalyticsDashboardFiltersSourceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum AnalyticsDashboardFiltersSourceOrderByRelevanceFieldEnum {
  FieldId = 'fieldId',
  FilterKey = 'filterKey',
  Id = 'id',
  PageId = 'pageId'
}

export type AnalyticsDashboardFiltersSourceOrderByRelevanceInput = {
  fields: Array<AnalyticsDashboardFiltersSourceOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type AnalyticsDashboardFiltersSourceOrderByWithAggregationInput = {
  _avg?: InputMaybe<AnalyticsDashboardFiltersSourceAvgOrderByAggregateInput>;
  _count?: InputMaybe<AnalyticsDashboardFiltersSourceCountOrderByAggregateInput>;
  _max?: InputMaybe<AnalyticsDashboardFiltersSourceMaxOrderByAggregateInput>;
  _min?: InputMaybe<AnalyticsDashboardFiltersSourceMinOrderByAggregateInput>;
  _sum?: InputMaybe<AnalyticsDashboardFiltersSourceSumOrderByAggregateInput>;
  addEmptyOption?: InputMaybe<SortOrder>;
  fieldId?: InputMaybe<SortOrderInput>;
  filterKey?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pageId?: InputMaybe<SortOrderInput>;
  templateId?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
};

export type AnalyticsDashboardFiltersSourceOrderByWithRelationInput = {
  _relevance?: InputMaybe<AnalyticsDashboardFiltersSourceOrderByRelevanceInput>;
  addEmptyOption?: InputMaybe<SortOrder>;
  fieldId?: InputMaybe<SortOrderInput>;
  filterKey?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pageId?: InputMaybe<SortOrderInput>;
  templateId?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
};

export enum AnalyticsDashboardFiltersSourceScalarFieldEnum {
  AddEmptyOption = 'addEmptyOption',
  DashboardId = 'dashboardId',
  FieldId = 'fieldId',
  FilterKey = 'filterKey',
  Id = 'id',
  PageId = 'pageId',
  TemplateId = 'templateId',
  Type = 'type'
}

export type AnalyticsDashboardFiltersSourceScalarWhereInput = {
  AND?: InputMaybe<Array<AnalyticsDashboardFiltersSourceScalarWhereInput>>;
  NOT?: InputMaybe<Array<AnalyticsDashboardFiltersSourceScalarWhereInput>>;
  OR?: InputMaybe<Array<AnalyticsDashboardFiltersSourceScalarWhereInput>>;
  addEmptyOption?: InputMaybe<BoolFilter>;
  fieldId?: InputMaybe<StringNullableFilter>;
  filterKey?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  pageId?: InputMaybe<StringNullableFilter>;
  templateId?: InputMaybe<IntNullableFilter>;
  type?: InputMaybe<EnumFiltersSourceTypeFilter>;
};

export type AnalyticsDashboardFiltersSourceScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<AnalyticsDashboardFiltersSourceScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<AnalyticsDashboardFiltersSourceScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<AnalyticsDashboardFiltersSourceScalarWhereWithAggregatesInput>>;
  addEmptyOption?: InputMaybe<BoolWithAggregatesFilter>;
  fieldId?: InputMaybe<StringNullableWithAggregatesFilter>;
  filterKey?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  pageId?: InputMaybe<StringNullableWithAggregatesFilter>;
  templateId?: InputMaybe<IntNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumFiltersSourceTypeWithAggregatesFilter>;
};

export type AnalyticsDashboardFiltersSourceSumAggregate = {
  __typename?: 'AnalyticsDashboardFiltersSourceSumAggregate';
  dashboardId?: Maybe<Scalars['Int']['output']>;
  templateId?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsDashboardFiltersSourceSumOrderByAggregateInput = {
  templateId?: InputMaybe<SortOrder>;
};

export type AnalyticsDashboardFiltersSourceUpdateInput = {
  addEmptyOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fieldId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  filterKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pageId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  templateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumFiltersSourceTypeFieldUpdateOperationsInput>;
};

export type AnalyticsDashboardFiltersSourceUpdateManyMutationInput = {
  addEmptyOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fieldId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  filterKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pageId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  templateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumFiltersSourceTypeFieldUpdateOperationsInput>;
};

export type AnalyticsDashboardFiltersSourceUpdateManyWithWhereWithoutDashboardInput = {
  data: AnalyticsDashboardFiltersSourceUpdateManyMutationInput;
  where: AnalyticsDashboardFiltersSourceScalarWhereInput;
};

export type AnalyticsDashboardFiltersSourceUpdateManyWithoutDashboardNestedInput = {
  connect?: InputMaybe<Array<AnalyticsDashboardFiltersSourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalyticsDashboardFiltersSourceCreateOrConnectWithoutDashboardInput>>;
  create?: InputMaybe<Array<AnalyticsDashboardFiltersSourceCreateWithoutDashboardInput>>;
  createMany?: InputMaybe<AnalyticsDashboardFiltersSourceCreateManyDashboardInputEnvelope>;
  delete?: InputMaybe<Array<AnalyticsDashboardFiltersSourceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnalyticsDashboardFiltersSourceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnalyticsDashboardFiltersSourceWhereUniqueInput>>;
  set?: InputMaybe<Array<AnalyticsDashboardFiltersSourceWhereUniqueInput>>;
  update?: InputMaybe<Array<AnalyticsDashboardFiltersSourceUpdateWithWhereUniqueWithoutDashboardInput>>;
  updateMany?: InputMaybe<Array<AnalyticsDashboardFiltersSourceUpdateManyWithWhereWithoutDashboardInput>>;
  upsert?: InputMaybe<Array<AnalyticsDashboardFiltersSourceUpsertWithWhereUniqueWithoutDashboardInput>>;
};

export type AnalyticsDashboardFiltersSourceUpdateWithWhereUniqueWithoutDashboardInput = {
  data: AnalyticsDashboardFiltersSourceUpdateWithoutDashboardInput;
  where: AnalyticsDashboardFiltersSourceWhereUniqueInput;
};

export type AnalyticsDashboardFiltersSourceUpdateWithoutDashboardInput = {
  addEmptyOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fieldId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  filterKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pageId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  templateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumFiltersSourceTypeFieldUpdateOperationsInput>;
};

export type AnalyticsDashboardFiltersSourceUpsertWithWhereUniqueWithoutDashboardInput = {
  create: AnalyticsDashboardFiltersSourceCreateWithoutDashboardInput;
  update: AnalyticsDashboardFiltersSourceUpdateWithoutDashboardInput;
  where: AnalyticsDashboardFiltersSourceWhereUniqueInput;
};

export type AnalyticsDashboardFiltersSourceWhereInput = {
  AND?: InputMaybe<Array<AnalyticsDashboardFiltersSourceWhereInput>>;
  NOT?: InputMaybe<Array<AnalyticsDashboardFiltersSourceWhereInput>>;
  OR?: InputMaybe<Array<AnalyticsDashboardFiltersSourceWhereInput>>;
  addEmptyOption?: InputMaybe<BoolFilter>;
  fieldId?: InputMaybe<StringNullableFilter>;
  filterKey?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  pageId?: InputMaybe<StringNullableFilter>;
  templateId?: InputMaybe<IntNullableFilter>;
  type?: InputMaybe<EnumFiltersSourceTypeFilter>;
};

export type AnalyticsDashboardFiltersSourceWhereUniqueInput = {
  AND?: InputMaybe<Array<AnalyticsDashboardFiltersSourceWhereInput>>;
  NOT?: InputMaybe<Array<AnalyticsDashboardFiltersSourceWhereInput>>;
  OR?: InputMaybe<Array<AnalyticsDashboardFiltersSourceWhereInput>>;
  addEmptyOption?: InputMaybe<BoolFilter>;
  fieldId?: InputMaybe<StringNullableFilter>;
  filterKey?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  pageId?: InputMaybe<StringNullableFilter>;
  templateId?: InputMaybe<IntNullableFilter>;
  type?: InputMaybe<EnumFiltersSourceTypeFilter>;
};

export type AnalyticsDashboardGroupBy = {
  __typename?: 'AnalyticsDashboardGroupBy';
  _avg?: Maybe<AnalyticsDashboardAvgAggregate>;
  _count?: Maybe<AnalyticsDashboardCountAggregate>;
  _max?: Maybe<AnalyticsDashboardMaxAggregate>;
  _min?: Maybe<AnalyticsDashboardMinAggregate>;
  _sum?: Maybe<AnalyticsDashboardSumAggregate>;
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  restricted: Scalars['Boolean']['output'];
};

export type AnalyticsDashboardMaxAggregate = {
  __typename?: 'AnalyticsDashboardMaxAggregate';
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  restricted?: Maybe<Scalars['Boolean']['output']>;
};

export type AnalyticsDashboardMaxOrderByAggregateInput = {
  content?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  restricted?: InputMaybe<SortOrder>;
};

export type AnalyticsDashboardMinAggregate = {
  __typename?: 'AnalyticsDashboardMinAggregate';
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  restricted?: Maybe<Scalars['Boolean']['output']>;
};

export type AnalyticsDashboardMinOrderByAggregateInput = {
  content?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  restricted?: InputMaybe<SortOrder>;
};

export enum AnalyticsDashboardOrderByRelevanceFieldEnum {
  Content = 'content',
  Name = 'name'
}

export type AnalyticsDashboardOrderByRelevanceInput = {
  fields: Array<AnalyticsDashboardOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type AnalyticsDashboardOrderByWithAggregationInput = {
  _avg?: InputMaybe<AnalyticsDashboardAvgOrderByAggregateInput>;
  _count?: InputMaybe<AnalyticsDashboardCountOrderByAggregateInput>;
  _max?: InputMaybe<AnalyticsDashboardMaxOrderByAggregateInput>;
  _min?: InputMaybe<AnalyticsDashboardMinOrderByAggregateInput>;
  _sum?: InputMaybe<AnalyticsDashboardSumOrderByAggregateInput>;
  content?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  restricted?: InputMaybe<SortOrder>;
};

export type AnalyticsDashboardOrderByWithRelationInput = {
  _relevance?: InputMaybe<AnalyticsDashboardOrderByRelevanceInput>;
  charts?: InputMaybe<AnalyticsDashboardChartOrderByRelationAggregateInput>;
  content?: InputMaybe<SortOrder>;
  filtersSources?: InputMaybe<AnalyticsDashboardFiltersSourceOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  restricted?: InputMaybe<SortOrder>;
};

export enum AnalyticsDashboardScalarFieldEnum {
  Content = 'content',
  Id = 'id',
  Name = 'name',
  Restricted = 'restricted'
}

export type AnalyticsDashboardScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<AnalyticsDashboardScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<AnalyticsDashboardScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<AnalyticsDashboardScalarWhereWithAggregatesInput>>;
  content?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  restricted?: InputMaybe<BoolWithAggregatesFilter>;
};

export type AnalyticsDashboardSumAggregate = {
  __typename?: 'AnalyticsDashboardSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsDashboardSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type AnalyticsDashboardUpdateInput = {
  charts?: InputMaybe<AnalyticsDashboardChartUpdateManyWithoutDashboardNestedInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  filtersSources?: InputMaybe<AnalyticsDashboardFiltersSourceUpdateManyWithoutDashboardNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  restricted?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type AnalyticsDashboardUpdateManyMutationInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  restricted?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type AnalyticsDashboardWhereInput = {
  AND?: InputMaybe<Array<AnalyticsDashboardWhereInput>>;
  NOT?: InputMaybe<Array<AnalyticsDashboardWhereInput>>;
  OR?: InputMaybe<Array<AnalyticsDashboardWhereInput>>;
  charts?: InputMaybe<AnalyticsDashboardChartListRelationFilter>;
  content?: InputMaybe<StringFilter>;
  filtersSources?: InputMaybe<AnalyticsDashboardFiltersSourceListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  restricted?: InputMaybe<BoolFilter>;
};

export type AnalyticsDashboardWhereUniqueInput = {
  AND?: InputMaybe<Array<AnalyticsDashboardWhereInput>>;
  NOT?: InputMaybe<Array<AnalyticsDashboardWhereInput>>;
  OR?: InputMaybe<Array<AnalyticsDashboardWhereInput>>;
  charts?: InputMaybe<AnalyticsDashboardChartListRelationFilter>;
  content?: InputMaybe<StringFilter>;
  filtersSources?: InputMaybe<AnalyticsDashboardFiltersSourceListRelationFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<StringFilter>;
  restricted?: InputMaybe<BoolFilter>;
};

export type AnalyticsPageField = {
  __typename?: 'AnalyticsPageField';
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AppAnalyticsDashboardUpdateInput = {
  charts: Array<AnalyticsDashboardChartCreateInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  filtersSources: Array<AnalyticsDashboardFiltersSourceCreateInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  restricted?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type AppAnalyticsDashboardWhereUniqueInput = {
  AND?: InputMaybe<Array<AnalyticsDashboardWhereInput>>;
  NOT?: InputMaybe<Array<AnalyticsDashboardWhereInput>>;
  OR?: InputMaybe<Array<AnalyticsDashboardWhereInput>>;
  charts?: InputMaybe<AnalyticsDashboardChartListRelationFilter>;
  content?: InputMaybe<StringFilter>;
  filtersSources?: InputMaybe<AnalyticsDashboardFiltersSourceListRelationFilter>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<StringFilter>;
  restricted?: InputMaybe<BoolFilter>;
};

export type BaseEventType = {
  __typename?: 'BaseEventType';
  action: Scalars['String']['output'];
  entity: Scalars['String']['output'];
};

export type BaseEventTypeInput = {
  action: Scalars['String']['input'];
  entity: Scalars['String']['input'];
};

export type BigIntNullableFilter = {
  equals?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  not?: InputMaybe<NestedBigIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type BoolNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedBoolNullableFilter>;
  _min?: InputMaybe<NestedBoolNullableFilter>;
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableWithAggregatesFilter>;
};

export type BoolWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedBoolFilter>;
  _min?: InputMaybe<NestedBoolFilter>;
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export enum CalendarInterval {
  Day = 'day',
  Month = 'month',
  Week = 'week'
}

export type Client = {
  __typename?: 'Client';
  applicationBaseUrl: Scalars['String']['output'];
  applicationBrandColor: Scalars['String']['output'];
  applicationLogoUrl: Scalars['String']['output'];
  applicationTitle: Scalars['String']['output'];
  bannerEnabled: Scalars['Boolean']['output'];
  bannerHeader: Scalars['String']['output'];
  bannerText: Scalars['String']['output'];
  clientFeatures: Array<ClientFeature>;
  clientPermissions: Array<ClientPermission>;
  databaseName?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  entityNamePlural: Scalars['String']['output'];
  entityNameSingular: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  insightPlaceholderPlural: Scalars['String']['output'];
  insightPlaceholderSingular: Scalars['String']['output'];
  keycloakFrontendClient: KeycloakClient;
  keycloakFrontendClientInternalId: Scalars['String']['output'];
  keycloakGroup: KeycloakGroup;
  keycloakGroupId: Scalars['String']['output'];
  keycloakGroupName: Scalars['String']['output'];
  permissions: Scalars['JSON']['output'];
  proposalNavigationPosition: ProposalNavigationPositionType;
  settings: Scalars['JSON']['output'];
  users: Array<KeycloakUser>;
  usersLimit: Scalars['Int']['output'];
};

export type ClientFeature = {
  __typename?: 'ClientFeature';
  clientId: Scalars['Int']['output'];
  name: Feature;
};

export type ClientFeatureCreateInput = {
  name: Feature;
};

export type ClientInput = {
  applicationBaseUrl: Scalars['String']['input'];
  applicationBrandColor: Scalars['HexColorCode']['input'];
  applicationLogoUrl: Scalars['String']['input'];
  applicationTitle: Scalars['String']['input'];
  bannerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  bannerHeader?: InputMaybe<Scalars['String']['input']>;
  bannerText?: InputMaybe<Scalars['String']['input']>;
  clientFeatures: Array<ClientFeatureCreateInput>;
  clientPermissions: Array<ClientPermissionCreateInput>;
  entityNamePlural?: InputMaybe<Scalars['String']['input']>;
  entityNameSingular?: InputMaybe<Scalars['String']['input']>;
  insightPlaceholderPlural?: InputMaybe<Scalars['String']['input']>;
  insightPlaceholderSingular?: InputMaybe<Scalars['String']['input']>;
  keycloakGroupName: Scalars['String']['input'];
  loginTheme: Scalars['String']['input'];
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  proposalNavigationPosition?: InputMaybe<ProposalNavigationPositionType>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  usersLimit: Scalars['Int']['input'];
};

export type ClientMembers = {
  __typename?: 'ClientMembers';
  usersProtected?: Maybe<Array<KeycloakUserProtected>>;
};

export type ClientPermission = {
  __typename?: 'ClientPermission';
  clientId: Scalars['Int']['output'];
  role: Scalars['String']['output'];
  scope: Scope;
};

export type ClientPermissionCreateInput = {
  role: Scalars['String']['input'];
  scope: Scope;
};

export type CredentialRepresentation = {
  __typename?: 'CredentialRepresentation';
  createdDate?: Maybe<Scalars['Float']['output']>;
  credentialData?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
  secretData?: Maybe<Scalars['String']['output']>;
  temporary?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userLabel?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type DataSource = {
  __typename?: 'DataSource';
  _count?: Maybe<DataSourceCount>;
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['Int']['output'];
  includeInFreshness: Scalars['Boolean']['output'];
  isSharedWithAdmin?: Maybe<Scalars['Boolean']['output']>;
  lastVersion: DataSourceVersion;
  name: Scalars['String']['output'];
  updatedAt: Scalars['Timestamp']['output'];
  versions: Array<DataSourceVersion>;
};


export type DataSourceVersionsArgs = {
  cursor?: InputMaybe<DataSourceVersionWhereUniqueInput>;
  distinct?: InputMaybe<Array<DataSourceVersionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DataSourceVersionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceVersionWhereInput>;
};

export type DataSourceAvgAggregate = {
  __typename?: 'DataSourceAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type DataSourceAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type DataSourceCell = {
  __typename?: 'DataSourceCell';
  columnUUID: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  initVersionId: Scalars['Int']['output'];
  lastVersion: DataSourceVersion;
  lastVersionId: Scalars['Int']['output'];
  rowUUID: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DataSourceCellAvgAggregate = {
  __typename?: 'DataSourceCellAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  initVersionId?: Maybe<Scalars['Float']['output']>;
  lastVersionId?: Maybe<Scalars['Float']['output']>;
};

export type DataSourceCellAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  initVersionId?: InputMaybe<SortOrder>;
  lastVersionId?: InputMaybe<SortOrder>;
};

export type DataSourceCellCountAggregate = {
  __typename?: 'DataSourceCellCountAggregate';
  _all: Scalars['Int']['output'];
  columnUUID: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  initVersionId: Scalars['Int']['output'];
  lastVersionId: Scalars['Int']['output'];
  rowUUID: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
};

export type DataSourceCellCountOrderByAggregateInput = {
  columnUUID?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  initVersionId?: InputMaybe<SortOrder>;
  lastVersionId?: InputMaybe<SortOrder>;
  rowUUID?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type DataSourceCellCreateInput = {
  columnUUID: Scalars['String']['input'];
  initVersionId: Scalars['Int']['input'];
  lastVersion: DataSourceVersionCreateNestedOneWithoutCellsInput;
  rowUUID: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type DataSourceCellCreateManyInput = {
  columnUUID: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  initVersionId: Scalars['Int']['input'];
  lastVersionId: Scalars['Int']['input'];
  rowUUID: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type DataSourceCellCreateManyLastVersionInput = {
  columnUUID: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  initVersionId: Scalars['Int']['input'];
  rowUUID: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type DataSourceCellCreateManyLastVersionInputEnvelope = {
  data: Array<DataSourceCellCreateManyLastVersionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DataSourceCellCreateNestedManyWithoutLastVersionInput = {
  connect?: InputMaybe<Array<DataSourceCellWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataSourceCellCreateOrConnectWithoutLastVersionInput>>;
  create?: InputMaybe<Array<DataSourceCellCreateWithoutLastVersionInput>>;
  createMany?: InputMaybe<DataSourceCellCreateManyLastVersionInputEnvelope>;
};

export type DataSourceCellCreateOrConnectWithoutLastVersionInput = {
  create: DataSourceCellCreateWithoutLastVersionInput;
  where: DataSourceCellWhereUniqueInput;
};

export type DataSourceCellCreateWithoutLastVersionInput = {
  columnUUID: Scalars['String']['input'];
  initVersionId: Scalars['Int']['input'];
  rowUUID: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type DataSourceCellGroupBy = {
  __typename?: 'DataSourceCellGroupBy';
  _avg?: Maybe<DataSourceCellAvgAggregate>;
  _count?: Maybe<DataSourceCellCountAggregate>;
  _max?: Maybe<DataSourceCellMaxAggregate>;
  _min?: Maybe<DataSourceCellMinAggregate>;
  _sum?: Maybe<DataSourceCellSumAggregate>;
  columnUUID: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  initVersionId: Scalars['Int']['output'];
  lastVersionId: Scalars['Int']['output'];
  rowUUID: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DataSourceCellLastVersionIdColumnUuidRowUuidCompoundUniqueInput = {
  columnUUID: Scalars['String']['input'];
  lastVersionId: Scalars['Int']['input'];
  rowUUID: Scalars['String']['input'];
};

export type DataSourceCellListRelationFilter = {
  every?: InputMaybe<DataSourceCellWhereInput>;
  none?: InputMaybe<DataSourceCellWhereInput>;
  some?: InputMaybe<DataSourceCellWhereInput>;
};

export type DataSourceCellMaxAggregate = {
  __typename?: 'DataSourceCellMaxAggregate';
  columnUUID?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  initVersionId?: Maybe<Scalars['Int']['output']>;
  lastVersionId?: Maybe<Scalars['Int']['output']>;
  rowUUID?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type DataSourceCellMaxOrderByAggregateInput = {
  columnUUID?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  initVersionId?: InputMaybe<SortOrder>;
  lastVersionId?: InputMaybe<SortOrder>;
  rowUUID?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type DataSourceCellMinAggregate = {
  __typename?: 'DataSourceCellMinAggregate';
  columnUUID?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  initVersionId?: Maybe<Scalars['Int']['output']>;
  lastVersionId?: Maybe<Scalars['Int']['output']>;
  rowUUID?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type DataSourceCellMinOrderByAggregateInput = {
  columnUUID?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  initVersionId?: InputMaybe<SortOrder>;
  lastVersionId?: InputMaybe<SortOrder>;
  rowUUID?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type DataSourceCellOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum DataSourceCellOrderByRelevanceFieldEnum {
  ColumnUuid = 'columnUUID',
  RowUuid = 'rowUUID',
  Value = 'value'
}

export type DataSourceCellOrderByRelevanceInput = {
  fields: Array<DataSourceCellOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type DataSourceCellOrderByWithAggregationInput = {
  _avg?: InputMaybe<DataSourceCellAvgOrderByAggregateInput>;
  _count?: InputMaybe<DataSourceCellCountOrderByAggregateInput>;
  _max?: InputMaybe<DataSourceCellMaxOrderByAggregateInput>;
  _min?: InputMaybe<DataSourceCellMinOrderByAggregateInput>;
  _sum?: InputMaybe<DataSourceCellSumOrderByAggregateInput>;
  columnUUID?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  initVersionId?: InputMaybe<SortOrder>;
  lastVersionId?: InputMaybe<SortOrder>;
  rowUUID?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type DataSourceCellOrderByWithRelationInput = {
  _relevance?: InputMaybe<DataSourceCellOrderByRelevanceInput>;
  columnUUID?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  initVersionId?: InputMaybe<SortOrder>;
  lastVersion?: InputMaybe<DataSourceVersionOrderByWithRelationInput>;
  lastVersionId?: InputMaybe<SortOrder>;
  rowUUID?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export enum DataSourceCellScalarFieldEnum {
  ColumnUuid = 'columnUUID',
  Id = 'id',
  InitVersionId = 'initVersionId',
  LastVersionId = 'lastVersionId',
  RowUuid = 'rowUUID',
  Value = 'value'
}

export type DataSourceCellScalarWhereInput = {
  AND?: InputMaybe<Array<DataSourceCellScalarWhereInput>>;
  NOT?: InputMaybe<Array<DataSourceCellScalarWhereInput>>;
  OR?: InputMaybe<Array<DataSourceCellScalarWhereInput>>;
  columnUUID?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  initVersionId?: InputMaybe<IntFilter>;
  lastVersionId?: InputMaybe<IntFilter>;
  rowUUID?: InputMaybe<StringFilter>;
  value?: InputMaybe<StringFilter>;
};

export type DataSourceCellScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DataSourceCellScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DataSourceCellScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DataSourceCellScalarWhereWithAggregatesInput>>;
  columnUUID?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  initVersionId?: InputMaybe<IntWithAggregatesFilter>;
  lastVersionId?: InputMaybe<IntWithAggregatesFilter>;
  rowUUID?: InputMaybe<StringWithAggregatesFilter>;
  value?: InputMaybe<StringWithAggregatesFilter>;
};

export type DataSourceCellSumAggregate = {
  __typename?: 'DataSourceCellSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  initVersionId?: Maybe<Scalars['Int']['output']>;
  lastVersionId?: Maybe<Scalars['Int']['output']>;
};

export type DataSourceCellSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  initVersionId?: InputMaybe<SortOrder>;
  lastVersionId?: InputMaybe<SortOrder>;
};

export type DataSourceCellUpdateInput = {
  columnUUID?: InputMaybe<StringFieldUpdateOperationsInput>;
  initVersionId?: InputMaybe<IntFieldUpdateOperationsInput>;
  lastVersion?: InputMaybe<DataSourceVersionUpdateOneRequiredWithoutCellsNestedInput>;
  rowUUID?: InputMaybe<StringFieldUpdateOperationsInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DataSourceCellUpdateManyMutationInput = {
  columnUUID?: InputMaybe<StringFieldUpdateOperationsInput>;
  initVersionId?: InputMaybe<IntFieldUpdateOperationsInput>;
  rowUUID?: InputMaybe<StringFieldUpdateOperationsInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DataSourceCellUpdateManyWithWhereWithoutLastVersionInput = {
  data: DataSourceCellUpdateManyMutationInput;
  where: DataSourceCellScalarWhereInput;
};

export type DataSourceCellUpdateManyWithoutLastVersionNestedInput = {
  connect?: InputMaybe<Array<DataSourceCellWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataSourceCellCreateOrConnectWithoutLastVersionInput>>;
  create?: InputMaybe<Array<DataSourceCellCreateWithoutLastVersionInput>>;
  createMany?: InputMaybe<DataSourceCellCreateManyLastVersionInputEnvelope>;
  delete?: InputMaybe<Array<DataSourceCellWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DataSourceCellScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DataSourceCellWhereUniqueInput>>;
  set?: InputMaybe<Array<DataSourceCellWhereUniqueInput>>;
  update?: InputMaybe<Array<DataSourceCellUpdateWithWhereUniqueWithoutLastVersionInput>>;
  updateMany?: InputMaybe<Array<DataSourceCellUpdateManyWithWhereWithoutLastVersionInput>>;
  upsert?: InputMaybe<Array<DataSourceCellUpsertWithWhereUniqueWithoutLastVersionInput>>;
};

export type DataSourceCellUpdateWithWhereUniqueWithoutLastVersionInput = {
  data: DataSourceCellUpdateWithoutLastVersionInput;
  where: DataSourceCellWhereUniqueInput;
};

export type DataSourceCellUpdateWithoutLastVersionInput = {
  columnUUID?: InputMaybe<StringFieldUpdateOperationsInput>;
  initVersionId?: InputMaybe<IntFieldUpdateOperationsInput>;
  rowUUID?: InputMaybe<StringFieldUpdateOperationsInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DataSourceCellUpsertWithWhereUniqueWithoutLastVersionInput = {
  create: DataSourceCellCreateWithoutLastVersionInput;
  update: DataSourceCellUpdateWithoutLastVersionInput;
  where: DataSourceCellWhereUniqueInput;
};

export type DataSourceCellWhereInput = {
  AND?: InputMaybe<Array<DataSourceCellWhereInput>>;
  NOT?: InputMaybe<Array<DataSourceCellWhereInput>>;
  OR?: InputMaybe<Array<DataSourceCellWhereInput>>;
  columnUUID?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  initVersionId?: InputMaybe<IntFilter>;
  lastVersion?: InputMaybe<DataSourceVersionScalarRelationFilter>;
  lastVersionId?: InputMaybe<IntFilter>;
  rowUUID?: InputMaybe<StringFilter>;
  value?: InputMaybe<StringFilter>;
};

export type DataSourceCellWhereUniqueInput = {
  AND?: InputMaybe<Array<DataSourceCellWhereInput>>;
  NOT?: InputMaybe<Array<DataSourceCellWhereInput>>;
  OR?: InputMaybe<Array<DataSourceCellWhereInput>>;
  columnUUID?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  initVersionId?: InputMaybe<IntFilter>;
  lastVersion?: InputMaybe<DataSourceVersionScalarRelationFilter>;
  lastVersionId?: InputMaybe<IntFilter>;
  lastVersionId_columnUUID_rowUUID?: InputMaybe<DataSourceCellLastVersionIdColumnUuidRowUuidCompoundUniqueInput>;
  rowUUID?: InputMaybe<StringFilter>;
  value?: InputMaybe<StringFilter>;
};

export type DataSourceCount = {
  __typename?: 'DataSourceCount';
  versions: Scalars['Int']['output'];
};


export type DataSourceCountVersionsArgs = {
  where?: InputMaybe<DataSourceVersionWhereInput>;
};

export type DataSourceCountAggregate = {
  __typename?: 'DataSourceCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  includeInFreshness: Scalars['Int']['output'];
  isSharedWithAdmin: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type DataSourceCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  includeInFreshness?: InputMaybe<SortOrder>;
  isSharedWithAdmin?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DataSourceCreateInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  includeInFreshness?: InputMaybe<Scalars['Boolean']['input']>;
  isSharedWithAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  versions?: InputMaybe<DataSourceVersionCreateNestedManyWithoutDataSourceInput>;
};

export type DataSourceCreateManyInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeInFreshness?: InputMaybe<Scalars['Boolean']['input']>;
  isSharedWithAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type DataSourceCreateNestedOneWithoutVersionsInput = {
  connect?: InputMaybe<DataSourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DataSourceCreateOrConnectWithoutVersionsInput>;
  create?: InputMaybe<DataSourceCreateWithoutVersionsInput>;
};

export type DataSourceCreateOrConnectWithoutVersionsInput = {
  create: DataSourceCreateWithoutVersionsInput;
  where: DataSourceWhereUniqueInput;
};

export type DataSourceCreateWithoutVersionsInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  includeInFreshness?: InputMaybe<Scalars['Boolean']['input']>;
  isSharedWithAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type DataSourceDeleteImpact = {
  __typename?: 'DataSourceDeleteImpact';
  insights: Scalars['Int']['output'];
  proposals: Scalars['Int']['output'];
};

export type DataSourceGroupBy = {
  __typename?: 'DataSourceGroupBy';
  _avg?: Maybe<DataSourceAvgAggregate>;
  _count?: Maybe<DataSourceCountAggregate>;
  _max?: Maybe<DataSourceMaxAggregate>;
  _min?: Maybe<DataSourceMinAggregate>;
  _sum?: Maybe<DataSourceSumAggregate>;
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['Int']['output'];
  includeInFreshness: Scalars['Boolean']['output'];
  isSharedWithAdmin?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

export type DataSourceMaxAggregate = {
  __typename?: 'DataSourceMaxAggregate';
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  includeInFreshness?: Maybe<Scalars['Boolean']['output']>;
  isSharedWithAdmin?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Timestamp']['output']>;
};

export type DataSourceMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  includeInFreshness?: InputMaybe<SortOrder>;
  isSharedWithAdmin?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DataSourceMeta = {
  __typename?: 'DataSourceMeta';
  id: Scalars['Int']['output'];
  lastVersion: DataSourceVersionMeta;
  name: Scalars['String']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

export type DataSourceMinAggregate = {
  __typename?: 'DataSourceMinAggregate';
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  includeInFreshness?: Maybe<Scalars['Boolean']['output']>;
  isSharedWithAdmin?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Timestamp']['output']>;
};

export type DataSourceMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  includeInFreshness?: InputMaybe<SortOrder>;
  isSharedWithAdmin?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum DataSourceOrderByRelevanceFieldEnum {
  Name = 'name'
}

export type DataSourceOrderByRelevanceInput = {
  fields: Array<DataSourceOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type DataSourceOrderByWithAggregationInput = {
  _avg?: InputMaybe<DataSourceAvgOrderByAggregateInput>;
  _count?: InputMaybe<DataSourceCountOrderByAggregateInput>;
  _max?: InputMaybe<DataSourceMaxOrderByAggregateInput>;
  _min?: InputMaybe<DataSourceMinOrderByAggregateInput>;
  _sum?: InputMaybe<DataSourceSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  includeInFreshness?: InputMaybe<SortOrder>;
  isSharedWithAdmin?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DataSourceOrderByWithRelationInput = {
  _relevance?: InputMaybe<DataSourceOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  includeInFreshness?: InputMaybe<SortOrder>;
  isSharedWithAdmin?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  versions?: InputMaybe<DataSourceVersionOrderByRelationAggregateInput>;
};

export type DataSourceSaveResolverCreateInput = {
  code: Scalars['String']['input'];
  columns: Scalars['JSON']['input'];
  hash?: InputMaybe<Scalars['String']['input']>;
  includeInFreshness?: InputMaybe<Scalars['Boolean']['input']>;
  isSharedWithAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  mappingRules: Scalars['JSON']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type: DataSourceType;
  usedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  validationRules: Scalars['JSON']['input'];
};

export type DataSourceSaveResolverUpdateInput = {
  code: Scalars['String']['input'];
  columns: Scalars['JSON']['input'];
  hash?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  includeInFreshness?: InputMaybe<Scalars['Boolean']['input']>;
  isSharedWithAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  mappingRules: Scalars['JSON']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type: DataSourceType;
  usedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  validationRules: Scalars['JSON']['input'];
};

export enum DataSourceScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  IncludeInFreshness = 'includeInFreshness',
  IsSharedWithAdmin = 'isSharedWithAdmin',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type DataSourceScalarRelationFilter = {
  is?: InputMaybe<DataSourceWhereInput>;
  isNot?: InputMaybe<DataSourceWhereInput>;
};

export type DataSourceScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DataSourceScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DataSourceScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DataSourceScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  includeInFreshness?: InputMaybe<BoolWithAggregatesFilter>;
  isSharedWithAdmin?: InputMaybe<BoolNullableWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DataSourceSumAggregate = {
  __typename?: 'DataSourceSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
};

export type DataSourceSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export enum DataSourceType {
  Clickhouse = 'CLICKHOUSE',
  Composite = 'COMPOSITE',
  Csv = 'CSV',
  HttpApi = 'HTTP_API',
  Mysql = 'MYSQL'
}

export type DataSourceUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  includeInFreshness?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isSharedWithAdmin?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  versions?: InputMaybe<DataSourceVersionUpdateManyWithoutDataSourceNestedInput>;
};

export type DataSourceUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  includeInFreshness?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isSharedWithAdmin?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataSourceUpdateOneRequiredWithoutVersionsNestedInput = {
  connect?: InputMaybe<DataSourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DataSourceCreateOrConnectWithoutVersionsInput>;
  create?: InputMaybe<DataSourceCreateWithoutVersionsInput>;
  update?: InputMaybe<DataSourceUpdateToOneWithWhereWithoutVersionsInput>;
  upsert?: InputMaybe<DataSourceUpsertWithoutVersionsInput>;
};

export type DataSourceUpdateToOneWithWhereWithoutVersionsInput = {
  data: DataSourceUpdateWithoutVersionsInput;
  where?: InputMaybe<DataSourceWhereInput>;
};

export type DataSourceUpdateWithoutVersionsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  includeInFreshness?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isSharedWithAdmin?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataSourceUpsertWithoutVersionsInput = {
  create: DataSourceCreateWithoutVersionsInput;
  update: DataSourceUpdateWithoutVersionsInput;
  where?: InputMaybe<DataSourceWhereInput>;
};

export type DataSourceVersion = {
  __typename?: 'DataSourceVersion';
  _count?: Maybe<DataSourceVersionCount>;
  cells: Array<DataSourceCell>;
  code: Scalars['String']['output'];
  columns: Scalars['JSON']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy: Scalars['String']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  dataSource: DataSource;
  dataSourceId: Scalars['Int']['output'];
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  mappingRules?: Maybe<Scalars['JSON']['output']>;
  type: DataSourceType;
  usedAt?: Maybe<Scalars['Timestamp']['output']>;
  validationRules?: Maybe<Scalars['JSON']['output']>;
};


export type DataSourceVersionCellsArgs = {
  cursor?: InputMaybe<DataSourceCellWhereUniqueInput>;
  distinct?: InputMaybe<Array<DataSourceCellScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DataSourceCellOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceCellWhereInput>;
};

export type DataSourceVersionAvgAggregate = {
  __typename?: 'DataSourceVersionAvgAggregate';
  dataSourceId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type DataSourceVersionAvgOrderByAggregateInput = {
  dataSourceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DataSourceVersionCount = {
  __typename?: 'DataSourceVersionCount';
  cells: Scalars['Int']['output'];
  proposalVersions: Scalars['Int']['output'];
};


export type DataSourceVersionCountCellsArgs = {
  where?: InputMaybe<DataSourceCellWhereInput>;
};


export type DataSourceVersionCountProposalVersionsArgs = {
  where?: InputMaybe<ProposalVersionDataSourceWhereInput>;
};

export type DataSourceVersionCountAggregate = {
  __typename?: 'DataSourceVersionCountAggregate';
  _all: Scalars['Int']['output'];
  code: Scalars['Int']['output'];
  columns: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['Int']['output'];
  dataSourceId: Scalars['Int']['output'];
  hash: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  mappingRules: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  usedAt: Scalars['Int']['output'];
  validationRules: Scalars['Int']['output'];
};

export type DataSourceVersionCountOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  columns?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  dataSourceId?: InputMaybe<SortOrder>;
  hash?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mappingRules?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  usedAt?: InputMaybe<SortOrder>;
  validationRules?: InputMaybe<SortOrder>;
};

export type DataSourceVersionCreateInput = {
  cells?: InputMaybe<DataSourceCellCreateNestedManyWithoutLastVersionInput>;
  code: Scalars['String']['input'];
  columns: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  dataSource: DataSourceCreateNestedOneWithoutVersionsInput;
  hash?: InputMaybe<Scalars['String']['input']>;
  mappingRules?: InputMaybe<Scalars['JSON']['input']>;
  type: DataSourceType;
  usedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  validationRules?: InputMaybe<Scalars['JSON']['input']>;
};

export type DataSourceVersionCreateManyDataSourceInput = {
  code: Scalars['String']['input'];
  columns: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mappingRules?: InputMaybe<Scalars['JSON']['input']>;
  type: DataSourceType;
  usedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  validationRules?: InputMaybe<Scalars['JSON']['input']>;
};

export type DataSourceVersionCreateManyDataSourceInputEnvelope = {
  data: Array<DataSourceVersionCreateManyDataSourceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DataSourceVersionCreateManyInput = {
  code: Scalars['String']['input'];
  columns: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  dataSourceId: Scalars['Int']['input'];
  hash?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mappingRules?: InputMaybe<Scalars['JSON']['input']>;
  type: DataSourceType;
  usedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  validationRules?: InputMaybe<Scalars['JSON']['input']>;
};

export type DataSourceVersionCreateNestedManyWithoutDataSourceInput = {
  connect?: InputMaybe<Array<DataSourceVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataSourceVersionCreateOrConnectWithoutDataSourceInput>>;
  create?: InputMaybe<Array<DataSourceVersionCreateWithoutDataSourceInput>>;
  createMany?: InputMaybe<DataSourceVersionCreateManyDataSourceInputEnvelope>;
};

export type DataSourceVersionCreateNestedOneWithoutCellsInput = {
  connect?: InputMaybe<DataSourceVersionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DataSourceVersionCreateOrConnectWithoutCellsInput>;
  create?: InputMaybe<DataSourceVersionCreateWithoutCellsInput>;
};

export type DataSourceVersionCreateNestedOneWithoutOriginInput = {
  connect?: InputMaybe<DataSourceVersionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DataSourceVersionCreateOrConnectWithoutOriginInput>;
  create?: InputMaybe<DataSourceVersionCreateWithoutOriginInput>;
};

export type DataSourceVersionCreateOrConnectWithoutCellsInput = {
  create: DataSourceVersionCreateWithoutCellsInput;
  where: DataSourceVersionWhereUniqueInput;
};

export type DataSourceVersionCreateOrConnectWithoutDataSourceInput = {
  create: DataSourceVersionCreateWithoutDataSourceInput;
  where: DataSourceVersionWhereUniqueInput;
};

export type DataSourceVersionCreateOrConnectWithoutOriginInput = {
  create: DataSourceVersionCreateWithoutOriginInput;
  where: DataSourceVersionWhereUniqueInput;
};

export type DataSourceVersionCreateWithoutCellsInput = {
  code: Scalars['String']['input'];
  columns: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  dataSource: DataSourceCreateNestedOneWithoutVersionsInput;
  hash?: InputMaybe<Scalars['String']['input']>;
  mappingRules?: InputMaybe<Scalars['JSON']['input']>;
  type: DataSourceType;
  usedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  validationRules?: InputMaybe<Scalars['JSON']['input']>;
};

export type DataSourceVersionCreateWithoutDataSourceInput = {
  cells?: InputMaybe<DataSourceCellCreateNestedManyWithoutLastVersionInput>;
  code: Scalars['String']['input'];
  columns: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  mappingRules?: InputMaybe<Scalars['JSON']['input']>;
  type: DataSourceType;
  usedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  validationRules?: InputMaybe<Scalars['JSON']['input']>;
};

export type DataSourceVersionCreateWithoutOriginInput = {
  cells?: InputMaybe<DataSourceCellCreateNestedManyWithoutLastVersionInput>;
  code: Scalars['String']['input'];
  columns: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  dataSource: DataSourceCreateNestedOneWithoutVersionsInput;
  hash?: InputMaybe<Scalars['String']['input']>;
  mappingRules?: InputMaybe<Scalars['JSON']['input']>;
  type: DataSourceType;
  usedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  validationRules?: InputMaybe<Scalars['JSON']['input']>;
};

export type DataSourceVersionGroupBy = {
  __typename?: 'DataSourceVersionGroupBy';
  _avg?: Maybe<DataSourceVersionAvgAggregate>;
  _count?: Maybe<DataSourceVersionCountAggregate>;
  _max?: Maybe<DataSourceVersionMaxAggregate>;
  _min?: Maybe<DataSourceVersionMinAggregate>;
  _sum?: Maybe<DataSourceVersionSumAggregate>;
  code: Scalars['String']['output'];
  columns: Scalars['JSON']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy: Scalars['String']['output'];
  dataSourceId: Scalars['Int']['output'];
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  mappingRules?: Maybe<Scalars['JSON']['output']>;
  type: DataSourceType;
  usedAt?: Maybe<Scalars['Timestamp']['output']>;
  validationRules?: Maybe<Scalars['JSON']['output']>;
};

export type DataSourceVersionListRelationFilter = {
  every?: InputMaybe<DataSourceVersionWhereInput>;
  none?: InputMaybe<DataSourceVersionWhereInput>;
  some?: InputMaybe<DataSourceVersionWhereInput>;
};

export type DataSourceVersionMaxAggregate = {
  __typename?: 'DataSourceVersionMaxAggregate';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dataSourceId?: Maybe<Scalars['Int']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<DataSourceType>;
  usedAt?: Maybe<Scalars['Timestamp']['output']>;
};

export type DataSourceVersionMaxOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  dataSourceId?: InputMaybe<SortOrder>;
  hash?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  usedAt?: InputMaybe<SortOrder>;
};

export type DataSourceVersionMeta = {
  __typename?: 'DataSourceVersionMeta';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['Int']['output'];
  usedAt?: Maybe<Scalars['Timestamp']['output']>;
};

export type DataSourceVersionMinAggregate = {
  __typename?: 'DataSourceVersionMinAggregate';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dataSourceId?: Maybe<Scalars['Int']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<DataSourceType>;
  usedAt?: Maybe<Scalars['Timestamp']['output']>;
};

export type DataSourceVersionMinOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  dataSourceId?: InputMaybe<SortOrder>;
  hash?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  usedAt?: InputMaybe<SortOrder>;
};

export type DataSourceVersionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum DataSourceVersionOrderByRelevanceFieldEnum {
  Code = 'code',
  CreatedBy = 'createdBy',
  Hash = 'hash'
}

export type DataSourceVersionOrderByRelevanceInput = {
  fields: Array<DataSourceVersionOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type DataSourceVersionOrderByWithAggregationInput = {
  _avg?: InputMaybe<DataSourceVersionAvgOrderByAggregateInput>;
  _count?: InputMaybe<DataSourceVersionCountOrderByAggregateInput>;
  _max?: InputMaybe<DataSourceVersionMaxOrderByAggregateInput>;
  _min?: InputMaybe<DataSourceVersionMinOrderByAggregateInput>;
  _sum?: InputMaybe<DataSourceVersionSumOrderByAggregateInput>;
  code?: InputMaybe<SortOrder>;
  columns?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  dataSourceId?: InputMaybe<SortOrder>;
  hash?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  mappingRules?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  usedAt?: InputMaybe<SortOrderInput>;
  validationRules?: InputMaybe<SortOrderInput>;
};

export type DataSourceVersionOrderByWithRelationInput = {
  _relevance?: InputMaybe<DataSourceVersionOrderByRelevanceInput>;
  cells?: InputMaybe<DataSourceCellOrderByRelationAggregateInput>;
  code?: InputMaybe<SortOrder>;
  columns?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  dataSource?: InputMaybe<DataSourceOrderByWithRelationInput>;
  dataSourceId?: InputMaybe<SortOrder>;
  hash?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  mappingRules?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  usedAt?: InputMaybe<SortOrderInput>;
  validationRules?: InputMaybe<SortOrderInput>;
};

export type DataSourceVersionOrigin = {
  __typename?: 'DataSourceVersionOrigin';
  createdAt: Scalars['Timestamp']['output'];
  proposal: Proposal;
  proposalId: Scalars['Int']['output'];
  version: DataSourceVersion;
  versionId: Scalars['Int']['output'];
};

export type DataSourceVersionOriginAvgAggregate = {
  __typename?: 'DataSourceVersionOriginAvgAggregate';
  proposalId?: Maybe<Scalars['Float']['output']>;
  versionId?: Maybe<Scalars['Float']['output']>;
};

export type DataSourceVersionOriginAvgOrderByAggregateInput = {
  proposalId?: InputMaybe<SortOrder>;
  versionId?: InputMaybe<SortOrder>;
};

export type DataSourceVersionOriginCountAggregate = {
  __typename?: 'DataSourceVersionOriginCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  proposalId: Scalars['Int']['output'];
  versionId: Scalars['Int']['output'];
};

export type DataSourceVersionOriginCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  proposalId?: InputMaybe<SortOrder>;
  versionId?: InputMaybe<SortOrder>;
};

export type DataSourceVersionOriginCreateInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  proposal: ProposalCreateNestedOneWithoutDataSourceVersionOriginInput;
  version: DataSourceVersionCreateNestedOneWithoutOriginInput;
};

export type DataSourceVersionOriginCreateManyInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  proposalId: Scalars['Int']['input'];
  versionId: Scalars['Int']['input'];
};

export type DataSourceVersionOriginGroupBy = {
  __typename?: 'DataSourceVersionOriginGroupBy';
  _avg?: Maybe<DataSourceVersionOriginAvgAggregate>;
  _count?: Maybe<DataSourceVersionOriginCountAggregate>;
  _max?: Maybe<DataSourceVersionOriginMaxAggregate>;
  _min?: Maybe<DataSourceVersionOriginMinAggregate>;
  _sum?: Maybe<DataSourceVersionOriginSumAggregate>;
  createdAt: Scalars['Timestamp']['output'];
  proposalId: Scalars['Int']['output'];
  versionId: Scalars['Int']['output'];
};

export type DataSourceVersionOriginMaxAggregate = {
  __typename?: 'DataSourceVersionOriginMaxAggregate';
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  proposalId?: Maybe<Scalars['Int']['output']>;
  versionId?: Maybe<Scalars['Int']['output']>;
};

export type DataSourceVersionOriginMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  proposalId?: InputMaybe<SortOrder>;
  versionId?: InputMaybe<SortOrder>;
};

export type DataSourceVersionOriginMinAggregate = {
  __typename?: 'DataSourceVersionOriginMinAggregate';
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  proposalId?: Maybe<Scalars['Int']['output']>;
  versionId?: Maybe<Scalars['Int']['output']>;
};

export type DataSourceVersionOriginMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  proposalId?: InputMaybe<SortOrder>;
  versionId?: InputMaybe<SortOrder>;
};

export type DataSourceVersionOriginOrderByWithAggregationInput = {
  _avg?: InputMaybe<DataSourceVersionOriginAvgOrderByAggregateInput>;
  _count?: InputMaybe<DataSourceVersionOriginCountOrderByAggregateInput>;
  _max?: InputMaybe<DataSourceVersionOriginMaxOrderByAggregateInput>;
  _min?: InputMaybe<DataSourceVersionOriginMinOrderByAggregateInput>;
  _sum?: InputMaybe<DataSourceVersionOriginSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  proposalId?: InputMaybe<SortOrder>;
  versionId?: InputMaybe<SortOrder>;
};

export type DataSourceVersionOriginOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  proposal?: InputMaybe<ProposalOrderByWithRelationInput>;
  proposalId?: InputMaybe<SortOrder>;
  version?: InputMaybe<DataSourceVersionOrderByWithRelationInput>;
  versionId?: InputMaybe<SortOrder>;
};

export enum DataSourceVersionOriginScalarFieldEnum {
  CreatedAt = 'createdAt',
  ProposalId = 'proposalId',
  VersionId = 'versionId'
}

export type DataSourceVersionOriginScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DataSourceVersionOriginScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DataSourceVersionOriginScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DataSourceVersionOriginScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  proposalId?: InputMaybe<IntWithAggregatesFilter>;
  versionId?: InputMaybe<IntWithAggregatesFilter>;
};

export type DataSourceVersionOriginSumAggregate = {
  __typename?: 'DataSourceVersionOriginSumAggregate';
  proposalId?: Maybe<Scalars['Int']['output']>;
  versionId?: Maybe<Scalars['Int']['output']>;
};

export type DataSourceVersionOriginSumOrderByAggregateInput = {
  proposalId?: InputMaybe<SortOrder>;
  versionId?: InputMaybe<SortOrder>;
};

export type DataSourceVersionOriginUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  proposal?: InputMaybe<ProposalUpdateOneRequiredWithoutDataSourceVersionOriginNestedInput>;
  version?: InputMaybe<DataSourceVersionUpdateOneRequiredWithoutOriginNestedInput>;
};

export type DataSourceVersionOriginUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataSourceVersionOriginWhereInput = {
  AND?: InputMaybe<Array<DataSourceVersionOriginWhereInput>>;
  NOT?: InputMaybe<Array<DataSourceVersionOriginWhereInput>>;
  OR?: InputMaybe<Array<DataSourceVersionOriginWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  proposal?: InputMaybe<ProposalScalarRelationFilter>;
  proposalId?: InputMaybe<IntFilter>;
  version?: InputMaybe<DataSourceVersionScalarRelationFilter>;
  versionId?: InputMaybe<IntFilter>;
};

export type DataSourceVersionOriginWhereUniqueInput = {
  AND?: InputMaybe<Array<DataSourceVersionOriginWhereInput>>;
  NOT?: InputMaybe<Array<DataSourceVersionOriginWhereInput>>;
  OR?: InputMaybe<Array<DataSourceVersionOriginWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  proposal?: InputMaybe<ProposalScalarRelationFilter>;
  proposalId?: InputMaybe<IntFilter>;
  version?: InputMaybe<DataSourceVersionScalarRelationFilter>;
  versionId?: InputMaybe<Scalars['Int']['input']>;
};

export enum DataSourceVersionScalarFieldEnum {
  Code = 'code',
  Columns = 'columns',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DataSourceId = 'dataSourceId',
  Hash = 'hash',
  Id = 'id',
  MappingRules = 'mappingRules',
  Type = 'type',
  UsedAt = 'usedAt',
  ValidationRules = 'validationRules'
}

export type DataSourceVersionScalarRelationFilter = {
  is?: InputMaybe<DataSourceVersionWhereInput>;
  isNot?: InputMaybe<DataSourceVersionWhereInput>;
};

export type DataSourceVersionScalarWhereInput = {
  AND?: InputMaybe<Array<DataSourceVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<DataSourceVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<DataSourceVersionScalarWhereInput>>;
  code?: InputMaybe<StringFilter>;
  columns?: InputMaybe<JsonFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  dataSourceId?: InputMaybe<IntFilter>;
  hash?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mappingRules?: InputMaybe<JsonNullableFilter>;
  type?: InputMaybe<EnumDataSourceTypeFilter>;
  usedAt?: InputMaybe<DateTimeNullableFilter>;
  validationRules?: InputMaybe<JsonNullableFilter>;
};

export type DataSourceVersionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DataSourceVersionScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DataSourceVersionScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DataSourceVersionScalarWhereWithAggregatesInput>>;
  code?: InputMaybe<StringWithAggregatesFilter>;
  columns?: InputMaybe<JsonWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  createdBy?: InputMaybe<StringWithAggregatesFilter>;
  dataSourceId?: InputMaybe<IntWithAggregatesFilter>;
  hash?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  mappingRules?: InputMaybe<JsonNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumDataSourceTypeWithAggregatesFilter>;
  usedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  validationRules?: InputMaybe<JsonNullableWithAggregatesFilter>;
};

export type DataSourceVersionSumAggregate = {
  __typename?: 'DataSourceVersionSumAggregate';
  dataSourceId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type DataSourceVersionSumOrderByAggregateInput = {
  dataSourceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DataSourceVersionUpdateInput = {
  cells?: InputMaybe<DataSourceCellUpdateManyWithoutLastVersionNestedInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  columns?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dataSource?: InputMaybe<DataSourceUpdateOneRequiredWithoutVersionsNestedInput>;
  hash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mappingRules?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<EnumDataSourceTypeFieldUpdateOperationsInput>;
  usedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validationRules?: InputMaybe<Scalars['JSON']['input']>;
};

export type DataSourceVersionUpdateManyMutationInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  columns?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  hash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mappingRules?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<EnumDataSourceTypeFieldUpdateOperationsInput>;
  usedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validationRules?: InputMaybe<Scalars['JSON']['input']>;
};

export type DataSourceVersionUpdateManyWithWhereWithoutDataSourceInput = {
  data: DataSourceVersionUpdateManyMutationInput;
  where: DataSourceVersionScalarWhereInput;
};

export type DataSourceVersionUpdateManyWithoutDataSourceNestedInput = {
  connect?: InputMaybe<Array<DataSourceVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataSourceVersionCreateOrConnectWithoutDataSourceInput>>;
  create?: InputMaybe<Array<DataSourceVersionCreateWithoutDataSourceInput>>;
  createMany?: InputMaybe<DataSourceVersionCreateManyDataSourceInputEnvelope>;
  delete?: InputMaybe<Array<DataSourceVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DataSourceVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DataSourceVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<DataSourceVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<DataSourceVersionUpdateWithWhereUniqueWithoutDataSourceInput>>;
  updateMany?: InputMaybe<Array<DataSourceVersionUpdateManyWithWhereWithoutDataSourceInput>>;
  upsert?: InputMaybe<Array<DataSourceVersionUpsertWithWhereUniqueWithoutDataSourceInput>>;
};

export type DataSourceVersionUpdateOneRequiredWithoutCellsNestedInput = {
  connect?: InputMaybe<DataSourceVersionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DataSourceVersionCreateOrConnectWithoutCellsInput>;
  create?: InputMaybe<DataSourceVersionCreateWithoutCellsInput>;
  update?: InputMaybe<DataSourceVersionUpdateToOneWithWhereWithoutCellsInput>;
  upsert?: InputMaybe<DataSourceVersionUpsertWithoutCellsInput>;
};

export type DataSourceVersionUpdateOneRequiredWithoutOriginNestedInput = {
  connect?: InputMaybe<DataSourceVersionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DataSourceVersionCreateOrConnectWithoutOriginInput>;
  create?: InputMaybe<DataSourceVersionCreateWithoutOriginInput>;
  update?: InputMaybe<DataSourceVersionUpdateToOneWithWhereWithoutOriginInput>;
  upsert?: InputMaybe<DataSourceVersionUpsertWithoutOriginInput>;
};

export type DataSourceVersionUpdateToOneWithWhereWithoutCellsInput = {
  data: DataSourceVersionUpdateWithoutCellsInput;
  where?: InputMaybe<DataSourceVersionWhereInput>;
};

export type DataSourceVersionUpdateToOneWithWhereWithoutOriginInput = {
  data: DataSourceVersionUpdateWithoutOriginInput;
  where?: InputMaybe<DataSourceVersionWhereInput>;
};

export type DataSourceVersionUpdateWithWhereUniqueWithoutDataSourceInput = {
  data: DataSourceVersionUpdateWithoutDataSourceInput;
  where: DataSourceVersionWhereUniqueInput;
};

export type DataSourceVersionUpdateWithoutCellsInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  columns?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dataSource?: InputMaybe<DataSourceUpdateOneRequiredWithoutVersionsNestedInput>;
  hash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mappingRules?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<EnumDataSourceTypeFieldUpdateOperationsInput>;
  usedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validationRules?: InputMaybe<Scalars['JSON']['input']>;
};

export type DataSourceVersionUpdateWithoutDataSourceInput = {
  cells?: InputMaybe<DataSourceCellUpdateManyWithoutLastVersionNestedInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  columns?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  hash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mappingRules?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<EnumDataSourceTypeFieldUpdateOperationsInput>;
  usedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validationRules?: InputMaybe<Scalars['JSON']['input']>;
};

export type DataSourceVersionUpdateWithoutOriginInput = {
  cells?: InputMaybe<DataSourceCellUpdateManyWithoutLastVersionNestedInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  columns?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dataSource?: InputMaybe<DataSourceUpdateOneRequiredWithoutVersionsNestedInput>;
  hash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mappingRules?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<EnumDataSourceTypeFieldUpdateOperationsInput>;
  usedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validationRules?: InputMaybe<Scalars['JSON']['input']>;
};

export type DataSourceVersionUpsertWithWhereUniqueWithoutDataSourceInput = {
  create: DataSourceVersionCreateWithoutDataSourceInput;
  update: DataSourceVersionUpdateWithoutDataSourceInput;
  where: DataSourceVersionWhereUniqueInput;
};

export type DataSourceVersionUpsertWithoutCellsInput = {
  create: DataSourceVersionCreateWithoutCellsInput;
  update: DataSourceVersionUpdateWithoutCellsInput;
  where?: InputMaybe<DataSourceVersionWhereInput>;
};

export type DataSourceVersionUpsertWithoutOriginInput = {
  create: DataSourceVersionCreateWithoutOriginInput;
  update: DataSourceVersionUpdateWithoutOriginInput;
  where?: InputMaybe<DataSourceVersionWhereInput>;
};

export type DataSourceVersionWhereInput = {
  AND?: InputMaybe<Array<DataSourceVersionWhereInput>>;
  NOT?: InputMaybe<Array<DataSourceVersionWhereInput>>;
  OR?: InputMaybe<Array<DataSourceVersionWhereInput>>;
  cells?: InputMaybe<DataSourceCellListRelationFilter>;
  code?: InputMaybe<StringFilter>;
  columns?: InputMaybe<JsonFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  dataSource?: InputMaybe<DataSourceScalarRelationFilter>;
  dataSourceId?: InputMaybe<IntFilter>;
  hash?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mappingRules?: InputMaybe<JsonNullableFilter>;
  type?: InputMaybe<EnumDataSourceTypeFilter>;
  usedAt?: InputMaybe<DateTimeNullableFilter>;
  validationRules?: InputMaybe<JsonNullableFilter>;
};

export type DataSourceVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<DataSourceVersionWhereInput>>;
  NOT?: InputMaybe<Array<DataSourceVersionWhereInput>>;
  OR?: InputMaybe<Array<DataSourceVersionWhereInput>>;
  cells?: InputMaybe<DataSourceCellListRelationFilter>;
  code?: InputMaybe<StringFilter>;
  columns?: InputMaybe<JsonFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  dataSource?: InputMaybe<DataSourceScalarRelationFilter>;
  dataSourceId?: InputMaybe<IntFilter>;
  hash?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mappingRules?: InputMaybe<JsonNullableFilter>;
  type?: InputMaybe<EnumDataSourceTypeFilter>;
  usedAt?: InputMaybe<DateTimeNullableFilter>;
  validationRules?: InputMaybe<JsonNullableFilter>;
};

export type DataSourceWhereInput = {
  AND?: InputMaybe<Array<DataSourceWhereInput>>;
  NOT?: InputMaybe<Array<DataSourceWhereInput>>;
  OR?: InputMaybe<Array<DataSourceWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  includeInFreshness?: InputMaybe<BoolFilter>;
  isSharedWithAdmin?: InputMaybe<BoolNullableFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  versions?: InputMaybe<DataSourceVersionListRelationFilter>;
};

export type DataSourceWhereUniqueInput = {
  AND?: InputMaybe<Array<DataSourceWhereInput>>;
  NOT?: InputMaybe<Array<DataSourceWhereInput>>;
  OR?: InputMaybe<Array<DataSourceWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeInFreshness?: InputMaybe<BoolFilter>;
  isSharedWithAdmin?: InputMaybe<BoolNullableFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  versions?: InputMaybe<DataSourceVersionListRelationFilter>;
};

export enum DateMode {
  Date = 'date',
  Datetime = 'datetime'
}

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['Timestamp']['input']>;
  gt?: InputMaybe<Scalars['Timestamp']['input']>;
  gte?: InputMaybe<Scalars['Timestamp']['input']>;
  in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  lt?: InputMaybe<Scalars['Timestamp']['input']>;
  lte?: InputMaybe<Scalars['Timestamp']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['Timestamp']['input']>;
  gt?: InputMaybe<Scalars['Timestamp']['input']>;
  gte?: InputMaybe<Scalars['Timestamp']['input']>;
  in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  lt?: InputMaybe<Scalars['Timestamp']['input']>;
  lte?: InputMaybe<Scalars['Timestamp']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
};

export type DateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['Timestamp']['input']>;
  gt?: InputMaybe<Scalars['Timestamp']['input']>;
  gte?: InputMaybe<Scalars['Timestamp']['input']>;
  in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  lt?: InputMaybe<Scalars['Timestamp']['input']>;
  lte?: InputMaybe<Scalars['Timestamp']['input']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
};

export type DateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['Timestamp']['input']>;
  gt?: InputMaybe<Scalars['Timestamp']['input']>;
  gte?: InputMaybe<Scalars['Timestamp']['input']>;
  in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  lt?: InputMaybe<Scalars['Timestamp']['input']>;
  lte?: InputMaybe<Scalars['Timestamp']['input']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
};

export type DefaultInfo = {
  __typename?: 'DefaultInfo';
  defaultFrontendClient: KeycloakClient;
  default_app_url: Scalars['String']['output'];
  keycloakServerInfo: KeycloakServerInfo;
};

export type EnumDataSourceTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<DataSourceType>;
};

export type EnumDataSourceTypeFilter = {
  equals?: InputMaybe<DataSourceType>;
  in?: InputMaybe<Array<DataSourceType>>;
  not?: InputMaybe<NestedEnumDataSourceTypeFilter>;
  notIn?: InputMaybe<Array<DataSourceType>>;
};

export type EnumDataSourceTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDataSourceTypeFilter>;
  _min?: InputMaybe<NestedEnumDataSourceTypeFilter>;
  equals?: InputMaybe<DataSourceType>;
  in?: InputMaybe<Array<DataSourceType>>;
  not?: InputMaybe<NestedEnumDataSourceTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DataSourceType>>;
};

export type EnumDateModeNullableFilter = {
  equals?: InputMaybe<DateMode>;
  in?: InputMaybe<Array<DateMode>>;
  not?: InputMaybe<NestedEnumDateModeNullableFilter>;
  notIn?: InputMaybe<Array<DateMode>>;
};

export type EnumFiltersSourceTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<FiltersSourceType>;
};

export type EnumFiltersSourceTypeFilter = {
  equals?: InputMaybe<FiltersSourceType>;
  in?: InputMaybe<Array<FiltersSourceType>>;
  not?: InputMaybe<NestedEnumFiltersSourceTypeFilter>;
  notIn?: InputMaybe<Array<FiltersSourceType>>;
};

export type EnumFiltersSourceTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumFiltersSourceTypeFilter>;
  _min?: InputMaybe<NestedEnumFiltersSourceTypeFilter>;
  equals?: InputMaybe<FiltersSourceType>;
  in?: InputMaybe<Array<FiltersSourceType>>;
  not?: InputMaybe<NestedEnumFiltersSourceTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<FiltersSourceType>>;
};

export type EnumProposalTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ProposalType>;
};

export type EnumProposalTypeFilter = {
  equals?: InputMaybe<ProposalType>;
  in?: InputMaybe<Array<ProposalType>>;
  not?: InputMaybe<NestedEnumProposalTypeFilter>;
  notIn?: InputMaybe<Array<ProposalType>>;
};

export type EnumTemplateTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<TemplateType>;
};

export type EnumTemplateTypeFilter = {
  equals?: InputMaybe<TemplateType>;
  in?: InputMaybe<Array<TemplateType>>;
  not?: InputMaybe<NestedEnumTemplateTypeFilter>;
  notIn?: InputMaybe<Array<TemplateType>>;
};

export type EnumTemplateTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumTemplateTypeFilter>;
  _min?: InputMaybe<NestedEnumTemplateTypeFilter>;
  equals?: InputMaybe<TemplateType>;
  in?: InputMaybe<Array<TemplateType>>;
  not?: InputMaybe<NestedEnumTemplateTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<TemplateType>>;
};

export type EventAggregationByInterval = {
  __typename?: 'EventAggregationByInterval';
  buckets: Array<AggregationBucket>;
  event: BaseEventType;
};

export enum Feature {
  FreshnessDataUsed = 'freshnessDataUsed'
}

export type Features = {
  __typename?: 'Features';
  delete_clients: Scalars['Boolean']['output'];
  dynamic_client_databases_management: Scalars['Boolean']['output'];
  new_proposals_ui: Scalars['Boolean']['output'];
};

export type FederatedIdentityRepresentation = {
  __typename?: 'FederatedIdentityRepresentation';
  identityProvider: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type Field = {
  fieldUUID: Scalars['String']['input'];
  in: Array<InputMaybe<Scalars['NumberStringBoolean']['input']>>;
};

export enum FiltersSourceType {
  ProposalField = 'PROPOSAL_FIELD',
  ProposalIds = 'PROPOSAL_IDS',
  ProposalOwners = 'PROPOSAL_OWNERS'
}

export type FloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type IdInt = {
  id: Scalars['Int']['input'];
};

export type InsightAuditChangeBreakdown = {
  __typename?: 'InsightAuditChangeBreakdown';
  columnsAffected: Array<Scalars['String']['output']>;
  pageBreakdown: Array<InsightAuditPageBreakdown>;
  pagesAffected: Array<Scalars['String']['output']>;
  rowsAffected: Scalars['Int']['output'];
  versionId: Scalars['Int']['output'];
};

export type InsightAuditChangeItem = {
  __typename?: 'InsightAuditChangeItem';
  createdAt: Scalars['Timestamp']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  insightId: Scalars['Int']['output'];
  insightName: Scalars['String']['output'];
  sequentialNumber: Scalars['Int']['output'];
};

export type InsightAuditChangesPaginated = {
  __typename?: 'InsightAuditChangesPaginated';
  count: Scalars['Int']['output'];
  items: Array<InsightAuditChangeItem>;
};

export type InsightAuditPageBreakdown = {
  __typename?: 'InsightAuditPageBreakdown';
  columnNames: Array<Scalars['String']['output']>;
  pageName: Scalars['String']['output'];
  pageUuid: Scalars['String']['output'];
  rowsAffected: Scalars['Int']['output'];
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedIntNullableFilter>;
  _min?: InputMaybe<NestedIntNullableFilter>;
  _sum?: InputMaybe<NestedIntNullableFilter>;
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type JsonFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type JsonNullableFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type JsonNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedJsonNullableFilter>;
  _min?: InputMaybe<NestedJsonNullableFilter>;
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type JsonWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedJsonFilter>;
  _min?: InputMaybe<NestedJsonFilter>;
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type KeycloakClient = {
  __typename?: 'KeycloakClient';
  attributes?: Maybe<KeycloakClientAttributes>;
  id: Scalars['String']['output'];
};

export type KeycloakClientAttributes = {
  __typename?: 'KeycloakClientAttributes';
  login_theme?: Maybe<Scalars['String']['output']>;
};

export type KeycloakClientAttributesInput = {
  login_theme?: InputMaybe<Scalars['String']['input']>;
};

export type KeycloakClientInput = {
  attributes?: InputMaybe<KeycloakClientAttributesInput>;
  id: Scalars['String']['input'];
};

export type KeycloakGroup = {
  __typename?: 'KeycloakGroup';
  access?: Maybe<Scalars['JSON']['output']>;
  attributes?: Maybe<Scalars['JSON']['output']>;
  clientRoles?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  realmRoles?: Maybe<Array<Scalars['String']['output']>>;
  subGroups?: Maybe<Array<KeycloakGroup>>;
};

export type KeycloakServerInfo = {
  __typename?: 'KeycloakServerInfo';
  themes?: Maybe<KeycloakThemes>;
};

export type KeycloakThemes = {
  __typename?: 'KeycloakThemes';
  account?: Maybe<Array<ThemeInfoRepresentation>>;
  admin?: Maybe<Array<ThemeInfoRepresentation>>;
  common?: Maybe<Array<ThemeInfoRepresentation>>;
  email?: Maybe<Array<ThemeInfoRepresentation>>;
  login?: Maybe<Array<ThemeInfoRepresentation>>;
  welcome?: Maybe<Array<ThemeInfoRepresentation>>;
};

export type KeycloakUser = {
  __typename?: 'KeycloakUser';
  clientConsents?: Maybe<Array<UserConsentRepresentation>>;
  createdTimestamp?: Maybe<Scalars['Float']['output']>;
  credentials?: Maybe<Array<CredentialRepresentation>>;
  disableableCredentialTypes?: Maybe<Array<Scalars['String']['output']>>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  federatedIdentities?: Maybe<Array<FederatedIdentityRepresentation>>;
  federationLink?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  lastLoginDate?: Maybe<Scalars['Float']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSentEmailDate?: Maybe<Scalars['Float']['output']>;
  notBefore?: Maybe<Scalars['Float']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  realm?: Maybe<Scalars['String']['output']>;
  realmRoles?: Maybe<Array<Scalars['String']['output']>>;
  requiredActions?: Maybe<Array<Scalars['String']['output']>>;
  role?: Maybe<Role>;
  self?: Maybe<Scalars['String']['output']>;
  serviceAccountClientId?: Maybe<Scalars['String']['output']>;
  subGroups: Array<KeycloakGroup>;
  totp?: Maybe<Scalars['Boolean']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type KeycloakUserProtected = {
  __typename?: 'KeycloakUserProtected';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type LogAuditEventInput = {
  proposalDownload?: InputMaybe<ProposalDownloadAuditEventInput>;
  proposalInteraction?: InputMaybe<ProposalInteractionAuditEventInput>;
  userLogin?: InputMaybe<UserLoginAuditEventInput>;
  userLogout?: InputMaybe<UserLogoutAuditEventInput>;
};

export enum LogicalOperator {
  And = 'AND',
  Or = 'OR'
}

export type Lookup = {
  __typename?: 'Lookup';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['Int']['output'];
  labelKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options: Scalars['JSON']['output'];
  updatedAt: Scalars['Timestamp']['output'];
  usedAt?: Maybe<Scalars['Timestamp']['output']>;
  valueKey: Scalars['String']['output'];
};

export type LookupAvgAggregate = {
  __typename?: 'LookupAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type LookupAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type LookupCountAggregate = {
  __typename?: 'LookupCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  labelKey: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  options: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  usedAt: Scalars['Int']['output'];
  valueKey: Scalars['Int']['output'];
};

export type LookupCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  labelKey?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  options?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  usedAt?: InputMaybe<SortOrder>;
  valueKey?: InputMaybe<SortOrder>;
};

export type LookupCreateInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  labelKey: Scalars['String']['input'];
  name: Scalars['String']['input'];
  options: Scalars['JSON']['input'];
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  usedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  valueKey: Scalars['String']['input'];
};

export type LookupCreateManyInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  labelKey: Scalars['String']['input'];
  name: Scalars['String']['input'];
  options: Scalars['JSON']['input'];
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  usedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  valueKey: Scalars['String']['input'];
};

export type LookupGroupBy = {
  __typename?: 'LookupGroupBy';
  _avg?: Maybe<LookupAvgAggregate>;
  _count?: Maybe<LookupCountAggregate>;
  _max?: Maybe<LookupMaxAggregate>;
  _min?: Maybe<LookupMinAggregate>;
  _sum?: Maybe<LookupSumAggregate>;
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['Int']['output'];
  labelKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options: Scalars['JSON']['output'];
  updatedAt: Scalars['Timestamp']['output'];
  usedAt?: Maybe<Scalars['Timestamp']['output']>;
  valueKey: Scalars['String']['output'];
};

export type LookupMaxAggregate = {
  __typename?: 'LookupMaxAggregate';
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  labelKey?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Timestamp']['output']>;
  usedAt?: Maybe<Scalars['Timestamp']['output']>;
  valueKey?: Maybe<Scalars['String']['output']>;
};

export type LookupMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  labelKey?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  usedAt?: InputMaybe<SortOrder>;
  valueKey?: InputMaybe<SortOrder>;
};

export type LookupMinAggregate = {
  __typename?: 'LookupMinAggregate';
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  labelKey?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Timestamp']['output']>;
  usedAt?: Maybe<Scalars['Timestamp']['output']>;
  valueKey?: Maybe<Scalars['String']['output']>;
};

export type LookupMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  labelKey?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  usedAt?: InputMaybe<SortOrder>;
  valueKey?: InputMaybe<SortOrder>;
};

export enum LookupOrderByRelevanceFieldEnum {
  LabelKey = 'labelKey',
  Name = 'name',
  ValueKey = 'valueKey'
}

export type LookupOrderByRelevanceInput = {
  fields: Array<LookupOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type LookupOrderByWithAggregationInput = {
  _avg?: InputMaybe<LookupAvgOrderByAggregateInput>;
  _count?: InputMaybe<LookupCountOrderByAggregateInput>;
  _max?: InputMaybe<LookupMaxOrderByAggregateInput>;
  _min?: InputMaybe<LookupMinOrderByAggregateInput>;
  _sum?: InputMaybe<LookupSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  labelKey?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  options?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  usedAt?: InputMaybe<SortOrderInput>;
  valueKey?: InputMaybe<SortOrder>;
};

export type LookupOrderByWithRelationInput = {
  _relevance?: InputMaybe<LookupOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  labelKey?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  options?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  usedAt?: InputMaybe<SortOrderInput>;
  valueKey?: InputMaybe<SortOrder>;
};

export enum LookupScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  LabelKey = 'labelKey',
  Name = 'name',
  Options = 'options',
  UpdatedAt = 'updatedAt',
  UsedAt = 'usedAt',
  ValueKey = 'valueKey'
}

export type LookupScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<LookupScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<LookupScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<LookupScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  labelKey?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  options?: InputMaybe<JsonWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  usedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  valueKey?: InputMaybe<StringWithAggregatesFilter>;
};

export type LookupSumAggregate = {
  __typename?: 'LookupSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
};

export type LookupSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type LookupUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  labelKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  usedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  valueKey?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LookupUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  labelKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  usedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  valueKey?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LookupWhereInput = {
  AND?: InputMaybe<Array<LookupWhereInput>>;
  NOT?: InputMaybe<Array<LookupWhereInput>>;
  OR?: InputMaybe<Array<LookupWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  labelKey?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  options?: InputMaybe<JsonFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  usedAt?: InputMaybe<DateTimeNullableFilter>;
  valueKey?: InputMaybe<StringFilter>;
};

export type LookupWhereUniqueInput = {
  AND?: InputMaybe<Array<LookupWhereInput>>;
  NOT?: InputMaybe<Array<LookupWhereInput>>;
  OR?: InputMaybe<Array<LookupWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  labelKey?: InputMaybe<StringFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<JsonFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  usedAt?: InputMaybe<DateTimeNullableFilter>;
  valueKey?: InputMaybe<StringFilter>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createClient: Client;
  createManyAnalyticsDashboard: AffectedRowsOutput;
  createManyAnalyticsDashboardChart: AffectedRowsOutput;
  createManyAnalyticsDashboardFiltersSource: AffectedRowsOutput;
  createManyDataSource: AffectedRowsOutput;
  createManyDataSourceCell: AffectedRowsOutput;
  createManyDataSourceVersion: AffectedRowsOutput;
  createManyDataSourceVersionOrigin: AffectedRowsOutput;
  createManyLookup: AffectedRowsOutput;
  createManyNote: AffectedRowsOutput;
  createManyProposalTemplate: AffectedRowsOutput;
  createManyUserProposalAccess: AffectedRowsOutput;
  createOneAnalyticsDashboard: AnalyticsDashboard;
  createOneAnalyticsDashboardChart: AnalyticsDashboardChart;
  createOneAnalyticsDashboardFiltersSource: AnalyticsDashboardFiltersSource;
  createOneDataSource: DataSource;
  createOneDataSourceCell: DataSourceCell;
  createOneDataSourceVersion: DataSourceVersion;
  createOneDataSourceVersionOrigin: DataSourceVersionOrigin;
  createOneLookup: Lookup;
  createOneNote: Note;
  createOneProposal: Proposal;
  createOneProposalTemplate: ProposalTemplate;
  createOneUserProposalAccess: UserProposalAccess;
  /** Returns id of created user */
  createUser: Scalars['String']['output'];
  dataSourceCreate: DataSource;
  dataSourceDelete: DataSource;
  dataSourceUpdate: DataSource;
  /** delete client, return id of deleted client */
  deleteClient: Scalars['String']['output'];
  deleteCredential: Scalars['Boolean']['output'];
  deleteManyAnalyticsDashboard: AffectedRowsOutput;
  deleteManyAnalyticsDashboardChart: AffectedRowsOutput;
  deleteManyAnalyticsDashboardFiltersSource: AffectedRowsOutput;
  deleteManyDataSource: AffectedRowsOutput;
  deleteManyDataSourceCell: AffectedRowsOutput;
  deleteManyDataSourceVersion: AffectedRowsOutput;
  deleteManyDataSourceVersionOrigin: AffectedRowsOutput;
  deleteManyLookup: AffectedRowsOutput;
  deleteManyNote: AffectedRowsOutput;
  deleteManyProposal: AffectedRowsOutput;
  deleteManyProposalTemplate: AffectedRowsOutput;
  deleteManyUserProposalAccess: AffectedRowsOutput;
  deleteOneAnalyticsDashboard?: Maybe<AnalyticsDashboard>;
  deleteOneAnalyticsDashboardChart?: Maybe<AnalyticsDashboardChart>;
  deleteOneAnalyticsDashboardFiltersSource?: Maybe<AnalyticsDashboardFiltersSource>;
  deleteOneDataSource?: Maybe<DataSource>;
  deleteOneDataSourceCell?: Maybe<DataSourceCell>;
  deleteOneDataSourceVersion?: Maybe<DataSourceVersion>;
  deleteOneDataSourceVersionOrigin?: Maybe<DataSourceVersionOrigin>;
  deleteOneLookup?: Maybe<Lookup>;
  deleteOneNote?: Maybe<Note>;
  deleteOneProposal?: Maybe<Proposal>;
  deleteOneProposalTemplate?: Maybe<ProposalTemplate>;
  deleteOneUserProposalAccess?: Maybe<UserProposalAccess>;
  deleteSubGroup: Scalars['String']['output'];
  deleteTemplate: ProposalTemplate;
  deleteUser: Scalars['String']['output'];
  logAuditEvent: Scalars['Boolean']['output'];
  patchExistingProposals: Scalars['Boolean']['output'];
  proposalEditorCheckInClosed: Scalars['Boolean']['output'];
  proposalEditorCheckInOpened?: Maybe<Scalars['String']['output']>;
  saveProposalMetrics: Scalars['Boolean']['output'];
  sendUpdatePasswordEmail: Scalars['String']['output'];
  setProposalPinned: Scalars['Boolean']['output'];
  syncUserActivity: Scalars['String']['output'];
  templateCreate: ProposalTemplate;
  templatePublishUpdate: ProposalTemplate;
  templateUpdate: ProposalTemplate;
  updateAnalyticsDashboard: AnalyticsDashboard;
  updateClient: Client;
  /** Disable/enable client, returns id of client */
  updateClientEnabledStatus: Scalars['String']['output'];
  updateDefaultTemplate: ProposalTemplate;
  updateKeycloakClient: KeycloakClient;
  updateManyAnalyticsDashboard: AffectedRowsOutput;
  updateManyAnalyticsDashboardChart: AffectedRowsOutput;
  updateManyAnalyticsDashboardFiltersSource: AffectedRowsOutput;
  updateManyDataSource: AffectedRowsOutput;
  updateManyDataSourceCell: AffectedRowsOutput;
  updateManyDataSourceVersion: AffectedRowsOutput;
  updateManyDataSourceVersionOrigin: AffectedRowsOutput;
  updateManyLookup: AffectedRowsOutput;
  updateManyNote: AffectedRowsOutput;
  updateManyProposalTemplate: AffectedRowsOutput;
  updateManyUserProposalAccess: AffectedRowsOutput;
  updateOneAnalyticsDashboard?: Maybe<AnalyticsDashboard>;
  updateOneAnalyticsDashboardChart?: Maybe<AnalyticsDashboardChart>;
  updateOneAnalyticsDashboardFiltersSource?: Maybe<AnalyticsDashboardFiltersSource>;
  updateOneDataSource?: Maybe<DataSource>;
  updateOneDataSourceCell?: Maybe<DataSourceCell>;
  updateOneDataSourceVersion?: Maybe<DataSourceVersion>;
  updateOneDataSourceVersionOrigin?: Maybe<DataSourceVersionOrigin>;
  updateOneLookup?: Maybe<Lookup>;
  updateOneNote?: Maybe<Note>;
  updateOneProposal?: Maybe<Proposal>;
  updateOneProposalTemplate?: Maybe<ProposalTemplate>;
  updateOneUserProposalAccess?: Maybe<UserProposalAccess>;
  updateUserEnabledStatus: Scalars['String']['output'];
  updateUserGroup: Scalars['String']['output'];
  updateUserRole: Scalars['String']['output'];
  updateUserSubGroup?: Maybe<Scalars['String']['output']>;
  upsertOneAnalyticsDashboard: AnalyticsDashboard;
  upsertOneAnalyticsDashboardChart: AnalyticsDashboardChart;
  upsertOneAnalyticsDashboardFiltersSource: AnalyticsDashboardFiltersSource;
  upsertOneDataSource: DataSource;
  upsertOneDataSourceCell: DataSourceCell;
  upsertOneDataSourceVersion: DataSourceVersion;
  upsertOneDataSourceVersionOrigin: DataSourceVersionOrigin;
  upsertOneLookup: Lookup;
  upsertOneNote: Note;
  upsertOneProposalTemplate: ProposalTemplate;
  upsertOneUserProposalAccess: UserProposalAccess;
};


export type MutationCreateClientArgs = {
  client: ClientInput;
};


export type MutationCreateManyAnalyticsDashboardArgs = {
  data: Array<AnalyticsDashboardCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyAnalyticsDashboardChartArgs = {
  data: Array<AnalyticsDashboardChartCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyAnalyticsDashboardFiltersSourceArgs = {
  data: Array<AnalyticsDashboardFiltersSourceCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyDataSourceArgs = {
  data: Array<DataSourceCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyDataSourceCellArgs = {
  data: Array<DataSourceCellCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyDataSourceVersionArgs = {
  data: Array<DataSourceVersionCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyDataSourceVersionOriginArgs = {
  data: Array<DataSourceVersionOriginCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyLookupArgs = {
  data: Array<LookupCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyNoteArgs = {
  data: Array<NoteCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyProposalTemplateArgs = {
  data: Array<ProposalTemplateCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyUserProposalAccessArgs = {
  data: Array<UserProposalAccessCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateOneAnalyticsDashboardArgs = {
  data: AnalyticsDashboardCreateInput;
};


export type MutationCreateOneAnalyticsDashboardChartArgs = {
  data: AnalyticsDashboardChartCreateInput;
};


export type MutationCreateOneAnalyticsDashboardFiltersSourceArgs = {
  data: AnalyticsDashboardFiltersSourceCreateInput;
};


export type MutationCreateOneDataSourceArgs = {
  data: DataSourceCreateInput;
};


export type MutationCreateOneDataSourceCellArgs = {
  data: DataSourceCellCreateInput;
};


export type MutationCreateOneDataSourceVersionArgs = {
  data: DataSourceVersionCreateInput;
};


export type MutationCreateOneDataSourceVersionOriginArgs = {
  data: DataSourceVersionOriginCreateInput;
};


export type MutationCreateOneLookupArgs = {
  data: LookupCreateInput;
};


export type MutationCreateOneNoteArgs = {
  data: NoteCreateInput;
};


export type MutationCreateOneProposalArgs = {
  data: ProposalCreateInput;
};


export type MutationCreateOneProposalTemplateArgs = {
  data: ProposalTemplateCreateInput;
};


export type MutationCreateOneUserProposalAccessArgs = {
  data: UserProposalAccessCreateInput;
};


export type MutationCreateUserArgs = {
  user: UserCreateInput;
};


export type MutationDataSourceCreateArgs = {
  data: DataSourceSaveResolverCreateInput;
};


export type MutationDataSourceDeleteArgs = {
  deleteProposals?: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};


export type MutationDataSourceUpdateArgs = {
  data: DataSourceSaveResolverUpdateInput;
};


export type MutationDeleteClientArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteCredentialArgs = {
  credentialId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationDeleteManyAnalyticsDashboardArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnalyticsDashboardWhereInput>;
};


export type MutationDeleteManyAnalyticsDashboardChartArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnalyticsDashboardChartWhereInput>;
};


export type MutationDeleteManyAnalyticsDashboardFiltersSourceArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnalyticsDashboardFiltersSourceWhereInput>;
};


export type MutationDeleteManyDataSourceArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceWhereInput>;
};


export type MutationDeleteManyDataSourceCellArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceCellWhereInput>;
};


export type MutationDeleteManyDataSourceVersionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceVersionWhereInput>;
};


export type MutationDeleteManyDataSourceVersionOriginArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceVersionOriginWhereInput>;
};


export type MutationDeleteManyLookupArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LookupWhereInput>;
};


export type MutationDeleteManyNoteArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NoteWhereInput>;
};


export type MutationDeleteManyProposalArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalWhereInput>;
};


export type MutationDeleteManyProposalTemplateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalTemplateWhereInput>;
};


export type MutationDeleteManyUserProposalAccessArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProposalAccessWhereInput>;
};


export type MutationDeleteOneAnalyticsDashboardArgs = {
  where: AnalyticsDashboardWhereUniqueInput;
};


export type MutationDeleteOneAnalyticsDashboardChartArgs = {
  where: AnalyticsDashboardChartWhereUniqueInput;
};


export type MutationDeleteOneAnalyticsDashboardFiltersSourceArgs = {
  where: AnalyticsDashboardFiltersSourceWhereUniqueInput;
};


export type MutationDeleteOneDataSourceArgs = {
  where: DataSourceWhereUniqueInput;
};


export type MutationDeleteOneDataSourceCellArgs = {
  where: DataSourceCellWhereUniqueInput;
};


export type MutationDeleteOneDataSourceVersionArgs = {
  where: DataSourceVersionWhereUniqueInput;
};


export type MutationDeleteOneDataSourceVersionOriginArgs = {
  where: DataSourceVersionOriginWhereUniqueInput;
};


export type MutationDeleteOneLookupArgs = {
  where: LookupWhereUniqueInput;
};


export type MutationDeleteOneNoteArgs = {
  where: NoteWhereUniqueInput;
};


export type MutationDeleteOneProposalArgs = {
  where: ProposalWhereUniqueInput;
};


export type MutationDeleteOneProposalTemplateArgs = {
  where: ProposalTemplateWhereUniqueInput;
};


export type MutationDeleteOneUserProposalAccessArgs = {
  where: UserProposalAccessWhereUniqueInput;
};


export type MutationDeleteSubGroupArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationLogAuditEventArgs = {
  input: LogAuditEventInput;
};


export type MutationPatchExistingProposalsArgs = {
  templateId: Scalars['Int']['input'];
};


export type MutationProposalEditorCheckInClosedArgs = {
  proposalId: Scalars['Int']['input'];
};


export type MutationProposalEditorCheckInOpenedArgs = {
  proposalId: Scalars['Int']['input'];
};


export type MutationSaveProposalMetricsArgs = {
  metrics: Array<ProposalMetricSaveInput>;
  proposalId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSendUpdatePasswordEmailArgs = {
  emailLifeSpanSeconds?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  requiredActions?: InputMaybe<Array<RequiredAction>>;
};


export type MutationSetProposalPinnedArgs = {
  pinned: Scalars['Boolean']['input'];
  proposalId: Scalars['Int']['input'];
};


export type MutationSyncUserActivityArgs = {
  input?: InputMaybe<SyncUserActivityInput>;
};


export type MutationTemplateCreateArgs = {
  data: TemplateCreateInput;
};


export type MutationTemplatePublishUpdateArgs = {
  id: Scalars['Int']['input'];
  isPublished: Scalars['Boolean']['input'];
};


export type MutationTemplateUpdateArgs = {
  data: TemplateUpdateInput;
};


export type MutationUpdateAnalyticsDashboardArgs = {
  data: AppAnalyticsDashboardUpdateInput;
  where: AppAnalyticsDashboardWhereUniqueInput;
};


export type MutationUpdateClientArgs = {
  client: ClientInput;
  id: Scalars['Int']['input'];
};


export type MutationUpdateClientEnabledStatusArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};


export type MutationUpdateDefaultTemplateArgs = {
  id: Scalars['Int']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  type: TemplateType;
};


export type MutationUpdateKeycloakClientArgs = {
  keycloakClient: KeycloakClientInput;
};


export type MutationUpdateManyAnalyticsDashboardArgs = {
  data: AnalyticsDashboardUpdateManyMutationInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnalyticsDashboardWhereInput>;
};


export type MutationUpdateManyAnalyticsDashboardChartArgs = {
  data: AnalyticsDashboardChartUpdateManyMutationInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnalyticsDashboardChartWhereInput>;
};


export type MutationUpdateManyAnalyticsDashboardFiltersSourceArgs = {
  data: AnalyticsDashboardFiltersSourceUpdateManyMutationInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnalyticsDashboardFiltersSourceWhereInput>;
};


export type MutationUpdateManyDataSourceArgs = {
  data: DataSourceUpdateManyMutationInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceWhereInput>;
};


export type MutationUpdateManyDataSourceCellArgs = {
  data: DataSourceCellUpdateManyMutationInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceCellWhereInput>;
};


export type MutationUpdateManyDataSourceVersionArgs = {
  data: DataSourceVersionUpdateManyMutationInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceVersionWhereInput>;
};


export type MutationUpdateManyDataSourceVersionOriginArgs = {
  data: DataSourceVersionOriginUpdateManyMutationInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceVersionOriginWhereInput>;
};


export type MutationUpdateManyLookupArgs = {
  data: LookupUpdateManyMutationInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LookupWhereInput>;
};


export type MutationUpdateManyNoteArgs = {
  data: NoteUpdateManyMutationInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NoteWhereInput>;
};


export type MutationUpdateManyProposalTemplateArgs = {
  data: ProposalTemplateUpdateManyMutationInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalTemplateWhereInput>;
};


export type MutationUpdateManyUserProposalAccessArgs = {
  data: UserProposalAccessUpdateManyMutationInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProposalAccessWhereInput>;
};


export type MutationUpdateOneAnalyticsDashboardArgs = {
  data: AnalyticsDashboardUpdateInput;
  where: AnalyticsDashboardWhereUniqueInput;
};


export type MutationUpdateOneAnalyticsDashboardChartArgs = {
  data: AnalyticsDashboardChartUpdateInput;
  where: AnalyticsDashboardChartWhereUniqueInput;
};


export type MutationUpdateOneAnalyticsDashboardFiltersSourceArgs = {
  data: AnalyticsDashboardFiltersSourceUpdateInput;
  where: AnalyticsDashboardFiltersSourceWhereUniqueInput;
};


export type MutationUpdateOneDataSourceArgs = {
  data: DataSourceUpdateInput;
  where: DataSourceWhereUniqueInput;
};


export type MutationUpdateOneDataSourceCellArgs = {
  data: DataSourceCellUpdateInput;
  where: DataSourceCellWhereUniqueInput;
};


export type MutationUpdateOneDataSourceVersionArgs = {
  data: DataSourceVersionUpdateInput;
  where: DataSourceVersionWhereUniqueInput;
};


export type MutationUpdateOneDataSourceVersionOriginArgs = {
  data: DataSourceVersionOriginUpdateInput;
  where: DataSourceVersionOriginWhereUniqueInput;
};


export type MutationUpdateOneLookupArgs = {
  data: LookupUpdateInput;
  where: LookupWhereUniqueInput;
};


export type MutationUpdateOneNoteArgs = {
  data: NoteUpdateInput;
  where: NoteWhereUniqueInput;
};


export type MutationUpdateOneProposalArgs = {
  data: ProposalUpdateInput;
  where: ProposalWhereUniqueInput;
};


export type MutationUpdateOneProposalTemplateArgs = {
  data: ProposalTemplateUpdateInput;
  where: ProposalTemplateWhereUniqueInput;
};


export type MutationUpdateOneUserProposalAccessArgs = {
  data: UserProposalAccessUpdateInput;
  where: UserProposalAccessWhereUniqueInput;
};


export type MutationUpdateUserEnabledStatusArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};


export type MutationUpdateUserGroupArgs = {
  groupId: Scalars['String']['input'];
};


export type MutationUpdateUserRoleArgs = {
  role: Role;
  userId: Scalars['String']['input'];
};


export type MutationUpdateUserSubGroupArgs = {
  subGroupId?: InputMaybe<Scalars['String']['input']>;
  subGroupName: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUpsertOneAnalyticsDashboardArgs = {
  create: AnalyticsDashboardCreateInput;
  update: AnalyticsDashboardUpdateInput;
  where: AnalyticsDashboardWhereUniqueInput;
};


export type MutationUpsertOneAnalyticsDashboardChartArgs = {
  create: AnalyticsDashboardChartCreateInput;
  update: AnalyticsDashboardChartUpdateInput;
  where: AnalyticsDashboardChartWhereUniqueInput;
};


export type MutationUpsertOneAnalyticsDashboardFiltersSourceArgs = {
  create: AnalyticsDashboardFiltersSourceCreateInput;
  update: AnalyticsDashboardFiltersSourceUpdateInput;
  where: AnalyticsDashboardFiltersSourceWhereUniqueInput;
};


export type MutationUpsertOneDataSourceArgs = {
  create: DataSourceCreateInput;
  update: DataSourceUpdateInput;
  where: DataSourceWhereUniqueInput;
};


export type MutationUpsertOneDataSourceCellArgs = {
  create: DataSourceCellCreateInput;
  update: DataSourceCellUpdateInput;
  where: DataSourceCellWhereUniqueInput;
};


export type MutationUpsertOneDataSourceVersionArgs = {
  create: DataSourceVersionCreateInput;
  update: DataSourceVersionUpdateInput;
  where: DataSourceVersionWhereUniqueInput;
};


export type MutationUpsertOneDataSourceVersionOriginArgs = {
  create: DataSourceVersionOriginCreateInput;
  update: DataSourceVersionOriginUpdateInput;
  where: DataSourceVersionOriginWhereUniqueInput;
};


export type MutationUpsertOneLookupArgs = {
  create: LookupCreateInput;
  update: LookupUpdateInput;
  where: LookupWhereUniqueInput;
};


export type MutationUpsertOneNoteArgs = {
  create: NoteCreateInput;
  update: NoteUpdateInput;
  where: NoteWhereUniqueInput;
};


export type MutationUpsertOneProposalTemplateArgs = {
  create: ProposalTemplateCreateInput;
  update: ProposalTemplateUpdateInput;
  where: ProposalTemplateWhereUniqueInput;
};


export type MutationUpsertOneUserProposalAccessArgs = {
  create: UserProposalAccessCreateInput;
  update: UserProposalAccessUpdateInput;
  where: UserProposalAccessWhereUniqueInput;
};

export type NavigationPositionResp = {
  __typename?: 'NavigationPositionResp';
  data: Scalars['String']['output'];
};

export type NestedBigIntNullableFilter = {
  equals?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  not?: InputMaybe<NestedBigIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedBoolNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedBoolNullableFilter>;
  _min?: InputMaybe<NestedBoolNullableFilter>;
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableWithAggregatesFilter>;
};

export type NestedBoolWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedBoolFilter>;
  _min?: InputMaybe<NestedBoolFilter>;
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['Timestamp']['input']>;
  gt?: InputMaybe<Scalars['Timestamp']['input']>;
  gte?: InputMaybe<Scalars['Timestamp']['input']>;
  in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  lt?: InputMaybe<Scalars['Timestamp']['input']>;
  lte?: InputMaybe<Scalars['Timestamp']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['Timestamp']['input']>;
  gt?: InputMaybe<Scalars['Timestamp']['input']>;
  gte?: InputMaybe<Scalars['Timestamp']['input']>;
  in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  lt?: InputMaybe<Scalars['Timestamp']['input']>;
  lte?: InputMaybe<Scalars['Timestamp']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
};

export type NestedDateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['Timestamp']['input']>;
  gt?: InputMaybe<Scalars['Timestamp']['input']>;
  gte?: InputMaybe<Scalars['Timestamp']['input']>;
  in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  lt?: InputMaybe<Scalars['Timestamp']['input']>;
  lte?: InputMaybe<Scalars['Timestamp']['input']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
};

export type NestedDateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['Timestamp']['input']>;
  gt?: InputMaybe<Scalars['Timestamp']['input']>;
  gte?: InputMaybe<Scalars['Timestamp']['input']>;
  in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  lt?: InputMaybe<Scalars['Timestamp']['input']>;
  lte?: InputMaybe<Scalars['Timestamp']['input']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
};

export type NestedEnumDataSourceTypeFilter = {
  equals?: InputMaybe<DataSourceType>;
  in?: InputMaybe<Array<DataSourceType>>;
  not?: InputMaybe<NestedEnumDataSourceTypeFilter>;
  notIn?: InputMaybe<Array<DataSourceType>>;
};

export type NestedEnumDataSourceTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDataSourceTypeFilter>;
  _min?: InputMaybe<NestedEnumDataSourceTypeFilter>;
  equals?: InputMaybe<DataSourceType>;
  in?: InputMaybe<Array<DataSourceType>>;
  not?: InputMaybe<NestedEnumDataSourceTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DataSourceType>>;
};

export type NestedEnumDateModeNullableFilter = {
  equals?: InputMaybe<DateMode>;
  in?: InputMaybe<Array<DateMode>>;
  not?: InputMaybe<NestedEnumDateModeNullableFilter>;
  notIn?: InputMaybe<Array<DateMode>>;
};

export type NestedEnumFiltersSourceTypeFilter = {
  equals?: InputMaybe<FiltersSourceType>;
  in?: InputMaybe<Array<FiltersSourceType>>;
  not?: InputMaybe<NestedEnumFiltersSourceTypeFilter>;
  notIn?: InputMaybe<Array<FiltersSourceType>>;
};

export type NestedEnumFiltersSourceTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumFiltersSourceTypeFilter>;
  _min?: InputMaybe<NestedEnumFiltersSourceTypeFilter>;
  equals?: InputMaybe<FiltersSourceType>;
  in?: InputMaybe<Array<FiltersSourceType>>;
  not?: InputMaybe<NestedEnumFiltersSourceTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<FiltersSourceType>>;
};

export type NestedEnumProposalTypeFilter = {
  equals?: InputMaybe<ProposalType>;
  in?: InputMaybe<Array<ProposalType>>;
  not?: InputMaybe<NestedEnumProposalTypeFilter>;
  notIn?: InputMaybe<Array<ProposalType>>;
};

export type NestedEnumTemplateTypeFilter = {
  equals?: InputMaybe<TemplateType>;
  in?: InputMaybe<Array<TemplateType>>;
  not?: InputMaybe<NestedEnumTemplateTypeFilter>;
  notIn?: InputMaybe<Array<TemplateType>>;
};

export type NestedEnumTemplateTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumTemplateTypeFilter>;
  _min?: InputMaybe<NestedEnumTemplateTypeFilter>;
  equals?: InputMaybe<TemplateType>;
  in?: InputMaybe<Array<TemplateType>>;
  not?: InputMaybe<NestedEnumTemplateTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<TemplateType>>;
};

export type NestedFloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedFloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedIntNullableFilter>;
  _min?: InputMaybe<NestedIntNullableFilter>;
  _sum?: InputMaybe<NestedIntNullableFilter>;
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedJsonFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type NestedJsonNullableFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Note = {
  __typename?: 'Note';
  content: Scalars['String']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  pageId: Scalars['String']['output'];
  proposal: Proposal;
  proposalId: Scalars['Int']['output'];
};

export type NoteAvgAggregate = {
  __typename?: 'NoteAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  proposalId?: Maybe<Scalars['Float']['output']>;
};

export type NoteAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  proposalId?: InputMaybe<SortOrder>;
};

export type NoteCountAggregate = {
  __typename?: 'NoteCountAggregate';
  _all: Scalars['Int']['output'];
  content: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  pageId: Scalars['Int']['output'];
  proposalId: Scalars['Int']['output'];
};

export type NoteCountOrderByAggregateInput = {
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pageId?: InputMaybe<SortOrder>;
  proposalId?: InputMaybe<SortOrder>;
};

export type NoteCreateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  proposal: ProposalCreateNestedOneWithoutNotesInput;
};

export type NoteCreateManyInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  pageId: Scalars['String']['input'];
  proposalId: Scalars['Int']['input'];
};

export type NoteCreateManyProposalInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  pageId: Scalars['String']['input'];
};

export type NoteCreateManyProposalInputEnvelope = {
  data: Array<NoteCreateManyProposalInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NoteCreateNestedManyWithoutProposalInput = {
  connect?: InputMaybe<Array<NoteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NoteCreateOrConnectWithoutProposalInput>>;
  create?: InputMaybe<Array<NoteCreateWithoutProposalInput>>;
  createMany?: InputMaybe<NoteCreateManyProposalInputEnvelope>;
};

export type NoteCreateOrConnectWithoutProposalInput = {
  create: NoteCreateWithoutProposalInput;
  where: NoteWhereUniqueInput;
};

export type NoteCreateWithoutProposalInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};

export type NoteGroupBy = {
  __typename?: 'NoteGroupBy';
  _avg?: Maybe<NoteAvgAggregate>;
  _count?: Maybe<NoteCountAggregate>;
  _max?: Maybe<NoteMaxAggregate>;
  _min?: Maybe<NoteMinAggregate>;
  _sum?: Maybe<NoteSumAggregate>;
  content: Scalars['String']['output'];
  createdAt: Scalars['Timestamp']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  pageId: Scalars['String']['output'];
  proposalId: Scalars['Int']['output'];
};

export type NoteListRelationFilter = {
  every?: InputMaybe<NoteWhereInput>;
  none?: InputMaybe<NoteWhereInput>;
  some?: InputMaybe<NoteWhereInput>;
};

export type NoteMaxAggregate = {
  __typename?: 'NoteMaxAggregate';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  pageId?: Maybe<Scalars['String']['output']>;
  proposalId?: Maybe<Scalars['Int']['output']>;
};

export type NoteMaxOrderByAggregateInput = {
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pageId?: InputMaybe<SortOrder>;
  proposalId?: InputMaybe<SortOrder>;
};

export type NoteMinAggregate = {
  __typename?: 'NoteMinAggregate';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  pageId?: Maybe<Scalars['String']['output']>;
  proposalId?: Maybe<Scalars['Int']['output']>;
};

export type NoteMinOrderByAggregateInput = {
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pageId?: InputMaybe<SortOrder>;
  proposalId?: InputMaybe<SortOrder>;
};

export type NoteOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum NoteOrderByRelevanceFieldEnum {
  Content = 'content',
  CreatedBy = 'createdBy',
  PageId = 'pageId'
}

export type NoteOrderByRelevanceInput = {
  fields: Array<NoteOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type NoteOrderByWithAggregationInput = {
  _avg?: InputMaybe<NoteAvgOrderByAggregateInput>;
  _count?: InputMaybe<NoteCountOrderByAggregateInput>;
  _max?: InputMaybe<NoteMaxOrderByAggregateInput>;
  _min?: InputMaybe<NoteMinOrderByAggregateInput>;
  _sum?: InputMaybe<NoteSumOrderByAggregateInput>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pageId?: InputMaybe<SortOrder>;
  proposalId?: InputMaybe<SortOrder>;
};

export type NoteOrderByWithRelationInput = {
  _relevance?: InputMaybe<NoteOrderByRelevanceInput>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pageId?: InputMaybe<SortOrder>;
  proposal?: InputMaybe<ProposalOrderByWithRelationInput>;
  proposalId?: InputMaybe<SortOrder>;
};

export enum NoteScalarFieldEnum {
  Content = 'content',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Id = 'id',
  PageId = 'pageId',
  ProposalId = 'proposalId'
}

export type NoteScalarWhereInput = {
  AND?: InputMaybe<Array<NoteScalarWhereInput>>;
  NOT?: InputMaybe<Array<NoteScalarWhereInput>>;
  OR?: InputMaybe<Array<NoteScalarWhereInput>>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  pageId?: InputMaybe<StringFilter>;
  proposalId?: InputMaybe<IntFilter>;
};

export type NoteScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<NoteScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<NoteScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<NoteScalarWhereWithAggregatesInput>>;
  content?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  createdBy?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  pageId?: InputMaybe<StringWithAggregatesFilter>;
  proposalId?: InputMaybe<IntWithAggregatesFilter>;
};

export type NoteSumAggregate = {
  __typename?: 'NoteSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  proposalId?: Maybe<Scalars['Int']['output']>;
};

export type NoteSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  proposalId?: InputMaybe<SortOrder>;
};

export type NoteUpdateInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  pageId?: InputMaybe<StringFieldUpdateOperationsInput>;
  proposal?: InputMaybe<ProposalUpdateOneRequiredWithoutNotesNestedInput>;
};

export type NoteUpdateManyMutationInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  pageId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NoteUpdateManyWithWhereWithoutProposalInput = {
  data: NoteUpdateManyMutationInput;
  where: NoteScalarWhereInput;
};

export type NoteUpdateManyWithoutProposalNestedInput = {
  connect?: InputMaybe<Array<NoteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NoteCreateOrConnectWithoutProposalInput>>;
  create?: InputMaybe<Array<NoteCreateWithoutProposalInput>>;
  createMany?: InputMaybe<NoteCreateManyProposalInputEnvelope>;
  delete?: InputMaybe<Array<NoteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NoteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NoteWhereUniqueInput>>;
  set?: InputMaybe<Array<NoteWhereUniqueInput>>;
  update?: InputMaybe<Array<NoteUpdateWithWhereUniqueWithoutProposalInput>>;
  updateMany?: InputMaybe<Array<NoteUpdateManyWithWhereWithoutProposalInput>>;
  upsert?: InputMaybe<Array<NoteUpsertWithWhereUniqueWithoutProposalInput>>;
};

export type NoteUpdateWithWhereUniqueWithoutProposalInput = {
  data: NoteUpdateWithoutProposalInput;
  where: NoteWhereUniqueInput;
};

export type NoteUpdateWithoutProposalInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  pageId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NoteUpsertWithWhereUniqueWithoutProposalInput = {
  create: NoteCreateWithoutProposalInput;
  update: NoteUpdateWithoutProposalInput;
  where: NoteWhereUniqueInput;
};

export type NoteWhereInput = {
  AND?: InputMaybe<Array<NoteWhereInput>>;
  NOT?: InputMaybe<Array<NoteWhereInput>>;
  OR?: InputMaybe<Array<NoteWhereInput>>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  pageId?: InputMaybe<StringFilter>;
  proposal?: InputMaybe<ProposalScalarRelationFilter>;
  proposalId?: InputMaybe<IntFilter>;
};

export type NoteWhereUniqueInput = {
  AND?: InputMaybe<Array<NoteWhereInput>>;
  NOT?: InputMaybe<Array<NoteWhereInput>>;
  OR?: InputMaybe<Array<NoteWhereInput>>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  pageId?: InputMaybe<StringFilter>;
  proposal?: InputMaybe<ProposalScalarRelationFilter>;
  proposalId?: InputMaybe<IntFilter>;
};

export type NullableBigIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['BigInt']['input']>;
  divide?: InputMaybe<Scalars['BigInt']['input']>;
  increment?: InputMaybe<Scalars['BigInt']['input']>;
  multiply?: InputMaybe<Scalars['BigInt']['input']>;
  set?: InputMaybe<Scalars['BigInt']['input']>;
};

export type NullableBoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type NullableEnumDateModeFieldUpdateOperationsInput = {
  set?: InputMaybe<DateMode>;
};

export type NullableFloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']['input']>;
  divide?: InputMaybe<Scalars['Float']['input']>;
  increment?: InputMaybe<Scalars['Float']['input']>;
  multiply?: InputMaybe<Scalars['Float']['input']>;
  set?: InputMaybe<Scalars['Float']['input']>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

export type Proposal = {
  __typename?: 'Proposal';
  _count?: Maybe<ProposalCount>;
  createdAt: Scalars['Timestamp']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isFinalized: Scalars['Boolean']['output'];
  lastVersion: ProposalVersion;
  name: Scalars['String']['output'];
  notes: Array<Note>;
  templateName?: Maybe<Scalars['String']['output']>;
  templateVersion: ProposalTemplateVersion;
  templateVersionId: Scalars['Int']['output'];
  totalCellCount?: Maybe<Scalars['Int']['output']>;
  totalCellDataBytes?: Maybe<Scalars['BigInt']['output']>;
  totalStorageMB?: Maybe<Scalars['Float']['output']>;
  type: ProposalType;
  versions: Array<ProposalVersion>;
};


export type ProposalNotesArgs = {
  cursor?: InputMaybe<NoteWhereUniqueInput>;
  distinct?: InputMaybe<Array<NoteScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NoteOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NoteWhereInput>;
};


export type ProposalVersionsArgs = {
  cursor?: InputMaybe<ProposalVersionWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProposalVersionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProposalVersionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalVersionWhereInput>;
};

export type ProposalAnalyticsPage = {
  __typename?: 'ProposalAnalyticsPage';
  fields: Array<AnalyticsPageField>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  primaryColumnUUID?: Maybe<Scalars['String']['output']>;
  type: TemplatePageType;
};

export type ProposalCell = {
  __typename?: 'ProposalCell';
  arrayIndex: Scalars['Int']['output'];
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  columnUUID: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  initVersionId: Scalars['Int']['output'];
  isEnteredValue: Scalars['Boolean']['output'];
  lastVersion: ProposalVersion;
  lastVersionId: Scalars['Int']['output'];
  numericValue?: Maybe<Scalars['Float']['output']>;
  pageUUID: Scalars['String']['output'];
  rawValue?: Maybe<Scalars['JSON']['output']>;
  rowUUID: Scalars['String']['output'];
  stringValue?: Maybe<Scalars['String']['output']>;
};

export type ProposalCellCreateManyLastVersionInput = {
  arrayIndex?: InputMaybe<Scalars['Int']['input']>;
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  columnUUID: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  initVersionId: Scalars['Int']['input'];
  isEnteredValue: Scalars['Boolean']['input'];
  numericValue?: InputMaybe<Scalars['Float']['input']>;
  pageUUID: Scalars['String']['input'];
  rawValue?: InputMaybe<Scalars['JSON']['input']>;
  rowUUID: Scalars['String']['input'];
  stringValue?: InputMaybe<Scalars['String']['input']>;
};

export type ProposalCellCreateManyLastVersionInputEnvelope = {
  data: Array<ProposalCellCreateManyLastVersionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProposalCellCreateNestedManyWithoutLastVersionInput = {
  connect?: InputMaybe<Array<ProposalCellWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProposalCellCreateOrConnectWithoutLastVersionInput>>;
  create?: InputMaybe<Array<ProposalCellCreateWithoutLastVersionInput>>;
  createMany?: InputMaybe<ProposalCellCreateManyLastVersionInputEnvelope>;
};

export type ProposalCellCreateOrConnectWithoutLastVersionInput = {
  create: ProposalCellCreateWithoutLastVersionInput;
  where: ProposalCellWhereUniqueInput;
};

export type ProposalCellCreateWithoutLastVersionInput = {
  arrayIndex?: InputMaybe<Scalars['Int']['input']>;
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  columnUUID: Scalars['String']['input'];
  initVersionId: Scalars['Int']['input'];
  isEnteredValue: Scalars['Boolean']['input'];
  numericValue?: InputMaybe<Scalars['Float']['input']>;
  pageUUID: Scalars['String']['input'];
  rawValue?: InputMaybe<Scalars['JSON']['input']>;
  rowUUID: Scalars['String']['input'];
  stringValue?: InputMaybe<Scalars['String']['input']>;
};

export type ProposalCellLastVersionIdColumnUuidRowUuidPageUuidArrayIndexCompoundUniqueInput = {
  arrayIndex: Scalars['Int']['input'];
  columnUUID: Scalars['String']['input'];
  lastVersionId: Scalars['Int']['input'];
  pageUUID: Scalars['String']['input'];
  rowUUID: Scalars['String']['input'];
};

export type ProposalCellListRelationFilter = {
  every?: InputMaybe<ProposalCellWhereInput>;
  none?: InputMaybe<ProposalCellWhereInput>;
  some?: InputMaybe<ProposalCellWhereInput>;
};

export type ProposalCellOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum ProposalCellOrderByRelevanceFieldEnum {
  ColumnUuid = 'columnUUID',
  PageUuid = 'pageUUID',
  RowUuid = 'rowUUID',
  StringValue = 'stringValue'
}

export type ProposalCellOrderByRelevanceInput = {
  fields: Array<ProposalCellOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type ProposalCellOrderByWithRelationInput = {
  _relevance?: InputMaybe<ProposalCellOrderByRelevanceInput>;
  arrayIndex?: InputMaybe<SortOrder>;
  booleanValue?: InputMaybe<SortOrderInput>;
  columnUUID?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  initVersionId?: InputMaybe<SortOrder>;
  isEnteredValue?: InputMaybe<SortOrder>;
  lastVersion?: InputMaybe<ProposalVersionOrderByWithRelationInput>;
  lastVersionId?: InputMaybe<SortOrder>;
  numericValue?: InputMaybe<SortOrderInput>;
  pageUUID?: InputMaybe<SortOrder>;
  rawValue?: InputMaybe<SortOrderInput>;
  rowUUID?: InputMaybe<SortOrder>;
  stringValue?: InputMaybe<SortOrderInput>;
};

export enum ProposalCellScalarFieldEnum {
  ArrayIndex = 'arrayIndex',
  BooleanValue = 'booleanValue',
  ColumnUuid = 'columnUUID',
  Id = 'id',
  InitVersionId = 'initVersionId',
  IsEnteredValue = 'isEnteredValue',
  LastVersionId = 'lastVersionId',
  NumericValue = 'numericValue',
  PageUuid = 'pageUUID',
  RawValue = 'rawValue',
  RowUuid = 'rowUUID',
  StringValue = 'stringValue'
}

export type ProposalCellScalarWhereInput = {
  AND?: InputMaybe<Array<ProposalCellScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProposalCellScalarWhereInput>>;
  OR?: InputMaybe<Array<ProposalCellScalarWhereInput>>;
  arrayIndex?: InputMaybe<IntFilter>;
  booleanValue?: InputMaybe<BoolNullableFilter>;
  columnUUID?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  initVersionId?: InputMaybe<IntFilter>;
  isEnteredValue?: InputMaybe<BoolFilter>;
  lastVersionId?: InputMaybe<IntFilter>;
  numericValue?: InputMaybe<FloatNullableFilter>;
  pageUUID?: InputMaybe<StringFilter>;
  rawValue?: InputMaybe<JsonNullableFilter>;
  rowUUID?: InputMaybe<StringFilter>;
  stringValue?: InputMaybe<StringNullableFilter>;
};

export type ProposalCellUpdateManyMutationInput = {
  arrayIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  booleanValue?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  columnUUID?: InputMaybe<StringFieldUpdateOperationsInput>;
  initVersionId?: InputMaybe<IntFieldUpdateOperationsInput>;
  isEnteredValue?: InputMaybe<BoolFieldUpdateOperationsInput>;
  numericValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  pageUUID?: InputMaybe<StringFieldUpdateOperationsInput>;
  rawValue?: InputMaybe<Scalars['JSON']['input']>;
  rowUUID?: InputMaybe<StringFieldUpdateOperationsInput>;
  stringValue?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProposalCellUpdateManyWithWhereWithoutLastVersionInput = {
  data: ProposalCellUpdateManyMutationInput;
  where: ProposalCellScalarWhereInput;
};

export type ProposalCellUpdateManyWithoutLastVersionNestedInput = {
  connect?: InputMaybe<Array<ProposalCellWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProposalCellCreateOrConnectWithoutLastVersionInput>>;
  create?: InputMaybe<Array<ProposalCellCreateWithoutLastVersionInput>>;
  createMany?: InputMaybe<ProposalCellCreateManyLastVersionInputEnvelope>;
  delete?: InputMaybe<Array<ProposalCellWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProposalCellScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProposalCellWhereUniqueInput>>;
  set?: InputMaybe<Array<ProposalCellWhereUniqueInput>>;
  update?: InputMaybe<Array<ProposalCellUpdateWithWhereUniqueWithoutLastVersionInput>>;
  updateMany?: InputMaybe<Array<ProposalCellUpdateManyWithWhereWithoutLastVersionInput>>;
  upsert?: InputMaybe<Array<ProposalCellUpsertWithWhereUniqueWithoutLastVersionInput>>;
};

export type ProposalCellUpdateWithWhereUniqueWithoutLastVersionInput = {
  data: ProposalCellUpdateWithoutLastVersionInput;
  where: ProposalCellWhereUniqueInput;
};

export type ProposalCellUpdateWithoutLastVersionInput = {
  arrayIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  booleanValue?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  columnUUID?: InputMaybe<StringFieldUpdateOperationsInput>;
  initVersionId?: InputMaybe<IntFieldUpdateOperationsInput>;
  isEnteredValue?: InputMaybe<BoolFieldUpdateOperationsInput>;
  numericValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  pageUUID?: InputMaybe<StringFieldUpdateOperationsInput>;
  rawValue?: InputMaybe<Scalars['JSON']['input']>;
  rowUUID?: InputMaybe<StringFieldUpdateOperationsInput>;
  stringValue?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProposalCellUpsertWithWhereUniqueWithoutLastVersionInput = {
  create: ProposalCellCreateWithoutLastVersionInput;
  update: ProposalCellUpdateWithoutLastVersionInput;
  where: ProposalCellWhereUniqueInput;
};

export type ProposalCellWhereInput = {
  AND?: InputMaybe<Array<ProposalCellWhereInput>>;
  NOT?: InputMaybe<Array<ProposalCellWhereInput>>;
  OR?: InputMaybe<Array<ProposalCellWhereInput>>;
  arrayIndex?: InputMaybe<IntFilter>;
  booleanValue?: InputMaybe<BoolNullableFilter>;
  columnUUID?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  initVersionId?: InputMaybe<IntFilter>;
  isEnteredValue?: InputMaybe<BoolFilter>;
  lastVersion?: InputMaybe<ProposalVersionScalarRelationFilter>;
  lastVersionId?: InputMaybe<IntFilter>;
  numericValue?: InputMaybe<FloatNullableFilter>;
  pageUUID?: InputMaybe<StringFilter>;
  rawValue?: InputMaybe<JsonNullableFilter>;
  rowUUID?: InputMaybe<StringFilter>;
  stringValue?: InputMaybe<StringNullableFilter>;
};

export type ProposalCellWhereUniqueInput = {
  AND?: InputMaybe<Array<ProposalCellWhereInput>>;
  NOT?: InputMaybe<Array<ProposalCellWhereInput>>;
  OR?: InputMaybe<Array<ProposalCellWhereInput>>;
  arrayIndex?: InputMaybe<IntFilter>;
  booleanValue?: InputMaybe<BoolNullableFilter>;
  columnUUID?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  initVersionId?: InputMaybe<IntFilter>;
  isEnteredValue?: InputMaybe<BoolFilter>;
  lastVersion?: InputMaybe<ProposalVersionScalarRelationFilter>;
  lastVersionId?: InputMaybe<IntFilter>;
  lastVersionId_columnUUID_rowUUID_pageUUID_arrayIndex?: InputMaybe<ProposalCellLastVersionIdColumnUuidRowUuidPageUuidArrayIndexCompoundUniqueInput>;
  numericValue?: InputMaybe<FloatNullableFilter>;
  pageUUID?: InputMaybe<StringFilter>;
  rawValue?: InputMaybe<JsonNullableFilter>;
  rowUUID?: InputMaybe<StringFilter>;
  stringValue?: InputMaybe<StringNullableFilter>;
};

export type ProposalCount = {
  __typename?: 'ProposalCount';
  dataSourceVersionOrigin: Scalars['Int']['output'];
  notes: Scalars['Int']['output'];
  userProposalAccess: Scalars['Int']['output'];
  userProposalPins: Scalars['Int']['output'];
  versions: Scalars['Int']['output'];
};


export type ProposalCountDataSourceVersionOriginArgs = {
  where?: InputMaybe<DataSourceVersionOriginWhereInput>;
};


export type ProposalCountNotesArgs = {
  where?: InputMaybe<NoteWhereInput>;
};


export type ProposalCountUserProposalAccessArgs = {
  where?: InputMaybe<UserProposalAccessWhereInput>;
};


export type ProposalCountUserProposalPinsArgs = {
  where?: InputMaybe<UserProposalPinWhereInput>;
};


export type ProposalCountVersionsArgs = {
  where?: InputMaybe<ProposalVersionWhereInput>;
};

export type ProposalCreateInput = {
  name: Scalars['String']['input'];
  templateId?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  version: ProposalVersionCreateInput;
};

export type ProposalCreateManyTemplateVersionInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  totalCellCount?: InputMaybe<Scalars['Int']['input']>;
  totalCellDataBytes?: InputMaybe<Scalars['BigInt']['input']>;
  type?: InputMaybe<ProposalType>;
};

export type ProposalCreateManyTemplateVersionInputEnvelope = {
  data: Array<ProposalCreateManyTemplateVersionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProposalCreateNestedManyWithoutTemplateVersionInput = {
  connect?: InputMaybe<Array<ProposalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProposalCreateOrConnectWithoutTemplateVersionInput>>;
  create?: InputMaybe<Array<ProposalCreateWithoutTemplateVersionInput>>;
  createMany?: InputMaybe<ProposalCreateManyTemplateVersionInputEnvelope>;
};

export type ProposalCreateNestedOneWithoutDataSourceVersionOriginInput = {
  connect?: InputMaybe<ProposalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProposalCreateOrConnectWithoutDataSourceVersionOriginInput>;
  create?: InputMaybe<ProposalCreateWithoutDataSourceVersionOriginInput>;
};

export type ProposalCreateNestedOneWithoutNotesInput = {
  connect?: InputMaybe<ProposalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProposalCreateOrConnectWithoutNotesInput>;
  create?: InputMaybe<ProposalCreateWithoutNotesInput>;
};

export type ProposalCreateNestedOneWithoutUserProposalAccessInput = {
  connect?: InputMaybe<ProposalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProposalCreateOrConnectWithoutUserProposalAccessInput>;
  create?: InputMaybe<ProposalCreateWithoutUserProposalAccessInput>;
};

export type ProposalCreateNestedOneWithoutVersionsInput = {
  connect?: InputMaybe<ProposalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProposalCreateOrConnectWithoutVersionsInput>;
  create?: InputMaybe<ProposalCreateWithoutVersionsInput>;
};

export type ProposalCreateOrConnectWithoutDataSourceVersionOriginInput = {
  create: ProposalCreateWithoutDataSourceVersionOriginInput;
  where: ProposalWhereUniqueInput;
};

export type ProposalCreateOrConnectWithoutNotesInput = {
  create: ProposalCreateWithoutNotesInput;
  where: ProposalWhereUniqueInput;
};

export type ProposalCreateOrConnectWithoutTemplateVersionInput = {
  create: ProposalCreateWithoutTemplateVersionInput;
  where: ProposalWhereUniqueInput;
};

export type ProposalCreateOrConnectWithoutUserProposalAccessInput = {
  create: ProposalCreateWithoutUserProposalAccessInput;
  where: ProposalWhereUniqueInput;
};

export type ProposalCreateOrConnectWithoutVersionsInput = {
  create: ProposalCreateWithoutVersionsInput;
  where: ProposalWhereUniqueInput;
};

export type ProposalCreateWithoutDataSourceVersionOriginInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy: Scalars['String']['input'];
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  lastEditor?: InputMaybe<ProposalLastEditorCreateNestedOneWithoutProposalInput>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<NoteCreateNestedManyWithoutProposalInput>;
  templateVersion: ProposalTemplateVersionCreateNestedOneWithoutProposalsInput;
  totalCellCount?: InputMaybe<Scalars['Int']['input']>;
  totalCellDataBytes?: InputMaybe<Scalars['BigInt']['input']>;
  type?: InputMaybe<ProposalType>;
  userProposalAccess?: InputMaybe<UserProposalAccessCreateNestedManyWithoutProposalInput>;
  userProposalPins?: InputMaybe<UserProposalPinCreateNestedManyWithoutProposalInput>;
  versions?: InputMaybe<ProposalVersionCreateNestedManyWithoutProposalInput>;
};

export type ProposalCreateWithoutNotesInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy: Scalars['String']['input'];
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  lastEditor?: InputMaybe<ProposalLastEditorCreateNestedOneWithoutProposalInput>;
  name: Scalars['String']['input'];
  templateVersion: ProposalTemplateVersionCreateNestedOneWithoutProposalsInput;
  totalCellCount?: InputMaybe<Scalars['Int']['input']>;
  totalCellDataBytes?: InputMaybe<Scalars['BigInt']['input']>;
  type?: InputMaybe<ProposalType>;
  userProposalAccess?: InputMaybe<UserProposalAccessCreateNestedManyWithoutProposalInput>;
  userProposalPins?: InputMaybe<UserProposalPinCreateNestedManyWithoutProposalInput>;
  versions?: InputMaybe<ProposalVersionCreateNestedManyWithoutProposalInput>;
};

export type ProposalCreateWithoutTemplateVersionInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy: Scalars['String']['input'];
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  lastEditor?: InputMaybe<ProposalLastEditorCreateNestedOneWithoutProposalInput>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<NoteCreateNestedManyWithoutProposalInput>;
  totalCellCount?: InputMaybe<Scalars['Int']['input']>;
  totalCellDataBytes?: InputMaybe<Scalars['BigInt']['input']>;
  type?: InputMaybe<ProposalType>;
  userProposalAccess?: InputMaybe<UserProposalAccessCreateNestedManyWithoutProposalInput>;
  userProposalPins?: InputMaybe<UserProposalPinCreateNestedManyWithoutProposalInput>;
  versions?: InputMaybe<ProposalVersionCreateNestedManyWithoutProposalInput>;
};

export type ProposalCreateWithoutUserProposalAccessInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy: Scalars['String']['input'];
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  lastEditor?: InputMaybe<ProposalLastEditorCreateNestedOneWithoutProposalInput>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<NoteCreateNestedManyWithoutProposalInput>;
  templateVersion: ProposalTemplateVersionCreateNestedOneWithoutProposalsInput;
  totalCellCount?: InputMaybe<Scalars['Int']['input']>;
  totalCellDataBytes?: InputMaybe<Scalars['BigInt']['input']>;
  type?: InputMaybe<ProposalType>;
  userProposalPins?: InputMaybe<UserProposalPinCreateNestedManyWithoutProposalInput>;
  versions?: InputMaybe<ProposalVersionCreateNestedManyWithoutProposalInput>;
};

export type ProposalCreateWithoutVersionsInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy: Scalars['String']['input'];
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  lastEditor?: InputMaybe<ProposalLastEditorCreateNestedOneWithoutProposalInput>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<NoteCreateNestedManyWithoutProposalInput>;
  templateVersion: ProposalTemplateVersionCreateNestedOneWithoutProposalsInput;
  totalCellCount?: InputMaybe<Scalars['Int']['input']>;
  totalCellDataBytes?: InputMaybe<Scalars['BigInt']['input']>;
  type?: InputMaybe<ProposalType>;
  userProposalAccess?: InputMaybe<UserProposalAccessCreateNestedManyWithoutProposalInput>;
  userProposalPins?: InputMaybe<UserProposalPinCreateNestedManyWithoutProposalInput>;
};

export type ProposalDownloadAuditEventInput = {
  proposal: ProposalWithPageIds;
};

export type ProposalField = {
  __typename?: 'ProposalField';
  createdAt: Scalars['Timestamp']['output'];
  dateMode?: Maybe<DateMode>;
  fieldId: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  proposalVersion: ProposalVersion;
  proposalVersionId: Scalars['Int']['output'];
  type?: Maybe<Scalars['String']['output']>;
  value: Scalars['JSON']['output'];
};

export type ProposalFieldCreateManyProposalVersionInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  dateMode?: InputMaybe<DateMode>;
  fieldId: Scalars['String']['input'];
  fieldName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['JSON']['input'];
};

export type ProposalFieldCreateManyProposalVersionInputEnvelope = {
  data: Array<ProposalFieldCreateManyProposalVersionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProposalFieldCreateNestedManyWithoutProposalVersionInput = {
  connect?: InputMaybe<Array<ProposalFieldWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProposalFieldCreateOrConnectWithoutProposalVersionInput>>;
  create?: InputMaybe<Array<ProposalFieldCreateWithoutProposalVersionInput>>;
  createMany?: InputMaybe<ProposalFieldCreateManyProposalVersionInputEnvelope>;
};

export type ProposalFieldCreateOrConnectWithoutProposalVersionInput = {
  create: ProposalFieldCreateWithoutProposalVersionInput;
  where: ProposalFieldWhereUniqueInput;
};

export type ProposalFieldCreateWithoutProposalVersionInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  dateMode?: InputMaybe<DateMode>;
  fieldId: Scalars['String']['input'];
  fieldName: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['JSON']['input'];
};

export type ProposalFieldListRelationFilter = {
  every?: InputMaybe<ProposalFieldWhereInput>;
  none?: InputMaybe<ProposalFieldWhereInput>;
  some?: InputMaybe<ProposalFieldWhereInput>;
};

export type ProposalFieldOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum ProposalFieldOrderByRelevanceFieldEnum {
  FieldId = 'fieldId',
  FieldName = 'fieldName',
  Type = 'type'
}

export type ProposalFieldOrderByRelevanceInput = {
  fields: Array<ProposalFieldOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type ProposalFieldOrderByWithRelationInput = {
  _relevance?: InputMaybe<ProposalFieldOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  dateMode?: InputMaybe<SortOrderInput>;
  fieldId?: InputMaybe<SortOrder>;
  fieldName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proposalVersion?: InputMaybe<ProposalVersionOrderByWithRelationInput>;
  proposalVersionId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrderInput>;
  value?: InputMaybe<SortOrder>;
};

export type ProposalFieldProposalVersionIdFieldIdCompoundUniqueInput = {
  fieldId: Scalars['String']['input'];
  proposalVersionId: Scalars['Int']['input'];
};

export enum ProposalFieldScalarFieldEnum {
  CreatedAt = 'createdAt',
  DateMode = 'dateMode',
  FieldId = 'fieldId',
  FieldName = 'fieldName',
  Id = 'id',
  ProposalVersionId = 'proposalVersionId',
  Type = 'type',
  Value = 'value'
}

export type ProposalFieldScalarWhereInput = {
  AND?: InputMaybe<Array<ProposalFieldScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProposalFieldScalarWhereInput>>;
  OR?: InputMaybe<Array<ProposalFieldScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateMode?: InputMaybe<EnumDateModeNullableFilter>;
  fieldId?: InputMaybe<StringFilter>;
  fieldName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  proposalVersionId?: InputMaybe<IntFilter>;
  type?: InputMaybe<StringNullableFilter>;
  value?: InputMaybe<JsonFilter>;
};

export type ProposalFieldUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateMode?: InputMaybe<NullableEnumDateModeFieldUpdateOperationsInput>;
  fieldId?: InputMaybe<StringFieldUpdateOperationsInput>;
  fieldName?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProposalFieldUpdateManyWithWhereWithoutProposalVersionInput = {
  data: ProposalFieldUpdateManyMutationInput;
  where: ProposalFieldScalarWhereInput;
};

export type ProposalFieldUpdateManyWithoutProposalVersionNestedInput = {
  connect?: InputMaybe<Array<ProposalFieldWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProposalFieldCreateOrConnectWithoutProposalVersionInput>>;
  create?: InputMaybe<Array<ProposalFieldCreateWithoutProposalVersionInput>>;
  createMany?: InputMaybe<ProposalFieldCreateManyProposalVersionInputEnvelope>;
  delete?: InputMaybe<Array<ProposalFieldWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProposalFieldScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProposalFieldWhereUniqueInput>>;
  set?: InputMaybe<Array<ProposalFieldWhereUniqueInput>>;
  update?: InputMaybe<Array<ProposalFieldUpdateWithWhereUniqueWithoutProposalVersionInput>>;
  updateMany?: InputMaybe<Array<ProposalFieldUpdateManyWithWhereWithoutProposalVersionInput>>;
  upsert?: InputMaybe<Array<ProposalFieldUpsertWithWhereUniqueWithoutProposalVersionInput>>;
};

export type ProposalFieldUpdateWithWhereUniqueWithoutProposalVersionInput = {
  data: ProposalFieldUpdateWithoutProposalVersionInput;
  where: ProposalFieldWhereUniqueInput;
};

export type ProposalFieldUpdateWithoutProposalVersionInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateMode?: InputMaybe<NullableEnumDateModeFieldUpdateOperationsInput>;
  fieldId?: InputMaybe<StringFieldUpdateOperationsInput>;
  fieldName?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProposalFieldUpsertWithWhereUniqueWithoutProposalVersionInput = {
  create: ProposalFieldCreateWithoutProposalVersionInput;
  update: ProposalFieldUpdateWithoutProposalVersionInput;
  where: ProposalFieldWhereUniqueInput;
};

export type ProposalFieldWhereInput = {
  AND?: InputMaybe<Array<ProposalFieldWhereInput>>;
  NOT?: InputMaybe<Array<ProposalFieldWhereInput>>;
  OR?: InputMaybe<Array<ProposalFieldWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateMode?: InputMaybe<EnumDateModeNullableFilter>;
  fieldId?: InputMaybe<StringFilter>;
  fieldName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  proposalVersion?: InputMaybe<ProposalVersionScalarRelationFilter>;
  proposalVersionId?: InputMaybe<IntFilter>;
  type?: InputMaybe<StringNullableFilter>;
  value?: InputMaybe<JsonFilter>;
};

export type ProposalFieldWhereUniqueInput = {
  AND?: InputMaybe<Array<ProposalFieldWhereInput>>;
  NOT?: InputMaybe<Array<ProposalFieldWhereInput>>;
  OR?: InputMaybe<Array<ProposalFieldWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateMode?: InputMaybe<EnumDateModeNullableFilter>;
  fieldId?: InputMaybe<StringFilter>;
  fieldName?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  proposalVersion?: InputMaybe<ProposalVersionScalarRelationFilter>;
  proposalVersionId?: InputMaybe<IntFilter>;
  proposalVersionId_fieldId?: InputMaybe<ProposalFieldProposalVersionIdFieldIdCompoundUniqueInput>;
  type?: InputMaybe<StringNullableFilter>;
  value?: InputMaybe<JsonFilter>;
};

export type ProposalInteractionAuditEventInput = {
  durationSeconds: Scalars['Int']['input'];
  proposal: ProposalWithPageIds;
};

export type ProposalLastEditorCreateNestedOneWithoutProposalInput = {
  connect?: InputMaybe<ProposalLastEditorWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProposalLastEditorCreateOrConnectWithoutProposalInput>;
  create?: InputMaybe<ProposalLastEditorCreateWithoutProposalInput>;
};

export type ProposalLastEditorCreateOrConnectWithoutProposalInput = {
  create: ProposalLastEditorCreateWithoutProposalInput;
  where: ProposalLastEditorWhereUniqueInput;
};

export type ProposalLastEditorCreateWithoutProposalInput = {
  email: Scalars['String']['input'];
  lastCheckedInAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ProposalLastEditorNullableScalarRelationFilter = {
  is?: InputMaybe<ProposalLastEditorWhereInput>;
  isNot?: InputMaybe<ProposalLastEditorWhereInput>;
};

export enum ProposalLastEditorOrderByRelevanceFieldEnum {
  Email = 'email'
}

export type ProposalLastEditorOrderByRelevanceInput = {
  fields: Array<ProposalLastEditorOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type ProposalLastEditorOrderByWithRelationInput = {
  _relevance?: InputMaybe<ProposalLastEditorOrderByRelevanceInput>;
  email?: InputMaybe<SortOrder>;
  lastCheckedInAt?: InputMaybe<SortOrder>;
  proposal?: InputMaybe<ProposalOrderByWithRelationInput>;
  proposalId?: InputMaybe<SortOrder>;
};

export type ProposalLastEditorUpdateOneWithoutProposalNestedInput = {
  connect?: InputMaybe<ProposalLastEditorWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProposalLastEditorCreateOrConnectWithoutProposalInput>;
  create?: InputMaybe<ProposalLastEditorCreateWithoutProposalInput>;
  delete?: InputMaybe<ProposalLastEditorWhereInput>;
  disconnect?: InputMaybe<ProposalLastEditorWhereInput>;
  update?: InputMaybe<ProposalLastEditorUpdateToOneWithWhereWithoutProposalInput>;
  upsert?: InputMaybe<ProposalLastEditorUpsertWithoutProposalInput>;
};

export type ProposalLastEditorUpdateToOneWithWhereWithoutProposalInput = {
  data: ProposalLastEditorUpdateWithoutProposalInput;
  where?: InputMaybe<ProposalLastEditorWhereInput>;
};

export type ProposalLastEditorUpdateWithoutProposalInput = {
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastCheckedInAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProposalLastEditorUpsertWithoutProposalInput = {
  create: ProposalLastEditorCreateWithoutProposalInput;
  update: ProposalLastEditorUpdateWithoutProposalInput;
  where?: InputMaybe<ProposalLastEditorWhereInput>;
};

export type ProposalLastEditorWhereInput = {
  AND?: InputMaybe<Array<ProposalLastEditorWhereInput>>;
  NOT?: InputMaybe<Array<ProposalLastEditorWhereInput>>;
  OR?: InputMaybe<Array<ProposalLastEditorWhereInput>>;
  email?: InputMaybe<StringFilter>;
  lastCheckedInAt?: InputMaybe<DateTimeFilter>;
  proposal?: InputMaybe<ProposalScalarRelationFilter>;
  proposalId?: InputMaybe<IntFilter>;
};

export type ProposalLastEditorWhereUniqueInput = {
  AND?: InputMaybe<Array<ProposalLastEditorWhereInput>>;
  NOT?: InputMaybe<Array<ProposalLastEditorWhereInput>>;
  OR?: InputMaybe<Array<ProposalLastEditorWhereInput>>;
  email?: InputMaybe<StringFilter>;
  lastCheckedInAt?: InputMaybe<DateTimeFilter>;
  proposal?: InputMaybe<ProposalScalarRelationFilter>;
  proposalId?: InputMaybe<Scalars['Int']['input']>;
};

export type ProposalListItem = {
  __typename?: 'ProposalListItem';
  createdAt: Scalars['Timestamp']['output'];
  createdBy: Scalars['String']['output'];
  dataSourceUsedAt?: Maybe<Scalars['Timestamp']['output']>;
  fields: Array<ProposalListItemField>;
  id: Scalars['Int']['output'];
  isFinalized: Scalars['Boolean']['output'];
  isPinned: Scalars['Boolean']['output'];
  lastVersionCreatedBy: Scalars['String']['output'];
  latestVersionId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  templateName: Scalars['String']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

export type ProposalListItemField = {
  __typename?: 'ProposalListItemField';
  dateMode?: Maybe<DateMode>;
  fieldId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ProposalListRelationFilter = {
  every?: InputMaybe<ProposalWhereInput>;
  none?: InputMaybe<ProposalWhereInput>;
  some?: InputMaybe<ProposalWhereInput>;
};

export type ProposalMetric = {
  __typename?: 'ProposalMetric';
  id: Scalars['Int']['output'];
  metricId: Scalars['String']['output'];
  metricName: Scalars['String']['output'];
  proposalVersion?: Maybe<ProposalVersion>;
  proposalVersionId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Timestamp']['output'];
  value: Scalars['JSON']['output'];
};


export type ProposalMetricProposalVersionArgs = {
  where?: InputMaybe<ProposalVersionWhereInput>;
};

export type ProposalMetricCreateManyProposalVersionInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  metricId: Scalars['String']['input'];
  metricName: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  value: Scalars['JSON']['input'];
};

export type ProposalMetricCreateManyProposalVersionInputEnvelope = {
  data: Array<ProposalMetricCreateManyProposalVersionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProposalMetricCreateNestedManyWithoutProposalVersionInput = {
  connect?: InputMaybe<Array<ProposalMetricWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProposalMetricCreateOrConnectWithoutProposalVersionInput>>;
  create?: InputMaybe<Array<ProposalMetricCreateWithoutProposalVersionInput>>;
  createMany?: InputMaybe<ProposalMetricCreateManyProposalVersionInputEnvelope>;
};

export type ProposalMetricCreateOrConnectWithoutProposalVersionInput = {
  create: ProposalMetricCreateWithoutProposalVersionInput;
  where: ProposalMetricWhereUniqueInput;
};

export type ProposalMetricCreateWithoutProposalVersionInput = {
  metricId: Scalars['String']['input'];
  metricName: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  value: Scalars['JSON']['input'];
};

export type ProposalMetricListRelationFilter = {
  every?: InputMaybe<ProposalMetricWhereInput>;
  none?: InputMaybe<ProposalMetricWhereInput>;
  some?: InputMaybe<ProposalMetricWhereInput>;
};

export type ProposalMetricOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum ProposalMetricOrderByRelevanceFieldEnum {
  MetricId = 'metricId',
  MetricName = 'metricName'
}

export type ProposalMetricOrderByRelevanceInput = {
  fields: Array<ProposalMetricOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type ProposalMetricOrderByWithRelationInput = {
  _relevance?: InputMaybe<ProposalMetricOrderByRelevanceInput>;
  id?: InputMaybe<SortOrder>;
  metricId?: InputMaybe<SortOrder>;
  metricName?: InputMaybe<SortOrder>;
  proposalVersion?: InputMaybe<ProposalVersionOrderByWithRelationInput>;
  proposalVersionId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type ProposalMetricSaveInput = {
  collectForEveryVersion: Scalars['Boolean']['input'];
  metricId: Scalars['String']['input'];
  metricName: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

export enum ProposalMetricScalarFieldEnum {
  Id = 'id',
  MetricId = 'metricId',
  MetricName = 'metricName',
  ProposalVersionId = 'proposalVersionId',
  UpdatedAt = 'updatedAt',
  Value = 'value'
}

export type ProposalMetricScalarWhereInput = {
  AND?: InputMaybe<Array<ProposalMetricScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProposalMetricScalarWhereInput>>;
  OR?: InputMaybe<Array<ProposalMetricScalarWhereInput>>;
  id?: InputMaybe<IntFilter>;
  metricId?: InputMaybe<StringFilter>;
  metricName?: InputMaybe<StringFilter>;
  proposalVersionId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  value?: InputMaybe<JsonFilter>;
};

export type ProposalMetricUpdateManyMutationInput = {
  metricId?: InputMaybe<StringFieldUpdateOperationsInput>;
  metricName?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProposalMetricUpdateManyWithWhereWithoutProposalVersionInput = {
  data: ProposalMetricUpdateManyMutationInput;
  where: ProposalMetricScalarWhereInput;
};

export type ProposalMetricUpdateManyWithoutProposalVersionNestedInput = {
  connect?: InputMaybe<Array<ProposalMetricWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProposalMetricCreateOrConnectWithoutProposalVersionInput>>;
  create?: InputMaybe<Array<ProposalMetricCreateWithoutProposalVersionInput>>;
  createMany?: InputMaybe<ProposalMetricCreateManyProposalVersionInputEnvelope>;
  delete?: InputMaybe<Array<ProposalMetricWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProposalMetricScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProposalMetricWhereUniqueInput>>;
  set?: InputMaybe<Array<ProposalMetricWhereUniqueInput>>;
  update?: InputMaybe<Array<ProposalMetricUpdateWithWhereUniqueWithoutProposalVersionInput>>;
  updateMany?: InputMaybe<Array<ProposalMetricUpdateManyWithWhereWithoutProposalVersionInput>>;
  upsert?: InputMaybe<Array<ProposalMetricUpsertWithWhereUniqueWithoutProposalVersionInput>>;
};

export type ProposalMetricUpdateWithWhereUniqueWithoutProposalVersionInput = {
  data: ProposalMetricUpdateWithoutProposalVersionInput;
  where: ProposalMetricWhereUniqueInput;
};

export type ProposalMetricUpdateWithoutProposalVersionInput = {
  metricId?: InputMaybe<StringFieldUpdateOperationsInput>;
  metricName?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProposalMetricUpsertWithWhereUniqueWithoutProposalVersionInput = {
  create: ProposalMetricCreateWithoutProposalVersionInput;
  update: ProposalMetricUpdateWithoutProposalVersionInput;
  where: ProposalMetricWhereUniqueInput;
};

export type ProposalMetricWhereInput = {
  AND?: InputMaybe<Array<ProposalMetricWhereInput>>;
  NOT?: InputMaybe<Array<ProposalMetricWhereInput>>;
  OR?: InputMaybe<Array<ProposalMetricWhereInput>>;
  id?: InputMaybe<IntFilter>;
  metricId?: InputMaybe<StringFilter>;
  metricName?: InputMaybe<StringFilter>;
  proposalVersion?: InputMaybe<ProposalVersionNullableScalarRelationFilter>;
  proposalVersionId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  value?: InputMaybe<JsonFilter>;
};

export type ProposalMetricWhereUniqueInput = {
  AND?: InputMaybe<Array<ProposalMetricWhereInput>>;
  NOT?: InputMaybe<Array<ProposalMetricWhereInput>>;
  OR?: InputMaybe<Array<ProposalMetricWhereInput>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  metricId?: InputMaybe<StringFilter>;
  metricName?: InputMaybe<StringFilter>;
  proposalVersion?: InputMaybe<ProposalVersionNullableScalarRelationFilter>;
  proposalVersionId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  value?: InputMaybe<JsonFilter>;
};

export enum ProposalNavigationPositionType {
  Horizontal = 'HORIZONTAL',
  Vertical = 'VERTICAL'
}

export type ProposalOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum ProposalOrderByRelevanceFieldEnum {
  CreatedBy = 'createdBy',
  Name = 'name'
}

export type ProposalOrderByRelevanceInput = {
  fields: Array<ProposalOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type ProposalOrderByWithRelationInput = {
  _relevance?: InputMaybe<ProposalOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isFinalized?: InputMaybe<SortOrder>;
  lastEditor?: InputMaybe<ProposalLastEditorOrderByWithRelationInput>;
  name?: InputMaybe<SortOrder>;
  notes?: InputMaybe<NoteOrderByRelationAggregateInput>;
  templateVersion?: InputMaybe<ProposalTemplateVersionOrderByWithRelationInput>;
  templateVersionId?: InputMaybe<SortOrder>;
  totalCellCount?: InputMaybe<SortOrderInput>;
  totalCellDataBytes?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  userProposalAccess?: InputMaybe<UserProposalAccessOrderByRelationAggregateInput>;
  userProposalPins?: InputMaybe<UserProposalPinOrderByRelationAggregateInput>;
  versions?: InputMaybe<ProposalVersionOrderByRelationAggregateInput>;
};

export type ProposalPageDataSourceRows = {
  __typename?: 'ProposalPageDataSourceRows';
  columns: Array<Scalars['String']['output']>;
  rows: Scalars['JSON']['output'];
};

export type ProposalPageRowIndex = {
  __typename?: 'ProposalPageRowIndex';
  pageUUID: Scalars['String']['output'];
  proposalId: Scalars['Int']['output'];
  rowUUID: Scalars['String']['output'];
  version: ProposalVersion;
  versionId: Scalars['Int']['output'];
};

export type ProposalPageRowIndexCreateManyVersionInput = {
  pageUUID: Scalars['String']['input'];
  proposalId: Scalars['Int']['input'];
  rowUUID: Scalars['String']['input'];
};

export type ProposalPageRowIndexCreateManyVersionInputEnvelope = {
  data: Array<ProposalPageRowIndexCreateManyVersionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProposalPageRowIndexCreateNestedManyWithoutVersionInput = {
  connect?: InputMaybe<Array<ProposalPageRowIndexWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProposalPageRowIndexCreateOrConnectWithoutVersionInput>>;
  create?: InputMaybe<Array<ProposalPageRowIndexCreateWithoutVersionInput>>;
  createMany?: InputMaybe<ProposalPageRowIndexCreateManyVersionInputEnvelope>;
};

export type ProposalPageRowIndexCreateOrConnectWithoutVersionInput = {
  create: ProposalPageRowIndexCreateWithoutVersionInput;
  where: ProposalPageRowIndexWhereUniqueInput;
};

export type ProposalPageRowIndexCreateWithoutVersionInput = {
  pageUUID: Scalars['String']['input'];
  proposalId: Scalars['Int']['input'];
  rowUUID: Scalars['String']['input'];
};

export type ProposalPageRowIndexListRelationFilter = {
  every?: InputMaybe<ProposalPageRowIndexWhereInput>;
  none?: InputMaybe<ProposalPageRowIndexWhereInput>;
  some?: InputMaybe<ProposalPageRowIndexWhereInput>;
};

export type ProposalPageRowIndexOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum ProposalPageRowIndexOrderByRelevanceFieldEnum {
  PageUuid = 'pageUUID',
  RowUuid = 'rowUUID'
}

export type ProposalPageRowIndexOrderByRelevanceInput = {
  fields: Array<ProposalPageRowIndexOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type ProposalPageRowIndexOrderByWithRelationInput = {
  _relevance?: InputMaybe<ProposalPageRowIndexOrderByRelevanceInput>;
  pageUUID?: InputMaybe<SortOrder>;
  proposalId?: InputMaybe<SortOrder>;
  rowUUID?: InputMaybe<SortOrder>;
  version?: InputMaybe<ProposalVersionOrderByWithRelationInput>;
  versionId?: InputMaybe<SortOrder>;
};

export type ProposalPageRowIndexPageUuidVersionIdRowUuidCompoundUniqueInput = {
  pageUUID: Scalars['String']['input'];
  rowUUID: Scalars['String']['input'];
  versionId: Scalars['Int']['input'];
};

export enum ProposalPageRowIndexScalarFieldEnum {
  PageUuid = 'pageUUID',
  ProposalId = 'proposalId',
  RowUuid = 'rowUUID',
  VersionId = 'versionId'
}

export type ProposalPageRowIndexScalarWhereInput = {
  AND?: InputMaybe<Array<ProposalPageRowIndexScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProposalPageRowIndexScalarWhereInput>>;
  OR?: InputMaybe<Array<ProposalPageRowIndexScalarWhereInput>>;
  pageUUID?: InputMaybe<StringFilter>;
  proposalId?: InputMaybe<IntFilter>;
  rowUUID?: InputMaybe<StringFilter>;
  versionId?: InputMaybe<IntFilter>;
};

export type ProposalPageRowIndexUpdateManyMutationInput = {
  pageUUID?: InputMaybe<StringFieldUpdateOperationsInput>;
  proposalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  rowUUID?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProposalPageRowIndexUpdateManyWithWhereWithoutVersionInput = {
  data: ProposalPageRowIndexUpdateManyMutationInput;
  where: ProposalPageRowIndexScalarWhereInput;
};

export type ProposalPageRowIndexUpdateManyWithoutVersionNestedInput = {
  connect?: InputMaybe<Array<ProposalPageRowIndexWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProposalPageRowIndexCreateOrConnectWithoutVersionInput>>;
  create?: InputMaybe<Array<ProposalPageRowIndexCreateWithoutVersionInput>>;
  createMany?: InputMaybe<ProposalPageRowIndexCreateManyVersionInputEnvelope>;
  delete?: InputMaybe<Array<ProposalPageRowIndexWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProposalPageRowIndexScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProposalPageRowIndexWhereUniqueInput>>;
  set?: InputMaybe<Array<ProposalPageRowIndexWhereUniqueInput>>;
  update?: InputMaybe<Array<ProposalPageRowIndexUpdateWithWhereUniqueWithoutVersionInput>>;
  updateMany?: InputMaybe<Array<ProposalPageRowIndexUpdateManyWithWhereWithoutVersionInput>>;
  upsert?: InputMaybe<Array<ProposalPageRowIndexUpsertWithWhereUniqueWithoutVersionInput>>;
};

export type ProposalPageRowIndexUpdateWithWhereUniqueWithoutVersionInput = {
  data: ProposalPageRowIndexUpdateWithoutVersionInput;
  where: ProposalPageRowIndexWhereUniqueInput;
};

export type ProposalPageRowIndexUpdateWithoutVersionInput = {
  pageUUID?: InputMaybe<StringFieldUpdateOperationsInput>;
  proposalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  rowUUID?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProposalPageRowIndexUpsertWithWhereUniqueWithoutVersionInput = {
  create: ProposalPageRowIndexCreateWithoutVersionInput;
  update: ProposalPageRowIndexUpdateWithoutVersionInput;
  where: ProposalPageRowIndexWhereUniqueInput;
};

export type ProposalPageRowIndexWhereInput = {
  AND?: InputMaybe<Array<ProposalPageRowIndexWhereInput>>;
  NOT?: InputMaybe<Array<ProposalPageRowIndexWhereInput>>;
  OR?: InputMaybe<Array<ProposalPageRowIndexWhereInput>>;
  pageUUID?: InputMaybe<StringFilter>;
  proposalId?: InputMaybe<IntFilter>;
  rowUUID?: InputMaybe<StringFilter>;
  version?: InputMaybe<ProposalVersionScalarRelationFilter>;
  versionId?: InputMaybe<IntFilter>;
};

export type ProposalPageRowIndexWhereUniqueInput = {
  AND?: InputMaybe<Array<ProposalPageRowIndexWhereInput>>;
  NOT?: InputMaybe<Array<ProposalPageRowIndexWhereInput>>;
  OR?: InputMaybe<Array<ProposalPageRowIndexWhereInput>>;
  pageUUID?: InputMaybe<StringFilter>;
  pageUUID_versionId_rowUUID?: InputMaybe<ProposalPageRowIndexPageUuidVersionIdRowUuidCompoundUniqueInput>;
  proposalId?: InputMaybe<IntFilter>;
  rowUUID?: InputMaybe<StringFilter>;
  version?: InputMaybe<ProposalVersionScalarRelationFilter>;
  versionId?: InputMaybe<IntFilter>;
};

export type ProposalRowSummaryResult = {
  __typename?: 'ProposalRowSummaryResult';
  column_uuid: Scalars['String']['output'];
  last_updated_at: Scalars['Timestamp']['output'];
};

export enum ProposalScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Id = 'id',
  IsFinalized = 'isFinalized',
  Name = 'name',
  TemplateVersionId = 'templateVersionId',
  TotalCellCount = 'totalCellCount',
  TotalCellDataBytes = 'totalCellDataBytes',
  Type = 'type'
}

export type ProposalScalarRelationFilter = {
  is?: InputMaybe<ProposalWhereInput>;
  isNot?: InputMaybe<ProposalWhereInput>;
};

export type ProposalScalarWhereInput = {
  AND?: InputMaybe<Array<ProposalScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProposalScalarWhereInput>>;
  OR?: InputMaybe<Array<ProposalScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  isFinalized?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  templateVersionId?: InputMaybe<IntFilter>;
  totalCellCount?: InputMaybe<IntNullableFilter>;
  totalCellDataBytes?: InputMaybe<BigIntNullableFilter>;
  type?: InputMaybe<EnumProposalTypeFilter>;
};

export type ProposalTemplate = {
  __typename?: 'ProposalTemplate';
  _count?: Maybe<ProposalTemplateCount>;
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  lastVersion: ProposalTemplateVersion;
  name: Scalars['String']['output'];
  type: TemplateType;
  updatedAt: Scalars['Timestamp']['output'];
  versions: Array<ProposalTemplateVersion>;
};


export type ProposalTemplateVersionsArgs = {
  cursor?: InputMaybe<ProposalTemplateVersionWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProposalTemplateVersionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProposalTemplateVersionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalTemplateVersionWhereInput>;
};

export type ProposalTemplateAvgAggregate = {
  __typename?: 'ProposalTemplateAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type ProposalTemplateAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type ProposalTemplateCount = {
  __typename?: 'ProposalTemplateCount';
  versions: Scalars['Int']['output'];
};


export type ProposalTemplateCountVersionsArgs = {
  where?: InputMaybe<ProposalTemplateVersionWhereInput>;
};

export type ProposalTemplateCountAggregate = {
  __typename?: 'ProposalTemplateCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isDefault: Scalars['Int']['output'];
  isPublished: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ProposalTemplateCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDefault?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProposalTemplateCreateInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  type?: InputMaybe<TemplateType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  versions?: InputMaybe<ProposalTemplateVersionCreateNestedManyWithoutTemplateInput>;
};

export type ProposalTemplateCreateManyInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  type?: InputMaybe<TemplateType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ProposalTemplateCreateNestedOneWithoutVersionsInput = {
  connect?: InputMaybe<ProposalTemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProposalTemplateCreateOrConnectWithoutVersionsInput>;
  create?: InputMaybe<ProposalTemplateCreateWithoutVersionsInput>;
};

export type ProposalTemplateCreateOrConnectWithoutVersionsInput = {
  create: ProposalTemplateCreateWithoutVersionsInput;
  where: ProposalTemplateWhereUniqueInput;
};

export type ProposalTemplateCreateWithoutVersionsInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  type?: InputMaybe<TemplateType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ProposalTemplateGroupBy = {
  __typename?: 'ProposalTemplateGroupBy';
  _avg?: Maybe<ProposalTemplateAvgAggregate>;
  _count?: Maybe<ProposalTemplateCountAggregate>;
  _max?: Maybe<ProposalTemplateMaxAggregate>;
  _min?: Maybe<ProposalTemplateMinAggregate>;
  _sum?: Maybe<ProposalTemplateSumAggregate>;
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: TemplateType;
  updatedAt: Scalars['Timestamp']['output'];
};

export type ProposalTemplateMaxAggregate = {
  __typename?: 'ProposalTemplateMaxAggregate';
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TemplateType>;
  updatedAt?: Maybe<Scalars['Timestamp']['output']>;
};

export type ProposalTemplateMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDefault?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProposalTemplateMinAggregate = {
  __typename?: 'ProposalTemplateMinAggregate';
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TemplateType>;
  updatedAt?: Maybe<Scalars['Timestamp']['output']>;
};

export type ProposalTemplateMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDefault?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ProposalTemplateOrderByRelevanceFieldEnum {
  Name = 'name'
}

export type ProposalTemplateOrderByRelevanceInput = {
  fields: Array<ProposalTemplateOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type ProposalTemplateOrderByWithAggregationInput = {
  _avg?: InputMaybe<ProposalTemplateAvgOrderByAggregateInput>;
  _count?: InputMaybe<ProposalTemplateCountOrderByAggregateInput>;
  _max?: InputMaybe<ProposalTemplateMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProposalTemplateMinOrderByAggregateInput>;
  _sum?: InputMaybe<ProposalTemplateSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDefault?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProposalTemplateOrderByWithRelationInput = {
  _relevance?: InputMaybe<ProposalTemplateOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDefault?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  versions?: InputMaybe<ProposalTemplateVersionOrderByRelationAggregateInput>;
};

export enum ProposalTemplateScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  IsDefault = 'isDefault',
  IsPublished = 'isPublished',
  Name = 'name',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type ProposalTemplateScalarRelationFilter = {
  is?: InputMaybe<ProposalTemplateWhereInput>;
  isNot?: InputMaybe<ProposalTemplateWhereInput>;
};

export type ProposalTemplateScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProposalTemplateScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProposalTemplateScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProposalTemplateScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  isDefault?: InputMaybe<BoolWithAggregatesFilter>;
  isPublished?: InputMaybe<BoolWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  type?: InputMaybe<EnumTemplateTypeWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ProposalTemplateSumAggregate = {
  __typename?: 'ProposalTemplateSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
};

export type ProposalTemplateSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type ProposalTemplateUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isDefault?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumTemplateTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  versions?: InputMaybe<ProposalTemplateVersionUpdateManyWithoutTemplateNestedInput>;
};

export type ProposalTemplateUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isDefault?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumTemplateTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProposalTemplateUpdateOneRequiredWithoutVersionsNestedInput = {
  connect?: InputMaybe<ProposalTemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProposalTemplateCreateOrConnectWithoutVersionsInput>;
  create?: InputMaybe<ProposalTemplateCreateWithoutVersionsInput>;
  update?: InputMaybe<ProposalTemplateUpdateToOneWithWhereWithoutVersionsInput>;
  upsert?: InputMaybe<ProposalTemplateUpsertWithoutVersionsInput>;
};

export type ProposalTemplateUpdateToOneWithWhereWithoutVersionsInput = {
  data: ProposalTemplateUpdateWithoutVersionsInput;
  where?: InputMaybe<ProposalTemplateWhereInput>;
};

export type ProposalTemplateUpdateWithoutVersionsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isDefault?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumTemplateTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProposalTemplateUpsertWithoutVersionsInput = {
  create: ProposalTemplateCreateWithoutVersionsInput;
  update: ProposalTemplateUpdateWithoutVersionsInput;
  where?: InputMaybe<ProposalTemplateWhereInput>;
};

export type ProposalTemplateVersion = {
  __typename?: 'ProposalTemplateVersion';
  ProposalVersion: Array<ProposalVersion>;
  _count?: Maybe<ProposalTemplateVersionCount>;
  analyticsPages: Array<ProposalAnalyticsPage>;
  createdAt: Scalars['Timestamp']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  metrics: Scalars['JSON']['output'];
  pages: Scalars['JSON']['output'];
  proposals: Array<Proposal>;
  settings: Scalars['JSON']['output'];
  template: ProposalTemplate;
  templateId: Scalars['Int']['output'];
};


export type ProposalTemplateVersionProposalVersionArgs = {
  cursor?: InputMaybe<ProposalVersionWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProposalVersionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProposalVersionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalVersionWhereInput>;
};


export type ProposalTemplateVersionProposalsArgs = {
  cursor?: InputMaybe<ProposalWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProposalScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProposalOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalWhereInput>;
};

export type ProposalTemplateVersionCount = {
  __typename?: 'ProposalTemplateVersionCount';
  ProposalVersion: Scalars['Int']['output'];
  proposals: Scalars['Int']['output'];
};


export type ProposalTemplateVersionCountProposalVersionArgs = {
  where?: InputMaybe<ProposalVersionWhereInput>;
};


export type ProposalTemplateVersionCountProposalsArgs = {
  where?: InputMaybe<ProposalWhereInput>;
};

export type ProposalTemplateVersionCreateManyTemplateInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  metrics?: InputMaybe<Scalars['JSON']['input']>;
  pages: Scalars['JSON']['input'];
  settings?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProposalTemplateVersionCreateManyTemplateInputEnvelope = {
  data: Array<ProposalTemplateVersionCreateManyTemplateInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProposalTemplateVersionCreateNestedManyWithoutTemplateInput = {
  connect?: InputMaybe<Array<ProposalTemplateVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProposalTemplateVersionCreateOrConnectWithoutTemplateInput>>;
  create?: InputMaybe<Array<ProposalTemplateVersionCreateWithoutTemplateInput>>;
  createMany?: InputMaybe<ProposalTemplateVersionCreateManyTemplateInputEnvelope>;
};

export type ProposalTemplateVersionCreateNestedOneWithoutProposalVersionInput = {
  connect?: InputMaybe<ProposalTemplateVersionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProposalTemplateVersionCreateOrConnectWithoutProposalVersionInput>;
  create?: InputMaybe<ProposalTemplateVersionCreateWithoutProposalVersionInput>;
};

export type ProposalTemplateVersionCreateNestedOneWithoutProposalsInput = {
  connect?: InputMaybe<ProposalTemplateVersionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProposalTemplateVersionCreateOrConnectWithoutProposalsInput>;
  create?: InputMaybe<ProposalTemplateVersionCreateWithoutProposalsInput>;
};

export type ProposalTemplateVersionCreateOrConnectWithoutProposalVersionInput = {
  create: ProposalTemplateVersionCreateWithoutProposalVersionInput;
  where: ProposalTemplateVersionWhereUniqueInput;
};

export type ProposalTemplateVersionCreateOrConnectWithoutProposalsInput = {
  create: ProposalTemplateVersionCreateWithoutProposalsInput;
  where: ProposalTemplateVersionWhereUniqueInput;
};

export type ProposalTemplateVersionCreateOrConnectWithoutTemplateInput = {
  create: ProposalTemplateVersionCreateWithoutTemplateInput;
  where: ProposalTemplateVersionWhereUniqueInput;
};

export type ProposalTemplateVersionCreateWithoutProposalVersionInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  metrics?: InputMaybe<Scalars['JSON']['input']>;
  pages: Scalars['JSON']['input'];
  proposals?: InputMaybe<ProposalCreateNestedManyWithoutTemplateVersionInput>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  template: ProposalTemplateCreateNestedOneWithoutVersionsInput;
};

export type ProposalTemplateVersionCreateWithoutProposalsInput = {
  ProposalVersion?: InputMaybe<ProposalVersionCreateNestedManyWithoutTemplateVersionInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  metrics?: InputMaybe<Scalars['JSON']['input']>;
  pages: Scalars['JSON']['input'];
  settings?: InputMaybe<Scalars['JSON']['input']>;
  template: ProposalTemplateCreateNestedOneWithoutVersionsInput;
};

export type ProposalTemplateVersionCreateWithoutTemplateInput = {
  ProposalVersion?: InputMaybe<ProposalVersionCreateNestedManyWithoutTemplateVersionInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  metrics?: InputMaybe<Scalars['JSON']['input']>;
  pages: Scalars['JSON']['input'];
  proposals?: InputMaybe<ProposalCreateNestedManyWithoutTemplateVersionInput>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProposalTemplateVersionListRelationFilter = {
  every?: InputMaybe<ProposalTemplateVersionWhereInput>;
  none?: InputMaybe<ProposalTemplateVersionWhereInput>;
  some?: InputMaybe<ProposalTemplateVersionWhereInput>;
};

export type ProposalTemplateVersionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum ProposalTemplateVersionOrderByRelevanceFieldEnum {
  CreatedBy = 'createdBy'
}

export type ProposalTemplateVersionOrderByRelevanceInput = {
  fields: Array<ProposalTemplateVersionOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type ProposalTemplateVersionOrderByWithRelationInput = {
  ProposalVersion?: InputMaybe<ProposalVersionOrderByRelationAggregateInput>;
  _relevance?: InputMaybe<ProposalTemplateVersionOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  metrics?: InputMaybe<SortOrder>;
  pages?: InputMaybe<SortOrder>;
  proposals?: InputMaybe<ProposalOrderByRelationAggregateInput>;
  settings?: InputMaybe<SortOrder>;
  template?: InputMaybe<ProposalTemplateOrderByWithRelationInput>;
  templateId?: InputMaybe<SortOrder>;
};

export enum ProposalTemplateVersionScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Id = 'id',
  Metrics = 'metrics',
  Pages = 'pages',
  Settings = 'settings',
  TemplateId = 'templateId'
}

export type ProposalTemplateVersionScalarRelationFilter = {
  is?: InputMaybe<ProposalTemplateVersionWhereInput>;
  isNot?: InputMaybe<ProposalTemplateVersionWhereInput>;
};

export type ProposalTemplateVersionScalarWhereInput = {
  AND?: InputMaybe<Array<ProposalTemplateVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProposalTemplateVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<ProposalTemplateVersionScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  metrics?: InputMaybe<JsonFilter>;
  pages?: InputMaybe<JsonFilter>;
  settings?: InputMaybe<JsonFilter>;
  templateId?: InputMaybe<IntFilter>;
};

export type ProposalTemplateVersionUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metrics?: InputMaybe<Scalars['JSON']['input']>;
  pages?: InputMaybe<Scalars['JSON']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProposalTemplateVersionUpdateManyWithWhereWithoutTemplateInput = {
  data: ProposalTemplateVersionUpdateManyMutationInput;
  where: ProposalTemplateVersionScalarWhereInput;
};

export type ProposalTemplateVersionUpdateManyWithoutTemplateNestedInput = {
  connect?: InputMaybe<Array<ProposalTemplateVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProposalTemplateVersionCreateOrConnectWithoutTemplateInput>>;
  create?: InputMaybe<Array<ProposalTemplateVersionCreateWithoutTemplateInput>>;
  createMany?: InputMaybe<ProposalTemplateVersionCreateManyTemplateInputEnvelope>;
  delete?: InputMaybe<Array<ProposalTemplateVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProposalTemplateVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProposalTemplateVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<ProposalTemplateVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<ProposalTemplateVersionUpdateWithWhereUniqueWithoutTemplateInput>>;
  updateMany?: InputMaybe<Array<ProposalTemplateVersionUpdateManyWithWhereWithoutTemplateInput>>;
  upsert?: InputMaybe<Array<ProposalTemplateVersionUpsertWithWhereUniqueWithoutTemplateInput>>;
};

export type ProposalTemplateVersionUpdateOneRequiredWithoutProposalVersionNestedInput = {
  connect?: InputMaybe<ProposalTemplateVersionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProposalTemplateVersionCreateOrConnectWithoutProposalVersionInput>;
  create?: InputMaybe<ProposalTemplateVersionCreateWithoutProposalVersionInput>;
  update?: InputMaybe<ProposalTemplateVersionUpdateToOneWithWhereWithoutProposalVersionInput>;
  upsert?: InputMaybe<ProposalTemplateVersionUpsertWithoutProposalVersionInput>;
};

export type ProposalTemplateVersionUpdateOneRequiredWithoutProposalsNestedInput = {
  connect?: InputMaybe<ProposalTemplateVersionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProposalTemplateVersionCreateOrConnectWithoutProposalsInput>;
  create?: InputMaybe<ProposalTemplateVersionCreateWithoutProposalsInput>;
  update?: InputMaybe<ProposalTemplateVersionUpdateToOneWithWhereWithoutProposalsInput>;
  upsert?: InputMaybe<ProposalTemplateVersionUpsertWithoutProposalsInput>;
};

export type ProposalTemplateVersionUpdateToOneWithWhereWithoutProposalVersionInput = {
  data: ProposalTemplateVersionUpdateWithoutProposalVersionInput;
  where?: InputMaybe<ProposalTemplateVersionWhereInput>;
};

export type ProposalTemplateVersionUpdateToOneWithWhereWithoutProposalsInput = {
  data: ProposalTemplateVersionUpdateWithoutProposalsInput;
  where?: InputMaybe<ProposalTemplateVersionWhereInput>;
};

export type ProposalTemplateVersionUpdateWithWhereUniqueWithoutTemplateInput = {
  data: ProposalTemplateVersionUpdateWithoutTemplateInput;
  where: ProposalTemplateVersionWhereUniqueInput;
};

export type ProposalTemplateVersionUpdateWithoutProposalVersionInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metrics?: InputMaybe<Scalars['JSON']['input']>;
  pages?: InputMaybe<Scalars['JSON']['input']>;
  proposals?: InputMaybe<ProposalUpdateManyWithoutTemplateVersionNestedInput>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  template?: InputMaybe<ProposalTemplateUpdateOneRequiredWithoutVersionsNestedInput>;
};

export type ProposalTemplateVersionUpdateWithoutProposalsInput = {
  ProposalVersion?: InputMaybe<ProposalVersionUpdateManyWithoutTemplateVersionNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metrics?: InputMaybe<Scalars['JSON']['input']>;
  pages?: InputMaybe<Scalars['JSON']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  template?: InputMaybe<ProposalTemplateUpdateOneRequiredWithoutVersionsNestedInput>;
};

export type ProposalTemplateVersionUpdateWithoutTemplateInput = {
  ProposalVersion?: InputMaybe<ProposalVersionUpdateManyWithoutTemplateVersionNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metrics?: InputMaybe<Scalars['JSON']['input']>;
  pages?: InputMaybe<Scalars['JSON']['input']>;
  proposals?: InputMaybe<ProposalUpdateManyWithoutTemplateVersionNestedInput>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProposalTemplateVersionUpsertWithWhereUniqueWithoutTemplateInput = {
  create: ProposalTemplateVersionCreateWithoutTemplateInput;
  update: ProposalTemplateVersionUpdateWithoutTemplateInput;
  where: ProposalTemplateVersionWhereUniqueInput;
};

export type ProposalTemplateVersionUpsertWithoutProposalVersionInput = {
  create: ProposalTemplateVersionCreateWithoutProposalVersionInput;
  update: ProposalTemplateVersionUpdateWithoutProposalVersionInput;
  where?: InputMaybe<ProposalTemplateVersionWhereInput>;
};

export type ProposalTemplateVersionUpsertWithoutProposalsInput = {
  create: ProposalTemplateVersionCreateWithoutProposalsInput;
  update: ProposalTemplateVersionUpdateWithoutProposalsInput;
  where?: InputMaybe<ProposalTemplateVersionWhereInput>;
};

export type ProposalTemplateVersionWhereInput = {
  AND?: InputMaybe<Array<ProposalTemplateVersionWhereInput>>;
  NOT?: InputMaybe<Array<ProposalTemplateVersionWhereInput>>;
  OR?: InputMaybe<Array<ProposalTemplateVersionWhereInput>>;
  ProposalVersion?: InputMaybe<ProposalVersionListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  metrics?: InputMaybe<JsonFilter>;
  pages?: InputMaybe<JsonFilter>;
  proposals?: InputMaybe<ProposalListRelationFilter>;
  settings?: InputMaybe<JsonFilter>;
  template?: InputMaybe<ProposalTemplateScalarRelationFilter>;
  templateId?: InputMaybe<IntFilter>;
};

export type ProposalTemplateVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<ProposalTemplateVersionWhereInput>>;
  NOT?: InputMaybe<Array<ProposalTemplateVersionWhereInput>>;
  OR?: InputMaybe<Array<ProposalTemplateVersionWhereInput>>;
  ProposalVersion?: InputMaybe<ProposalVersionListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  metrics?: InputMaybe<JsonFilter>;
  pages?: InputMaybe<JsonFilter>;
  proposals?: InputMaybe<ProposalListRelationFilter>;
  settings?: InputMaybe<JsonFilter>;
  template?: InputMaybe<ProposalTemplateScalarRelationFilter>;
  templateId?: InputMaybe<IntFilter>;
};

export type ProposalTemplateWhereInput = {
  AND?: InputMaybe<Array<ProposalTemplateWhereInput>>;
  NOT?: InputMaybe<Array<ProposalTemplateWhereInput>>;
  OR?: InputMaybe<Array<ProposalTemplateWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  isDefault?: InputMaybe<BoolFilter>;
  isPublished?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumTemplateTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  versions?: InputMaybe<ProposalTemplateVersionListRelationFilter>;
};

export type ProposalTemplateWhereUniqueInput = {
  AND?: InputMaybe<Array<ProposalTemplateWhereInput>>;
  NOT?: InputMaybe<Array<ProposalTemplateWhereInput>>;
  OR?: InputMaybe<Array<ProposalTemplateWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isDefault?: InputMaybe<BoolFilter>;
  isPublished?: InputMaybe<BoolFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumTemplateTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  versions?: InputMaybe<ProposalTemplateVersionListRelationFilter>;
};

export enum ProposalType {
  Insight = 'INSIGHT',
  Proposal = 'PROPOSAL'
}

export type ProposalUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isFinalized?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastEditor?: InputMaybe<ProposalLastEditorUpdateOneWithoutProposalNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NoteUpdateManyWithoutProposalNestedInput>;
  userProposalAccess?: InputMaybe<UserProposalAccessUpdateManyWithoutProposalNestedInput>;
  version?: InputMaybe<ProposalVersionCreateInput>;
};

export type ProposalUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  isFinalized?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalCellCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  totalCellDataBytes?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumProposalTypeFieldUpdateOperationsInput>;
};

export type ProposalUpdateManyWithWhereWithoutTemplateVersionInput = {
  data: ProposalUpdateManyMutationInput;
  where: ProposalScalarWhereInput;
};

export type ProposalUpdateManyWithoutTemplateVersionNestedInput = {
  connect?: InputMaybe<Array<ProposalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProposalCreateOrConnectWithoutTemplateVersionInput>>;
  create?: InputMaybe<Array<ProposalCreateWithoutTemplateVersionInput>>;
  createMany?: InputMaybe<ProposalCreateManyTemplateVersionInputEnvelope>;
  delete?: InputMaybe<Array<ProposalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProposalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProposalWhereUniqueInput>>;
  set?: InputMaybe<Array<ProposalWhereUniqueInput>>;
  update?: InputMaybe<Array<ProposalUpdateWithWhereUniqueWithoutTemplateVersionInput>>;
  updateMany?: InputMaybe<Array<ProposalUpdateManyWithWhereWithoutTemplateVersionInput>>;
  upsert?: InputMaybe<Array<ProposalUpsertWithWhereUniqueWithoutTemplateVersionInput>>;
};

export type ProposalUpdateOneRequiredWithoutDataSourceVersionOriginNestedInput = {
  connect?: InputMaybe<ProposalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProposalCreateOrConnectWithoutDataSourceVersionOriginInput>;
  create?: InputMaybe<ProposalCreateWithoutDataSourceVersionOriginInput>;
  update?: InputMaybe<ProposalUpdateToOneWithWhereWithoutDataSourceVersionOriginInput>;
  upsert?: InputMaybe<ProposalUpsertWithoutDataSourceVersionOriginInput>;
};

export type ProposalUpdateOneRequiredWithoutNotesNestedInput = {
  connect?: InputMaybe<ProposalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProposalCreateOrConnectWithoutNotesInput>;
  create?: InputMaybe<ProposalCreateWithoutNotesInput>;
  update?: InputMaybe<ProposalUpdateToOneWithWhereWithoutNotesInput>;
  upsert?: InputMaybe<ProposalUpsertWithoutNotesInput>;
};

export type ProposalUpdateOneRequiredWithoutUserProposalAccessNestedInput = {
  connect?: InputMaybe<ProposalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProposalCreateOrConnectWithoutUserProposalAccessInput>;
  create?: InputMaybe<ProposalCreateWithoutUserProposalAccessInput>;
  update?: InputMaybe<ProposalUpdateToOneWithWhereWithoutUserProposalAccessInput>;
  upsert?: InputMaybe<ProposalUpsertWithoutUserProposalAccessInput>;
};

export type ProposalUpdateOneRequiredWithoutVersionsNestedInput = {
  connect?: InputMaybe<ProposalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProposalCreateOrConnectWithoutVersionsInput>;
  create?: InputMaybe<ProposalCreateWithoutVersionsInput>;
  update?: InputMaybe<ProposalUpdateToOneWithWhereWithoutVersionsInput>;
  upsert?: InputMaybe<ProposalUpsertWithoutVersionsInput>;
};

export type ProposalUpdateToOneWithWhereWithoutDataSourceVersionOriginInput = {
  data: ProposalUpdateWithoutDataSourceVersionOriginInput;
  where?: InputMaybe<ProposalWhereInput>;
};

export type ProposalUpdateToOneWithWhereWithoutNotesInput = {
  data: ProposalUpdateWithoutNotesInput;
  where?: InputMaybe<ProposalWhereInput>;
};

export type ProposalUpdateToOneWithWhereWithoutUserProposalAccessInput = {
  data: ProposalUpdateWithoutUserProposalAccessInput;
  where?: InputMaybe<ProposalWhereInput>;
};

export type ProposalUpdateToOneWithWhereWithoutVersionsInput = {
  data: ProposalUpdateWithoutVersionsInput;
  where?: InputMaybe<ProposalWhereInput>;
};

export type ProposalUpdateWithWhereUniqueWithoutTemplateVersionInput = {
  data: ProposalUpdateWithoutTemplateVersionInput;
  where: ProposalWhereUniqueInput;
};

export type ProposalUpdateWithoutDataSourceVersionOriginInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  isFinalized?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastEditor?: InputMaybe<ProposalLastEditorUpdateOneWithoutProposalNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NoteUpdateManyWithoutProposalNestedInput>;
  templateVersion?: InputMaybe<ProposalTemplateVersionUpdateOneRequiredWithoutProposalsNestedInput>;
  totalCellCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  totalCellDataBytes?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumProposalTypeFieldUpdateOperationsInput>;
  userProposalAccess?: InputMaybe<UserProposalAccessUpdateManyWithoutProposalNestedInput>;
  userProposalPins?: InputMaybe<UserProposalPinUpdateManyWithoutProposalNestedInput>;
  versions?: InputMaybe<ProposalVersionUpdateManyWithoutProposalNestedInput>;
};

export type ProposalUpdateWithoutNotesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  isFinalized?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastEditor?: InputMaybe<ProposalLastEditorUpdateOneWithoutProposalNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  templateVersion?: InputMaybe<ProposalTemplateVersionUpdateOneRequiredWithoutProposalsNestedInput>;
  totalCellCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  totalCellDataBytes?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumProposalTypeFieldUpdateOperationsInput>;
  userProposalAccess?: InputMaybe<UserProposalAccessUpdateManyWithoutProposalNestedInput>;
  userProposalPins?: InputMaybe<UserProposalPinUpdateManyWithoutProposalNestedInput>;
  versions?: InputMaybe<ProposalVersionUpdateManyWithoutProposalNestedInput>;
};

export type ProposalUpdateWithoutTemplateVersionInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  isFinalized?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastEditor?: InputMaybe<ProposalLastEditorUpdateOneWithoutProposalNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NoteUpdateManyWithoutProposalNestedInput>;
  totalCellCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  totalCellDataBytes?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumProposalTypeFieldUpdateOperationsInput>;
  userProposalAccess?: InputMaybe<UserProposalAccessUpdateManyWithoutProposalNestedInput>;
  userProposalPins?: InputMaybe<UserProposalPinUpdateManyWithoutProposalNestedInput>;
  versions?: InputMaybe<ProposalVersionUpdateManyWithoutProposalNestedInput>;
};

export type ProposalUpdateWithoutUserProposalAccessInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  isFinalized?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastEditor?: InputMaybe<ProposalLastEditorUpdateOneWithoutProposalNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NoteUpdateManyWithoutProposalNestedInput>;
  templateVersion?: InputMaybe<ProposalTemplateVersionUpdateOneRequiredWithoutProposalsNestedInput>;
  totalCellCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  totalCellDataBytes?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumProposalTypeFieldUpdateOperationsInput>;
  userProposalPins?: InputMaybe<UserProposalPinUpdateManyWithoutProposalNestedInput>;
  versions?: InputMaybe<ProposalVersionUpdateManyWithoutProposalNestedInput>;
};

export type ProposalUpdateWithoutVersionsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  isFinalized?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastEditor?: InputMaybe<ProposalLastEditorUpdateOneWithoutProposalNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NoteUpdateManyWithoutProposalNestedInput>;
  templateVersion?: InputMaybe<ProposalTemplateVersionUpdateOneRequiredWithoutProposalsNestedInput>;
  totalCellCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  totalCellDataBytes?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumProposalTypeFieldUpdateOperationsInput>;
  userProposalAccess?: InputMaybe<UserProposalAccessUpdateManyWithoutProposalNestedInput>;
  userProposalPins?: InputMaybe<UserProposalPinUpdateManyWithoutProposalNestedInput>;
};

export type ProposalUpsertWithWhereUniqueWithoutTemplateVersionInput = {
  create: ProposalCreateWithoutTemplateVersionInput;
  update: ProposalUpdateWithoutTemplateVersionInput;
  where: ProposalWhereUniqueInput;
};

export type ProposalUpsertWithoutDataSourceVersionOriginInput = {
  create: ProposalCreateWithoutDataSourceVersionOriginInput;
  update: ProposalUpdateWithoutDataSourceVersionOriginInput;
  where?: InputMaybe<ProposalWhereInput>;
};

export type ProposalUpsertWithoutNotesInput = {
  create: ProposalCreateWithoutNotesInput;
  update: ProposalUpdateWithoutNotesInput;
  where?: InputMaybe<ProposalWhereInput>;
};

export type ProposalUpsertWithoutUserProposalAccessInput = {
  create: ProposalCreateWithoutUserProposalAccessInput;
  update: ProposalUpdateWithoutUserProposalAccessInput;
  where?: InputMaybe<ProposalWhereInput>;
};

export type ProposalUpsertWithoutVersionsInput = {
  create: ProposalCreateWithoutVersionsInput;
  update: ProposalUpdateWithoutVersionsInput;
  where?: InputMaybe<ProposalWhereInput>;
};

export type ProposalVersion = {
  __typename?: 'ProposalVersion';
  _count?: Maybe<ProposalVersionCount>;
  cells: Array<ProposalCell>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  createdBy: Scalars['String']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  dataSchemaVersion: Scalars['Int']['output'];
  dataSourceUsedAt?: Maybe<Scalars['Timestamp']['output']>;
  dataSourceVersions: Array<ProposalVersionDataSource>;
  extractedPages: Scalars['JSON']['output'];
  fields: Array<ProposalField>;
  id: Scalars['Int']['output'];
  initialJsonHash: Scalars['String']['output'];
  initialJsonSizeBytes?: Maybe<Scalars['Int']['output']>;
  isSharedWithClient: Scalars['Boolean']['output'];
  jsonSizeBytes?: Maybe<Scalars['Int']['output']>;
  metrics: Array<ProposalMetric>;
  pageRowIndex: Array<ProposalPageRowIndex>;
  proposal: Proposal;
  proposalId: Scalars['Int']['output'];
  sequentialNumber: Scalars['Int']['output'];
  templateVersion: ProposalTemplateVersion;
  templateVersionId: Scalars['Int']['output'];
};


export type ProposalVersionCellsArgs = {
  cursor?: InputMaybe<ProposalCellWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProposalCellScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProposalCellOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalCellWhereInput>;
};


export type ProposalVersionDataSourceVersionsArgs = {
  cursor?: InputMaybe<ProposalVersionDataSourceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProposalVersionDataSourceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProposalVersionDataSourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalVersionDataSourceWhereInput>;
};


export type ProposalVersionFieldsArgs = {
  cursor?: InputMaybe<ProposalFieldWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProposalFieldScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProposalFieldOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalFieldWhereInput>;
};


export type ProposalVersionMetricsArgs = {
  cursor?: InputMaybe<ProposalMetricWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProposalMetricScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProposalMetricOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalMetricWhereInput>;
};


export type ProposalVersionPageRowIndexArgs = {
  cursor?: InputMaybe<ProposalPageRowIndexWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProposalPageRowIndexScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProposalPageRowIndexOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalPageRowIndexWhereInput>;
};

export type ProposalVersionCount = {
  __typename?: 'ProposalVersionCount';
  cells: Scalars['Int']['output'];
  dataSourceVersions: Scalars['Int']['output'];
  fields: Scalars['Int']['output'];
  metrics: Scalars['Int']['output'];
  pageRowIndex: Scalars['Int']['output'];
};


export type ProposalVersionCountCellsArgs = {
  where?: InputMaybe<ProposalCellWhereInput>;
};


export type ProposalVersionCountDataSourceVersionsArgs = {
  where?: InputMaybe<ProposalVersionDataSourceWhereInput>;
};


export type ProposalVersionCountFieldsArgs = {
  where?: InputMaybe<ProposalFieldWhereInput>;
};


export type ProposalVersionCountMetricsArgs = {
  where?: InputMaybe<ProposalMetricWhereInput>;
};


export type ProposalVersionCountPageRowIndexArgs = {
  where?: InputMaybe<ProposalPageRowIndexWhereInput>;
};

export type ProposalVersionCreateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  data: Scalars['JSON']['input'];
  dataSourceUsedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  dataSourceVersionIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  fields?: InputMaybe<ProposalFieldCreateNestedManyWithoutProposalVersionInput>;
  isSharedWithClient?: InputMaybe<Scalars['Boolean']['input']>;
  metrics?: InputMaybe<ProposalMetricCreateNestedManyWithoutProposalVersionInput>;
  templateVersionId: Scalars['Float']['input'];
};

export type ProposalVersionCreateManyProposalInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy: Scalars['String']['input'];
  dataSchemaVersion?: InputMaybe<Scalars['Int']['input']>;
  dataSourceUsedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  extractedPages?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  initialJsonHash?: InputMaybe<Scalars['String']['input']>;
  initialJsonSizeBytes?: InputMaybe<Scalars['Int']['input']>;
  isSharedWithClient?: InputMaybe<Scalars['Boolean']['input']>;
  jsonSizeBytes?: InputMaybe<Scalars['Int']['input']>;
  sequentialNumber: Scalars['Int']['input'];
  templateVersionId: Scalars['Int']['input'];
};

export type ProposalVersionCreateManyProposalInputEnvelope = {
  data: Array<ProposalVersionCreateManyProposalInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProposalVersionCreateManyTemplateVersionInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy: Scalars['String']['input'];
  dataSchemaVersion?: InputMaybe<Scalars['Int']['input']>;
  dataSourceUsedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  extractedPages?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  initialJsonHash?: InputMaybe<Scalars['String']['input']>;
  initialJsonSizeBytes?: InputMaybe<Scalars['Int']['input']>;
  isSharedWithClient?: InputMaybe<Scalars['Boolean']['input']>;
  jsonSizeBytes?: InputMaybe<Scalars['Int']['input']>;
  proposalId: Scalars['Int']['input'];
  sequentialNumber: Scalars['Int']['input'];
};

export type ProposalVersionCreateManyTemplateVersionInputEnvelope = {
  data: Array<ProposalVersionCreateManyTemplateVersionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProposalVersionCreateNestedManyWithoutProposalInput = {
  connect?: InputMaybe<Array<ProposalVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProposalVersionCreateOrConnectWithoutProposalInput>>;
  create?: InputMaybe<Array<ProposalVersionCreateWithoutProposalInput>>;
  createMany?: InputMaybe<ProposalVersionCreateManyProposalInputEnvelope>;
};

export type ProposalVersionCreateNestedManyWithoutTemplateVersionInput = {
  connect?: InputMaybe<Array<ProposalVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProposalVersionCreateOrConnectWithoutTemplateVersionInput>>;
  create?: InputMaybe<Array<ProposalVersionCreateWithoutTemplateVersionInput>>;
  createMany?: InputMaybe<ProposalVersionCreateManyTemplateVersionInputEnvelope>;
};

export type ProposalVersionCreateOrConnectWithoutProposalInput = {
  create: ProposalVersionCreateWithoutProposalInput;
  where: ProposalVersionWhereUniqueInput;
};

export type ProposalVersionCreateOrConnectWithoutTemplateVersionInput = {
  create: ProposalVersionCreateWithoutTemplateVersionInput;
  where: ProposalVersionWhereUniqueInput;
};

export type ProposalVersionCreateWithoutProposalInput = {
  cells?: InputMaybe<ProposalCellCreateNestedManyWithoutLastVersionInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy: Scalars['String']['input'];
  data?: InputMaybe<ProposalVersionDataCreateNestedOneWithoutProposalVersionInput>;
  dataSchemaVersion?: InputMaybe<Scalars['Int']['input']>;
  dataSourceUsedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  extractedPages?: InputMaybe<Scalars['JSON']['input']>;
  fields?: InputMaybe<ProposalFieldCreateNestedManyWithoutProposalVersionInput>;
  initialJsonHash?: InputMaybe<Scalars['String']['input']>;
  initialJsonSizeBytes?: InputMaybe<Scalars['Int']['input']>;
  isSharedWithClient?: InputMaybe<Scalars['Boolean']['input']>;
  jsonSizeBytes?: InputMaybe<Scalars['Int']['input']>;
  metrics?: InputMaybe<ProposalMetricCreateNestedManyWithoutProposalVersionInput>;
  pageRowIndex?: InputMaybe<ProposalPageRowIndexCreateNestedManyWithoutVersionInput>;
  sequentialNumber: Scalars['Int']['input'];
  templateVersion: ProposalTemplateVersionCreateNestedOneWithoutProposalVersionInput;
};

export type ProposalVersionCreateWithoutTemplateVersionInput = {
  cells?: InputMaybe<ProposalCellCreateNestedManyWithoutLastVersionInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy: Scalars['String']['input'];
  data?: InputMaybe<ProposalVersionDataCreateNestedOneWithoutProposalVersionInput>;
  dataSchemaVersion?: InputMaybe<Scalars['Int']['input']>;
  dataSourceUsedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  extractedPages?: InputMaybe<Scalars['JSON']['input']>;
  fields?: InputMaybe<ProposalFieldCreateNestedManyWithoutProposalVersionInput>;
  initialJsonHash?: InputMaybe<Scalars['String']['input']>;
  initialJsonSizeBytes?: InputMaybe<Scalars['Int']['input']>;
  isSharedWithClient?: InputMaybe<Scalars['Boolean']['input']>;
  jsonSizeBytes?: InputMaybe<Scalars['Int']['input']>;
  metrics?: InputMaybe<ProposalMetricCreateNestedManyWithoutProposalVersionInput>;
  pageRowIndex?: InputMaybe<ProposalPageRowIndexCreateNestedManyWithoutVersionInput>;
  proposal: ProposalCreateNestedOneWithoutVersionsInput;
  sequentialNumber: Scalars['Int']['input'];
};

export type ProposalVersionDataCreateNestedOneWithoutProposalVersionInput = {
  connect?: InputMaybe<ProposalVersionDataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProposalVersionDataCreateOrConnectWithoutProposalVersionInput>;
  create?: InputMaybe<ProposalVersionDataCreateWithoutProposalVersionInput>;
};

export type ProposalVersionDataCreateOrConnectWithoutProposalVersionInput = {
  create: ProposalVersionDataCreateWithoutProposalVersionInput;
  where: ProposalVersionDataWhereUniqueInput;
};

export type ProposalVersionDataCreateWithoutProposalVersionInput = {
  data: Scalars['JSON']['input'];
};

export type ProposalVersionDataNullableScalarRelationFilter = {
  is?: InputMaybe<ProposalVersionDataWhereInput>;
  isNot?: InputMaybe<ProposalVersionDataWhereInput>;
};

export type ProposalVersionDataOrderByWithRelationInput = {
  data?: InputMaybe<SortOrder>;
  proposalVersion?: InputMaybe<ProposalVersionOrderByWithRelationInput>;
  proposalVersionId?: InputMaybe<SortOrder>;
};

export type ProposalVersionDataSource = {
  __typename?: 'ProposalVersionDataSource';
  createdAt: Scalars['Timestamp']['output'];
  dataSourceVersion: DataSourceVersion;
  dataSourceVersionId: Scalars['Int']['output'];
  proposalVersion: ProposalVersion;
  proposalVersionId: Scalars['Int']['output'];
};

export type ProposalVersionDataSourceOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  dataSourceVersion?: InputMaybe<DataSourceVersionOrderByWithRelationInput>;
  dataSourceVersionId?: InputMaybe<SortOrder>;
  proposalVersion?: InputMaybe<ProposalVersionOrderByWithRelationInput>;
  proposalVersionId?: InputMaybe<SortOrder>;
};

export type ProposalVersionDataSourceProposalVersionIdDataSourceVersionIdCompoundUniqueInput = {
  dataSourceVersionId: Scalars['Int']['input'];
  proposalVersionId: Scalars['Int']['input'];
};

export enum ProposalVersionDataSourceScalarFieldEnum {
  CreatedAt = 'createdAt',
  DataSourceVersionId = 'dataSourceVersionId',
  ProposalVersionId = 'proposalVersionId'
}

export type ProposalVersionDataSourceWhereInput = {
  AND?: InputMaybe<Array<ProposalVersionDataSourceWhereInput>>;
  NOT?: InputMaybe<Array<ProposalVersionDataSourceWhereInput>>;
  OR?: InputMaybe<Array<ProposalVersionDataSourceWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dataSourceVersion?: InputMaybe<DataSourceVersionScalarRelationFilter>;
  dataSourceVersionId?: InputMaybe<IntFilter>;
  proposalVersion?: InputMaybe<ProposalVersionScalarRelationFilter>;
  proposalVersionId?: InputMaybe<IntFilter>;
};

export type ProposalVersionDataSourceWhereUniqueInput = {
  AND?: InputMaybe<Array<ProposalVersionDataSourceWhereInput>>;
  NOT?: InputMaybe<Array<ProposalVersionDataSourceWhereInput>>;
  OR?: InputMaybe<Array<ProposalVersionDataSourceWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dataSourceVersion?: InputMaybe<DataSourceVersionScalarRelationFilter>;
  dataSourceVersionId?: InputMaybe<IntFilter>;
  proposalVersion?: InputMaybe<ProposalVersionScalarRelationFilter>;
  proposalVersionId?: InputMaybe<IntFilter>;
  proposalVersionId_dataSourceVersionId?: InputMaybe<ProposalVersionDataSourceProposalVersionIdDataSourceVersionIdCompoundUniqueInput>;
};

export type ProposalVersionDataUpdateOneWithoutProposalVersionNestedInput = {
  connect?: InputMaybe<ProposalVersionDataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProposalVersionDataCreateOrConnectWithoutProposalVersionInput>;
  create?: InputMaybe<ProposalVersionDataCreateWithoutProposalVersionInput>;
  delete?: InputMaybe<ProposalVersionDataWhereInput>;
  disconnect?: InputMaybe<ProposalVersionDataWhereInput>;
  update?: InputMaybe<ProposalVersionDataUpdateToOneWithWhereWithoutProposalVersionInput>;
  upsert?: InputMaybe<ProposalVersionDataUpsertWithoutProposalVersionInput>;
};

export type ProposalVersionDataUpdateToOneWithWhereWithoutProposalVersionInput = {
  data: ProposalVersionDataUpdateWithoutProposalVersionInput;
  where?: InputMaybe<ProposalVersionDataWhereInput>;
};

export type ProposalVersionDataUpdateWithoutProposalVersionInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProposalVersionDataUpsertWithoutProposalVersionInput = {
  create: ProposalVersionDataCreateWithoutProposalVersionInput;
  update: ProposalVersionDataUpdateWithoutProposalVersionInput;
  where?: InputMaybe<ProposalVersionDataWhereInput>;
};

export type ProposalVersionDataWhereInput = {
  AND?: InputMaybe<Array<ProposalVersionDataWhereInput>>;
  NOT?: InputMaybe<Array<ProposalVersionDataWhereInput>>;
  OR?: InputMaybe<Array<ProposalVersionDataWhereInput>>;
  data?: InputMaybe<JsonFilter>;
  proposalVersion?: InputMaybe<ProposalVersionScalarRelationFilter>;
  proposalVersionId?: InputMaybe<IntFilter>;
};

export type ProposalVersionDataWhereUniqueInput = {
  AND?: InputMaybe<Array<ProposalVersionDataWhereInput>>;
  NOT?: InputMaybe<Array<ProposalVersionDataWhereInput>>;
  OR?: InputMaybe<Array<ProposalVersionDataWhereInput>>;
  data?: InputMaybe<JsonFilter>;
  proposalVersion?: InputMaybe<ProposalVersionScalarRelationFilter>;
  proposalVersionId?: InputMaybe<Scalars['Int']['input']>;
};

export type ProposalVersionListRelationFilter = {
  every?: InputMaybe<ProposalVersionWhereInput>;
  none?: InputMaybe<ProposalVersionWhereInput>;
  some?: InputMaybe<ProposalVersionWhereInput>;
};

export type ProposalVersionNullableScalarRelationFilter = {
  is?: InputMaybe<ProposalVersionWhereInput>;
  isNot?: InputMaybe<ProposalVersionWhereInput>;
};

export type ProposalVersionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum ProposalVersionOrderByRelevanceFieldEnum {
  Comment = 'comment',
  CreatedBy = 'createdBy',
  InitialJsonHash = 'initialJsonHash'
}

export type ProposalVersionOrderByRelevanceInput = {
  fields: Array<ProposalVersionOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type ProposalVersionOrderByWithRelationInput = {
  _relevance?: InputMaybe<ProposalVersionOrderByRelevanceInput>;
  cells?: InputMaybe<ProposalCellOrderByRelationAggregateInput>;
  comment?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  data?: InputMaybe<ProposalVersionDataOrderByWithRelationInput>;
  dataSchemaVersion?: InputMaybe<SortOrder>;
  dataSourceUsedAt?: InputMaybe<SortOrderInput>;
  extractedPages?: InputMaybe<SortOrder>;
  fields?: InputMaybe<ProposalFieldOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  initialJsonHash?: InputMaybe<SortOrder>;
  initialJsonSizeBytes?: InputMaybe<SortOrderInput>;
  isSharedWithClient?: InputMaybe<SortOrder>;
  jsonSizeBytes?: InputMaybe<SortOrderInput>;
  metrics?: InputMaybe<ProposalMetricOrderByRelationAggregateInput>;
  pageRowIndex?: InputMaybe<ProposalPageRowIndexOrderByRelationAggregateInput>;
  proposal?: InputMaybe<ProposalOrderByWithRelationInput>;
  proposalId?: InputMaybe<SortOrder>;
  sequentialNumber?: InputMaybe<SortOrder>;
  templateVersion?: InputMaybe<ProposalTemplateVersionOrderByWithRelationInput>;
  templateVersionId?: InputMaybe<SortOrder>;
};

export enum ProposalVersionScalarFieldEnum {
  Comment = 'comment',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DataSchemaVersion = 'dataSchemaVersion',
  DataSourceUsedAt = 'dataSourceUsedAt',
  ExtractedPages = 'extractedPages',
  Id = 'id',
  InitialJsonHash = 'initialJsonHash',
  InitialJsonSizeBytes = 'initialJsonSizeBytes',
  IsSharedWithClient = 'isSharedWithClient',
  JsonSizeBytes = 'jsonSizeBytes',
  ProposalId = 'proposalId',
  SequentialNumber = 'sequentialNumber',
  TemplateVersionId = 'templateVersionId'
}

export type ProposalVersionScalarRelationFilter = {
  is?: InputMaybe<ProposalVersionWhereInput>;
  isNot?: InputMaybe<ProposalVersionWhereInput>;
};

export type ProposalVersionScalarWhereInput = {
  AND?: InputMaybe<Array<ProposalVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProposalVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<ProposalVersionScalarWhereInput>>;
  comment?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  dataSchemaVersion?: InputMaybe<IntFilter>;
  dataSourceUsedAt?: InputMaybe<DateTimeNullableFilter>;
  extractedPages?: InputMaybe<JsonFilter>;
  id?: InputMaybe<IntFilter>;
  initialJsonHash?: InputMaybe<StringFilter>;
  initialJsonSizeBytes?: InputMaybe<IntNullableFilter>;
  isSharedWithClient?: InputMaybe<BoolFilter>;
  jsonSizeBytes?: InputMaybe<IntNullableFilter>;
  proposalId?: InputMaybe<IntFilter>;
  sequentialNumber?: InputMaybe<IntFilter>;
  templateVersionId?: InputMaybe<IntFilter>;
};

export type ProposalVersionUpdateManyMutationInput = {
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dataSchemaVersion?: InputMaybe<IntFieldUpdateOperationsInput>;
  dataSourceUsedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  extractedPages?: InputMaybe<Scalars['JSON']['input']>;
  initialJsonHash?: InputMaybe<StringFieldUpdateOperationsInput>;
  initialJsonSizeBytes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isSharedWithClient?: InputMaybe<BoolFieldUpdateOperationsInput>;
  jsonSizeBytes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sequentialNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ProposalVersionUpdateManyWithWhereWithoutProposalInput = {
  data: ProposalVersionUpdateManyMutationInput;
  where: ProposalVersionScalarWhereInput;
};

export type ProposalVersionUpdateManyWithWhereWithoutTemplateVersionInput = {
  data: ProposalVersionUpdateManyMutationInput;
  where: ProposalVersionScalarWhereInput;
};

export type ProposalVersionUpdateManyWithoutProposalNestedInput = {
  connect?: InputMaybe<Array<ProposalVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProposalVersionCreateOrConnectWithoutProposalInput>>;
  create?: InputMaybe<Array<ProposalVersionCreateWithoutProposalInput>>;
  createMany?: InputMaybe<ProposalVersionCreateManyProposalInputEnvelope>;
  delete?: InputMaybe<Array<ProposalVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProposalVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProposalVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<ProposalVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<ProposalVersionUpdateWithWhereUniqueWithoutProposalInput>>;
  updateMany?: InputMaybe<Array<ProposalVersionUpdateManyWithWhereWithoutProposalInput>>;
  upsert?: InputMaybe<Array<ProposalVersionUpsertWithWhereUniqueWithoutProposalInput>>;
};

export type ProposalVersionUpdateManyWithoutTemplateVersionNestedInput = {
  connect?: InputMaybe<Array<ProposalVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProposalVersionCreateOrConnectWithoutTemplateVersionInput>>;
  create?: InputMaybe<Array<ProposalVersionCreateWithoutTemplateVersionInput>>;
  createMany?: InputMaybe<ProposalVersionCreateManyTemplateVersionInputEnvelope>;
  delete?: InputMaybe<Array<ProposalVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProposalVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProposalVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<ProposalVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<ProposalVersionUpdateWithWhereUniqueWithoutTemplateVersionInput>>;
  updateMany?: InputMaybe<Array<ProposalVersionUpdateManyWithWhereWithoutTemplateVersionInput>>;
  upsert?: InputMaybe<Array<ProposalVersionUpsertWithWhereUniqueWithoutTemplateVersionInput>>;
};

export type ProposalVersionUpdateWithWhereUniqueWithoutProposalInput = {
  data: ProposalVersionUpdateWithoutProposalInput;
  where: ProposalVersionWhereUniqueInput;
};

export type ProposalVersionUpdateWithWhereUniqueWithoutTemplateVersionInput = {
  data: ProposalVersionUpdateWithoutTemplateVersionInput;
  where: ProposalVersionWhereUniqueInput;
};

export type ProposalVersionUpdateWithoutProposalInput = {
  cells?: InputMaybe<ProposalCellUpdateManyWithoutLastVersionNestedInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<ProposalVersionDataUpdateOneWithoutProposalVersionNestedInput>;
  dataSchemaVersion?: InputMaybe<IntFieldUpdateOperationsInput>;
  dataSourceUsedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  extractedPages?: InputMaybe<Scalars['JSON']['input']>;
  fields?: InputMaybe<ProposalFieldUpdateManyWithoutProposalVersionNestedInput>;
  initialJsonHash?: InputMaybe<StringFieldUpdateOperationsInput>;
  initialJsonSizeBytes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isSharedWithClient?: InputMaybe<BoolFieldUpdateOperationsInput>;
  jsonSizeBytes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  metrics?: InputMaybe<ProposalMetricUpdateManyWithoutProposalVersionNestedInput>;
  pageRowIndex?: InputMaybe<ProposalPageRowIndexUpdateManyWithoutVersionNestedInput>;
  sequentialNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
  templateVersion?: InputMaybe<ProposalTemplateVersionUpdateOneRequiredWithoutProposalVersionNestedInput>;
};

export type ProposalVersionUpdateWithoutTemplateVersionInput = {
  cells?: InputMaybe<ProposalCellUpdateManyWithoutLastVersionNestedInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<ProposalVersionDataUpdateOneWithoutProposalVersionNestedInput>;
  dataSchemaVersion?: InputMaybe<IntFieldUpdateOperationsInput>;
  dataSourceUsedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  extractedPages?: InputMaybe<Scalars['JSON']['input']>;
  fields?: InputMaybe<ProposalFieldUpdateManyWithoutProposalVersionNestedInput>;
  initialJsonHash?: InputMaybe<StringFieldUpdateOperationsInput>;
  initialJsonSizeBytes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isSharedWithClient?: InputMaybe<BoolFieldUpdateOperationsInput>;
  jsonSizeBytes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  metrics?: InputMaybe<ProposalMetricUpdateManyWithoutProposalVersionNestedInput>;
  pageRowIndex?: InputMaybe<ProposalPageRowIndexUpdateManyWithoutVersionNestedInput>;
  proposal?: InputMaybe<ProposalUpdateOneRequiredWithoutVersionsNestedInput>;
  sequentialNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ProposalVersionUpsertWithWhereUniqueWithoutProposalInput = {
  create: ProposalVersionCreateWithoutProposalInput;
  update: ProposalVersionUpdateWithoutProposalInput;
  where: ProposalVersionWhereUniqueInput;
};

export type ProposalVersionUpsertWithWhereUniqueWithoutTemplateVersionInput = {
  create: ProposalVersionCreateWithoutTemplateVersionInput;
  update: ProposalVersionUpdateWithoutTemplateVersionInput;
  where: ProposalVersionWhereUniqueInput;
};

export type ProposalVersionWhereInput = {
  AND?: InputMaybe<Array<ProposalVersionWhereInput>>;
  NOT?: InputMaybe<Array<ProposalVersionWhereInput>>;
  OR?: InputMaybe<Array<ProposalVersionWhereInput>>;
  cells?: InputMaybe<ProposalCellListRelationFilter>;
  comment?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  data?: InputMaybe<ProposalVersionDataNullableScalarRelationFilter>;
  dataSchemaVersion?: InputMaybe<IntFilter>;
  dataSourceUsedAt?: InputMaybe<DateTimeNullableFilter>;
  extractedPages?: InputMaybe<JsonFilter>;
  fields?: InputMaybe<ProposalFieldListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  initialJsonHash?: InputMaybe<StringFilter>;
  initialJsonSizeBytes?: InputMaybe<IntNullableFilter>;
  isSharedWithClient?: InputMaybe<BoolFilter>;
  jsonSizeBytes?: InputMaybe<IntNullableFilter>;
  metrics?: InputMaybe<ProposalMetricListRelationFilter>;
  pageRowIndex?: InputMaybe<ProposalPageRowIndexListRelationFilter>;
  proposal?: InputMaybe<ProposalScalarRelationFilter>;
  proposalId?: InputMaybe<IntFilter>;
  sequentialNumber?: InputMaybe<IntFilter>;
  templateVersion?: InputMaybe<ProposalTemplateVersionScalarRelationFilter>;
  templateVersionId?: InputMaybe<IntFilter>;
};

export type ProposalVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<ProposalVersionWhereInput>>;
  NOT?: InputMaybe<Array<ProposalVersionWhereInput>>;
  OR?: InputMaybe<Array<ProposalVersionWhereInput>>;
  cells?: InputMaybe<ProposalCellListRelationFilter>;
  comment?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  data?: InputMaybe<ProposalVersionDataNullableScalarRelationFilter>;
  dataSchemaVersion?: InputMaybe<IntFilter>;
  dataSourceUsedAt?: InputMaybe<DateTimeNullableFilter>;
  extractedPages?: InputMaybe<JsonFilter>;
  fields?: InputMaybe<ProposalFieldListRelationFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  initialJsonHash?: InputMaybe<StringFilter>;
  initialJsonSizeBytes?: InputMaybe<IntNullableFilter>;
  isSharedWithClient?: InputMaybe<BoolFilter>;
  jsonSizeBytes?: InputMaybe<IntNullableFilter>;
  metrics?: InputMaybe<ProposalMetricListRelationFilter>;
  pageRowIndex?: InputMaybe<ProposalPageRowIndexListRelationFilter>;
  proposal?: InputMaybe<ProposalScalarRelationFilter>;
  proposalId?: InputMaybe<IntFilter>;
  sequentialNumber?: InputMaybe<IntFilter>;
  templateVersion?: InputMaybe<ProposalTemplateVersionScalarRelationFilter>;
  templateVersionId?: InputMaybe<IntFilter>;
};

export type ProposalWhereInput = {
  AND?: InputMaybe<Array<ProposalWhereInput>>;
  NOT?: InputMaybe<Array<ProposalWhereInput>>;
  OR?: InputMaybe<Array<ProposalWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  isFinalized?: InputMaybe<BoolFilter>;
  lastEditor?: InputMaybe<ProposalLastEditorNullableScalarRelationFilter>;
  name?: InputMaybe<StringFilter>;
  notes?: InputMaybe<NoteListRelationFilter>;
  templateVersion?: InputMaybe<ProposalTemplateVersionScalarRelationFilter>;
  templateVersionId?: InputMaybe<IntFilter>;
  totalCellCount?: InputMaybe<IntNullableFilter>;
  totalCellDataBytes?: InputMaybe<BigIntNullableFilter>;
  type?: InputMaybe<EnumProposalTypeFilter>;
  userProposalAccess?: InputMaybe<UserProposalAccessListRelationFilter>;
  userProposalPins?: InputMaybe<UserProposalPinListRelationFilter>;
  versions?: InputMaybe<ProposalVersionListRelationFilter>;
};

export type ProposalWhereUniqueInput = {
  AND?: InputMaybe<Array<ProposalWhereInput>>;
  NOT?: InputMaybe<Array<ProposalWhereInput>>;
  OR?: InputMaybe<Array<ProposalWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isFinalized?: InputMaybe<BoolFilter>;
  lastEditor?: InputMaybe<ProposalLastEditorNullableScalarRelationFilter>;
  name?: InputMaybe<StringFilter>;
  notes?: InputMaybe<NoteListRelationFilter>;
  templateVersion?: InputMaybe<ProposalTemplateVersionScalarRelationFilter>;
  templateVersionId?: InputMaybe<IntFilter>;
  totalCellCount?: InputMaybe<IntNullableFilter>;
  totalCellDataBytes?: InputMaybe<BigIntNullableFilter>;
  type?: InputMaybe<EnumProposalTypeFilter>;
  userProposalAccess?: InputMaybe<UserProposalAccessListRelationFilter>;
  userProposalPins?: InputMaybe<UserProposalPinListRelationFilter>;
  versions?: InputMaybe<ProposalVersionListRelationFilter>;
};

export type ProposalWithPageIds = {
  id: Scalars['Int']['input'];
  pageIds: Array<Scalars['String']['input']>;
  version: IdInt;
};

export type ProposalsFilter = {
  items: Array<ProposalsFilterItem>;
  logicalOperator: LogicalOperator;
};

export type ProposalsFilterItem = {
  field: Scalars['String']['input'];
  operator: Scalars['String']['input'];
  value: Scalars['String']['input'];
  values?: Array<Scalars['String']['input']>;
};

export type ProposalsPaginated = {
  __typename?: 'ProposalsPaginated';
  count: Scalars['Int']['output'];
  items: Array<ProposalListItem>;
};

export type ProposalsSortItem = {
  field: Scalars['String']['input'];
  sort?: InputMaybe<SortOrder>;
};

export type PublicConfig = {
  __typename?: 'PublicConfig';
  cdnHost: Scalars['String']['output'];
  cdnMediaUploadEndpoint: Scalars['String']['output'];
  clickhouseConfigured: Scalars['Boolean']['output'];
  features: Features;
};

export type Query = {
  __typename?: 'Query';
  aggregateAnalyticsDashboard: AggregateAnalyticsDashboard;
  aggregateAnalyticsDashboardChart: AggregateAnalyticsDashboardChart;
  aggregateAnalyticsDashboardFiltersSource: AggregateAnalyticsDashboardFiltersSource;
  aggregateDataSource: AggregateDataSource;
  aggregateDataSourceCell: AggregateDataSourceCell;
  aggregateDataSourceVersion: AggregateDataSourceVersion;
  aggregateDataSourceVersionOrigin: AggregateDataSourceVersionOrigin;
  aggregateLookup: AggregateLookup;
  aggregateNote: AggregateNote;
  aggregateProposalTemplate: AggregateProposalTemplate;
  aggregateUserProposalAccess: AggregateUserProposalAccess;
  allProposalsIds: Array<Scalars['Int']['output']>;
  analyticsDashboard?: Maybe<AnalyticsDashboard>;
  analyticsDashboardChart?: Maybe<AnalyticsDashboardChart>;
  analyticsDashboardCharts: Array<AnalyticsDashboardChart>;
  analyticsDashboardFiltersSource?: Maybe<AnalyticsDashboardFiltersSource>;
  analyticsDashboardFiltersSources: Array<AnalyticsDashboardFiltersSource>;
  analyticsDashboards: Array<AnalyticsDashboard>;
  auditEvents: Array<EventAggregationByInterval>;
  client: Client;
  /** return all clients */
  clients: Array<Client>;
  configPublicInfo: PublicConfig;
  currentClient: Client;
  /** Returns client members without sensitive data */
  currentClientMembers: ClientMembers;
  dashboardChartData: Scalars['String']['output'];
  dataSource?: Maybe<DataSource>;
  dataSourceCell?: Maybe<DataSourceCell>;
  dataSourceCells: Array<DataSourceCell>;
  dataSourceDeleteImpact: DataSourceDeleteImpact;
  dataSourceGet?: Maybe<DataSource>;
  dataSourceVersion?: Maybe<DataSourceVersion>;
  dataSourceVersionOrigin?: Maybe<DataSourceVersionOrigin>;
  dataSourceVersionOrigins: Array<DataSourceVersionOrigin>;
  dataSourceVersions: Array<DataSourceVersion>;
  dataSources: Array<DataSource>;
  dataSourcesMeta: Array<DataSourceMeta>;
  defaultInfo: DefaultInfo;
  findFirstAnalyticsDashboard?: Maybe<AnalyticsDashboard>;
  findFirstAnalyticsDashboardChart?: Maybe<AnalyticsDashboardChart>;
  findFirstAnalyticsDashboardChartOrThrow?: Maybe<AnalyticsDashboardChart>;
  findFirstAnalyticsDashboardFiltersSource?: Maybe<AnalyticsDashboardFiltersSource>;
  findFirstAnalyticsDashboardFiltersSourceOrThrow?: Maybe<AnalyticsDashboardFiltersSource>;
  findFirstAnalyticsDashboardOrThrow?: Maybe<AnalyticsDashboard>;
  findFirstDataSource?: Maybe<DataSource>;
  findFirstDataSourceCell?: Maybe<DataSourceCell>;
  findFirstDataSourceCellOrThrow?: Maybe<DataSourceCell>;
  findFirstDataSourceOrThrow?: Maybe<DataSource>;
  findFirstDataSourceVersion?: Maybe<DataSourceVersion>;
  findFirstDataSourceVersionOrThrow?: Maybe<DataSourceVersion>;
  findFirstDataSourceVersionOrigin?: Maybe<DataSourceVersionOrigin>;
  findFirstDataSourceVersionOriginOrThrow?: Maybe<DataSourceVersionOrigin>;
  findFirstLookup?: Maybe<Lookup>;
  findFirstLookupOrThrow?: Maybe<Lookup>;
  findFirstNote?: Maybe<Note>;
  findFirstNoteOrThrow?: Maybe<Note>;
  findFirstProposalTemplate?: Maybe<ProposalTemplate>;
  findFirstProposalTemplateOrThrow?: Maybe<ProposalTemplate>;
  findFirstProposalTemplateVersionOrThrow?: Maybe<ProposalTemplateVersion>;
  findFirstUserProposalAccess?: Maybe<UserProposalAccess>;
  findFirstUserProposalAccessOrThrow?: Maybe<UserProposalAccess>;
  getAnalyticsDashboard?: Maybe<AnalyticsDashboard>;
  getAnalyticsDashboardChart?: Maybe<AnalyticsDashboardChart>;
  getAnalyticsDashboardFiltersSource?: Maybe<AnalyticsDashboardFiltersSource>;
  getDataSource?: Maybe<DataSource>;
  getDataSourceCell?: Maybe<DataSourceCell>;
  getDataSourceVersion?: Maybe<DataSourceVersion>;
  getDataSourceVersionOrigin?: Maybe<DataSourceVersionOrigin>;
  getLookup?: Maybe<Lookup>;
  getNote?: Maybe<Note>;
  getProposalTemplate?: Maybe<ProposalTemplate>;
  getUserProposalAccess?: Maybe<UserProposalAccess>;
  groupByAnalyticsDashboard: Array<AnalyticsDashboardGroupBy>;
  groupByAnalyticsDashboardChart: Array<AnalyticsDashboardChartGroupBy>;
  groupByAnalyticsDashboardFiltersSource: Array<AnalyticsDashboardFiltersSourceGroupBy>;
  groupByDataSource: Array<DataSourceGroupBy>;
  groupByDataSourceCell: Array<DataSourceCellGroupBy>;
  groupByDataSourceVersion: Array<DataSourceVersionGroupBy>;
  groupByDataSourceVersionOrigin: Array<DataSourceVersionOriginGroupBy>;
  groupByLookup: Array<LookupGroupBy>;
  groupByNote: Array<NoteGroupBy>;
  groupByProposalTemplate: Array<ProposalTemplateGroupBy>;
  groupByUserProposalAccess: Array<UserProposalAccessGroupBy>;
  insightAuditChangeBreakdown?: Maybe<InsightAuditChangeBreakdown>;
  insightAuditChanges: InsightAuditChangesPaginated;
  lastEditor?: Maybe<Scalars['String']['output']>;
  lookup?: Maybe<Lookup>;
  lookups: Array<Lookup>;
  navigationPositionByClient: NavigationPositionResp;
  note?: Maybe<Note>;
  notes: Array<Note>;
  prompt?: Maybe<Scalars['String']['output']>;
  proposal?: Maybe<Proposal>;
  proposalAnalytic?: Maybe<Resp>;
  proposalName: Scalars['String']['output'];
  proposalPageDataSourceRows?: Maybe<ProposalPageDataSourceRows>;
  proposalRowSummary: Array<ProposalRowSummaryResult>;
  proposalTemplate?: Maybe<ProposalTemplate>;
  proposalTemplates: Array<ProposalTemplate>;
  proposalVersions: Array<ProposalVersion>;
  proposals: ProposalsPaginated;
  templateOptions: Array<ProposalTemplate>;
  userCredentials: Array<CredentialRepresentation>;
  userProposalAccess?: Maybe<UserProposalAccess>;
  userProposalAccesses: Array<UserProposalAccess>;
  usersActivity: Array<UserActivityRow>;
};


export type QueryAggregateAnalyticsDashboardArgs = {
  cursor?: InputMaybe<AnalyticsDashboardWhereUniqueInput>;
  orderBy?: InputMaybe<Array<AnalyticsDashboardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnalyticsDashboardWhereInput>;
};


export type QueryAggregateAnalyticsDashboardChartArgs = {
  cursor?: InputMaybe<AnalyticsDashboardChartWhereUniqueInput>;
  orderBy?: InputMaybe<Array<AnalyticsDashboardChartOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnalyticsDashboardChartWhereInput>;
};


export type QueryAggregateAnalyticsDashboardFiltersSourceArgs = {
  cursor?: InputMaybe<AnalyticsDashboardFiltersSourceWhereUniqueInput>;
  orderBy?: InputMaybe<Array<AnalyticsDashboardFiltersSourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnalyticsDashboardFiltersSourceWhereInput>;
};


export type QueryAggregateDataSourceArgs = {
  cursor?: InputMaybe<DataSourceWhereUniqueInput>;
  orderBy?: InputMaybe<Array<DataSourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceWhereInput>;
};


export type QueryAggregateDataSourceCellArgs = {
  cursor?: InputMaybe<DataSourceCellWhereUniqueInput>;
  orderBy?: InputMaybe<Array<DataSourceCellOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceCellWhereInput>;
};


export type QueryAggregateDataSourceVersionArgs = {
  cursor?: InputMaybe<DataSourceVersionWhereUniqueInput>;
  orderBy?: InputMaybe<Array<DataSourceVersionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceVersionWhereInput>;
};


export type QueryAggregateDataSourceVersionOriginArgs = {
  cursor?: InputMaybe<DataSourceVersionOriginWhereUniqueInput>;
  orderBy?: InputMaybe<Array<DataSourceVersionOriginOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceVersionOriginWhereInput>;
};


export type QueryAggregateLookupArgs = {
  cursor?: InputMaybe<LookupWhereUniqueInput>;
  orderBy?: InputMaybe<Array<LookupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LookupWhereInput>;
};


export type QueryAggregateNoteArgs = {
  cursor?: InputMaybe<NoteWhereUniqueInput>;
  orderBy?: InputMaybe<Array<NoteOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NoteWhereInput>;
};


export type QueryAggregateProposalTemplateArgs = {
  cursor?: InputMaybe<ProposalTemplateWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ProposalTemplateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalTemplateWhereInput>;
};


export type QueryAggregateUserProposalAccessArgs = {
  cursor?: InputMaybe<UserProposalAccessWhereUniqueInput>;
  orderBy?: InputMaybe<Array<UserProposalAccessOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProposalAccessWhereInput>;
};


export type QueryAnalyticsDashboardArgs = {
  where: AnalyticsDashboardWhereUniqueInput;
};


export type QueryAnalyticsDashboardChartArgs = {
  where: AnalyticsDashboardChartWhereUniqueInput;
};


export type QueryAnalyticsDashboardChartsArgs = {
  cursor?: InputMaybe<AnalyticsDashboardChartWhereUniqueInput>;
  distinct?: InputMaybe<Array<AnalyticsDashboardChartScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AnalyticsDashboardChartOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnalyticsDashboardChartWhereInput>;
};


export type QueryAnalyticsDashboardFiltersSourceArgs = {
  where: AnalyticsDashboardFiltersSourceWhereUniqueInput;
};


export type QueryAnalyticsDashboardFiltersSourcesArgs = {
  cursor?: InputMaybe<AnalyticsDashboardFiltersSourceWhereUniqueInput>;
  distinct?: InputMaybe<Array<AnalyticsDashboardFiltersSourceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AnalyticsDashboardFiltersSourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnalyticsDashboardFiltersSourceWhereInput>;
};


export type QueryAnalyticsDashboardsArgs = {
  cursor?: InputMaybe<AnalyticsDashboardWhereUniqueInput>;
  distinct?: InputMaybe<Array<AnalyticsDashboardScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AnalyticsDashboardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnalyticsDashboardWhereInput>;
};


export type QueryAuditEventsArgs = {
  calendarInterval: CalendarInterval;
  clientId: Scalars['Int']['input'];
  endDate: Scalars['Float']['input'];
  eventTypes: Array<BaseEventTypeInput>;
  startDate: Scalars['Float']['input'];
  subGroupsIds: Array<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClientArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDashboardChartDataArgs = {
  chartId: Scalars['String']['input'];
  variables?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryDataSourceArgs = {
  where: DataSourceWhereUniqueInput;
};


export type QueryDataSourceCellArgs = {
  where: DataSourceCellWhereUniqueInput;
};


export type QueryDataSourceCellsArgs = {
  cursor?: InputMaybe<DataSourceCellWhereUniqueInput>;
  distinct?: InputMaybe<Array<DataSourceCellScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DataSourceCellOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceCellWhereInput>;
};


export type QueryDataSourceDeleteImpactArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDataSourceGetArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDataSourceVersionArgs = {
  where: DataSourceVersionWhereUniqueInput;
};


export type QueryDataSourceVersionOriginArgs = {
  where: DataSourceVersionOriginWhereUniqueInput;
};


export type QueryDataSourceVersionOriginsArgs = {
  cursor?: InputMaybe<DataSourceVersionOriginWhereUniqueInput>;
  distinct?: InputMaybe<Array<DataSourceVersionOriginScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DataSourceVersionOriginOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceVersionOriginWhereInput>;
};


export type QueryDataSourceVersionsArgs = {
  cursor?: InputMaybe<DataSourceVersionWhereUniqueInput>;
  distinct?: InputMaybe<Array<DataSourceVersionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DataSourceVersionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceVersionWhereInput>;
};


export type QueryDataSourcesArgs = {
  cursor?: InputMaybe<DataSourceWhereUniqueInput>;
  distinct?: InputMaybe<Array<DataSourceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DataSourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceWhereInput>;
};


export type QueryDataSourcesMetaArgs = {
  cursor?: InputMaybe<DataSourceWhereUniqueInput>;
  distinct?: InputMaybe<Array<DataSourceScalarFieldEnum>>;
  ignoreLastVersionsOfProposalId?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceWhereInput>;
};


export type QueryFindFirstAnalyticsDashboardArgs = {
  cursor?: InputMaybe<AnalyticsDashboardWhereUniqueInput>;
  distinct?: InputMaybe<Array<AnalyticsDashboardScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AnalyticsDashboardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnalyticsDashboardWhereInput>;
};


export type QueryFindFirstAnalyticsDashboardChartArgs = {
  cursor?: InputMaybe<AnalyticsDashboardChartWhereUniqueInput>;
  distinct?: InputMaybe<Array<AnalyticsDashboardChartScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AnalyticsDashboardChartOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnalyticsDashboardChartWhereInput>;
};


export type QueryFindFirstAnalyticsDashboardChartOrThrowArgs = {
  cursor?: InputMaybe<AnalyticsDashboardChartWhereUniqueInput>;
  distinct?: InputMaybe<Array<AnalyticsDashboardChartScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AnalyticsDashboardChartOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnalyticsDashboardChartWhereInput>;
};


export type QueryFindFirstAnalyticsDashboardFiltersSourceArgs = {
  cursor?: InputMaybe<AnalyticsDashboardFiltersSourceWhereUniqueInput>;
  distinct?: InputMaybe<Array<AnalyticsDashboardFiltersSourceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AnalyticsDashboardFiltersSourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnalyticsDashboardFiltersSourceWhereInput>;
};


export type QueryFindFirstAnalyticsDashboardFiltersSourceOrThrowArgs = {
  cursor?: InputMaybe<AnalyticsDashboardFiltersSourceWhereUniqueInput>;
  distinct?: InputMaybe<Array<AnalyticsDashboardFiltersSourceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AnalyticsDashboardFiltersSourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnalyticsDashboardFiltersSourceWhereInput>;
};


export type QueryFindFirstAnalyticsDashboardOrThrowArgs = {
  cursor?: InputMaybe<AnalyticsDashboardWhereUniqueInput>;
  distinct?: InputMaybe<Array<AnalyticsDashboardScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AnalyticsDashboardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnalyticsDashboardWhereInput>;
};


export type QueryFindFirstDataSourceArgs = {
  cursor?: InputMaybe<DataSourceWhereUniqueInput>;
  distinct?: InputMaybe<Array<DataSourceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DataSourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceWhereInput>;
};


export type QueryFindFirstDataSourceCellArgs = {
  cursor?: InputMaybe<DataSourceCellWhereUniqueInput>;
  distinct?: InputMaybe<Array<DataSourceCellScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DataSourceCellOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceCellWhereInput>;
};


export type QueryFindFirstDataSourceCellOrThrowArgs = {
  cursor?: InputMaybe<DataSourceCellWhereUniqueInput>;
  distinct?: InputMaybe<Array<DataSourceCellScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DataSourceCellOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceCellWhereInput>;
};


export type QueryFindFirstDataSourceOrThrowArgs = {
  cursor?: InputMaybe<DataSourceWhereUniqueInput>;
  distinct?: InputMaybe<Array<DataSourceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DataSourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceWhereInput>;
};


export type QueryFindFirstDataSourceVersionArgs = {
  cursor?: InputMaybe<DataSourceVersionWhereUniqueInput>;
  distinct?: InputMaybe<Array<DataSourceVersionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DataSourceVersionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceVersionWhereInput>;
};


export type QueryFindFirstDataSourceVersionOrThrowArgs = {
  cursor?: InputMaybe<DataSourceVersionWhereUniqueInput>;
  distinct?: InputMaybe<Array<DataSourceVersionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DataSourceVersionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceVersionWhereInput>;
};


export type QueryFindFirstDataSourceVersionOriginArgs = {
  cursor?: InputMaybe<DataSourceVersionOriginWhereUniqueInput>;
  distinct?: InputMaybe<Array<DataSourceVersionOriginScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DataSourceVersionOriginOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceVersionOriginWhereInput>;
};


export type QueryFindFirstDataSourceVersionOriginOrThrowArgs = {
  cursor?: InputMaybe<DataSourceVersionOriginWhereUniqueInput>;
  distinct?: InputMaybe<Array<DataSourceVersionOriginScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DataSourceVersionOriginOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceVersionOriginWhereInput>;
};


export type QueryFindFirstLookupArgs = {
  cursor?: InputMaybe<LookupWhereUniqueInput>;
  distinct?: InputMaybe<Array<LookupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LookupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LookupWhereInput>;
};


export type QueryFindFirstLookupOrThrowArgs = {
  cursor?: InputMaybe<LookupWhereUniqueInput>;
  distinct?: InputMaybe<Array<LookupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LookupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LookupWhereInput>;
};


export type QueryFindFirstNoteArgs = {
  cursor?: InputMaybe<NoteWhereUniqueInput>;
  distinct?: InputMaybe<Array<NoteScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NoteOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NoteWhereInput>;
};


export type QueryFindFirstNoteOrThrowArgs = {
  cursor?: InputMaybe<NoteWhereUniqueInput>;
  distinct?: InputMaybe<Array<NoteScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NoteOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NoteWhereInput>;
};


export type QueryFindFirstProposalTemplateArgs = {
  cursor?: InputMaybe<ProposalTemplateWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProposalTemplateScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProposalTemplateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalTemplateWhereInput>;
};


export type QueryFindFirstProposalTemplateOrThrowArgs = {
  cursor?: InputMaybe<ProposalTemplateWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProposalTemplateScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProposalTemplateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalTemplateWhereInput>;
};


export type QueryFindFirstProposalTemplateVersionOrThrowArgs = {
  cursor?: InputMaybe<ProposalTemplateVersionWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProposalTemplateVersionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProposalTemplateVersionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalTemplateVersionWhereInput>;
};


export type QueryFindFirstUserProposalAccessArgs = {
  cursor?: InputMaybe<UserProposalAccessWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProposalAccessScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProposalAccessOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProposalAccessWhereInput>;
};


export type QueryFindFirstUserProposalAccessOrThrowArgs = {
  cursor?: InputMaybe<UserProposalAccessWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProposalAccessScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProposalAccessOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProposalAccessWhereInput>;
};


export type QueryGetAnalyticsDashboardArgs = {
  where: AnalyticsDashboardWhereUniqueInput;
};


export type QueryGetAnalyticsDashboardChartArgs = {
  where: AnalyticsDashboardChartWhereUniqueInput;
};


export type QueryGetAnalyticsDashboardFiltersSourceArgs = {
  where: AnalyticsDashboardFiltersSourceWhereUniqueInput;
};


export type QueryGetDataSourceArgs = {
  where: DataSourceWhereUniqueInput;
};


export type QueryGetDataSourceCellArgs = {
  where: DataSourceCellWhereUniqueInput;
};


export type QueryGetDataSourceVersionArgs = {
  where: DataSourceVersionWhereUniqueInput;
};


export type QueryGetDataSourceVersionOriginArgs = {
  where: DataSourceVersionOriginWhereUniqueInput;
};


export type QueryGetLookupArgs = {
  where: LookupWhereUniqueInput;
};


export type QueryGetNoteArgs = {
  where: NoteWhereUniqueInput;
};


export type QueryGetProposalTemplateArgs = {
  where: ProposalTemplateWhereUniqueInput;
};


export type QueryGetUserProposalAccessArgs = {
  where: UserProposalAccessWhereUniqueInput;
};


export type QueryGroupByAnalyticsDashboardArgs = {
  by: Array<AnalyticsDashboardScalarFieldEnum>;
  having?: InputMaybe<AnalyticsDashboardScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<AnalyticsDashboardOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnalyticsDashboardWhereInput>;
};


export type QueryGroupByAnalyticsDashboardChartArgs = {
  by: Array<AnalyticsDashboardChartScalarFieldEnum>;
  having?: InputMaybe<AnalyticsDashboardChartScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<AnalyticsDashboardChartOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnalyticsDashboardChartWhereInput>;
};


export type QueryGroupByAnalyticsDashboardFiltersSourceArgs = {
  by: Array<AnalyticsDashboardFiltersSourceScalarFieldEnum>;
  having?: InputMaybe<AnalyticsDashboardFiltersSourceScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<AnalyticsDashboardFiltersSourceOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnalyticsDashboardFiltersSourceWhereInput>;
};


export type QueryGroupByDataSourceArgs = {
  by: Array<DataSourceScalarFieldEnum>;
  having?: InputMaybe<DataSourceScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<DataSourceOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceWhereInput>;
};


export type QueryGroupByDataSourceCellArgs = {
  by: Array<DataSourceCellScalarFieldEnum>;
  having?: InputMaybe<DataSourceCellScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<DataSourceCellOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceCellWhereInput>;
};


export type QueryGroupByDataSourceVersionArgs = {
  by: Array<DataSourceVersionScalarFieldEnum>;
  having?: InputMaybe<DataSourceVersionScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<DataSourceVersionOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceVersionWhereInput>;
};


export type QueryGroupByDataSourceVersionOriginArgs = {
  by: Array<DataSourceVersionOriginScalarFieldEnum>;
  having?: InputMaybe<DataSourceVersionOriginScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<DataSourceVersionOriginOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DataSourceVersionOriginWhereInput>;
};


export type QueryGroupByLookupArgs = {
  by: Array<LookupScalarFieldEnum>;
  having?: InputMaybe<LookupScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<LookupOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LookupWhereInput>;
};


export type QueryGroupByNoteArgs = {
  by: Array<NoteScalarFieldEnum>;
  having?: InputMaybe<NoteScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<NoteOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NoteWhereInput>;
};


export type QueryGroupByProposalTemplateArgs = {
  by: Array<ProposalTemplateScalarFieldEnum>;
  having?: InputMaybe<ProposalTemplateScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<ProposalTemplateOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalTemplateWhereInput>;
};


export type QueryGroupByUserProposalAccessArgs = {
  by: Array<UserProposalAccessScalarFieldEnum>;
  having?: InputMaybe<UserProposalAccessScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<UserProposalAccessOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProposalAccessWhereInput>;
};


export type QueryInsightAuditChangeBreakdownArgs = {
  versionId: Scalars['Int']['input'];
};


export type QueryInsightAuditChangesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLastEditorArgs = {
  proposalId: Scalars['Int']['input'];
};


export type QueryLookupArgs = {
  where: LookupWhereUniqueInput;
};


export type QueryLookupsArgs = {
  cursor?: InputMaybe<LookupWhereUniqueInput>;
  distinct?: InputMaybe<Array<LookupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LookupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LookupWhereInput>;
};


export type QueryNavigationPositionByClientArgs = {
  keycloackGroupName: Scalars['String']['input'];
};


export type QueryNoteArgs = {
  where: NoteWhereUniqueInput;
};


export type QueryNotesArgs = {
  cursor?: InputMaybe<NoteWhereUniqueInput>;
  distinct?: InputMaybe<Array<NoteScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NoteOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NoteWhereInput>;
};


export type QueryPromptArgs = {
  message: Scalars['String']['input'];
};


export type QueryProposalArgs = {
  where: ProposalWhereUniqueInput;
};


export type QueryProposalAnalyticArgs = {
  aggregate: Array<Aggregate>;
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
  fields?: InputMaybe<Array<Field>>;
  proposalIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  proposalOwners?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
};


export type QueryProposalNameArgs = {
  proposalId: Scalars['Int']['input'];
};


export type QueryProposalPageDataSourceRowsArgs = {
  pageUuid: Scalars['String']['input'];
  proposalId: Scalars['Int']['input'];
  versionId: Scalars['Int']['input'];
};


export type QueryProposalRowSummaryArgs = {
  pageUuid: Scalars['String']['input'];
  rowUuid: Scalars['String']['input'];
  versionId: Scalars['Float']['input'];
};


export type QueryProposalTemplateArgs = {
  where: ProposalTemplateWhereUniqueInput;
};


export type QueryProposalTemplatesArgs = {
  cursor?: InputMaybe<ProposalTemplateWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProposalTemplateScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProposalTemplateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalTemplateWhereInput>;
};


export type QueryProposalVersionsArgs = {
  cursor?: InputMaybe<ProposalVersionWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProposalVersionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProposalVersionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProposalVersionWhereInput>;
};


export type QueryProposalsArgs = {
  filter?: InputMaybe<ProposalsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProposalsSortItem>>;
  pinnedFirst?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchUserEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<ProposalType>;
};


export type QueryTemplateOptionsArgs = {
  type: TemplateType;
};


export type QueryUserCredentialsArgs = {
  id: Scalars['String']['input'];
};


export type QueryUserProposalAccessArgs = {
  where: UserProposalAccessWhereUniqueInput;
};


export type QueryUserProposalAccessesArgs = {
  cursor?: InputMaybe<UserProposalAccessWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProposalAccessScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProposalAccessOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProposalAccessWhereInput>;
};


export type QueryUsersActivityArgs = {
  clientId: Scalars['Int']['input'];
  endDate: Scalars['Float']['input'];
  startDate: Scalars['Float']['input'];
  subGroupsIds: Array<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export enum RequiredAction {
  ConfigureTotp = 'CONFIGURE_TOTP',
  UpdatePassword = 'UPDATE_PASSWORD',
  VerifyEmail = 'VERIFY_EMAIL'
}

export type Resp = {
  __typename?: 'Resp';
  data: Scalars['JSON']['output'];
};

/** Role of the user */
export enum Role {
  Admin = 'admin',
  FxcAdmin = 'fxc_admin',
  Superuser = 'superuser',
  User = 'user',
  Viewer = 'viewer'
}

export enum Scope {
  Analytics = 'Analytics',
  Client = 'Client',
  Clients = 'Clients',
  DataSources = 'DataSources',
  Insights = 'Insights',
  Lookups = 'Lookups',
  Proposals = 'Proposals',
  Templates = 'Templates'
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortOrderInput = {
  nulls?: InputMaybe<NullsOrder>;
  sort: SortOrder;
};

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SyncUserActivityInput = {
  syncEmail?: InputMaybe<Scalars['Boolean']['input']>;
  syncLogin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TemplateCreateInput = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  metrics: Scalars['JSON']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pages: Scalars['JSON']['input'];
  settings: Scalars['JSON']['input'];
  type?: InputMaybe<TemplateType>;
};

export enum TemplatePageType {
  Form = 'FORM',
  Group = 'GROUP',
  Report = 'REPORT',
  Table = 'TABLE'
}

export enum TemplateType {
  Insight = 'INSIGHT',
  Proposal = 'PROPOSAL'
}

export type TemplateUpdateInput = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  metrics: Scalars['JSON']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pages: Scalars['JSON']['input'];
  settings: Scalars['JSON']['input'];
};

export type ThemeInfoRepresentation = {
  __typename?: 'ThemeInfoRepresentation';
  locales?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
};

export type UserActivityRow = {
  __typename?: 'UserActivityRow';
  activity_time_seconds: Scalars['Float']['output'];
  email: Scalars['String']['output'];
  insight_update: Scalars['Float']['output'];
  logins: Scalars['Float']['output'];
  proposal_create: Scalars['Float']['output'];
  proposal_update: Scalars['Float']['output'];
  proposal_update_unique: Scalars['Float']['output'];
};

export type UserConsentRepresentation = {
  __typename?: 'UserConsentRepresentation';
  clientId?: Maybe<Scalars['String']['output']>;
  createDate?: Maybe<Scalars['String']['output']>;
  grantedClientScopes?: Maybe<Array<Scalars['String']['output']>>;
  lastUpdatedDate?: Maybe<Scalars['Float']['output']>;
};

export type UserCreateInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  keycloakGroupId?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  role?: InputMaybe<Role>;
};

export type UserFacingError = {
  __typename?: 'UserFacingError';
  code: UserFacingErrorCode;
};

export enum UserFacingErrorCode {
  AdminDataSourceRestrictedAction = 'adminDataSourceRestrictedAction',
  AnalyticsDashboardSqlInArrayParamError = 'analyticsDashboardSqlInArrayParamError',
  CannotReplaceProposalWithExistingCells = 'cannotReplaceProposalWithExistingCells',
  ClickHouseNotConfigured = 'clickHouseNotConfigured',
  ClientDisabled = 'clientDisabled',
  ClientNotFound = 'clientNotFound',
  ClientUsersLimit = 'clientUsersLimit',
  ClientWithSuchNameAlreadyExist = 'clientWithSuchNameAlreadyExist',
  ClientWithThisBaseUrlAlreadyExist = 'clientWithThisBaseUrlAlreadyExist',
  ClientKeycloakGroupNameKeyP2002 = 'client_keycloak_group_name_key_P2002',
  ClientsLimit = 'clientsLimit',
  CreateClient = 'createClient',
  CreateOneDataSource = 'createOneDataSource',
  CreateOneProposal = 'createOneProposal',
  CreateOneProposalTemplate = 'createOneProposalTemplate',
  CreateUser = 'createUser',
  DataSourceDeleteWithProposalsNotAllowed = 'dataSourceDeleteWithProposalsNotAllowed',
  DataSourceExportNotFound = 'dataSourceExportNotFound',
  DataSourceImportArchiveTooLarge = 'dataSourceImportArchiveTooLarge',
  DataSourceImportCleanupFailed = 'dataSourceImportCleanupFailed',
  DataSourceImportCreatedConcurrently = 'dataSourceImportCreatedConcurrently',
  DataSourceImportInvalidArchive = 'dataSourceImportInvalidArchive',
  DataSourceImportPartiallyFailed = 'dataSourceImportPartiallyFailed',
  DataSourceImportPlanChanged = 'dataSourceImportPlanChanged',
  DataSourceImportVersionTooLarge = 'dataSourceImportVersionTooLarge',
  DataSourceInUse = 'dataSourceInUse',
  DataSourceNotFound = 'dataSourceNotFound',
  DataSourceNameKeyP2002 = 'data_source_name_key_P2002',
  Default = 'default',
  LookuperNameKeyP2002 = 'lookuper_name_key_P2002',
  PermissionsNotFound = 'permissionsNotFound',
  ProposalEditLockDeadlock = 'proposalEditLockDeadlock',
  ProposalIsFinalized = 'proposalIsFinalized',
  ProposalNotAccessibleToUser = 'proposalNotAccessibleToUser',
  ProposalTemplateNameKeyP2002 = 'proposal_template_name_key_P2002',
  SubGroupToDeleteHasMembers = 'subGroupToDeleteHasMembers',
  TemplateCreateFailed = 'templateCreateFailed',
  TemplateUpdateFailed = 'templateUpdateFailed',
  TooManyAuditEvents = 'tooManyAuditEvents',
  UpdateNotChangedProposal = 'updateNotChangedProposal',
  UserAlreadyBelongsToGroup = 'userAlreadyBelongsToGroup',
  UserDoesNotBelongToAnyGroup = 'userDoesNotBelongToAnyGroup',
  UserDoesNotHaveRequiredPermissions = 'userDoesNotHaveRequiredPermissions',
  UserEmailAlreadyVerified = 'userEmailAlreadyVerified',
  UserEmailDomainIsNotWhitelisted = 'userEmailDomainIsNotWhitelisted',
  UserNotFound = 'userNotFound',
  UserWithSuchEmailAlreadyExist = 'userWithSuchEmailAlreadyExist'
}

export type UserLoginAuditEventInput = {
  _?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserLogoutAuditEventInput = {
  _?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProposalAccess = {
  __typename?: 'UserProposalAccess';
  proposal: Proposal;
  proposalId: Scalars['Int']['output'];
  updatedAt: Scalars['Timestamp']['output'];
  userEmail: Scalars['String']['output'];
};

export type UserProposalAccessAvgAggregate = {
  __typename?: 'UserProposalAccessAvgAggregate';
  proposalId?: Maybe<Scalars['Float']['output']>;
};

export type UserProposalAccessAvgOrderByAggregateInput = {
  proposalId?: InputMaybe<SortOrder>;
};

export type UserProposalAccessCountAggregate = {
  __typename?: 'UserProposalAccessCountAggregate';
  _all: Scalars['Int']['output'];
  proposalId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userEmail: Scalars['Int']['output'];
};

export type UserProposalAccessCountOrderByAggregateInput = {
  proposalId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userEmail?: InputMaybe<SortOrder>;
};

export type UserProposalAccessCreateInput = {
  proposal: ProposalCreateNestedOneWithoutUserProposalAccessInput;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userEmail: Scalars['String']['input'];
};

export type UserProposalAccessCreateManyInput = {
  proposalId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userEmail: Scalars['String']['input'];
};

export type UserProposalAccessCreateManyProposalInput = {
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userEmail: Scalars['String']['input'];
};

export type UserProposalAccessCreateManyProposalInputEnvelope = {
  data: Array<UserProposalAccessCreateManyProposalInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProposalAccessCreateNestedManyWithoutProposalInput = {
  connect?: InputMaybe<Array<UserProposalAccessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProposalAccessCreateOrConnectWithoutProposalInput>>;
  create?: InputMaybe<Array<UserProposalAccessCreateWithoutProposalInput>>;
  createMany?: InputMaybe<UserProposalAccessCreateManyProposalInputEnvelope>;
};

export type UserProposalAccessCreateOrConnectWithoutProposalInput = {
  create: UserProposalAccessCreateWithoutProposalInput;
  where: UserProposalAccessWhereUniqueInput;
};

export type UserProposalAccessCreateWithoutProposalInput = {
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userEmail: Scalars['String']['input'];
};

export type UserProposalAccessGroupBy = {
  __typename?: 'UserProposalAccessGroupBy';
  _avg?: Maybe<UserProposalAccessAvgAggregate>;
  _count?: Maybe<UserProposalAccessCountAggregate>;
  _max?: Maybe<UserProposalAccessMaxAggregate>;
  _min?: Maybe<UserProposalAccessMinAggregate>;
  _sum?: Maybe<UserProposalAccessSumAggregate>;
  proposalId: Scalars['Int']['output'];
  updatedAt: Scalars['Timestamp']['output'];
  userEmail: Scalars['String']['output'];
};

export type UserProposalAccessListRelationFilter = {
  every?: InputMaybe<UserProposalAccessWhereInput>;
  none?: InputMaybe<UserProposalAccessWhereInput>;
  some?: InputMaybe<UserProposalAccessWhereInput>;
};

export type UserProposalAccessMaxAggregate = {
  __typename?: 'UserProposalAccessMaxAggregate';
  proposalId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Timestamp']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
};

export type UserProposalAccessMaxOrderByAggregateInput = {
  proposalId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userEmail?: InputMaybe<SortOrder>;
};

export type UserProposalAccessMinAggregate = {
  __typename?: 'UserProposalAccessMinAggregate';
  proposalId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Timestamp']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
};

export type UserProposalAccessMinOrderByAggregateInput = {
  proposalId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userEmail?: InputMaybe<SortOrder>;
};

export type UserProposalAccessOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum UserProposalAccessOrderByRelevanceFieldEnum {
  UserEmail = 'userEmail'
}

export type UserProposalAccessOrderByRelevanceInput = {
  fields: Array<UserProposalAccessOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type UserProposalAccessOrderByWithAggregationInput = {
  _avg?: InputMaybe<UserProposalAccessAvgOrderByAggregateInput>;
  _count?: InputMaybe<UserProposalAccessCountOrderByAggregateInput>;
  _max?: InputMaybe<UserProposalAccessMaxOrderByAggregateInput>;
  _min?: InputMaybe<UserProposalAccessMinOrderByAggregateInput>;
  _sum?: InputMaybe<UserProposalAccessSumOrderByAggregateInput>;
  proposalId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userEmail?: InputMaybe<SortOrder>;
};

export type UserProposalAccessOrderByWithRelationInput = {
  _relevance?: InputMaybe<UserProposalAccessOrderByRelevanceInput>;
  proposal?: InputMaybe<ProposalOrderByWithRelationInput>;
  proposalId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userEmail?: InputMaybe<SortOrder>;
};

export enum UserProposalAccessScalarFieldEnum {
  ProposalId = 'proposalId',
  UpdatedAt = 'updatedAt',
  UserEmail = 'userEmail'
}

export type UserProposalAccessScalarWhereInput = {
  AND?: InputMaybe<Array<UserProposalAccessScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserProposalAccessScalarWhereInput>>;
  OR?: InputMaybe<Array<UserProposalAccessScalarWhereInput>>;
  proposalId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userEmail?: InputMaybe<StringFilter>;
};

export type UserProposalAccessScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<UserProposalAccessScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<UserProposalAccessScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<UserProposalAccessScalarWhereWithAggregatesInput>>;
  proposalId?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  userEmail?: InputMaybe<StringWithAggregatesFilter>;
};

export type UserProposalAccessSumAggregate = {
  __typename?: 'UserProposalAccessSumAggregate';
  proposalId?: Maybe<Scalars['Int']['output']>;
};

export type UserProposalAccessSumOrderByAggregateInput = {
  proposalId?: InputMaybe<SortOrder>;
};

export type UserProposalAccessUpdateInput = {
  proposal?: InputMaybe<ProposalUpdateOneRequiredWithoutUserProposalAccessNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userEmail?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserProposalAccessUpdateManyMutationInput = {
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userEmail?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserProposalAccessUpdateManyWithWhereWithoutProposalInput = {
  data: UserProposalAccessUpdateManyMutationInput;
  where: UserProposalAccessScalarWhereInput;
};

export type UserProposalAccessUpdateManyWithoutProposalNestedInput = {
  connect?: InputMaybe<Array<UserProposalAccessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProposalAccessCreateOrConnectWithoutProposalInput>>;
  create?: InputMaybe<Array<UserProposalAccessCreateWithoutProposalInput>>;
  createMany?: InputMaybe<UserProposalAccessCreateManyProposalInputEnvelope>;
  delete?: InputMaybe<Array<UserProposalAccessWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProposalAccessScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProposalAccessWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProposalAccessWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProposalAccessUpdateWithWhereUniqueWithoutProposalInput>>;
  updateMany?: InputMaybe<Array<UserProposalAccessUpdateManyWithWhereWithoutProposalInput>>;
  upsert?: InputMaybe<Array<UserProposalAccessUpsertWithWhereUniqueWithoutProposalInput>>;
};

export type UserProposalAccessUpdateWithWhereUniqueWithoutProposalInput = {
  data: UserProposalAccessUpdateWithoutProposalInput;
  where: UserProposalAccessWhereUniqueInput;
};

export type UserProposalAccessUpdateWithoutProposalInput = {
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userEmail?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserProposalAccessUpsertWithWhereUniqueWithoutProposalInput = {
  create: UserProposalAccessCreateWithoutProposalInput;
  update: UserProposalAccessUpdateWithoutProposalInput;
  where: UserProposalAccessWhereUniqueInput;
};

export type UserProposalAccessUserEmailProposalIdCompoundUniqueInput = {
  proposalId: Scalars['Int']['input'];
  userEmail: Scalars['String']['input'];
};

export type UserProposalAccessWhereInput = {
  AND?: InputMaybe<Array<UserProposalAccessWhereInput>>;
  NOT?: InputMaybe<Array<UserProposalAccessWhereInput>>;
  OR?: InputMaybe<Array<UserProposalAccessWhereInput>>;
  proposal?: InputMaybe<ProposalScalarRelationFilter>;
  proposalId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userEmail?: InputMaybe<StringFilter>;
};

export type UserProposalAccessWhereUniqueInput = {
  AND?: InputMaybe<Array<UserProposalAccessWhereInput>>;
  NOT?: InputMaybe<Array<UserProposalAccessWhereInput>>;
  OR?: InputMaybe<Array<UserProposalAccessWhereInput>>;
  proposal?: InputMaybe<ProposalScalarRelationFilter>;
  proposalId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userEmail?: InputMaybe<StringFilter>;
  userEmail_proposalId?: InputMaybe<UserProposalAccessUserEmailProposalIdCompoundUniqueInput>;
};

export type UserProposalPinCreateManyProposalInput = {
  pinnedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userEmail: Scalars['String']['input'];
};

export type UserProposalPinCreateManyProposalInputEnvelope = {
  data: Array<UserProposalPinCreateManyProposalInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProposalPinCreateNestedManyWithoutProposalInput = {
  connect?: InputMaybe<Array<UserProposalPinWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProposalPinCreateOrConnectWithoutProposalInput>>;
  create?: InputMaybe<Array<UserProposalPinCreateWithoutProposalInput>>;
  createMany?: InputMaybe<UserProposalPinCreateManyProposalInputEnvelope>;
};

export type UserProposalPinCreateOrConnectWithoutProposalInput = {
  create: UserProposalPinCreateWithoutProposalInput;
  where: UserProposalPinWhereUniqueInput;
};

export type UserProposalPinCreateWithoutProposalInput = {
  pinnedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userEmail: Scalars['String']['input'];
};

export type UserProposalPinListRelationFilter = {
  every?: InputMaybe<UserProposalPinWhereInput>;
  none?: InputMaybe<UserProposalPinWhereInput>;
  some?: InputMaybe<UserProposalPinWhereInput>;
};

export type UserProposalPinOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserProposalPinScalarWhereInput = {
  AND?: InputMaybe<Array<UserProposalPinScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserProposalPinScalarWhereInput>>;
  OR?: InputMaybe<Array<UserProposalPinScalarWhereInput>>;
  pinnedAt?: InputMaybe<DateTimeFilter>;
  proposalId?: InputMaybe<IntFilter>;
  userEmail?: InputMaybe<StringFilter>;
};

export type UserProposalPinUpdateManyMutationInput = {
  pinnedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userEmail?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserProposalPinUpdateManyWithWhereWithoutProposalInput = {
  data: UserProposalPinUpdateManyMutationInput;
  where: UserProposalPinScalarWhereInput;
};

export type UserProposalPinUpdateManyWithoutProposalNestedInput = {
  connect?: InputMaybe<Array<UserProposalPinWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProposalPinCreateOrConnectWithoutProposalInput>>;
  create?: InputMaybe<Array<UserProposalPinCreateWithoutProposalInput>>;
  createMany?: InputMaybe<UserProposalPinCreateManyProposalInputEnvelope>;
  delete?: InputMaybe<Array<UserProposalPinWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProposalPinScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProposalPinWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProposalPinWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProposalPinUpdateWithWhereUniqueWithoutProposalInput>>;
  updateMany?: InputMaybe<Array<UserProposalPinUpdateManyWithWhereWithoutProposalInput>>;
  upsert?: InputMaybe<Array<UserProposalPinUpsertWithWhereUniqueWithoutProposalInput>>;
};

export type UserProposalPinUpdateWithWhereUniqueWithoutProposalInput = {
  data: UserProposalPinUpdateWithoutProposalInput;
  where: UserProposalPinWhereUniqueInput;
};

export type UserProposalPinUpdateWithoutProposalInput = {
  pinnedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userEmail?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserProposalPinUpsertWithWhereUniqueWithoutProposalInput = {
  create: UserProposalPinCreateWithoutProposalInput;
  update: UserProposalPinUpdateWithoutProposalInput;
  where: UserProposalPinWhereUniqueInput;
};

export type UserProposalPinUserEmailProposalIdCompoundUniqueInput = {
  proposalId: Scalars['Int']['input'];
  userEmail: Scalars['String']['input'];
};

export type UserProposalPinWhereInput = {
  AND?: InputMaybe<Array<UserProposalPinWhereInput>>;
  NOT?: InputMaybe<Array<UserProposalPinWhereInput>>;
  OR?: InputMaybe<Array<UserProposalPinWhereInput>>;
  pinnedAt?: InputMaybe<DateTimeFilter>;
  proposal?: InputMaybe<ProposalScalarRelationFilter>;
  proposalId?: InputMaybe<IntFilter>;
  userEmail?: InputMaybe<StringFilter>;
};

export type UserProposalPinWhereUniqueInput = {
  AND?: InputMaybe<Array<UserProposalPinWhereInput>>;
  NOT?: InputMaybe<Array<UserProposalPinWhereInput>>;
  OR?: InputMaybe<Array<UserProposalPinWhereInput>>;
  pinnedAt?: InputMaybe<DateTimeFilter>;
  proposal?: InputMaybe<ProposalScalarRelationFilter>;
  proposalId?: InputMaybe<IntFilter>;
  userEmail?: InputMaybe<StringFilter>;
  userEmail_proposalId?: InputMaybe<UserProposalPinUserEmailProposalIdCompoundUniqueInput>;
};

export type ClientSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientSettingsQuery = { __typename?: 'Query', currentClient: { __typename?: 'Client', id: number, entityNamePlural: string, entityNameSingular: string, insightPlaceholderSingular: string, insightPlaceholderPlural: string, proposalNavigationPosition: ProposalNavigationPositionType, clientPermissions: Array<{ __typename?: 'ClientPermission', clientId: number, scope: Scope, role: string }>, clientFeatures: Array<{ __typename?: 'ClientFeature', name: Feature }> } };

export type NavigationPositionByClientQueryVariables = Exact<{
  keycloackGroupName: Scalars['String']['input'];
}>;


export type NavigationPositionByClientQuery = { __typename?: 'Query', navigationPositionByClient: { __typename?: 'NavigationPositionResp', data: string } };

export type ListDataSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListDataSourcesQuery = { __typename?: 'Query', dataSources: Array<{ __typename?: 'DataSource', id: number, name: string, updatedAt: any, createdAt: any, lastVersion: { __typename?: 'DataSourceVersion', id: number, type: DataSourceType, columns: any, usedAt?: any | null } }> };

export type GetDataSourceQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetDataSourceQuery = { __typename?: 'Query', dataSourceGet?: { __typename?: 'DataSource', id: number, name: string, isSharedWithAdmin?: boolean | null, includeInFreshness: boolean, lastVersion: { __typename?: 'DataSourceVersion', id: number, type: DataSourceType, code: string, columns: any, validationRules?: any | null, mappingRules?: any | null, createdAt: any, usedAt?: any | null, hash?: string | null } } | null };

export type DataSourceUpdateMutationVariables = Exact<{
  data: DataSourceSaveResolverUpdateInput;
}>;


export type DataSourceUpdateMutation = { __typename?: 'Mutation', dataSourceUpdate: { __typename?: 'DataSource', id: number } };

export type DataSourceCreateMutationVariables = Exact<{
  data: DataSourceSaveResolverCreateInput;
}>;


export type DataSourceCreateMutation = { __typename?: 'Mutation', dataSourceCreate: { __typename?: 'DataSource', id: number, name: string } };

export type CreateOneDataSourceMutationVariables = Exact<{
  data: DataSourceCreateInput;
}>;


export type CreateOneDataSourceMutation = { __typename?: 'Mutation', createOneDataSource: { __typename?: 'DataSource', id: number } };

export type DataSourceDeleteImpactQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DataSourceDeleteImpactQuery = { __typename?: 'Query', dataSourceDeleteImpact: { __typename?: 'DataSourceDeleteImpact', proposals: number, insights: number } };

export type DataSourceDeleteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  deleteProposals: Scalars['Boolean']['input'];
}>;


export type DataSourceDeleteMutation = { __typename?: 'Mutation', dataSourceDelete: { __typename?: 'DataSource', id: number } };

export type GetDataSourceDataByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetDataSourceDataByIdQuery = { __typename?: 'Query', dataSource?: { __typename?: 'DataSource', id: number, name: string, updatedAt: any, lastVersion: { __typename?: 'DataSourceVersion', data?: any | null, columns: any, usedAt?: any | null } } | null };

export type GetDataSourceDataByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetDataSourceDataByNameQuery = { __typename?: 'Query', dataSource?: { __typename?: 'DataSource', id: number, name: string, updatedAt: any, lastVersion: { __typename?: 'DataSourceVersion', data?: any | null, columns: any, usedAt?: any | null } } | null };

export type GetDataSourceDataByVersionIdQueryVariables = Exact<{
  versionId: Scalars['Int']['input'];
}>;


export type GetDataSourceDataByVersionIdQuery = { __typename?: 'Query', dataSourceVersion?: { __typename?: 'DataSourceVersion', id: number, data?: any | null, columns: any, usedAt?: any | null, createdAt: any, dataSource: { __typename?: 'DataSource', id: number, name: string, createdAt: any } } | null };

export type GetDataSourceVersionsByMetaQueryVariables = Exact<{
  versionFilters: Array<DataSourceVersionWhereInput> | DataSourceVersionWhereInput;
}>;


export type GetDataSourceVersionsByMetaQuery = { __typename?: 'Query', dataSourceVersions: Array<{ __typename?: 'DataSourceVersion', id: number, createdAt: any, dataSourceId: number, usedAt?: any | null, dataSource: { __typename?: 'DataSource', id: number, name: string, createdAt: any } }> };

export type ListUpdatedAtDataSourcesQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type ListUpdatedAtDataSourcesQuery = { __typename?: 'Query', dataSources: Array<{ __typename?: 'DataSource', id: number, updatedAt: any, lastVersion: { __typename?: 'DataSourceVersion', usedAt?: any | null } }> };

export type GetDataSourcesMetaQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  ignoreLastVersionsOfProposalId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDataSourcesMetaQuery = { __typename?: 'Query', dataSourcesMeta: Array<{ __typename?: 'DataSourceMeta', id: number, name: string, updatedAt: any, lastVersion: { __typename?: 'DataSourceVersionMeta', id: number, createdAt: any, usedAt?: any | null } }> };

export type DataSourceColumnsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DataSourceColumnsQuery = { __typename?: 'Query', dataSource?: { __typename?: 'DataSource', id: number, lastVersion: { __typename?: 'DataSourceVersion', columns: any } } | null };

export type DataSourceNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type DataSourceNamesQuery = { __typename?: 'Query', dataSources: Array<{ __typename?: 'DataSource', id: number, name: string }> };

export type DataSourceOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type DataSourceOptionsQuery = { __typename?: 'Query', dataSources: Array<{ __typename?: 'DataSource', id: number, name: string }> };

export type KeycloakUserFragment = { __typename?: 'KeycloakUser', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, emailVerified?: boolean | null, enabled?: boolean | null, role?: Role | null, lastLoginDate?: number | null, lastSentEmailDate?: number | null, subGroups: Array<{ __typename?: 'KeycloakGroup', id?: string | null, name?: string | null }> };

export type BaseClientFragment = { __typename?: 'Client', id: number, keycloakGroupName: string, keycloakGroupId: string, databaseName?: string | null, usersLimit: number, enabled: boolean, applicationTitle: string, applicationLogoUrl: string, applicationBrandColor: string, applicationBaseUrl: string, proposalNavigationPosition: ProposalNavigationPositionType, bannerHeader: string, bannerText: string, bannerEnabled: boolean, keycloakFrontendClientInternalId: string, entityNameSingular: string, entityNamePlural: string, insightPlaceholderSingular: string, insightPlaceholderPlural: string };

export type ClientFragment = { __typename?: 'Client', id: number, keycloakGroupName: string, keycloakGroupId: string, databaseName?: string | null, usersLimit: number, enabled: boolean, applicationTitle: string, applicationLogoUrl: string, applicationBrandColor: string, applicationBaseUrl: string, proposalNavigationPosition: ProposalNavigationPositionType, bannerHeader: string, bannerText: string, bannerEnabled: boolean, keycloakFrontendClientInternalId: string, entityNameSingular: string, entityNamePlural: string, insightPlaceholderSingular: string, insightPlaceholderPlural: string, clientPermissions: Array<{ __typename?: 'ClientPermission', scope: Scope, role: string }>, clientFeatures: Array<{ __typename?: 'ClientFeature', name: Feature }>, keycloakGroup: { __typename?: 'KeycloakGroup', id?: string | null, name?: string | null, subGroups?: Array<{ __typename?: 'KeycloakGroup', id?: string | null, name?: string | null, path?: string | null }> | null }, keycloakFrontendClient: { __typename?: 'KeycloakClient', id: string, attributes?: { __typename?: 'KeycloakClientAttributes', login_theme?: string | null } | null } };

export type ClientsQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientsQuery = { __typename?: 'Query', clients: Array<{ __typename?: 'Client', id: number, keycloakGroupName: string, keycloakGroupId: string, databaseName?: string | null, usersLimit: number, enabled: boolean, applicationTitle: string, applicationLogoUrl: string, applicationBrandColor: string, applicationBaseUrl: string, proposalNavigationPosition: ProposalNavigationPositionType, bannerHeader: string, bannerText: string, bannerEnabled: boolean, keycloakFrontendClientInternalId: string, entityNameSingular: string, entityNamePlural: string, insightPlaceholderSingular: string, insightPlaceholderPlural: string }> };

export type ClientQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ClientQuery = { __typename?: 'Query', client: { __typename?: 'Client', id: number, keycloakGroupName: string, keycloakGroupId: string, databaseName?: string | null, usersLimit: number, enabled: boolean, applicationTitle: string, applicationLogoUrl: string, applicationBrandColor: string, applicationBaseUrl: string, proposalNavigationPosition: ProposalNavigationPositionType, bannerHeader: string, bannerText: string, bannerEnabled: boolean, keycloakFrontendClientInternalId: string, entityNameSingular: string, entityNamePlural: string, insightPlaceholderSingular: string, insightPlaceholderPlural: string, clientPermissions: Array<{ __typename?: 'ClientPermission', scope: Scope, role: string }>, clientFeatures: Array<{ __typename?: 'ClientFeature', name: Feature }>, keycloakGroup: { __typename?: 'KeycloakGroup', id?: string | null, name?: string | null, subGroups?: Array<{ __typename?: 'KeycloakGroup', id?: string | null, name?: string | null, path?: string | null }> | null }, keycloakFrontendClient: { __typename?: 'KeycloakClient', id: string, attributes?: { __typename?: 'KeycloakClientAttributes', login_theme?: string | null } | null } } };

export type ClientUsersQueryVariables = Exact<{
  clientId: Scalars['Int']['input'];
}>;


export type ClientUsersQuery = { __typename?: 'Query', client: { __typename?: 'Client', users: Array<{ __typename?: 'KeycloakUser', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, emailVerified?: boolean | null, enabled?: boolean | null, role?: Role | null, lastLoginDate?: number | null, lastSentEmailDate?: number | null, subGroups: Array<{ __typename?: 'KeycloakGroup', id?: string | null, name?: string | null }> }> } };

export type CreateClientMutationVariables = Exact<{
  client: ClientInput;
}>;


export type CreateClientMutation = { __typename?: 'Mutation', createClient: { __typename?: 'Client', id: number, keycloakGroupName: string, keycloakGroupId: string, databaseName?: string | null, usersLimit: number, enabled: boolean, applicationTitle: string, applicationLogoUrl: string, applicationBrandColor: string, applicationBaseUrl: string, proposalNavigationPosition: ProposalNavigationPositionType, bannerHeader: string, bannerText: string, bannerEnabled: boolean, keycloakFrontendClientInternalId: string, entityNameSingular: string, entityNamePlural: string, insightPlaceholderSingular: string, insightPlaceholderPlural: string, clientPermissions: Array<{ __typename?: 'ClientPermission', scope: Scope, role: string }>, clientFeatures: Array<{ __typename?: 'ClientFeature', name: Feature }>, keycloakGroup: { __typename?: 'KeycloakGroup', id?: string | null, name?: string | null, subGroups?: Array<{ __typename?: 'KeycloakGroup', id?: string | null, name?: string | null, path?: string | null }> | null }, keycloakFrontendClient: { __typename?: 'KeycloakClient', id: string, attributes?: { __typename?: 'KeycloakClientAttributes', login_theme?: string | null } | null } } };

export type UpdateClientMutationVariables = Exact<{
  client: ClientInput;
  id: Scalars['Int']['input'];
}>;


export type UpdateClientMutation = { __typename?: 'Mutation', updateClient: { __typename?: 'Client', id: number, keycloakGroupName: string, keycloakGroupId: string, databaseName?: string | null, usersLimit: number, enabled: boolean, applicationTitle: string, applicationLogoUrl: string, applicationBrandColor: string, applicationBaseUrl: string, proposalNavigationPosition: ProposalNavigationPositionType, bannerHeader: string, bannerText: string, bannerEnabled: boolean, keycloakFrontendClientInternalId: string, entityNameSingular: string, entityNamePlural: string, insightPlaceholderSingular: string, insightPlaceholderPlural: string, clientPermissions: Array<{ __typename?: 'ClientPermission', scope: Scope, role: string }>, clientFeatures: Array<{ __typename?: 'ClientFeature', name: Feature }>, keycloakGroup: { __typename?: 'KeycloakGroup', id?: string | null, name?: string | null, subGroups?: Array<{ __typename?: 'KeycloakGroup', id?: string | null, name?: string | null, path?: string | null }> | null }, keycloakFrontendClient: { __typename?: 'KeycloakClient', id: string, attributes?: { __typename?: 'KeycloakClientAttributes', login_theme?: string | null } | null } } };

export type DeleteClientMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteClientMutation = { __typename?: 'Mutation', deleteClient: string };

export type UpdateClientEnabledStatusMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type UpdateClientEnabledStatusMutation = { __typename?: 'Mutation', updateClientEnabledStatus: string };

export type CurrentClientQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentClientQuery = { __typename?: 'Query', currentClient: { __typename?: 'Client', id: number, keycloakGroupName: string, keycloakGroupId: string, databaseName?: string | null, usersLimit: number, enabled: boolean, applicationTitle: string, applicationLogoUrl: string, applicationBrandColor: string, applicationBaseUrl: string, proposalNavigationPosition: ProposalNavigationPositionType, bannerHeader: string, bannerText: string, bannerEnabled: boolean, keycloakFrontendClientInternalId: string, entityNameSingular: string, entityNamePlural: string, insightPlaceholderSingular: string, insightPlaceholderPlural: string, users: Array<{ __typename?: 'KeycloakUser', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, emailVerified?: boolean | null, enabled?: boolean | null, role?: Role | null, lastLoginDate?: number | null, lastSentEmailDate?: number | null, subGroups: Array<{ __typename?: 'KeycloakGroup', id?: string | null, name?: string | null }> }>, clientPermissions: Array<{ __typename?: 'ClientPermission', scope: Scope, role: string }>, clientFeatures: Array<{ __typename?: 'ClientFeature', name: Feature }>, keycloakGroup: { __typename?: 'KeycloakGroup', id?: string | null, name?: string | null, subGroups?: Array<{ __typename?: 'KeycloakGroup', id?: string | null, name?: string | null, path?: string | null }> | null }, keycloakFrontendClient: { __typename?: 'KeycloakClient', id: string, attributes?: { __typename?: 'KeycloakClientAttributes', login_theme?: string | null } | null } } };

export type CurrentClientUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentClientUsersQuery = { __typename?: 'Query', currentClient: { __typename?: 'Client', id: number, users: Array<{ __typename?: 'KeycloakUser', id: string, enabled?: boolean | null, firstName?: string | null, lastName?: string | null, role?: Role | null, email?: string | null, subGroups: Array<{ __typename?: 'KeycloakGroup', id?: string | null, name?: string | null }> }> } };

export type WhiteLabelPropsQueryVariables = Exact<{ [key: string]: never; }>;


export type WhiteLabelPropsQuery = { __typename?: 'Query', currentClient: { __typename?: 'Client', id: number, applicationBaseUrl: string, applicationBrandColor: string, applicationLogoUrl: string, applicationTitle: string } };

export type CurrentClientIdQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentClientIdQuery = { __typename?: 'Query', currentClient: { __typename?: 'Client', id: number } };

export type CurrentClientMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentClientMembersQuery = { __typename?: 'Query', currentClientMembers: { __typename?: 'ClientMembers', usersProtected?: Array<{ __typename?: 'KeycloakUserProtected', id: string, firstName: string, lastName: string, email: string }> | null } };

export type UserCredentialsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UserCredentialsQuery = { __typename?: 'Query', userCredentials: Array<{ __typename?: 'CredentialRepresentation', id?: string | null, type?: string | null, createdDate?: number | null, userLabel?: string | null }> };

export type DeleteUserCredentialMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  credentialId: Scalars['String']['input'];
}>;


export type DeleteUserCredentialMutation = { __typename?: 'Mutation', deleteCredential: boolean };

export type CreateUserMutationVariables = Exact<{
  user: UserCreateInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: string };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: string };

export type SendUpdatePasswordEmailMutationVariables = Exact<{
  id: Scalars['String']['input'];
  emailLifeSpanSeconds?: InputMaybe<Scalars['Int']['input']>;
  requiredActions?: InputMaybe<Array<RequiredAction> | RequiredAction>;
}>;


export type SendUpdatePasswordEmailMutation = { __typename?: 'Mutation', sendUpdatePasswordEmail: string };

export type UpdateUserRoleMutationVariables = Exact<{
  role: Role;
  userId: Scalars['String']['input'];
}>;


export type UpdateUserRoleMutation = { __typename?: 'Mutation', updateUserRole: string };

export type UpdateUserSubGroupMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  subGroupName: Scalars['String']['input'];
  subGroupId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserSubGroupMutation = { __typename?: 'Mutation', updateUserSubGroup?: string | null };

export type DeleteSubGroupMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteSubGroupMutation = { __typename?: 'Mutation', deleteSubGroup: string };

export type UpdateUserEnabledStatusMutationVariables = Exact<{
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
}>;


export type UpdateUserEnabledStatusMutation = { __typename?: 'Mutation', updateUserEnabledStatus: string };

export type UpdateUserGroupMutationVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type UpdateUserGroupMutation = { __typename?: 'Mutation', updateUserGroup: string };

export type PublicConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicConfigQuery = { __typename?: 'Query', configPublicInfo: { __typename?: 'PublicConfig', cdnHost: string, cdnMediaUploadEndpoint: string, clickhouseConfigured: boolean, features: { __typename?: 'Features', delete_clients: boolean, new_proposals_ui: boolean } } };

export type DefaultInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type DefaultInfoQuery = { __typename?: 'Query', defaultInfo: { __typename?: 'DefaultInfo', default_app_url: string, defaultFrontendClient: { __typename?: 'KeycloakClient', id: string, attributes?: { __typename?: 'KeycloakClientAttributes', login_theme?: string | null } | null }, keycloakServerInfo: { __typename?: 'KeycloakServerInfo', themes?: { __typename?: 'KeycloakThemes', login?: Array<{ __typename?: 'ThemeInfoRepresentation', name: string }> | null } | null } } };

export type UpdateKeycloakClientMutationVariables = Exact<{
  keycloakClient: KeycloakClientInput;
}>;


export type UpdateKeycloakClientMutation = { __typename?: 'Mutation', updateKeycloakClient: { __typename: 'KeycloakClient', id: string } };

export type TemplateVersionFragment = { __typename?: 'ProposalTemplateVersion', id: number, pages: any, settings: any, metrics: any };

export type GetInsightTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInsightTemplateQuery = { __typename?: 'Query', proposalTemplates: Array<{ __typename?: 'ProposalTemplate', id: number, name: string, type: TemplateType, lastVersion: { __typename?: 'ProposalTemplateVersion', id: number, pages: any, settings: any, metrics: any } }> };

export type ListInsightsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProposalsSortItem> | ProposalsSortItem>;
  filter?: InputMaybe<ProposalsFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchUserEmails?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ListInsightsQuery = { __typename?: 'Query', proposals: { __typename?: 'ProposalsPaginated', count: number, items: Array<{ __typename?: 'ProposalListItem', id: number, name: string, templateName: string, createdBy: string, updatedAt: any, dataSourceUsedAt?: any | null, createdAt: any, lastVersionCreatedBy: string, isPinned: boolean }> } };

export type InsightAuditChangesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InsightAuditChangesQuery = { __typename?: 'Query', insightAuditChanges: { __typename?: 'InsightAuditChangesPaginated', count: number, items: Array<{ __typename?: 'InsightAuditChangeItem', id: number, insightId: number, insightName: string, createdAt: any, createdBy: string, sequentialNumber: number }> } };

export type InsightAuditChangeBreakdownQueryVariables = Exact<{
  versionId: Scalars['Int']['input'];
}>;


export type InsightAuditChangeBreakdownQuery = { __typename?: 'Query', insightAuditChangeBreakdown?: { __typename?: 'InsightAuditChangeBreakdown', versionId: number, rowsAffected: number, columnsAffected: Array<string>, pagesAffected: Array<string>, pageBreakdown: Array<{ __typename?: 'InsightAuditPageBreakdown', pageUuid: string, pageName: string, rowsAffected: number, columnNames: Array<string> }> } | null };

export type ListProposalTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListProposalTemplatesQuery = { __typename?: 'Query', proposalTemplates: Array<{ __typename?: 'ProposalTemplate', id: number, name: string, type: TemplateType, updatedAt: any, createdAt: any, isDefault: boolean, isPublished: boolean, lastVersion: { __typename?: 'ProposalTemplateVersion', createdAt: any, id: number, pages: any, settings: any, metrics: any } }> };

export type GetProposalTemplateQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetProposalTemplateQuery = { __typename?: 'Query', proposalTemplate?: { __typename?: 'ProposalTemplate', id: number, name: string, updatedAt: any, createdAt: any, lastVersion: { __typename?: 'ProposalTemplateVersion', id: number, pages: any, settings: any, metrics: any } } | null };

export type ProposalTemplateVersionQueryVariables = Exact<{
  where: ProposalTemplateVersionWhereInput;
}>;


export type ProposalTemplateVersionQuery = { __typename?: 'Query', proposalTemplateVersion?: { __typename?: 'ProposalTemplateVersion', createdAt: any, id: number, pages: any, settings: any, metrics: any, template: { __typename?: 'ProposalTemplate', id: number, name: string, type: TemplateType } } | null };

export type UpdateOneProposalTemplateMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  data: ProposalTemplateUpdateInput;
}>;


export type UpdateOneProposalTemplateMutation = { __typename?: 'Mutation', updateOneProposalTemplate?: { __typename?: 'ProposalTemplate', id: number } | null };

export type TemplateCreateMutationVariables = Exact<{
  data: TemplateCreateInput;
}>;


export type TemplateCreateMutation = { __typename?: 'Mutation', templateCreate: { __typename?: 'ProposalTemplate', id: number } };

export type TemplateUpdateMutationVariables = Exact<{
  data: TemplateUpdateInput;
}>;


export type TemplateUpdateMutation = { __typename?: 'Mutation', templateUpdate: { __typename?: 'ProposalTemplate', id: number } };

export type DeleteTemplateMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteTemplateMutation = { __typename?: 'Mutation', deleteTemplate: { __typename?: 'ProposalTemplate', id: number } };

export type UpdateDefaultTemplateMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  type: TemplateType;
}>;


export type UpdateDefaultTemplateMutation = { __typename?: 'Mutation', updateDefaultTemplate: { __typename?: 'ProposalTemplate', id: number, isDefault: boolean } };

export type PatchExistingProposalsMutationVariables = Exact<{
  templateId: Scalars['Int']['input'];
}>;


export type PatchExistingProposalsMutation = { __typename?: 'Mutation', patchExistingProposals: boolean };

export type PromptQueryVariables = Exact<{
  message: Scalars['String']['input'];
}>;


export type PromptQuery = { __typename?: 'Query', prompt?: string | null };

export type TemplatePublishUpdateMutationVariables = Exact<{
  isPublished: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
}>;


export type TemplatePublishUpdateMutation = { __typename?: 'Mutation', templatePublishUpdate: { __typename?: 'ProposalTemplate', id: number, isPublished: boolean } };

export type SetProposalPinnedMutationVariables = Exact<{
  proposalId: Scalars['Int']['input'];
  pinned: Scalars['Boolean']['input'];
}>;


export type SetProposalPinnedMutation = { __typename?: 'Mutation', setProposalPinned: boolean };

export type GetAnalyticFiltersSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAnalyticFiltersSourcesQuery = { __typename?: 'Query', proposalIds: Array<number>, owners: Array<{ __typename?: 'ProposalVersion', createdBy: string }>, proposalAnalyticFiltersAggregations?: { __typename?: 'Resp', data: any } | null };

export type ProposalAnalyticQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
  fields?: InputMaybe<Array<Field> | Field>;
  aggregate: Array<Aggregate> | Aggregate;
  proposalIds?: InputMaybe<Array<Scalars['Float']['input']> | Scalars['Float']['input']>;
  proposalOwners?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ProposalAnalyticQuery = { __typename?: 'Query', proposalAnalytic?: { __typename?: 'Resp', data: any } | null };

export type ClientAuditEventsQueryVariables = Exact<{
  startDate: Scalars['Float']['input'];
  endDate: Scalars['Float']['input'];
  calendarInterval: CalendarInterval;
  eventTypes: Array<BaseEventTypeInput> | BaseEventTypeInput;
  clientId: Scalars['Int']['input'];
  subGroupsIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type ClientAuditEventsQuery = { __typename?: 'Query', auditEvents: Array<{ __typename?: 'EventAggregationByInterval', event: { __typename?: 'BaseEventType', entity: string, action: string }, buckets: Array<{ __typename?: 'AggregationBucket', key: number, doc_count: number }> }> };

export type UsersActivityQueryVariables = Exact<{
  startDate: Scalars['Float']['input'];
  endDate: Scalars['Float']['input'];
  clientId: Scalars['Int']['input'];
  subGroupsIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersActivityQuery = { __typename?: 'Query', usersActivity: Array<{ __typename?: 'UserActivityRow', activity_time_seconds: number, email: string, logins: number, proposal_create: number, proposal_update: number, proposal_update_unique: number, insight_update: number }> };

export type AnalyticsDashboardsQueryVariables = Exact<{ [key: string]: never; }>;


export type AnalyticsDashboardsQuery = { __typename?: 'Query', analyticsDashboards: Array<{ __typename?: 'AnalyticsDashboard', id: number, name: string, restricted: boolean }> };

export type AnalyticsDashboardFragment = { __typename?: 'AnalyticsDashboard', id: number, name: string, content: string, restricted: boolean, filtersSources: Array<{ __typename?: 'AnalyticsDashboardFiltersSource', id: string, type: FiltersSourceType, templateId?: number | null, pageId?: string | null, fieldId?: string | null, filterKey: string, addEmptyOption: boolean, analyticsPage?: { __typename?: 'ProposalAnalyticsPage', id: string, name: string, type: TemplatePageType, primaryColumnUUID?: string | null, fields: Array<{ __typename?: 'AnalyticsPageField', id: string, name: string, fullName: string }> } | null }>, charts: Array<{ __typename?: 'AnalyticsDashboardChart', id: string, name: string, showTable: boolean, sqlQuery: string, dashboardDefinition: string, templateId: number, pageId: string, tableColumns: any }> };

export type DashboardChartDataQueryVariables = Exact<{
  chartId: Scalars['String']['input'];
  variables: Scalars['JSON']['input'];
}>;


export type DashboardChartDataQuery = { __typename?: 'Query', dashboardChartData: string };

export type AnalyticsDashboardQueryVariables = Exact<{
  where: AnalyticsDashboardWhereUniqueInput;
}>;


export type AnalyticsDashboardQuery = { __typename?: 'Query', analyticsDashboard?: { __typename?: 'AnalyticsDashboard', id: number, name: string, content: string, restricted: boolean, filtersSources: Array<{ __typename?: 'AnalyticsDashboardFiltersSource', id: string, type: FiltersSourceType, templateId?: number | null, pageId?: string | null, fieldId?: string | null, filterKey: string, addEmptyOption: boolean, analyticsPage?: { __typename?: 'ProposalAnalyticsPage', id: string, name: string, type: TemplatePageType, primaryColumnUUID?: string | null, fields: Array<{ __typename?: 'AnalyticsPageField', id: string, name: string, fullName: string }> } | null }>, charts: Array<{ __typename?: 'AnalyticsDashboardChart', id: string, name: string, showTable: boolean, sqlQuery: string, dashboardDefinition: string, templateId: number, pageId: string, tableColumns: any }> } | null };

export type CreateAnalyticsDashboardMutationVariables = Exact<{
  data: AnalyticsDashboardCreateInput;
}>;


export type CreateAnalyticsDashboardMutation = { __typename?: 'Mutation', createOneAnalyticsDashboard: { __typename?: 'AnalyticsDashboard', id: number, name: string, content: string, restricted: boolean, filtersSources: Array<{ __typename?: 'AnalyticsDashboardFiltersSource', id: string, type: FiltersSourceType, templateId?: number | null, pageId?: string | null, fieldId?: string | null, filterKey: string, addEmptyOption: boolean, analyticsPage?: { __typename?: 'ProposalAnalyticsPage', id: string, name: string, type: TemplatePageType, primaryColumnUUID?: string | null, fields: Array<{ __typename?: 'AnalyticsPageField', id: string, name: string, fullName: string }> } | null }>, charts: Array<{ __typename?: 'AnalyticsDashboardChart', id: string, name: string, showTable: boolean, sqlQuery: string, dashboardDefinition: string, templateId: number, pageId: string, tableColumns: any }> } };

export type DeleteAnalyticsDashboardMutationVariables = Exact<{
  where: AnalyticsDashboardWhereUniqueInput;
}>;


export type DeleteAnalyticsDashboardMutation = { __typename?: 'Mutation', deleteOneAnalyticsDashboard?: { __typename?: 'AnalyticsDashboard', id: number } | null };

export type UpdateAnalyticsDashboardMutationVariables = Exact<{
  data: AppAnalyticsDashboardUpdateInput;
  where: AppAnalyticsDashboardWhereUniqueInput;
}>;


export type UpdateAnalyticsDashboardMutation = { __typename?: 'Mutation', updateAnalyticsDashboard: { __typename?: 'AnalyticsDashboard', id: number, name: string, content: string, restricted: boolean, filtersSources: Array<{ __typename?: 'AnalyticsDashboardFiltersSource', id: string, type: FiltersSourceType, templateId?: number | null, pageId?: string | null, fieldId?: string | null, filterKey: string, addEmptyOption: boolean, analyticsPage?: { __typename?: 'ProposalAnalyticsPage', id: string, name: string, type: TemplatePageType, primaryColumnUUID?: string | null, fields: Array<{ __typename?: 'AnalyticsPageField', id: string, name: string, fullName: string }> } | null }>, charts: Array<{ __typename?: 'AnalyticsDashboardChart', id: string, name: string, showTable: boolean, sqlQuery: string, dashboardDefinition: string, templateId: number, pageId: string, tableColumns: any }> } };

export type AnalyticsChartTemplatesOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AnalyticsChartTemplatesOptionsQuery = { __typename?: 'Query', proposalTemplates: Array<{ __typename?: 'ProposalTemplate', id: number, name: string, lastVersion: { __typename?: 'ProposalTemplateVersion', id: number, analyticsPages: Array<{ __typename?: 'ProposalAnalyticsPage', id: string, name: string, type: TemplatePageType, primaryColumnUUID?: string | null, fields: Array<{ __typename?: 'AnalyticsPageField', id: string, name: string, fullName: string }> }> } }> };

export type AnalyticsPagesByTemplateIdsQueryVariables = Exact<{
  templateIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type AnalyticsPagesByTemplateIdsQuery = { __typename?: 'Query', proposalTemplates: Array<{ __typename?: 'ProposalTemplate', id: number, lastVersion: { __typename?: 'ProposalTemplateVersion', analyticsPages: Array<{ __typename?: 'ProposalAnalyticsPage', id: string, primaryColumnUUID?: string | null }> } }> };

export type GetDynamicAnalyticFiltersSourcesQueryVariables = Exact<{
  aggregations: Array<Aggregate> | Aggregate;
  includeProposalIds?: InputMaybe<Scalars['Boolean']['input']>;
  includeOwners?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetDynamicAnalyticFiltersSourcesQuery = { __typename?: 'Query', proposalIds?: Array<number>, owners?: Array<{ __typename?: 'ProposalVersion', createdBy: string }>, proposalAnalyticFiltersAggregations?: { __typename?: 'Resp', data: any } | null };

export type RecentProposalsQueryVariables = Exact<{ [key: string]: never; }>;


export type RecentProposalsQuery = { __typename?: 'Query', proposals: { __typename?: 'ProposalsPaginated', items: Array<{ __typename?: 'ProposalListItem', id: number, name: string, createdBy: string, dataSourceUsedAt?: any | null, latestVersionId: number, updatedAt: any, lastVersionCreatedBy: string, isFinalized: boolean }> } };

export type ListLookupsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListLookupsQuery = { __typename?: 'Query', lookups: Array<{ __typename?: 'Lookup', id: number, name: string, updatedAt: any, createdAt: any }> };

export type GetLookupsByIdQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetLookupsByIdQuery = { __typename?: 'Query', lookups: Array<{ __typename?: 'Lookup', id: number, name: string, valueKey: string, labelKey: string, options: any, usedAt?: any | null }> };

export type GetLookupQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetLookupQuery = { __typename?: 'Query', lookup?: { __typename?: 'Lookup', id: number, name: string, valueKey: string, labelKey: string, options: any, usedAt?: any | null } | null };

export type CreateOneLookupMutationVariables = Exact<{
  data: LookupCreateInput;
}>;


export type CreateOneLookupMutation = { __typename?: 'Mutation', createOneLookup: { __typename?: 'Lookup', id: number } };

export type UpdateOneLookupMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  data: LookupUpdateInput;
}>;


export type UpdateOneLookupMutation = { __typename?: 'Mutation', updateOneLookup?: { __typename?: 'Lookup', id: number } | null };

export type DeleteOneLookupMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteOneLookupMutation = { __typename?: 'Mutation', deleteOneLookup?: { __typename?: 'Lookup', id: number } | null };

export type LookupsOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type LookupsOptionsQuery = { __typename?: 'Query', lookups: Array<{ __typename?: 'Lookup', id: number, name: string }> };

export type ListProposalsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProposalsSortItem> | ProposalsSortItem>;
  filter?: InputMaybe<ProposalsFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchUserEmails?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ListProposalsQuery = { __typename?: 'Query', proposals: { __typename?: 'ProposalsPaginated', count: number, items: Array<{ __typename?: 'ProposalListItem', id: number, name: string, templateName: string, createdBy: string, updatedAt: any, dataSourceUsedAt?: any | null, createdAt: any, lastVersionCreatedBy: string, latestVersionId: number, isFinalized: boolean, isPinned: boolean, fields: Array<{ __typename?: 'ProposalListItemField', name: string, value?: string | null, fieldId: string, type: string, dateMode?: DateMode | null }> }> } };

export type ProposalVersionFreshnessDataSourcesQueryVariables = Exact<{
  proposalId: Scalars['Int']['input'];
  versionId: Scalars['Int']['input'];
}>;


export type ProposalVersionFreshnessDataSourcesQuery = { __typename?: 'Query', proposal?: { __typename?: 'Proposal', id: number, versions: Array<{ __typename?: 'ProposalVersion', id: number, dataSourceVersions: Array<{ __typename?: 'ProposalVersionDataSource', dataSourceVersion: { __typename?: 'DataSourceVersion', createdAt: any, usedAt?: any | null, dataSource: { __typename?: 'DataSource', name: string } } }> }> } | null };

export type ProposalVersionDsLinksFragment = { __typename?: 'ProposalVersion', dataSourceVersions: Array<{ __typename?: 'ProposalVersionDataSource', dataSourceVersionId: number, dataSourceVersion: { __typename?: 'DataSourceVersion', id: number, dataSourceId: number, usedAt?: any | null, createdAt: any, dataSource: { __typename?: 'DataSource', name: string } } }> };

export type GetOneProposalQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneProposalQuery = { __typename?: 'Query', proposal?: { __typename?: 'Proposal', id: number, type: ProposalType, name: string, templateVersionId: number, isFinalized: boolean, versions: Array<{ __typename?: 'ProposalVersion', id: number, createdAt: any, createdBy: string, dataSourceUsedAt?: any | null, sequentialNumber: number }>, lastVersion: { __typename?: 'ProposalVersion', id: number, data?: any | null, createdAt: any, dataSourceUsedAt?: any | null, dataSourceVersions: Array<{ __typename?: 'ProposalVersionDataSource', dataSourceVersionId: number, dataSourceVersion: { __typename?: 'DataSourceVersion', id: number, dataSourceId: number, usedAt?: any | null, createdAt: any, dataSource: { __typename?: 'DataSource', name: string } } }> } } | null };

export type GetLastProposalEditorQueryVariables = Exact<{
  proposalId: Scalars['Int']['input'];
}>;


export type GetLastProposalEditorQuery = { __typename?: 'Query', lastEditor?: string | null };

export type ProposalEditorCheckInOpenedMutationVariables = Exact<{
  proposalId: Scalars['Int']['input'];
}>;


export type ProposalEditorCheckInOpenedMutation = { __typename?: 'Mutation', proposalEditorCheckInOpened?: string | null };

export type ProposalEditorCheckInClosedMutationVariables = Exact<{
  proposalId: Scalars['Int']['input'];
}>;


export type ProposalEditorCheckInClosedMutation = { __typename?: 'Mutation', proposalEditorCheckInClosed: boolean };

export type GetOneProposalNameQueryVariables = Exact<{
  proposalId: Scalars['Int']['input'];
}>;


export type GetOneProposalNameQuery = { __typename?: 'Query', proposalName: string };

export type CreateOneProposalMutationVariables = Exact<{
  data: ProposalCreateInput;
}>;


export type CreateOneProposalMutation = { __typename?: 'Mutation', createOneProposal: { __typename?: 'Proposal', id: number } };

export type UpdateOneProposalMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  data: ProposalUpdateInput;
}>;


export type UpdateOneProposalMutation = { __typename?: 'Mutation', updateOneProposal?: { __typename?: 'Proposal', id: number, lastVersion: Array<{ __typename?: 'ProposalVersion', id: number }> } | null };

export type DeleteOneProposalMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteOneProposalMutation = { __typename?: 'Mutation', deleteOneProposal?: { __typename?: 'Proposal', id: number } | null };

export type DeleteManyProposalMutationVariables = Exact<{
  where?: InputMaybe<ProposalWhereInput>;
}>;


export type DeleteManyProposalMutation = { __typename?: 'Mutation', deleteManyProposal: { __typename?: 'AffectedRowsOutput', count: number } };

export type ProposalTemplateOptionsQueryVariables = Exact<{
  type: TemplateType;
}>;


export type ProposalTemplateOptionsQuery = { __typename?: 'Query', templateOptions: Array<{ __typename?: 'ProposalTemplate', id: number, name: string, isDefault: boolean, isPublished: boolean }> };

export type GetLookupOptionsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetLookupOptionsQuery = { __typename?: 'Query', lookup?: { __typename?: 'Lookup', id: number, options: any, valueKey: string, labelKey: string } | null };

export type ListProposalVersionsQueryVariables = Exact<{
  proposalId: Scalars['Int']['input'];
}>;


export type ListProposalVersionsQuery = { __typename?: 'Query', proposal?: { __typename?: 'Proposal', id: number, versions: Array<{ __typename?: 'ProposalVersion', id: number, createdAt: any, createdBy: string, comment?: string | null, dataSourceUsedAt?: any | null, isSharedWithClient: boolean, sequentialNumber: number }> } | null };

export type ProposalVersionQueryVariables = Exact<{
  proposalId: Scalars['Int']['input'];
  versionId: Scalars['Int']['input'];
}>;


export type ProposalVersionQuery = { __typename?: 'Query', proposal?: { __typename?: 'Proposal', id: number, name: string, templateVersionId: number, type: ProposalType, versions: Array<{ __typename?: 'ProposalVersion', id: number, data?: any | null, createdAt: any, createdBy: string, dataSourceUsedAt?: any | null, sequentialNumber: number, templateVersionId: number, dataSourceVersions: Array<{ __typename?: 'ProposalVersionDataSource', dataSourceVersionId: number, dataSourceVersion: { __typename?: 'DataSourceVersion', id: number, dataSourceId: number, usedAt?: any | null, createdAt: any, dataSource: { __typename?: 'DataSource', name: string } } }> }> } | null };

export type UpdateProposalAccessesMutationVariables = Exact<{
  usersDeleteAccess: Array<Scalars['String']['input']> | Scalars['String']['input'];
  usersGiveAccess: Array<UserProposalAccessCreateManyInput> | UserProposalAccessCreateManyInput;
  proposalId: Scalars['Int']['input'];
}>;


export type UpdateProposalAccessesMutation = { __typename?: 'Mutation', deleteManyUserProposalAccess: { __typename?: 'AffectedRowsOutput', count: number }, createManyUserProposalAccess: { __typename?: 'AffectedRowsOutput', count: number } };

export type ProposalContributorsQueryVariables = Exact<{
  proposalId: Scalars['Int']['input'];
}>;


export type ProposalContributorsQuery = { __typename?: 'Query', userProposalAccesses: Array<{ __typename?: 'UserProposalAccess', email: string }> };

export type NoteFragment = { __typename?: 'Note', id: number, createdBy: string, createdAt: any, content: string, pageId: string };

export type GetOneProposalWithAllNotesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOneProposalWithAllNotesQuery = { __typename?: 'Query', proposal?: { __typename?: 'Proposal', id: number, name: string, isFinalized: boolean, notes: Array<{ __typename?: 'Note', id: number, createdBy: string, createdAt: any, content: string, pageId: string }>, templateVersion: { __typename?: 'ProposalTemplateVersion', templateId: number } } | null };

export type NotesQueryVariables = Exact<{
  where?: InputMaybe<NoteWhereInput>;
}>;


export type NotesQuery = { __typename?: 'Query', notes: Array<{ __typename?: 'Note', id: number, createdBy: string, createdAt: any, content: string, pageId: string }> };

export type UpdateNoteMutationVariables = Exact<{
  data: NoteUpdateInput;
  where: NoteWhereUniqueInput;
}>;


export type UpdateNoteMutation = { __typename?: 'Mutation', updateOneNote?: { __typename?: 'Note', id: number, createdBy: string, createdAt: any, content: string, pageId: string } | null };

export type CreateNoteMutationVariables = Exact<{
  data: NoteCreateInput;
}>;


export type CreateNoteMutation = { __typename?: 'Mutation', createOneNote: { __typename?: 'Note', id: number, createdBy: string, createdAt: any, content: string, pageId: string } };

export type DeleteOneNoteMutationVariables = Exact<{
  where: NoteWhereUniqueInput;
}>;


export type DeleteOneNoteMutation = { __typename?: 'Mutation', deleteOneNote?: { __typename?: 'Note', id: number } | null };

export type LogAuditEventMutationVariables = Exact<{
  input: LogAuditEventInput;
}>;


export type LogAuditEventMutation = { __typename?: 'Mutation', logAuditEvent: boolean };

export type SaveProposalMetricsMutationVariables = Exact<{
  proposalId?: InputMaybe<Scalars['Int']['input']>;
  metrics: Array<ProposalMetricSaveInput> | ProposalMetricSaveInput;
}>;


export type SaveProposalMetricsMutation = { __typename?: 'Mutation', saveProposalMetrics: boolean };

export type GetProposalRowSummaryQueryVariables = Exact<{
  versionId: Scalars['Float']['input'];
  pageUuid: Scalars['String']['input'];
  rowUuid: Scalars['String']['input'];
}>;


export type GetProposalRowSummaryQuery = { __typename?: 'Query', proposalRowSummary: Array<{ __typename?: 'ProposalRowSummaryResult', column_uuid: string, last_updated_at: any }> };

export type GetProposalPageDataSourceRowsQueryVariables = Exact<{
  proposalId: Scalars['Int']['input'];
  versionId: Scalars['Int']['input'];
  pageUuid: Scalars['String']['input'];
}>;


export type GetProposalPageDataSourceRowsQuery = { __typename?: 'Query', proposalPageDataSourceRows?: { __typename?: 'ProposalPageDataSourceRows', columns: Array<string>, rows: any } | null };

export type ListInsightTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListInsightTemplatesQuery = { __typename?: 'Query', proposalTemplates: Array<{ __typename?: 'ProposalTemplate', id: number, name: string, type: TemplateType, updatedAt: any, createdAt: any, isDefault: boolean, isPublished: boolean, lastVersion: { __typename?: 'ProposalTemplateVersion', createdAt: any, id: number, pages: any, settings: any, metrics: any } }> };

export const KeycloakUserFragmentDoc = gql`
    fragment keycloakUser on KeycloakUser {
  id
  firstName
  lastName
  email
  emailVerified
  enabled
  role
  lastLoginDate
  lastSentEmailDate
  subGroups {
    id
    name
  }
}
    `;
export const BaseClientFragmentDoc = gql`
    fragment baseClient on Client {
  id
  keycloakGroupName
  keycloakGroupId
  databaseName
  usersLimit
  enabled
  applicationTitle
  applicationLogoUrl
  applicationBrandColor
  applicationBaseUrl
  proposalNavigationPosition
  bannerHeader
  bannerText
  bannerEnabled
  keycloakFrontendClientInternalId
  entityNameSingular
  entityNamePlural
  insightPlaceholderSingular
  insightPlaceholderPlural
}
    `;
export const ClientFragmentDoc = gql`
    fragment client on Client {
  ...baseClient
  clientPermissions {
    scope
    role
  }
  clientFeatures {
    name
  }
  keycloakGroup {
    id
    name
    subGroups {
      id
      name
      path
    }
  }
  keycloakFrontendClient {
    id
    attributes {
      login_theme
    }
  }
}
    ${BaseClientFragmentDoc}`;
export const TemplateVersionFragmentDoc = gql`
    fragment TemplateVersion on ProposalTemplateVersion {
  id
  pages
  settings
  metrics
}
    `;
export const AnalyticsDashboardFragmentDoc = gql`
    fragment analyticsDashboard on AnalyticsDashboard {
  id
  name
  content
  restricted
  filtersSources {
    id
    type
    templateId
    pageId
    fieldId
    filterKey
    addEmptyOption
    analyticsPage {
      id
      name
      type
      primaryColumnUUID
      fields {
        id
        name
        fullName
      }
    }
  }
  charts {
    id
    name
    showTable
    sqlQuery
    dashboardDefinition
    templateId
    pageId
    tableColumns
  }
}
    `;
export const ProposalVersionDsLinksFragmentDoc = gql`
    fragment ProposalVersionDsLinks on ProposalVersion {
  dataSourceVersions {
    dataSourceVersionId
    dataSourceVersion {
      id
      dataSourceId
      usedAt
      createdAt
      dataSource {
        name
      }
    }
  }
}
    `;
export const NoteFragmentDoc = gql`
    fragment note on Note {
  id
  createdBy
  createdAt
  content
  pageId
}
    `;
export const ClientSettingsDocument = gql`
    query ClientSettings {
  currentClient {
    id
    entityNamePlural
    entityNameSingular
    insightPlaceholderSingular
    insightPlaceholderPlural
    clientPermissions {
      clientId
      scope
      role
    }
    clientFeatures {
      name
    }
    proposalNavigationPosition
  }
}
    `;

/**
 * __useClientSettingsQuery__
 *
 * To run a query within a React component, call `useClientSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientSettingsQuery(baseOptions?: Apollo.QueryHookOptions<ClientSettingsQuery, ClientSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientSettingsQuery, ClientSettingsQueryVariables>(ClientSettingsDocument, options);
      }
export function useClientSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientSettingsQuery, ClientSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientSettingsQuery, ClientSettingsQueryVariables>(ClientSettingsDocument, options);
        }
export function useClientSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientSettingsQuery, ClientSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientSettingsQuery, ClientSettingsQueryVariables>(ClientSettingsDocument, options);
        }
export type ClientSettingsQueryHookResult = ReturnType<typeof useClientSettingsQuery>;
export type ClientSettingsLazyQueryHookResult = ReturnType<typeof useClientSettingsLazyQuery>;
export type ClientSettingsSuspenseQueryHookResult = ReturnType<typeof useClientSettingsSuspenseQuery>;
export type ClientSettingsQueryResult = Apollo.QueryResult<ClientSettingsQuery, ClientSettingsQueryVariables>;
export const NavigationPositionByClientDocument = gql`
    query NavigationPositionByClient($keycloackGroupName: String!) {
  navigationPositionByClient(keycloackGroupName: $keycloackGroupName) {
    data
  }
}
    `;

/**
 * __useNavigationPositionByClientQuery__
 *
 * To run a query within a React component, call `useNavigationPositionByClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigationPositionByClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigationPositionByClientQuery({
 *   variables: {
 *      keycloackGroupName: // value for 'keycloackGroupName'
 *   },
 * });
 */
export function useNavigationPositionByClientQuery(baseOptions: Apollo.QueryHookOptions<NavigationPositionByClientQuery, NavigationPositionByClientQueryVariables> & ({ variables: NavigationPositionByClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavigationPositionByClientQuery, NavigationPositionByClientQueryVariables>(NavigationPositionByClientDocument, options);
      }
export function useNavigationPositionByClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavigationPositionByClientQuery, NavigationPositionByClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavigationPositionByClientQuery, NavigationPositionByClientQueryVariables>(NavigationPositionByClientDocument, options);
        }
export function useNavigationPositionByClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NavigationPositionByClientQuery, NavigationPositionByClientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NavigationPositionByClientQuery, NavigationPositionByClientQueryVariables>(NavigationPositionByClientDocument, options);
        }
export type NavigationPositionByClientQueryHookResult = ReturnType<typeof useNavigationPositionByClientQuery>;
export type NavigationPositionByClientLazyQueryHookResult = ReturnType<typeof useNavigationPositionByClientLazyQuery>;
export type NavigationPositionByClientSuspenseQueryHookResult = ReturnType<typeof useNavigationPositionByClientSuspenseQuery>;
export type NavigationPositionByClientQueryResult = Apollo.QueryResult<NavigationPositionByClientQuery, NavigationPositionByClientQueryVariables>;
export const ListDataSourcesDocument = gql`
    query ListDataSources {
  dataSources {
    id
    name
    updatedAt
    createdAt
    lastVersion {
      id
      type
      columns
      usedAt
    }
  }
}
    `;

/**
 * __useListDataSourcesQuery__
 *
 * To run a query within a React component, call `useListDataSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDataSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDataSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListDataSourcesQuery(baseOptions?: Apollo.QueryHookOptions<ListDataSourcesQuery, ListDataSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDataSourcesQuery, ListDataSourcesQueryVariables>(ListDataSourcesDocument, options);
      }
export function useListDataSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDataSourcesQuery, ListDataSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDataSourcesQuery, ListDataSourcesQueryVariables>(ListDataSourcesDocument, options);
        }
export function useListDataSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDataSourcesQuery, ListDataSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListDataSourcesQuery, ListDataSourcesQueryVariables>(ListDataSourcesDocument, options);
        }
export type ListDataSourcesQueryHookResult = ReturnType<typeof useListDataSourcesQuery>;
export type ListDataSourcesLazyQueryHookResult = ReturnType<typeof useListDataSourcesLazyQuery>;
export type ListDataSourcesSuspenseQueryHookResult = ReturnType<typeof useListDataSourcesSuspenseQuery>;
export type ListDataSourcesQueryResult = Apollo.QueryResult<ListDataSourcesQuery, ListDataSourcesQueryVariables>;
export const GetDataSourceDocument = gql`
    query GetDataSource($id: Int!) {
  dataSourceGet(id: $id) {
    id
    name
    isSharedWithAdmin
    includeInFreshness
    lastVersion {
      id
      type
      code
      columns
      validationRules
      mappingRules
      createdAt
      usedAt
      hash
    }
  }
}
    `;

/**
 * __useGetDataSourceQuery__
 *
 * To run a query within a React component, call `useGetDataSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataSourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDataSourceQuery(baseOptions: Apollo.QueryHookOptions<GetDataSourceQuery, GetDataSourceQueryVariables> & ({ variables: GetDataSourceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataSourceQuery, GetDataSourceQueryVariables>(GetDataSourceDocument, options);
      }
export function useGetDataSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataSourceQuery, GetDataSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataSourceQuery, GetDataSourceQueryVariables>(GetDataSourceDocument, options);
        }
export function useGetDataSourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDataSourceQuery, GetDataSourceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDataSourceQuery, GetDataSourceQueryVariables>(GetDataSourceDocument, options);
        }
export type GetDataSourceQueryHookResult = ReturnType<typeof useGetDataSourceQuery>;
export type GetDataSourceLazyQueryHookResult = ReturnType<typeof useGetDataSourceLazyQuery>;
export type GetDataSourceSuspenseQueryHookResult = ReturnType<typeof useGetDataSourceSuspenseQuery>;
export type GetDataSourceQueryResult = Apollo.QueryResult<GetDataSourceQuery, GetDataSourceQueryVariables>;
export const DataSourceUpdateDocument = gql`
    mutation DataSourceUpdate($data: DataSourceSaveResolverUpdateInput!) {
  dataSourceUpdate(data: $data) {
    id
  }
}
    `;
export type DataSourceUpdateMutationFn = Apollo.MutationFunction<DataSourceUpdateMutation, DataSourceUpdateMutationVariables>;

/**
 * __useDataSourceUpdateMutation__
 *
 * To run a mutation, you first call `useDataSourceUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataSourceUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataSourceUpdateMutation, { data, loading, error }] = useDataSourceUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDataSourceUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DataSourceUpdateMutation, DataSourceUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataSourceUpdateMutation, DataSourceUpdateMutationVariables>(DataSourceUpdateDocument, options);
      }
export type DataSourceUpdateMutationHookResult = ReturnType<typeof useDataSourceUpdateMutation>;
export type DataSourceUpdateMutationResult = Apollo.MutationResult<DataSourceUpdateMutation>;
export type DataSourceUpdateMutationOptions = Apollo.BaseMutationOptions<DataSourceUpdateMutation, DataSourceUpdateMutationVariables>;
export const DataSourceCreateDocument = gql`
    mutation DataSourceCreate($data: DataSourceSaveResolverCreateInput!) {
  dataSourceCreate(data: $data) {
    id
    name
  }
}
    `;
export type DataSourceCreateMutationFn = Apollo.MutationFunction<DataSourceCreateMutation, DataSourceCreateMutationVariables>;

/**
 * __useDataSourceCreateMutation__
 *
 * To run a mutation, you first call `useDataSourceCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataSourceCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataSourceCreateMutation, { data, loading, error }] = useDataSourceCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDataSourceCreateMutation(baseOptions?: Apollo.MutationHookOptions<DataSourceCreateMutation, DataSourceCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataSourceCreateMutation, DataSourceCreateMutationVariables>(DataSourceCreateDocument, options);
      }
export type DataSourceCreateMutationHookResult = ReturnType<typeof useDataSourceCreateMutation>;
export type DataSourceCreateMutationResult = Apollo.MutationResult<DataSourceCreateMutation>;
export type DataSourceCreateMutationOptions = Apollo.BaseMutationOptions<DataSourceCreateMutation, DataSourceCreateMutationVariables>;
export const CreateOneDataSourceDocument = gql`
    mutation CreateOneDataSource($data: DataSourceCreateInput!) {
  createOneDataSource(data: $data) {
    id
  }
}
    `;
export type CreateOneDataSourceMutationFn = Apollo.MutationFunction<CreateOneDataSourceMutation, CreateOneDataSourceMutationVariables>;

/**
 * __useCreateOneDataSourceMutation__
 *
 * To run a mutation, you first call `useCreateOneDataSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneDataSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneDataSourceMutation, { data, loading, error }] = useCreateOneDataSourceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneDataSourceMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneDataSourceMutation, CreateOneDataSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneDataSourceMutation, CreateOneDataSourceMutationVariables>(CreateOneDataSourceDocument, options);
      }
export type CreateOneDataSourceMutationHookResult = ReturnType<typeof useCreateOneDataSourceMutation>;
export type CreateOneDataSourceMutationResult = Apollo.MutationResult<CreateOneDataSourceMutation>;
export type CreateOneDataSourceMutationOptions = Apollo.BaseMutationOptions<CreateOneDataSourceMutation, CreateOneDataSourceMutationVariables>;
export const DataSourceDeleteImpactDocument = gql`
    query DataSourceDeleteImpact($id: Int!) {
  dataSourceDeleteImpact(id: $id) {
    proposals
    insights
  }
}
    `;

/**
 * __useDataSourceDeleteImpactQuery__
 *
 * To run a query within a React component, call `useDataSourceDeleteImpactQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataSourceDeleteImpactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataSourceDeleteImpactQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataSourceDeleteImpactQuery(baseOptions: Apollo.QueryHookOptions<DataSourceDeleteImpactQuery, DataSourceDeleteImpactQueryVariables> & ({ variables: DataSourceDeleteImpactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataSourceDeleteImpactQuery, DataSourceDeleteImpactQueryVariables>(DataSourceDeleteImpactDocument, options);
      }
export function useDataSourceDeleteImpactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataSourceDeleteImpactQuery, DataSourceDeleteImpactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataSourceDeleteImpactQuery, DataSourceDeleteImpactQueryVariables>(DataSourceDeleteImpactDocument, options);
        }
export function useDataSourceDeleteImpactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataSourceDeleteImpactQuery, DataSourceDeleteImpactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataSourceDeleteImpactQuery, DataSourceDeleteImpactQueryVariables>(DataSourceDeleteImpactDocument, options);
        }
export type DataSourceDeleteImpactQueryHookResult = ReturnType<typeof useDataSourceDeleteImpactQuery>;
export type DataSourceDeleteImpactLazyQueryHookResult = ReturnType<typeof useDataSourceDeleteImpactLazyQuery>;
export type DataSourceDeleteImpactSuspenseQueryHookResult = ReturnType<typeof useDataSourceDeleteImpactSuspenseQuery>;
export type DataSourceDeleteImpactQueryResult = Apollo.QueryResult<DataSourceDeleteImpactQuery, DataSourceDeleteImpactQueryVariables>;
export const DataSourceDeleteDocument = gql`
    mutation DataSourceDelete($id: Int!, $deleteProposals: Boolean!) {
  dataSourceDelete(id: $id, deleteProposals: $deleteProposals) {
    id
  }
}
    `;
export type DataSourceDeleteMutationFn = Apollo.MutationFunction<DataSourceDeleteMutation, DataSourceDeleteMutationVariables>;

/**
 * __useDataSourceDeleteMutation__
 *
 * To run a mutation, you first call `useDataSourceDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDataSourceDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dataSourceDeleteMutation, { data, loading, error }] = useDataSourceDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      deleteProposals: // value for 'deleteProposals'
 *   },
 * });
 */
export function useDataSourceDeleteMutation(baseOptions?: Apollo.MutationHookOptions<DataSourceDeleteMutation, DataSourceDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DataSourceDeleteMutation, DataSourceDeleteMutationVariables>(DataSourceDeleteDocument, options);
      }
export type DataSourceDeleteMutationHookResult = ReturnType<typeof useDataSourceDeleteMutation>;
export type DataSourceDeleteMutationResult = Apollo.MutationResult<DataSourceDeleteMutation>;
export type DataSourceDeleteMutationOptions = Apollo.BaseMutationOptions<DataSourceDeleteMutation, DataSourceDeleteMutationVariables>;
export const GetDataSourceDataByIdDocument = gql`
    query GetDataSourceDataById($id: Int!) {
  dataSource(where: {id: $id}) {
    id
    name
    updatedAt
    lastVersion {
      data
      columns
      usedAt
    }
  }
}
    `;

/**
 * __useGetDataSourceDataByIdQuery__
 *
 * To run a query within a React component, call `useGetDataSourceDataByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataSourceDataByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataSourceDataByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDataSourceDataByIdQuery(baseOptions: Apollo.QueryHookOptions<GetDataSourceDataByIdQuery, GetDataSourceDataByIdQueryVariables> & ({ variables: GetDataSourceDataByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataSourceDataByIdQuery, GetDataSourceDataByIdQueryVariables>(GetDataSourceDataByIdDocument, options);
      }
export function useGetDataSourceDataByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataSourceDataByIdQuery, GetDataSourceDataByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataSourceDataByIdQuery, GetDataSourceDataByIdQueryVariables>(GetDataSourceDataByIdDocument, options);
        }
export function useGetDataSourceDataByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDataSourceDataByIdQuery, GetDataSourceDataByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDataSourceDataByIdQuery, GetDataSourceDataByIdQueryVariables>(GetDataSourceDataByIdDocument, options);
        }
export type GetDataSourceDataByIdQueryHookResult = ReturnType<typeof useGetDataSourceDataByIdQuery>;
export type GetDataSourceDataByIdLazyQueryHookResult = ReturnType<typeof useGetDataSourceDataByIdLazyQuery>;
export type GetDataSourceDataByIdSuspenseQueryHookResult = ReturnType<typeof useGetDataSourceDataByIdSuspenseQuery>;
export type GetDataSourceDataByIdQueryResult = Apollo.QueryResult<GetDataSourceDataByIdQuery, GetDataSourceDataByIdQueryVariables>;
export const GetDataSourceDataByNameDocument = gql`
    query GetDataSourceDataByName($name: String!) {
  dataSource(where: {name: $name}) {
    id
    name
    updatedAt
    lastVersion {
      data
      columns
      usedAt
    }
  }
}
    `;

/**
 * __useGetDataSourceDataByNameQuery__
 *
 * To run a query within a React component, call `useGetDataSourceDataByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataSourceDataByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataSourceDataByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetDataSourceDataByNameQuery(baseOptions: Apollo.QueryHookOptions<GetDataSourceDataByNameQuery, GetDataSourceDataByNameQueryVariables> & ({ variables: GetDataSourceDataByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataSourceDataByNameQuery, GetDataSourceDataByNameQueryVariables>(GetDataSourceDataByNameDocument, options);
      }
export function useGetDataSourceDataByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataSourceDataByNameQuery, GetDataSourceDataByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataSourceDataByNameQuery, GetDataSourceDataByNameQueryVariables>(GetDataSourceDataByNameDocument, options);
        }
export function useGetDataSourceDataByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDataSourceDataByNameQuery, GetDataSourceDataByNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDataSourceDataByNameQuery, GetDataSourceDataByNameQueryVariables>(GetDataSourceDataByNameDocument, options);
        }
export type GetDataSourceDataByNameQueryHookResult = ReturnType<typeof useGetDataSourceDataByNameQuery>;
export type GetDataSourceDataByNameLazyQueryHookResult = ReturnType<typeof useGetDataSourceDataByNameLazyQuery>;
export type GetDataSourceDataByNameSuspenseQueryHookResult = ReturnType<typeof useGetDataSourceDataByNameSuspenseQuery>;
export type GetDataSourceDataByNameQueryResult = Apollo.QueryResult<GetDataSourceDataByNameQuery, GetDataSourceDataByNameQueryVariables>;
export const GetDataSourceDataByVersionIdDocument = gql`
    query GetDataSourceDataByVersionId($versionId: Int!) {
  dataSourceVersion(where: {id: $versionId}) {
    id
    data
    columns
    usedAt
    createdAt
    dataSource {
      id
      name
      createdAt
    }
  }
}
    `;

/**
 * __useGetDataSourceDataByVersionIdQuery__
 *
 * To run a query within a React component, call `useGetDataSourceDataByVersionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataSourceDataByVersionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataSourceDataByVersionIdQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useGetDataSourceDataByVersionIdQuery(baseOptions: Apollo.QueryHookOptions<GetDataSourceDataByVersionIdQuery, GetDataSourceDataByVersionIdQueryVariables> & ({ variables: GetDataSourceDataByVersionIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataSourceDataByVersionIdQuery, GetDataSourceDataByVersionIdQueryVariables>(GetDataSourceDataByVersionIdDocument, options);
      }
export function useGetDataSourceDataByVersionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataSourceDataByVersionIdQuery, GetDataSourceDataByVersionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataSourceDataByVersionIdQuery, GetDataSourceDataByVersionIdQueryVariables>(GetDataSourceDataByVersionIdDocument, options);
        }
export function useGetDataSourceDataByVersionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDataSourceDataByVersionIdQuery, GetDataSourceDataByVersionIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDataSourceDataByVersionIdQuery, GetDataSourceDataByVersionIdQueryVariables>(GetDataSourceDataByVersionIdDocument, options);
        }
export type GetDataSourceDataByVersionIdQueryHookResult = ReturnType<typeof useGetDataSourceDataByVersionIdQuery>;
export type GetDataSourceDataByVersionIdLazyQueryHookResult = ReturnType<typeof useGetDataSourceDataByVersionIdLazyQuery>;
export type GetDataSourceDataByVersionIdSuspenseQueryHookResult = ReturnType<typeof useGetDataSourceDataByVersionIdSuspenseQuery>;
export type GetDataSourceDataByVersionIdQueryResult = Apollo.QueryResult<GetDataSourceDataByVersionIdQuery, GetDataSourceDataByVersionIdQueryVariables>;
export const GetDataSourceVersionsByMetaDocument = gql`
    query GetDataSourceVersionsByMeta($versionFilters: [DataSourceVersionWhereInput!]!) {
  dataSourceVersions(where: {OR: $versionFilters}) {
    id
    createdAt
    dataSourceId
    usedAt
    dataSource {
      id
      name
      createdAt
    }
  }
}
    `;

/**
 * __useGetDataSourceVersionsByMetaQuery__
 *
 * To run a query within a React component, call `useGetDataSourceVersionsByMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataSourceVersionsByMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataSourceVersionsByMetaQuery({
 *   variables: {
 *      versionFilters: // value for 'versionFilters'
 *   },
 * });
 */
export function useGetDataSourceVersionsByMetaQuery(baseOptions: Apollo.QueryHookOptions<GetDataSourceVersionsByMetaQuery, GetDataSourceVersionsByMetaQueryVariables> & ({ variables: GetDataSourceVersionsByMetaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataSourceVersionsByMetaQuery, GetDataSourceVersionsByMetaQueryVariables>(GetDataSourceVersionsByMetaDocument, options);
      }
export function useGetDataSourceVersionsByMetaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataSourceVersionsByMetaQuery, GetDataSourceVersionsByMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataSourceVersionsByMetaQuery, GetDataSourceVersionsByMetaQueryVariables>(GetDataSourceVersionsByMetaDocument, options);
        }
export function useGetDataSourceVersionsByMetaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDataSourceVersionsByMetaQuery, GetDataSourceVersionsByMetaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDataSourceVersionsByMetaQuery, GetDataSourceVersionsByMetaQueryVariables>(GetDataSourceVersionsByMetaDocument, options);
        }
export type GetDataSourceVersionsByMetaQueryHookResult = ReturnType<typeof useGetDataSourceVersionsByMetaQuery>;
export type GetDataSourceVersionsByMetaLazyQueryHookResult = ReturnType<typeof useGetDataSourceVersionsByMetaLazyQuery>;
export type GetDataSourceVersionsByMetaSuspenseQueryHookResult = ReturnType<typeof useGetDataSourceVersionsByMetaSuspenseQuery>;
export type GetDataSourceVersionsByMetaQueryResult = Apollo.QueryResult<GetDataSourceVersionsByMetaQuery, GetDataSourceVersionsByMetaQueryVariables>;
export const ListUpdatedAtDataSourcesDocument = gql`
    query ListUpdatedAtDataSources($ids: [Int!]!) {
  dataSources(where: {id: {in: $ids}}) {
    id
    updatedAt
    lastVersion {
      usedAt
    }
  }
}
    `;

/**
 * __useListUpdatedAtDataSourcesQuery__
 *
 * To run a query within a React component, call `useListUpdatedAtDataSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUpdatedAtDataSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUpdatedAtDataSourcesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useListUpdatedAtDataSourcesQuery(baseOptions: Apollo.QueryHookOptions<ListUpdatedAtDataSourcesQuery, ListUpdatedAtDataSourcesQueryVariables> & ({ variables: ListUpdatedAtDataSourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUpdatedAtDataSourcesQuery, ListUpdatedAtDataSourcesQueryVariables>(ListUpdatedAtDataSourcesDocument, options);
      }
export function useListUpdatedAtDataSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUpdatedAtDataSourcesQuery, ListUpdatedAtDataSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUpdatedAtDataSourcesQuery, ListUpdatedAtDataSourcesQueryVariables>(ListUpdatedAtDataSourcesDocument, options);
        }
export function useListUpdatedAtDataSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUpdatedAtDataSourcesQuery, ListUpdatedAtDataSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListUpdatedAtDataSourcesQuery, ListUpdatedAtDataSourcesQueryVariables>(ListUpdatedAtDataSourcesDocument, options);
        }
export type ListUpdatedAtDataSourcesQueryHookResult = ReturnType<typeof useListUpdatedAtDataSourcesQuery>;
export type ListUpdatedAtDataSourcesLazyQueryHookResult = ReturnType<typeof useListUpdatedAtDataSourcesLazyQuery>;
export type ListUpdatedAtDataSourcesSuspenseQueryHookResult = ReturnType<typeof useListUpdatedAtDataSourcesSuspenseQuery>;
export type ListUpdatedAtDataSourcesQueryResult = Apollo.QueryResult<ListUpdatedAtDataSourcesQuery, ListUpdatedAtDataSourcesQueryVariables>;
export const GetDataSourcesMetaDocument = gql`
    query GetDataSourcesMeta($ids: [Int!]!, $ignoreLastVersionsOfProposalId: Int) {
  dataSourcesMeta(
    where: {id: {in: $ids}}
    ignoreLastVersionsOfProposalId: $ignoreLastVersionsOfProposalId
  ) {
    id
    name
    updatedAt
    lastVersion {
      id
      createdAt
      usedAt
    }
  }
}
    `;

/**
 * __useGetDataSourcesMetaQuery__
 *
 * To run a query within a React component, call `useGetDataSourcesMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataSourcesMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataSourcesMetaQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      ignoreLastVersionsOfProposalId: // value for 'ignoreLastVersionsOfProposalId'
 *   },
 * });
 */
export function useGetDataSourcesMetaQuery(baseOptions: Apollo.QueryHookOptions<GetDataSourcesMetaQuery, GetDataSourcesMetaQueryVariables> & ({ variables: GetDataSourcesMetaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataSourcesMetaQuery, GetDataSourcesMetaQueryVariables>(GetDataSourcesMetaDocument, options);
      }
export function useGetDataSourcesMetaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataSourcesMetaQuery, GetDataSourcesMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataSourcesMetaQuery, GetDataSourcesMetaQueryVariables>(GetDataSourcesMetaDocument, options);
        }
export function useGetDataSourcesMetaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDataSourcesMetaQuery, GetDataSourcesMetaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDataSourcesMetaQuery, GetDataSourcesMetaQueryVariables>(GetDataSourcesMetaDocument, options);
        }
export type GetDataSourcesMetaQueryHookResult = ReturnType<typeof useGetDataSourcesMetaQuery>;
export type GetDataSourcesMetaLazyQueryHookResult = ReturnType<typeof useGetDataSourcesMetaLazyQuery>;
export type GetDataSourcesMetaSuspenseQueryHookResult = ReturnType<typeof useGetDataSourcesMetaSuspenseQuery>;
export type GetDataSourcesMetaQueryResult = Apollo.QueryResult<GetDataSourcesMetaQuery, GetDataSourcesMetaQueryVariables>;
export const DataSourceColumnsDocument = gql`
    query DataSourceColumns($id: Int!) {
  dataSource(where: {id: $id}) {
    id
    lastVersion {
      columns
    }
  }
}
    `;

/**
 * __useDataSourceColumnsQuery__
 *
 * To run a query within a React component, call `useDataSourceColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataSourceColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataSourceColumnsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDataSourceColumnsQuery(baseOptions: Apollo.QueryHookOptions<DataSourceColumnsQuery, DataSourceColumnsQueryVariables> & ({ variables: DataSourceColumnsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataSourceColumnsQuery, DataSourceColumnsQueryVariables>(DataSourceColumnsDocument, options);
      }
export function useDataSourceColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataSourceColumnsQuery, DataSourceColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataSourceColumnsQuery, DataSourceColumnsQueryVariables>(DataSourceColumnsDocument, options);
        }
export function useDataSourceColumnsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataSourceColumnsQuery, DataSourceColumnsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataSourceColumnsQuery, DataSourceColumnsQueryVariables>(DataSourceColumnsDocument, options);
        }
export type DataSourceColumnsQueryHookResult = ReturnType<typeof useDataSourceColumnsQuery>;
export type DataSourceColumnsLazyQueryHookResult = ReturnType<typeof useDataSourceColumnsLazyQuery>;
export type DataSourceColumnsSuspenseQueryHookResult = ReturnType<typeof useDataSourceColumnsSuspenseQuery>;
export type DataSourceColumnsQueryResult = Apollo.QueryResult<DataSourceColumnsQuery, DataSourceColumnsQueryVariables>;
export const DataSourceNamesDocument = gql`
    query DataSourceNames {
  dataSources {
    id
    name
  }
}
    `;

/**
 * __useDataSourceNamesQuery__
 *
 * To run a query within a React component, call `useDataSourceNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataSourceNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataSourceNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataSourceNamesQuery(baseOptions?: Apollo.QueryHookOptions<DataSourceNamesQuery, DataSourceNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataSourceNamesQuery, DataSourceNamesQueryVariables>(DataSourceNamesDocument, options);
      }
export function useDataSourceNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataSourceNamesQuery, DataSourceNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataSourceNamesQuery, DataSourceNamesQueryVariables>(DataSourceNamesDocument, options);
        }
export function useDataSourceNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataSourceNamesQuery, DataSourceNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataSourceNamesQuery, DataSourceNamesQueryVariables>(DataSourceNamesDocument, options);
        }
export type DataSourceNamesQueryHookResult = ReturnType<typeof useDataSourceNamesQuery>;
export type DataSourceNamesLazyQueryHookResult = ReturnType<typeof useDataSourceNamesLazyQuery>;
export type DataSourceNamesSuspenseQueryHookResult = ReturnType<typeof useDataSourceNamesSuspenseQuery>;
export type DataSourceNamesQueryResult = Apollo.QueryResult<DataSourceNamesQuery, DataSourceNamesQueryVariables>;
export const DataSourceOptionsDocument = gql`
    query DataSourceOptions {
  dataSources {
    id
    name
  }
}
    `;

/**
 * __useDataSourceOptionsQuery__
 *
 * To run a query within a React component, call `useDataSourceOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataSourceOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataSourceOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataSourceOptionsQuery(baseOptions?: Apollo.QueryHookOptions<DataSourceOptionsQuery, DataSourceOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataSourceOptionsQuery, DataSourceOptionsQueryVariables>(DataSourceOptionsDocument, options);
      }
export function useDataSourceOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataSourceOptionsQuery, DataSourceOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataSourceOptionsQuery, DataSourceOptionsQueryVariables>(DataSourceOptionsDocument, options);
        }
export function useDataSourceOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataSourceOptionsQuery, DataSourceOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataSourceOptionsQuery, DataSourceOptionsQueryVariables>(DataSourceOptionsDocument, options);
        }
export type DataSourceOptionsQueryHookResult = ReturnType<typeof useDataSourceOptionsQuery>;
export type DataSourceOptionsLazyQueryHookResult = ReturnType<typeof useDataSourceOptionsLazyQuery>;
export type DataSourceOptionsSuspenseQueryHookResult = ReturnType<typeof useDataSourceOptionsSuspenseQuery>;
export type DataSourceOptionsQueryResult = Apollo.QueryResult<DataSourceOptionsQuery, DataSourceOptionsQueryVariables>;
export const ClientsDocument = gql`
    query clients {
  clients {
    ...baseClient
  }
}
    ${BaseClientFragmentDoc}`;

/**
 * __useClientsQuery__
 *
 * To run a query within a React component, call `useClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientsQuery(baseOptions?: Apollo.QueryHookOptions<ClientsQuery, ClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientsQuery, ClientsQueryVariables>(ClientsDocument, options);
      }
export function useClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientsQuery, ClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientsQuery, ClientsQueryVariables>(ClientsDocument, options);
        }
export function useClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientsQuery, ClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientsQuery, ClientsQueryVariables>(ClientsDocument, options);
        }
export type ClientsQueryHookResult = ReturnType<typeof useClientsQuery>;
export type ClientsLazyQueryHookResult = ReturnType<typeof useClientsLazyQuery>;
export type ClientsSuspenseQueryHookResult = ReturnType<typeof useClientsSuspenseQuery>;
export type ClientsQueryResult = Apollo.QueryResult<ClientsQuery, ClientsQueryVariables>;
export const ClientDocument = gql`
    query client($id: Int!) {
  client(id: $id) {
    ...client
  }
}
    ${ClientFragmentDoc}`;

/**
 * __useClientQuery__
 *
 * To run a query within a React component, call `useClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientQuery(baseOptions: Apollo.QueryHookOptions<ClientQuery, ClientQueryVariables> & ({ variables: ClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientQuery, ClientQueryVariables>(ClientDocument, options);
      }
export function useClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientQuery, ClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientQuery, ClientQueryVariables>(ClientDocument, options);
        }
export function useClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientQuery, ClientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientQuery, ClientQueryVariables>(ClientDocument, options);
        }
export type ClientQueryHookResult = ReturnType<typeof useClientQuery>;
export type ClientLazyQueryHookResult = ReturnType<typeof useClientLazyQuery>;
export type ClientSuspenseQueryHookResult = ReturnType<typeof useClientSuspenseQuery>;
export type ClientQueryResult = Apollo.QueryResult<ClientQuery, ClientQueryVariables>;
export const ClientUsersDocument = gql`
    query clientUsers($clientId: Int!) {
  client(id: $clientId) {
    users {
      ...keycloakUser
    }
  }
}
    ${KeycloakUserFragmentDoc}`;

/**
 * __useClientUsersQuery__
 *
 * To run a query within a React component, call `useClientUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientUsersQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useClientUsersQuery(baseOptions: Apollo.QueryHookOptions<ClientUsersQuery, ClientUsersQueryVariables> & ({ variables: ClientUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientUsersQuery, ClientUsersQueryVariables>(ClientUsersDocument, options);
      }
export function useClientUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientUsersQuery, ClientUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientUsersQuery, ClientUsersQueryVariables>(ClientUsersDocument, options);
        }
export function useClientUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientUsersQuery, ClientUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientUsersQuery, ClientUsersQueryVariables>(ClientUsersDocument, options);
        }
export type ClientUsersQueryHookResult = ReturnType<typeof useClientUsersQuery>;
export type ClientUsersLazyQueryHookResult = ReturnType<typeof useClientUsersLazyQuery>;
export type ClientUsersSuspenseQueryHookResult = ReturnType<typeof useClientUsersSuspenseQuery>;
export type ClientUsersQueryResult = Apollo.QueryResult<ClientUsersQuery, ClientUsersQueryVariables>;
export const CreateClientDocument = gql`
    mutation createClient($client: ClientInput!) {
  createClient(client: $client) {
    ...client
  }
}
    ${ClientFragmentDoc}`;
export type CreateClientMutationFn = Apollo.MutationFunction<CreateClientMutation, CreateClientMutationVariables>;

/**
 * __useCreateClientMutation__
 *
 * To run a mutation, you first call `useCreateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientMutation, { data, loading, error }] = useCreateClientMutation({
 *   variables: {
 *      client: // value for 'client'
 *   },
 * });
 */
export function useCreateClientMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientMutation, CreateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientMutation, CreateClientMutationVariables>(CreateClientDocument, options);
      }
export type CreateClientMutationHookResult = ReturnType<typeof useCreateClientMutation>;
export type CreateClientMutationResult = Apollo.MutationResult<CreateClientMutation>;
export type CreateClientMutationOptions = Apollo.BaseMutationOptions<CreateClientMutation, CreateClientMutationVariables>;
export const UpdateClientDocument = gql`
    mutation updateClient($client: ClientInput!, $id: Int!) {
  updateClient(id: $id, client: $client) {
    ...client
  }
}
    ${ClientFragmentDoc}`;
export type UpdateClientMutationFn = Apollo.MutationFunction<UpdateClientMutation, UpdateClientMutationVariables>;

/**
 * __useUpdateClientMutation__
 *
 * To run a mutation, you first call `useUpdateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientMutation, { data, loading, error }] = useUpdateClientMutation({
 *   variables: {
 *      client: // value for 'client'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateClientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientMutation, UpdateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientMutation, UpdateClientMutationVariables>(UpdateClientDocument, options);
      }
export type UpdateClientMutationHookResult = ReturnType<typeof useUpdateClientMutation>;
export type UpdateClientMutationResult = Apollo.MutationResult<UpdateClientMutation>;
export type UpdateClientMutationOptions = Apollo.BaseMutationOptions<UpdateClientMutation, UpdateClientMutationVariables>;
export const DeleteClientDocument = gql`
    mutation deleteClient($id: Int!) {
  deleteClient(id: $id)
}
    `;
export type DeleteClientMutationFn = Apollo.MutationFunction<DeleteClientMutation, DeleteClientMutationVariables>;

/**
 * __useDeleteClientMutation__
 *
 * To run a mutation, you first call `useDeleteClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientMutation, { data, loading, error }] = useDeleteClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientMutation, DeleteClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientMutation, DeleteClientMutationVariables>(DeleteClientDocument, options);
      }
export type DeleteClientMutationHookResult = ReturnType<typeof useDeleteClientMutation>;
export type DeleteClientMutationResult = Apollo.MutationResult<DeleteClientMutation>;
export type DeleteClientMutationOptions = Apollo.BaseMutationOptions<DeleteClientMutation, DeleteClientMutationVariables>;
export const UpdateClientEnabledStatusDocument = gql`
    mutation updateClientEnabledStatus($id: Int!, $enabled: Boolean!) {
  updateClientEnabledStatus(enabled: $enabled, id: $id)
}
    `;
export type UpdateClientEnabledStatusMutationFn = Apollo.MutationFunction<UpdateClientEnabledStatusMutation, UpdateClientEnabledStatusMutationVariables>;

/**
 * __useUpdateClientEnabledStatusMutation__
 *
 * To run a mutation, you first call `useUpdateClientEnabledStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientEnabledStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientEnabledStatusMutation, { data, loading, error }] = useUpdateClientEnabledStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateClientEnabledStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientEnabledStatusMutation, UpdateClientEnabledStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientEnabledStatusMutation, UpdateClientEnabledStatusMutationVariables>(UpdateClientEnabledStatusDocument, options);
      }
export type UpdateClientEnabledStatusMutationHookResult = ReturnType<typeof useUpdateClientEnabledStatusMutation>;
export type UpdateClientEnabledStatusMutationResult = Apollo.MutationResult<UpdateClientEnabledStatusMutation>;
export type UpdateClientEnabledStatusMutationOptions = Apollo.BaseMutationOptions<UpdateClientEnabledStatusMutation, UpdateClientEnabledStatusMutationVariables>;
export const CurrentClientDocument = gql`
    query currentClient {
  currentClient {
    ...client
    users {
      ...keycloakUser
    }
  }
}
    ${ClientFragmentDoc}
${KeycloakUserFragmentDoc}`;

/**
 * __useCurrentClientQuery__
 *
 * To run a query within a React component, call `useCurrentClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentClientQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentClientQuery(baseOptions?: Apollo.QueryHookOptions<CurrentClientQuery, CurrentClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentClientQuery, CurrentClientQueryVariables>(CurrentClientDocument, options);
      }
export function useCurrentClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentClientQuery, CurrentClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentClientQuery, CurrentClientQueryVariables>(CurrentClientDocument, options);
        }
export function useCurrentClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentClientQuery, CurrentClientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentClientQuery, CurrentClientQueryVariables>(CurrentClientDocument, options);
        }
export type CurrentClientQueryHookResult = ReturnType<typeof useCurrentClientQuery>;
export type CurrentClientLazyQueryHookResult = ReturnType<typeof useCurrentClientLazyQuery>;
export type CurrentClientSuspenseQueryHookResult = ReturnType<typeof useCurrentClientSuspenseQuery>;
export type CurrentClientQueryResult = Apollo.QueryResult<CurrentClientQuery, CurrentClientQueryVariables>;
export const CurrentClientUsersDocument = gql`
    query currentClientUsers {
  currentClient {
    id
    users {
      id
      enabled
      firstName
      lastName
      role
      email
      subGroups {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useCurrentClientUsersQuery__
 *
 * To run a query within a React component, call `useCurrentClientUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentClientUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentClientUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentClientUsersQuery(baseOptions?: Apollo.QueryHookOptions<CurrentClientUsersQuery, CurrentClientUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentClientUsersQuery, CurrentClientUsersQueryVariables>(CurrentClientUsersDocument, options);
      }
export function useCurrentClientUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentClientUsersQuery, CurrentClientUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentClientUsersQuery, CurrentClientUsersQueryVariables>(CurrentClientUsersDocument, options);
        }
export function useCurrentClientUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentClientUsersQuery, CurrentClientUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentClientUsersQuery, CurrentClientUsersQueryVariables>(CurrentClientUsersDocument, options);
        }
export type CurrentClientUsersQueryHookResult = ReturnType<typeof useCurrentClientUsersQuery>;
export type CurrentClientUsersLazyQueryHookResult = ReturnType<typeof useCurrentClientUsersLazyQuery>;
export type CurrentClientUsersSuspenseQueryHookResult = ReturnType<typeof useCurrentClientUsersSuspenseQuery>;
export type CurrentClientUsersQueryResult = Apollo.QueryResult<CurrentClientUsersQuery, CurrentClientUsersQueryVariables>;
export const WhiteLabelPropsDocument = gql`
    query whiteLabelProps {
  currentClient {
    id
    applicationBaseUrl
    applicationBrandColor
    applicationLogoUrl
    applicationTitle
  }
}
    `;

/**
 * __useWhiteLabelPropsQuery__
 *
 * To run a query within a React component, call `useWhiteLabelPropsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhiteLabelPropsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhiteLabelPropsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWhiteLabelPropsQuery(baseOptions?: Apollo.QueryHookOptions<WhiteLabelPropsQuery, WhiteLabelPropsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhiteLabelPropsQuery, WhiteLabelPropsQueryVariables>(WhiteLabelPropsDocument, options);
      }
export function useWhiteLabelPropsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhiteLabelPropsQuery, WhiteLabelPropsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhiteLabelPropsQuery, WhiteLabelPropsQueryVariables>(WhiteLabelPropsDocument, options);
        }
export function useWhiteLabelPropsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WhiteLabelPropsQuery, WhiteLabelPropsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WhiteLabelPropsQuery, WhiteLabelPropsQueryVariables>(WhiteLabelPropsDocument, options);
        }
export type WhiteLabelPropsQueryHookResult = ReturnType<typeof useWhiteLabelPropsQuery>;
export type WhiteLabelPropsLazyQueryHookResult = ReturnType<typeof useWhiteLabelPropsLazyQuery>;
export type WhiteLabelPropsSuspenseQueryHookResult = ReturnType<typeof useWhiteLabelPropsSuspenseQuery>;
export type WhiteLabelPropsQueryResult = Apollo.QueryResult<WhiteLabelPropsQuery, WhiteLabelPropsQueryVariables>;
export const CurrentClientIdDocument = gql`
    query currentClientId {
  currentClient {
    id
  }
}
    `;

/**
 * __useCurrentClientIdQuery__
 *
 * To run a query within a React component, call `useCurrentClientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentClientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentClientIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentClientIdQuery(baseOptions?: Apollo.QueryHookOptions<CurrentClientIdQuery, CurrentClientIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentClientIdQuery, CurrentClientIdQueryVariables>(CurrentClientIdDocument, options);
      }
export function useCurrentClientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentClientIdQuery, CurrentClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentClientIdQuery, CurrentClientIdQueryVariables>(CurrentClientIdDocument, options);
        }
export function useCurrentClientIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentClientIdQuery, CurrentClientIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentClientIdQuery, CurrentClientIdQueryVariables>(CurrentClientIdDocument, options);
        }
export type CurrentClientIdQueryHookResult = ReturnType<typeof useCurrentClientIdQuery>;
export type CurrentClientIdLazyQueryHookResult = ReturnType<typeof useCurrentClientIdLazyQuery>;
export type CurrentClientIdSuspenseQueryHookResult = ReturnType<typeof useCurrentClientIdSuspenseQuery>;
export type CurrentClientIdQueryResult = Apollo.QueryResult<CurrentClientIdQuery, CurrentClientIdQueryVariables>;
export const CurrentClientMembersDocument = gql`
    query currentClientMembers {
  currentClientMembers {
    usersProtected {
      id
      firstName
      lastName
      email
    }
  }
}
    `;

/**
 * __useCurrentClientMembersQuery__
 *
 * To run a query within a React component, call `useCurrentClientMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentClientMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentClientMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentClientMembersQuery(baseOptions?: Apollo.QueryHookOptions<CurrentClientMembersQuery, CurrentClientMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentClientMembersQuery, CurrentClientMembersQueryVariables>(CurrentClientMembersDocument, options);
      }
export function useCurrentClientMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentClientMembersQuery, CurrentClientMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentClientMembersQuery, CurrentClientMembersQueryVariables>(CurrentClientMembersDocument, options);
        }
export function useCurrentClientMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentClientMembersQuery, CurrentClientMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentClientMembersQuery, CurrentClientMembersQueryVariables>(CurrentClientMembersDocument, options);
        }
export type CurrentClientMembersQueryHookResult = ReturnType<typeof useCurrentClientMembersQuery>;
export type CurrentClientMembersLazyQueryHookResult = ReturnType<typeof useCurrentClientMembersLazyQuery>;
export type CurrentClientMembersSuspenseQueryHookResult = ReturnType<typeof useCurrentClientMembersSuspenseQuery>;
export type CurrentClientMembersQueryResult = Apollo.QueryResult<CurrentClientMembersQuery, CurrentClientMembersQueryVariables>;
export const UserCredentialsDocument = gql`
    query userCredentials($id: String!) {
  userCredentials(id: $id) {
    id
    type
    createdDate
    userLabel
  }
}
    `;

/**
 * __useUserCredentialsQuery__
 *
 * To run a query within a React component, call `useUserCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCredentialsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserCredentialsQuery(baseOptions: Apollo.QueryHookOptions<UserCredentialsQuery, UserCredentialsQueryVariables> & ({ variables: UserCredentialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCredentialsQuery, UserCredentialsQueryVariables>(UserCredentialsDocument, options);
      }
export function useUserCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCredentialsQuery, UserCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCredentialsQuery, UserCredentialsQueryVariables>(UserCredentialsDocument, options);
        }
export function useUserCredentialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserCredentialsQuery, UserCredentialsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserCredentialsQuery, UserCredentialsQueryVariables>(UserCredentialsDocument, options);
        }
export type UserCredentialsQueryHookResult = ReturnType<typeof useUserCredentialsQuery>;
export type UserCredentialsLazyQueryHookResult = ReturnType<typeof useUserCredentialsLazyQuery>;
export type UserCredentialsSuspenseQueryHookResult = ReturnType<typeof useUserCredentialsSuspenseQuery>;
export type UserCredentialsQueryResult = Apollo.QueryResult<UserCredentialsQuery, UserCredentialsQueryVariables>;
export const DeleteUserCredentialDocument = gql`
    mutation deleteUserCredential($userId: String!, $credentialId: String!) {
  deleteCredential(userId: $userId, credentialId: $credentialId)
}
    `;
export type DeleteUserCredentialMutationFn = Apollo.MutationFunction<DeleteUserCredentialMutation, DeleteUserCredentialMutationVariables>;

/**
 * __useDeleteUserCredentialMutation__
 *
 * To run a mutation, you first call `useDeleteUserCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserCredentialMutation, { data, loading, error }] = useDeleteUserCredentialMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      credentialId: // value for 'credentialId'
 *   },
 * });
 */
export function useDeleteUserCredentialMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserCredentialMutation, DeleteUserCredentialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserCredentialMutation, DeleteUserCredentialMutationVariables>(DeleteUserCredentialDocument, options);
      }
export type DeleteUserCredentialMutationHookResult = ReturnType<typeof useDeleteUserCredentialMutation>;
export type DeleteUserCredentialMutationResult = Apollo.MutationResult<DeleteUserCredentialMutation>;
export type DeleteUserCredentialMutationOptions = Apollo.BaseMutationOptions<DeleteUserCredentialMutation, DeleteUserCredentialMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($user: UserCreateInput!) {
  createUser(user: $user)
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($id: String!) {
  deleteUser(id: $id)
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const SendUpdatePasswordEmailDocument = gql`
    mutation sendUpdatePasswordEmail($id: String!, $emailLifeSpanSeconds: Int, $requiredActions: [RequiredAction!]) {
  sendUpdatePasswordEmail(
    id: $id
    emailLifeSpanSeconds: $emailLifeSpanSeconds
    requiredActions: $requiredActions
  )
}
    `;
export type SendUpdatePasswordEmailMutationFn = Apollo.MutationFunction<SendUpdatePasswordEmailMutation, SendUpdatePasswordEmailMutationVariables>;

/**
 * __useSendUpdatePasswordEmailMutation__
 *
 * To run a mutation, you first call `useSendUpdatePasswordEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendUpdatePasswordEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendUpdatePasswordEmailMutation, { data, loading, error }] = useSendUpdatePasswordEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      emailLifeSpanSeconds: // value for 'emailLifeSpanSeconds'
 *      requiredActions: // value for 'requiredActions'
 *   },
 * });
 */
export function useSendUpdatePasswordEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendUpdatePasswordEmailMutation, SendUpdatePasswordEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendUpdatePasswordEmailMutation, SendUpdatePasswordEmailMutationVariables>(SendUpdatePasswordEmailDocument, options);
      }
export type SendUpdatePasswordEmailMutationHookResult = ReturnType<typeof useSendUpdatePasswordEmailMutation>;
export type SendUpdatePasswordEmailMutationResult = Apollo.MutationResult<SendUpdatePasswordEmailMutation>;
export type SendUpdatePasswordEmailMutationOptions = Apollo.BaseMutationOptions<SendUpdatePasswordEmailMutation, SendUpdatePasswordEmailMutationVariables>;
export const UpdateUserRoleDocument = gql`
    mutation updateUserRole($role: Role!, $userId: String!) {
  updateUserRole(role: $role, userId: $userId)
}
    `;
export type UpdateUserRoleMutationFn = Apollo.MutationFunction<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;

/**
 * __useUpdateUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRoleMutation, { data, loading, error }] = useUpdateUserRoleMutation({
 *   variables: {
 *      role: // value for 'role'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>(UpdateUserRoleDocument, options);
      }
export type UpdateUserRoleMutationHookResult = ReturnType<typeof useUpdateUserRoleMutation>;
export type UpdateUserRoleMutationResult = Apollo.MutationResult<UpdateUserRoleMutation>;
export type UpdateUserRoleMutationOptions = Apollo.BaseMutationOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;
export const UpdateUserSubGroupDocument = gql`
    mutation updateUserSubGroup($userId: String!, $subGroupName: String!, $subGroupId: String) {
  updateUserSubGroup(
    userId: $userId
    subGroupId: $subGroupId
    subGroupName: $subGroupName
  )
}
    `;
export type UpdateUserSubGroupMutationFn = Apollo.MutationFunction<UpdateUserSubGroupMutation, UpdateUserSubGroupMutationVariables>;

/**
 * __useUpdateUserSubGroupMutation__
 *
 * To run a mutation, you first call `useUpdateUserSubGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSubGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSubGroupMutation, { data, loading, error }] = useUpdateUserSubGroupMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      subGroupName: // value for 'subGroupName'
 *      subGroupId: // value for 'subGroupId'
 *   },
 * });
 */
export function useUpdateUserSubGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSubGroupMutation, UpdateUserSubGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserSubGroupMutation, UpdateUserSubGroupMutationVariables>(UpdateUserSubGroupDocument, options);
      }
export type UpdateUserSubGroupMutationHookResult = ReturnType<typeof useUpdateUserSubGroupMutation>;
export type UpdateUserSubGroupMutationResult = Apollo.MutationResult<UpdateUserSubGroupMutation>;
export type UpdateUserSubGroupMutationOptions = Apollo.BaseMutationOptions<UpdateUserSubGroupMutation, UpdateUserSubGroupMutationVariables>;
export const DeleteSubGroupDocument = gql`
    mutation deleteSubGroup($id: String!) {
  deleteSubGroup(id: $id)
}
    `;
export type DeleteSubGroupMutationFn = Apollo.MutationFunction<DeleteSubGroupMutation, DeleteSubGroupMutationVariables>;

/**
 * __useDeleteSubGroupMutation__
 *
 * To run a mutation, you first call `useDeleteSubGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubGroupMutation, { data, loading, error }] = useDeleteSubGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSubGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubGroupMutation, DeleteSubGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSubGroupMutation, DeleteSubGroupMutationVariables>(DeleteSubGroupDocument, options);
      }
export type DeleteSubGroupMutationHookResult = ReturnType<typeof useDeleteSubGroupMutation>;
export type DeleteSubGroupMutationResult = Apollo.MutationResult<DeleteSubGroupMutation>;
export type DeleteSubGroupMutationOptions = Apollo.BaseMutationOptions<DeleteSubGroupMutation, DeleteSubGroupMutationVariables>;
export const UpdateUserEnabledStatusDocument = gql`
    mutation updateUserEnabledStatus($enabled: Boolean!, $id: String!) {
  updateUserEnabledStatus(enabled: $enabled, id: $id)
}
    `;
export type UpdateUserEnabledStatusMutationFn = Apollo.MutationFunction<UpdateUserEnabledStatusMutation, UpdateUserEnabledStatusMutationVariables>;

/**
 * __useUpdateUserEnabledStatusMutation__
 *
 * To run a mutation, you first call `useUpdateUserEnabledStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserEnabledStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserEnabledStatusMutation, { data, loading, error }] = useUpdateUserEnabledStatusMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateUserEnabledStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserEnabledStatusMutation, UpdateUserEnabledStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserEnabledStatusMutation, UpdateUserEnabledStatusMutationVariables>(UpdateUserEnabledStatusDocument, options);
      }
export type UpdateUserEnabledStatusMutationHookResult = ReturnType<typeof useUpdateUserEnabledStatusMutation>;
export type UpdateUserEnabledStatusMutationResult = Apollo.MutationResult<UpdateUserEnabledStatusMutation>;
export type UpdateUserEnabledStatusMutationOptions = Apollo.BaseMutationOptions<UpdateUserEnabledStatusMutation, UpdateUserEnabledStatusMutationVariables>;
export const UpdateUserGroupDocument = gql`
    mutation updateUserGroup($groupId: String!) {
  updateUserGroup(groupId: $groupId)
}
    `;
export type UpdateUserGroupMutationFn = Apollo.MutationFunction<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>;

/**
 * __useUpdateUserGroupMutation__
 *
 * To run a mutation, you first call `useUpdateUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserGroupMutation, { data, loading, error }] = useUpdateUserGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useUpdateUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>(UpdateUserGroupDocument, options);
      }
export type UpdateUserGroupMutationHookResult = ReturnType<typeof useUpdateUserGroupMutation>;
export type UpdateUserGroupMutationResult = Apollo.MutationResult<UpdateUserGroupMutation>;
export type UpdateUserGroupMutationOptions = Apollo.BaseMutationOptions<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>;
export const PublicConfigDocument = gql`
    query publicConfig {
  configPublicInfo {
    cdnHost
    cdnMediaUploadEndpoint
    clickhouseConfigured
    features {
      delete_clients
      new_proposals_ui
    }
  }
}
    `;

/**
 * __usePublicConfigQuery__
 *
 * To run a query within a React component, call `usePublicConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicConfigQuery(baseOptions?: Apollo.QueryHookOptions<PublicConfigQuery, PublicConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicConfigQuery, PublicConfigQueryVariables>(PublicConfigDocument, options);
      }
export function usePublicConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicConfigQuery, PublicConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicConfigQuery, PublicConfigQueryVariables>(PublicConfigDocument, options);
        }
export function usePublicConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicConfigQuery, PublicConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicConfigQuery, PublicConfigQueryVariables>(PublicConfigDocument, options);
        }
export type PublicConfigQueryHookResult = ReturnType<typeof usePublicConfigQuery>;
export type PublicConfigLazyQueryHookResult = ReturnType<typeof usePublicConfigLazyQuery>;
export type PublicConfigSuspenseQueryHookResult = ReturnType<typeof usePublicConfigSuspenseQuery>;
export type PublicConfigQueryResult = Apollo.QueryResult<PublicConfigQuery, PublicConfigQueryVariables>;
export const DefaultInfoDocument = gql`
    query defaultInfo {
  defaultInfo {
    default_app_url
    defaultFrontendClient {
      id
      attributes {
        login_theme
      }
    }
    keycloakServerInfo {
      themes {
        login {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useDefaultInfoQuery__
 *
 * To run a query within a React component, call `useDefaultInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useDefaultInfoQuery(baseOptions?: Apollo.QueryHookOptions<DefaultInfoQuery, DefaultInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefaultInfoQuery, DefaultInfoQueryVariables>(DefaultInfoDocument, options);
      }
export function useDefaultInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefaultInfoQuery, DefaultInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefaultInfoQuery, DefaultInfoQueryVariables>(DefaultInfoDocument, options);
        }
export function useDefaultInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefaultInfoQuery, DefaultInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefaultInfoQuery, DefaultInfoQueryVariables>(DefaultInfoDocument, options);
        }
export type DefaultInfoQueryHookResult = ReturnType<typeof useDefaultInfoQuery>;
export type DefaultInfoLazyQueryHookResult = ReturnType<typeof useDefaultInfoLazyQuery>;
export type DefaultInfoSuspenseQueryHookResult = ReturnType<typeof useDefaultInfoSuspenseQuery>;
export type DefaultInfoQueryResult = Apollo.QueryResult<DefaultInfoQuery, DefaultInfoQueryVariables>;
export const UpdateKeycloakClientDocument = gql`
    mutation updateKeycloakClient($keycloakClient: KeycloakClientInput!) {
  updateKeycloakClient(keycloakClient: $keycloakClient) {
    __typename
    id
  }
}
    `;
export type UpdateKeycloakClientMutationFn = Apollo.MutationFunction<UpdateKeycloakClientMutation, UpdateKeycloakClientMutationVariables>;

/**
 * __useUpdateKeycloakClientMutation__
 *
 * To run a mutation, you first call `useUpdateKeycloakClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKeycloakClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKeycloakClientMutation, { data, loading, error }] = useUpdateKeycloakClientMutation({
 *   variables: {
 *      keycloakClient: // value for 'keycloakClient'
 *   },
 * });
 */
export function useUpdateKeycloakClientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKeycloakClientMutation, UpdateKeycloakClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKeycloakClientMutation, UpdateKeycloakClientMutationVariables>(UpdateKeycloakClientDocument, options);
      }
export type UpdateKeycloakClientMutationHookResult = ReturnType<typeof useUpdateKeycloakClientMutation>;
export type UpdateKeycloakClientMutationResult = Apollo.MutationResult<UpdateKeycloakClientMutation>;
export type UpdateKeycloakClientMutationOptions = Apollo.BaseMutationOptions<UpdateKeycloakClientMutation, UpdateKeycloakClientMutationVariables>;
export const GetInsightTemplateDocument = gql`
    query GetInsightTemplate {
  proposalTemplates(where: {type: {equals: INSIGHT}}, take: 1) {
    id
    name
    type
    lastVersion {
      ...TemplateVersion
    }
  }
}
    ${TemplateVersionFragmentDoc}`;

/**
 * __useGetInsightTemplateQuery__
 *
 * To run a query within a React component, call `useGetInsightTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightTemplateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInsightTemplateQuery(baseOptions?: Apollo.QueryHookOptions<GetInsightTemplateQuery, GetInsightTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsightTemplateQuery, GetInsightTemplateQueryVariables>(GetInsightTemplateDocument, options);
      }
export function useGetInsightTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsightTemplateQuery, GetInsightTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsightTemplateQuery, GetInsightTemplateQueryVariables>(GetInsightTemplateDocument, options);
        }
export function useGetInsightTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsightTemplateQuery, GetInsightTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInsightTemplateQuery, GetInsightTemplateQueryVariables>(GetInsightTemplateDocument, options);
        }
export type GetInsightTemplateQueryHookResult = ReturnType<typeof useGetInsightTemplateQuery>;
export type GetInsightTemplateLazyQueryHookResult = ReturnType<typeof useGetInsightTemplateLazyQuery>;
export type GetInsightTemplateSuspenseQueryHookResult = ReturnType<typeof useGetInsightTemplateSuspenseQuery>;
export type GetInsightTemplateQueryResult = Apollo.QueryResult<GetInsightTemplateQuery, GetInsightTemplateQueryVariables>;
export const ListInsightsDocument = gql`
    query ListInsights($skip: Int, $take: Int, $orderBy: [ProposalsSortItem!], $filter: ProposalsFilter, $search: String, $searchUserEmails: [String!]) {
  proposals(
    offset: $skip
    limit: $take
    orderBy: $orderBy
    filter: $filter
    search: $search
    searchUserEmails: $searchUserEmails
    type: INSIGHT
  ) {
    count
    items {
      id
      name
      templateName
      createdBy
      updatedAt
      dataSourceUsedAt
      createdAt
      lastVersionCreatedBy
      isPinned
    }
  }
}
    `;

/**
 * __useListInsightsQuery__
 *
 * To run a query within a React component, call `useListInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListInsightsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *      searchUserEmails: // value for 'searchUserEmails'
 *   },
 * });
 */
export function useListInsightsQuery(baseOptions?: Apollo.QueryHookOptions<ListInsightsQuery, ListInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListInsightsQuery, ListInsightsQueryVariables>(ListInsightsDocument, options);
      }
export function useListInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListInsightsQuery, ListInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListInsightsQuery, ListInsightsQueryVariables>(ListInsightsDocument, options);
        }
export function useListInsightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListInsightsQuery, ListInsightsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListInsightsQuery, ListInsightsQueryVariables>(ListInsightsDocument, options);
        }
export type ListInsightsQueryHookResult = ReturnType<typeof useListInsightsQuery>;
export type ListInsightsLazyQueryHookResult = ReturnType<typeof useListInsightsLazyQuery>;
export type ListInsightsSuspenseQueryHookResult = ReturnType<typeof useListInsightsSuspenseQuery>;
export type ListInsightsQueryResult = Apollo.QueryResult<ListInsightsQuery, ListInsightsQueryVariables>;
export const InsightAuditChangesDocument = gql`
    query InsightAuditChanges($skip: Int, $take: Int) {
  insightAuditChanges(skip: $skip, take: $take) {
    count
    items {
      id
      insightId
      insightName
      createdAt
      createdBy
      sequentialNumber
    }
  }
}
    `;

/**
 * __useInsightAuditChangesQuery__
 *
 * To run a query within a React component, call `useInsightAuditChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightAuditChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightAuditChangesQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useInsightAuditChangesQuery(baseOptions?: Apollo.QueryHookOptions<InsightAuditChangesQuery, InsightAuditChangesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightAuditChangesQuery, InsightAuditChangesQueryVariables>(InsightAuditChangesDocument, options);
      }
export function useInsightAuditChangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightAuditChangesQuery, InsightAuditChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightAuditChangesQuery, InsightAuditChangesQueryVariables>(InsightAuditChangesDocument, options);
        }
export function useInsightAuditChangesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightAuditChangesQuery, InsightAuditChangesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightAuditChangesQuery, InsightAuditChangesQueryVariables>(InsightAuditChangesDocument, options);
        }
export type InsightAuditChangesQueryHookResult = ReturnType<typeof useInsightAuditChangesQuery>;
export type InsightAuditChangesLazyQueryHookResult = ReturnType<typeof useInsightAuditChangesLazyQuery>;
export type InsightAuditChangesSuspenseQueryHookResult = ReturnType<typeof useInsightAuditChangesSuspenseQuery>;
export type InsightAuditChangesQueryResult = Apollo.QueryResult<InsightAuditChangesQuery, InsightAuditChangesQueryVariables>;
export const InsightAuditChangeBreakdownDocument = gql`
    query InsightAuditChangeBreakdown($versionId: Int!) {
  insightAuditChangeBreakdown(versionId: $versionId) {
    versionId
    rowsAffected
    columnsAffected
    pagesAffected
    pageBreakdown {
      pageUuid
      pageName
      rowsAffected
      columnNames
    }
  }
}
    `;

/**
 * __useInsightAuditChangeBreakdownQuery__
 *
 * To run a query within a React component, call `useInsightAuditChangeBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightAuditChangeBreakdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightAuditChangeBreakdownQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useInsightAuditChangeBreakdownQuery(baseOptions: Apollo.QueryHookOptions<InsightAuditChangeBreakdownQuery, InsightAuditChangeBreakdownQueryVariables> & ({ variables: InsightAuditChangeBreakdownQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightAuditChangeBreakdownQuery, InsightAuditChangeBreakdownQueryVariables>(InsightAuditChangeBreakdownDocument, options);
      }
export function useInsightAuditChangeBreakdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightAuditChangeBreakdownQuery, InsightAuditChangeBreakdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightAuditChangeBreakdownQuery, InsightAuditChangeBreakdownQueryVariables>(InsightAuditChangeBreakdownDocument, options);
        }
export function useInsightAuditChangeBreakdownSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightAuditChangeBreakdownQuery, InsightAuditChangeBreakdownQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightAuditChangeBreakdownQuery, InsightAuditChangeBreakdownQueryVariables>(InsightAuditChangeBreakdownDocument, options);
        }
export type InsightAuditChangeBreakdownQueryHookResult = ReturnType<typeof useInsightAuditChangeBreakdownQuery>;
export type InsightAuditChangeBreakdownLazyQueryHookResult = ReturnType<typeof useInsightAuditChangeBreakdownLazyQuery>;
export type InsightAuditChangeBreakdownSuspenseQueryHookResult = ReturnType<typeof useInsightAuditChangeBreakdownSuspenseQuery>;
export type InsightAuditChangeBreakdownQueryResult = Apollo.QueryResult<InsightAuditChangeBreakdownQuery, InsightAuditChangeBreakdownQueryVariables>;
export const ListProposalTemplatesDocument = gql`
    query ListProposalTemplates {
  proposalTemplates(where: {type: {equals: PROPOSAL}}) {
    id
    name
    type
    updatedAt
    createdAt
    isDefault
    isPublished
    lastVersion {
      ...TemplateVersion
      createdAt
    }
  }
}
    ${TemplateVersionFragmentDoc}`;

/**
 * __useListProposalTemplatesQuery__
 *
 * To run a query within a React component, call `useListProposalTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProposalTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProposalTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListProposalTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ListProposalTemplatesQuery, ListProposalTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProposalTemplatesQuery, ListProposalTemplatesQueryVariables>(ListProposalTemplatesDocument, options);
      }
export function useListProposalTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProposalTemplatesQuery, ListProposalTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProposalTemplatesQuery, ListProposalTemplatesQueryVariables>(ListProposalTemplatesDocument, options);
        }
export function useListProposalTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProposalTemplatesQuery, ListProposalTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListProposalTemplatesQuery, ListProposalTemplatesQueryVariables>(ListProposalTemplatesDocument, options);
        }
export type ListProposalTemplatesQueryHookResult = ReturnType<typeof useListProposalTemplatesQuery>;
export type ListProposalTemplatesLazyQueryHookResult = ReturnType<typeof useListProposalTemplatesLazyQuery>;
export type ListProposalTemplatesSuspenseQueryHookResult = ReturnType<typeof useListProposalTemplatesSuspenseQuery>;
export type ListProposalTemplatesQueryResult = Apollo.QueryResult<ListProposalTemplatesQuery, ListProposalTemplatesQueryVariables>;
export const GetProposalTemplateDocument = gql`
    query GetProposalTemplate($id: Int!) {
  proposalTemplate(where: {id: $id}) {
    id
    name
    updatedAt
    createdAt
    lastVersion {
      ...TemplateVersion
    }
  }
}
    ${TemplateVersionFragmentDoc}`;

/**
 * __useGetProposalTemplateQuery__
 *
 * To run a query within a React component, call `useGetProposalTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProposalTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProposalTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProposalTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetProposalTemplateQuery, GetProposalTemplateQueryVariables> & ({ variables: GetProposalTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProposalTemplateQuery, GetProposalTemplateQueryVariables>(GetProposalTemplateDocument, options);
      }
export function useGetProposalTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProposalTemplateQuery, GetProposalTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProposalTemplateQuery, GetProposalTemplateQueryVariables>(GetProposalTemplateDocument, options);
        }
export function useGetProposalTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProposalTemplateQuery, GetProposalTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProposalTemplateQuery, GetProposalTemplateQueryVariables>(GetProposalTemplateDocument, options);
        }
export type GetProposalTemplateQueryHookResult = ReturnType<typeof useGetProposalTemplateQuery>;
export type GetProposalTemplateLazyQueryHookResult = ReturnType<typeof useGetProposalTemplateLazyQuery>;
export type GetProposalTemplateSuspenseQueryHookResult = ReturnType<typeof useGetProposalTemplateSuspenseQuery>;
export type GetProposalTemplateQueryResult = Apollo.QueryResult<GetProposalTemplateQuery, GetProposalTemplateQueryVariables>;
export const ProposalTemplateVersionDocument = gql`
    query ProposalTemplateVersion($where: ProposalTemplateVersionWhereInput!) {
  proposalTemplateVersion: findFirstProposalTemplateVersionOrThrow(
    where: $where
    orderBy: {id: desc}
    take: 1
  ) {
    ...TemplateVersion
    createdAt
    template {
      id
      name
      type
    }
  }
}
    ${TemplateVersionFragmentDoc}`;

/**
 * __useProposalTemplateVersionQuery__
 *
 * To run a query within a React component, call `useProposalTemplateVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalTemplateVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalTemplateVersionQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProposalTemplateVersionQuery(baseOptions: Apollo.QueryHookOptions<ProposalTemplateVersionQuery, ProposalTemplateVersionQueryVariables> & ({ variables: ProposalTemplateVersionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProposalTemplateVersionQuery, ProposalTemplateVersionQueryVariables>(ProposalTemplateVersionDocument, options);
      }
export function useProposalTemplateVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProposalTemplateVersionQuery, ProposalTemplateVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProposalTemplateVersionQuery, ProposalTemplateVersionQueryVariables>(ProposalTemplateVersionDocument, options);
        }
export function useProposalTemplateVersionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProposalTemplateVersionQuery, ProposalTemplateVersionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProposalTemplateVersionQuery, ProposalTemplateVersionQueryVariables>(ProposalTemplateVersionDocument, options);
        }
export type ProposalTemplateVersionQueryHookResult = ReturnType<typeof useProposalTemplateVersionQuery>;
export type ProposalTemplateVersionLazyQueryHookResult = ReturnType<typeof useProposalTemplateVersionLazyQuery>;
export type ProposalTemplateVersionSuspenseQueryHookResult = ReturnType<typeof useProposalTemplateVersionSuspenseQuery>;
export type ProposalTemplateVersionQueryResult = Apollo.QueryResult<ProposalTemplateVersionQuery, ProposalTemplateVersionQueryVariables>;
export const UpdateOneProposalTemplateDocument = gql`
    mutation UpdateOneProposalTemplate($id: Int!, $data: ProposalTemplateUpdateInput!) {
  updateOneProposalTemplate(where: {id: $id}, data: $data) {
    id
  }
}
    `;
export type UpdateOneProposalTemplateMutationFn = Apollo.MutationFunction<UpdateOneProposalTemplateMutation, UpdateOneProposalTemplateMutationVariables>;

/**
 * __useUpdateOneProposalTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateOneProposalTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneProposalTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneProposalTemplateMutation, { data, loading, error }] = useUpdateOneProposalTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOneProposalTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneProposalTemplateMutation, UpdateOneProposalTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneProposalTemplateMutation, UpdateOneProposalTemplateMutationVariables>(UpdateOneProposalTemplateDocument, options);
      }
export type UpdateOneProposalTemplateMutationHookResult = ReturnType<typeof useUpdateOneProposalTemplateMutation>;
export type UpdateOneProposalTemplateMutationResult = Apollo.MutationResult<UpdateOneProposalTemplateMutation>;
export type UpdateOneProposalTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateOneProposalTemplateMutation, UpdateOneProposalTemplateMutationVariables>;
export const TemplateCreateDocument = gql`
    mutation TemplateCreate($data: TemplateCreateInput!) {
  templateCreate(data: $data) {
    id
  }
}
    `;
export type TemplateCreateMutationFn = Apollo.MutationFunction<TemplateCreateMutation, TemplateCreateMutationVariables>;

/**
 * __useTemplateCreateMutation__
 *
 * To run a mutation, you first call `useTemplateCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplateCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templateCreateMutation, { data, loading, error }] = useTemplateCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTemplateCreateMutation(baseOptions?: Apollo.MutationHookOptions<TemplateCreateMutation, TemplateCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplateCreateMutation, TemplateCreateMutationVariables>(TemplateCreateDocument, options);
      }
export type TemplateCreateMutationHookResult = ReturnType<typeof useTemplateCreateMutation>;
export type TemplateCreateMutationResult = Apollo.MutationResult<TemplateCreateMutation>;
export type TemplateCreateMutationOptions = Apollo.BaseMutationOptions<TemplateCreateMutation, TemplateCreateMutationVariables>;
export const TemplateUpdateDocument = gql`
    mutation TemplateUpdate($data: TemplateUpdateInput!) {
  templateUpdate(data: $data) {
    id
  }
}
    `;
export type TemplateUpdateMutationFn = Apollo.MutationFunction<TemplateUpdateMutation, TemplateUpdateMutationVariables>;

/**
 * __useTemplateUpdateMutation__
 *
 * To run a mutation, you first call `useTemplateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templateUpdateMutation, { data, loading, error }] = useTemplateUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTemplateUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TemplateUpdateMutation, TemplateUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplateUpdateMutation, TemplateUpdateMutationVariables>(TemplateUpdateDocument, options);
      }
export type TemplateUpdateMutationHookResult = ReturnType<typeof useTemplateUpdateMutation>;
export type TemplateUpdateMutationResult = Apollo.MutationResult<TemplateUpdateMutation>;
export type TemplateUpdateMutationOptions = Apollo.BaseMutationOptions<TemplateUpdateMutation, TemplateUpdateMutationVariables>;
export const DeleteTemplateDocument = gql`
    mutation DeleteTemplate($id: Int!) {
  deleteTemplate(id: $id) {
    id
  }
}
    `;
export type DeleteTemplateMutationFn = Apollo.MutationFunction<DeleteTemplateMutation, DeleteTemplateMutationVariables>;

/**
 * __useDeleteTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateMutation, { data, loading, error }] = useDeleteTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTemplateMutation, DeleteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTemplateMutation, DeleteTemplateMutationVariables>(DeleteTemplateDocument, options);
      }
export type DeleteTemplateMutationHookResult = ReturnType<typeof useDeleteTemplateMutation>;
export type DeleteTemplateMutationResult = Apollo.MutationResult<DeleteTemplateMutation>;
export type DeleteTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteTemplateMutation, DeleteTemplateMutationVariables>;
export const UpdateDefaultTemplateDocument = gql`
    mutation UpdateDefaultTemplate($id: Int!, $isDefault: Boolean, $type: TemplateType!) {
  updateDefaultTemplate(id: $id, isDefault: $isDefault, type: $type) {
    id
    isDefault
  }
}
    `;
export type UpdateDefaultTemplateMutationFn = Apollo.MutationFunction<UpdateDefaultTemplateMutation, UpdateDefaultTemplateMutationVariables>;

/**
 * __useUpdateDefaultTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateDefaultTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefaultTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefaultTemplateMutation, { data, loading, error }] = useUpdateDefaultTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isDefault: // value for 'isDefault'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateDefaultTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDefaultTemplateMutation, UpdateDefaultTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDefaultTemplateMutation, UpdateDefaultTemplateMutationVariables>(UpdateDefaultTemplateDocument, options);
      }
export type UpdateDefaultTemplateMutationHookResult = ReturnType<typeof useUpdateDefaultTemplateMutation>;
export type UpdateDefaultTemplateMutationResult = Apollo.MutationResult<UpdateDefaultTemplateMutation>;
export type UpdateDefaultTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateDefaultTemplateMutation, UpdateDefaultTemplateMutationVariables>;
export const PatchExistingProposalsDocument = gql`
    mutation PatchExistingProposals($templateId: Int!) {
  patchExistingProposals(templateId: $templateId)
}
    `;
export type PatchExistingProposalsMutationFn = Apollo.MutationFunction<PatchExistingProposalsMutation, PatchExistingProposalsMutationVariables>;

/**
 * __usePatchExistingProposalsMutation__
 *
 * To run a mutation, you first call `usePatchExistingProposalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchExistingProposalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchExistingProposalsMutation, { data, loading, error }] = usePatchExistingProposalsMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function usePatchExistingProposalsMutation(baseOptions?: Apollo.MutationHookOptions<PatchExistingProposalsMutation, PatchExistingProposalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatchExistingProposalsMutation, PatchExistingProposalsMutationVariables>(PatchExistingProposalsDocument, options);
      }
export type PatchExistingProposalsMutationHookResult = ReturnType<typeof usePatchExistingProposalsMutation>;
export type PatchExistingProposalsMutationResult = Apollo.MutationResult<PatchExistingProposalsMutation>;
export type PatchExistingProposalsMutationOptions = Apollo.BaseMutationOptions<PatchExistingProposalsMutation, PatchExistingProposalsMutationVariables>;
export const PromptDocument = gql`
    query Prompt($message: String!) {
  prompt(message: $message)
}
    `;

/**
 * __usePromptQuery__
 *
 * To run a query within a React component, call `usePromptQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromptQuery({
 *   variables: {
 *      message: // value for 'message'
 *   },
 * });
 */
export function usePromptQuery(baseOptions: Apollo.QueryHookOptions<PromptQuery, PromptQueryVariables> & ({ variables: PromptQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromptQuery, PromptQueryVariables>(PromptDocument, options);
      }
export function usePromptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromptQuery, PromptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromptQuery, PromptQueryVariables>(PromptDocument, options);
        }
export function usePromptSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromptQuery, PromptQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PromptQuery, PromptQueryVariables>(PromptDocument, options);
        }
export type PromptQueryHookResult = ReturnType<typeof usePromptQuery>;
export type PromptLazyQueryHookResult = ReturnType<typeof usePromptLazyQuery>;
export type PromptSuspenseQueryHookResult = ReturnType<typeof usePromptSuspenseQuery>;
export type PromptQueryResult = Apollo.QueryResult<PromptQuery, PromptQueryVariables>;
export const TemplatePublishUpdateDocument = gql`
    mutation TemplatePublishUpdate($isPublished: Boolean!, $id: Int!) {
  templatePublishUpdate(isPublished: $isPublished, id: $id) {
    id
    isPublished
  }
}
    `;
export type TemplatePublishUpdateMutationFn = Apollo.MutationFunction<TemplatePublishUpdateMutation, TemplatePublishUpdateMutationVariables>;

/**
 * __useTemplatePublishUpdateMutation__
 *
 * To run a mutation, you first call `useTemplatePublishUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplatePublishUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templatePublishUpdateMutation, { data, loading, error }] = useTemplatePublishUpdateMutation({
 *   variables: {
 *      isPublished: // value for 'isPublished'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTemplatePublishUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TemplatePublishUpdateMutation, TemplatePublishUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplatePublishUpdateMutation, TemplatePublishUpdateMutationVariables>(TemplatePublishUpdateDocument, options);
      }
export type TemplatePublishUpdateMutationHookResult = ReturnType<typeof useTemplatePublishUpdateMutation>;
export type TemplatePublishUpdateMutationResult = Apollo.MutationResult<TemplatePublishUpdateMutation>;
export type TemplatePublishUpdateMutationOptions = Apollo.BaseMutationOptions<TemplatePublishUpdateMutation, TemplatePublishUpdateMutationVariables>;
export const SetProposalPinnedDocument = gql`
    mutation SetProposalPinned($proposalId: Int!, $pinned: Boolean!) {
  setProposalPinned(proposalId: $proposalId, pinned: $pinned)
}
    `;
export type SetProposalPinnedMutationFn = Apollo.MutationFunction<SetProposalPinnedMutation, SetProposalPinnedMutationVariables>;

/**
 * __useSetProposalPinnedMutation__
 *
 * To run a mutation, you first call `useSetProposalPinnedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProposalPinnedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProposalPinnedMutation, { data, loading, error }] = useSetProposalPinnedMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *      pinned: // value for 'pinned'
 *   },
 * });
 */
export function useSetProposalPinnedMutation(baseOptions?: Apollo.MutationHookOptions<SetProposalPinnedMutation, SetProposalPinnedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProposalPinnedMutation, SetProposalPinnedMutationVariables>(SetProposalPinnedDocument, options);
      }
export type SetProposalPinnedMutationHookResult = ReturnType<typeof useSetProposalPinnedMutation>;
export type SetProposalPinnedMutationResult = Apollo.MutationResult<SetProposalPinnedMutation>;
export type SetProposalPinnedMutationOptions = Apollo.BaseMutationOptions<SetProposalPinnedMutation, SetProposalPinnedMutationVariables>;
export const GetAnalyticFiltersSourcesDocument = gql`
    query GetAnalyticFiltersSources {
  proposalIds: allProposalsIds
  owners: proposalVersions(distinct: createdBy) {
    createdBy
  }
  proposalAnalyticFiltersAggregations: proposalAnalytic(
    aggregate: [{from: "2d895864-3aa6-427a-91cd-abb8b63fc091", primaryColumnUUID: "8db9d6d3-6b16-4b51-8800-fc8298ee3262", select: [{as: "sfdcDealIds", columnUUID: "8db9d6d3-6b16-4b51-8800-fc8298ee3262", valueType: string, aggregate: "group_concat", distinct: true}, {as: "regionsOfOpportunity", columnUUID: "f4a050d3-334f-4ac0-9f58-953aecdc7d25", valueType: string, aggregate: "group_concat", distinct: true}, {as: "primaryUseCases", columnUUID: "ae69034a-3628-40a1-8edb-5a9772ac8d61", valueType: string, aggregate: "group_concat", distinct: true}, {as: "customerTypes", columnUUID: "b7a6157c-61f2-4a31-98eb-29ed85430068", valueType: string, aggregate: "group_concat", distinct: true}, {as: "platforms", columnUUID: "71784e7e-da0f-4bc1-9d1b-f69951e8ab4b", valueType: string, aggregate: "group_concat", distinct: true}, {as: "settlementTerms", columnUUID: "841cbc9f-01ce-41b7-9a67-ea55d6288583", valueType: string, aggregate: "group_concat", distinct: true}, {as: "rateRefreshFrequencies", columnUUID: "d305a252-e80b-434e-bb92-c8953be4e207", valueType: string, aggregate: "group_concat", distinct: true}, {as: "flowTypes", columnUUID: "a79fdcc6-af86-4cbe-9472-e92d66a7964f", valueType: string, aggregate: "group_concat", distinct: true}, {as: "countriesOfOrigination", columnUUID: "9ea80535-0b7c-42f8-9f26-58fa39ccaa1a", valueType: string, aggregate: "group_concat", distinct: true}]}, {from: "15df9e22-9c7e-4991-b35e-9427abbc3668", primaryColumnUUID: "d5de461d-550b-4523-8ebd-b18b7528479c", select: [{as: "receivingCountries", columnUUID: "d5de461d-550b-4523-8ebd-b18b7528479c", valueType: string, aggregate: "group_concat", distinct: true}, {as: "modesOfPayment", columnUUID: "2f39f904-7e70-4a16-af06-840669104770", valueType: string, aggregate: "group_concat", distinct: true}, {as: "payoutCurrencies", columnUUID: "d95d5e19-bafb-4ba2-829b-4b75d40feaea", valueType: string, aggregate: "group_concat", distinct: true}, {as: "settlementCurrencies", columnUUID: "ad6ef6b2-4059-42ba-958c-013fc5781e38", valueType: string, aggregate: "group_concat", distinct: true}]}]
  ) {
    data
  }
}
    `;

/**
 * __useGetAnalyticFiltersSourcesQuery__
 *
 * To run a query within a React component, call `useGetAnalyticFiltersSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticFiltersSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticFiltersSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAnalyticFiltersSourcesQuery(baseOptions?: Apollo.QueryHookOptions<GetAnalyticFiltersSourcesQuery, GetAnalyticFiltersSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticFiltersSourcesQuery, GetAnalyticFiltersSourcesQueryVariables>(GetAnalyticFiltersSourcesDocument, options);
      }
export function useGetAnalyticFiltersSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticFiltersSourcesQuery, GetAnalyticFiltersSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticFiltersSourcesQuery, GetAnalyticFiltersSourcesQueryVariables>(GetAnalyticFiltersSourcesDocument, options);
        }
export function useGetAnalyticFiltersSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyticFiltersSourcesQuery, GetAnalyticFiltersSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnalyticFiltersSourcesQuery, GetAnalyticFiltersSourcesQueryVariables>(GetAnalyticFiltersSourcesDocument, options);
        }
export type GetAnalyticFiltersSourcesQueryHookResult = ReturnType<typeof useGetAnalyticFiltersSourcesQuery>;
export type GetAnalyticFiltersSourcesLazyQueryHookResult = ReturnType<typeof useGetAnalyticFiltersSourcesLazyQuery>;
export type GetAnalyticFiltersSourcesSuspenseQueryHookResult = ReturnType<typeof useGetAnalyticFiltersSourcesSuspenseQuery>;
export type GetAnalyticFiltersSourcesQueryResult = Apollo.QueryResult<GetAnalyticFiltersSourcesQuery, GetAnalyticFiltersSourcesQueryVariables>;
export const ProposalAnalyticDocument = gql`
    query ProposalAnalytic($startDate: Timestamp, $endDate: Timestamp, $fields: [Field!], $aggregate: [Aggregate!]!, $proposalIds: [Float!], $proposalOwners: [String!]) {
  proposalAnalytic(
    startDate: $startDate
    endDate: $endDate
    fields: $fields
    aggregate: $aggregate
    proposalIds: $proposalIds
    proposalOwners: $proposalOwners
  ) {
    data
  }
}
    `;

/**
 * __useProposalAnalyticQuery__
 *
 * To run a query within a React component, call `useProposalAnalyticQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalAnalyticQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalAnalyticQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      fields: // value for 'fields'
 *      aggregate: // value for 'aggregate'
 *      proposalIds: // value for 'proposalIds'
 *      proposalOwners: // value for 'proposalOwners'
 *   },
 * });
 */
export function useProposalAnalyticQuery(baseOptions: Apollo.QueryHookOptions<ProposalAnalyticQuery, ProposalAnalyticQueryVariables> & ({ variables: ProposalAnalyticQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProposalAnalyticQuery, ProposalAnalyticQueryVariables>(ProposalAnalyticDocument, options);
      }
export function useProposalAnalyticLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProposalAnalyticQuery, ProposalAnalyticQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProposalAnalyticQuery, ProposalAnalyticQueryVariables>(ProposalAnalyticDocument, options);
        }
export function useProposalAnalyticSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProposalAnalyticQuery, ProposalAnalyticQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProposalAnalyticQuery, ProposalAnalyticQueryVariables>(ProposalAnalyticDocument, options);
        }
export type ProposalAnalyticQueryHookResult = ReturnType<typeof useProposalAnalyticQuery>;
export type ProposalAnalyticLazyQueryHookResult = ReturnType<typeof useProposalAnalyticLazyQuery>;
export type ProposalAnalyticSuspenseQueryHookResult = ReturnType<typeof useProposalAnalyticSuspenseQuery>;
export type ProposalAnalyticQueryResult = Apollo.QueryResult<ProposalAnalyticQuery, ProposalAnalyticQueryVariables>;
export const ClientAuditEventsDocument = gql`
    query clientAuditEvents($startDate: Float!, $endDate: Float!, $calendarInterval: CalendarInterval!, $eventTypes: [BaseEventTypeInput!]!, $clientId: Int!, $subGroupsIds: [String!]!, $timeZone: String) {
  auditEvents(
    startDate: $startDate
    endDate: $endDate
    calendarInterval: $calendarInterval
    eventTypes: $eventTypes
    clientId: $clientId
    subGroupsIds: $subGroupsIds
    timeZone: $timeZone
  ) {
    event {
      entity
      action
    }
    buckets {
      key
      doc_count
    }
  }
}
    `;

/**
 * __useClientAuditEventsQuery__
 *
 * To run a query within a React component, call `useClientAuditEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientAuditEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientAuditEventsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      calendarInterval: // value for 'calendarInterval'
 *      eventTypes: // value for 'eventTypes'
 *      clientId: // value for 'clientId'
 *      subGroupsIds: // value for 'subGroupsIds'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useClientAuditEventsQuery(baseOptions: Apollo.QueryHookOptions<ClientAuditEventsQuery, ClientAuditEventsQueryVariables> & ({ variables: ClientAuditEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientAuditEventsQuery, ClientAuditEventsQueryVariables>(ClientAuditEventsDocument, options);
      }
export function useClientAuditEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientAuditEventsQuery, ClientAuditEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientAuditEventsQuery, ClientAuditEventsQueryVariables>(ClientAuditEventsDocument, options);
        }
export function useClientAuditEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientAuditEventsQuery, ClientAuditEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientAuditEventsQuery, ClientAuditEventsQueryVariables>(ClientAuditEventsDocument, options);
        }
export type ClientAuditEventsQueryHookResult = ReturnType<typeof useClientAuditEventsQuery>;
export type ClientAuditEventsLazyQueryHookResult = ReturnType<typeof useClientAuditEventsLazyQuery>;
export type ClientAuditEventsSuspenseQueryHookResult = ReturnType<typeof useClientAuditEventsSuspenseQuery>;
export type ClientAuditEventsQueryResult = Apollo.QueryResult<ClientAuditEventsQuery, ClientAuditEventsQueryVariables>;
export const UsersActivityDocument = gql`
    query usersActivity($startDate: Float!, $endDate: Float!, $clientId: Int!, $subGroupsIds: [String!]!, $timeZone: String) {
  usersActivity(
    startDate: $startDate
    endDate: $endDate
    clientId: $clientId
    subGroupsIds: $subGroupsIds
    timeZone: $timeZone
  ) {
    activity_time_seconds
    email
    logins
    proposal_create
    proposal_update
    proposal_update_unique
    insight_update
  }
}
    `;

/**
 * __useUsersActivityQuery__
 *
 * To run a query within a React component, call `useUsersActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersActivityQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      clientId: // value for 'clientId'
 *      subGroupsIds: // value for 'subGroupsIds'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useUsersActivityQuery(baseOptions: Apollo.QueryHookOptions<UsersActivityQuery, UsersActivityQueryVariables> & ({ variables: UsersActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersActivityQuery, UsersActivityQueryVariables>(UsersActivityDocument, options);
      }
export function useUsersActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersActivityQuery, UsersActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersActivityQuery, UsersActivityQueryVariables>(UsersActivityDocument, options);
        }
export function useUsersActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersActivityQuery, UsersActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersActivityQuery, UsersActivityQueryVariables>(UsersActivityDocument, options);
        }
export type UsersActivityQueryHookResult = ReturnType<typeof useUsersActivityQuery>;
export type UsersActivityLazyQueryHookResult = ReturnType<typeof useUsersActivityLazyQuery>;
export type UsersActivitySuspenseQueryHookResult = ReturnType<typeof useUsersActivitySuspenseQuery>;
export type UsersActivityQueryResult = Apollo.QueryResult<UsersActivityQuery, UsersActivityQueryVariables>;
export const AnalyticsDashboardsDocument = gql`
    query AnalyticsDashboards {
  analyticsDashboards {
    id
    name
    restricted
  }
}
    `;

/**
 * __useAnalyticsDashboardsQuery__
 *
 * To run a query within a React component, call `useAnalyticsDashboardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsDashboardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsDashboardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAnalyticsDashboardsQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsDashboardsQuery, AnalyticsDashboardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsDashboardsQuery, AnalyticsDashboardsQueryVariables>(AnalyticsDashboardsDocument, options);
      }
export function useAnalyticsDashboardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsDashboardsQuery, AnalyticsDashboardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsDashboardsQuery, AnalyticsDashboardsQueryVariables>(AnalyticsDashboardsDocument, options);
        }
export function useAnalyticsDashboardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsDashboardsQuery, AnalyticsDashboardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsDashboardsQuery, AnalyticsDashboardsQueryVariables>(AnalyticsDashboardsDocument, options);
        }
export type AnalyticsDashboardsQueryHookResult = ReturnType<typeof useAnalyticsDashboardsQuery>;
export type AnalyticsDashboardsLazyQueryHookResult = ReturnType<typeof useAnalyticsDashboardsLazyQuery>;
export type AnalyticsDashboardsSuspenseQueryHookResult = ReturnType<typeof useAnalyticsDashboardsSuspenseQuery>;
export type AnalyticsDashboardsQueryResult = Apollo.QueryResult<AnalyticsDashboardsQuery, AnalyticsDashboardsQueryVariables>;
export const DashboardChartDataDocument = gql`
    query DashboardChartData($chartId: String!, $variables: JSON!) {
  dashboardChartData(chartId: $chartId, variables: $variables)
}
    `;

/**
 * __useDashboardChartDataQuery__
 *
 * To run a query within a React component, call `useDashboardChartDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardChartDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardChartDataQuery({
 *   variables: {
 *      chartId: // value for 'chartId'
 *      variables: // value for 'variables'
 *   },
 * });
 */
export function useDashboardChartDataQuery(baseOptions: Apollo.QueryHookOptions<DashboardChartDataQuery, DashboardChartDataQueryVariables> & ({ variables: DashboardChartDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardChartDataQuery, DashboardChartDataQueryVariables>(DashboardChartDataDocument, options);
      }
export function useDashboardChartDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardChartDataQuery, DashboardChartDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardChartDataQuery, DashboardChartDataQueryVariables>(DashboardChartDataDocument, options);
        }
export function useDashboardChartDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardChartDataQuery, DashboardChartDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardChartDataQuery, DashboardChartDataQueryVariables>(DashboardChartDataDocument, options);
        }
export type DashboardChartDataQueryHookResult = ReturnType<typeof useDashboardChartDataQuery>;
export type DashboardChartDataLazyQueryHookResult = ReturnType<typeof useDashboardChartDataLazyQuery>;
export type DashboardChartDataSuspenseQueryHookResult = ReturnType<typeof useDashboardChartDataSuspenseQuery>;
export type DashboardChartDataQueryResult = Apollo.QueryResult<DashboardChartDataQuery, DashboardChartDataQueryVariables>;
export const AnalyticsDashboardDocument = gql`
    query AnalyticsDashboard($where: AnalyticsDashboardWhereUniqueInput!) {
  analyticsDashboard(where: $where) {
    ...analyticsDashboard
  }
}
    ${AnalyticsDashboardFragmentDoc}`;

/**
 * __useAnalyticsDashboardQuery__
 *
 * To run a query within a React component, call `useAnalyticsDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsDashboardQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAnalyticsDashboardQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsDashboardQuery, AnalyticsDashboardQueryVariables> & ({ variables: AnalyticsDashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsDashboardQuery, AnalyticsDashboardQueryVariables>(AnalyticsDashboardDocument, options);
      }
export function useAnalyticsDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsDashboardQuery, AnalyticsDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsDashboardQuery, AnalyticsDashboardQueryVariables>(AnalyticsDashboardDocument, options);
        }
export function useAnalyticsDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsDashboardQuery, AnalyticsDashboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsDashboardQuery, AnalyticsDashboardQueryVariables>(AnalyticsDashboardDocument, options);
        }
export type AnalyticsDashboardQueryHookResult = ReturnType<typeof useAnalyticsDashboardQuery>;
export type AnalyticsDashboardLazyQueryHookResult = ReturnType<typeof useAnalyticsDashboardLazyQuery>;
export type AnalyticsDashboardSuspenseQueryHookResult = ReturnType<typeof useAnalyticsDashboardSuspenseQuery>;
export type AnalyticsDashboardQueryResult = Apollo.QueryResult<AnalyticsDashboardQuery, AnalyticsDashboardQueryVariables>;
export const CreateAnalyticsDashboardDocument = gql`
    mutation CreateAnalyticsDashboard($data: AnalyticsDashboardCreateInput!) {
  createOneAnalyticsDashboard(data: $data) {
    ...analyticsDashboard
  }
}
    ${AnalyticsDashboardFragmentDoc}`;
export type CreateAnalyticsDashboardMutationFn = Apollo.MutationFunction<CreateAnalyticsDashboardMutation, CreateAnalyticsDashboardMutationVariables>;

/**
 * __useCreateAnalyticsDashboardMutation__
 *
 * To run a mutation, you first call `useCreateAnalyticsDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnalyticsDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnalyticsDashboardMutation, { data, loading, error }] = useCreateAnalyticsDashboardMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAnalyticsDashboardMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnalyticsDashboardMutation, CreateAnalyticsDashboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAnalyticsDashboardMutation, CreateAnalyticsDashboardMutationVariables>(CreateAnalyticsDashboardDocument, options);
      }
export type CreateAnalyticsDashboardMutationHookResult = ReturnType<typeof useCreateAnalyticsDashboardMutation>;
export type CreateAnalyticsDashboardMutationResult = Apollo.MutationResult<CreateAnalyticsDashboardMutation>;
export type CreateAnalyticsDashboardMutationOptions = Apollo.BaseMutationOptions<CreateAnalyticsDashboardMutation, CreateAnalyticsDashboardMutationVariables>;
export const DeleteAnalyticsDashboardDocument = gql`
    mutation DeleteAnalyticsDashboard($where: AnalyticsDashboardWhereUniqueInput!) {
  deleteOneAnalyticsDashboard(where: $where) {
    id
  }
}
    `;
export type DeleteAnalyticsDashboardMutationFn = Apollo.MutationFunction<DeleteAnalyticsDashboardMutation, DeleteAnalyticsDashboardMutationVariables>;

/**
 * __useDeleteAnalyticsDashboardMutation__
 *
 * To run a mutation, you first call `useDeleteAnalyticsDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnalyticsDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnalyticsDashboardMutation, { data, loading, error }] = useDeleteAnalyticsDashboardMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteAnalyticsDashboardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAnalyticsDashboardMutation, DeleteAnalyticsDashboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAnalyticsDashboardMutation, DeleteAnalyticsDashboardMutationVariables>(DeleteAnalyticsDashboardDocument, options);
      }
export type DeleteAnalyticsDashboardMutationHookResult = ReturnType<typeof useDeleteAnalyticsDashboardMutation>;
export type DeleteAnalyticsDashboardMutationResult = Apollo.MutationResult<DeleteAnalyticsDashboardMutation>;
export type DeleteAnalyticsDashboardMutationOptions = Apollo.BaseMutationOptions<DeleteAnalyticsDashboardMutation, DeleteAnalyticsDashboardMutationVariables>;
export const UpdateAnalyticsDashboardDocument = gql`
    mutation UpdateAnalyticsDashboard($data: AppAnalyticsDashboardUpdateInput!, $where: AppAnalyticsDashboardWhereUniqueInput!) {
  updateAnalyticsDashboard(data: $data, where: $where) {
    ...analyticsDashboard
  }
}
    ${AnalyticsDashboardFragmentDoc}`;
export type UpdateAnalyticsDashboardMutationFn = Apollo.MutationFunction<UpdateAnalyticsDashboardMutation, UpdateAnalyticsDashboardMutationVariables>;

/**
 * __useUpdateAnalyticsDashboardMutation__
 *
 * To run a mutation, you first call `useUpdateAnalyticsDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnalyticsDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnalyticsDashboardMutation, { data, loading, error }] = useUpdateAnalyticsDashboardMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateAnalyticsDashboardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAnalyticsDashboardMutation, UpdateAnalyticsDashboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAnalyticsDashboardMutation, UpdateAnalyticsDashboardMutationVariables>(UpdateAnalyticsDashboardDocument, options);
      }
export type UpdateAnalyticsDashboardMutationHookResult = ReturnType<typeof useUpdateAnalyticsDashboardMutation>;
export type UpdateAnalyticsDashboardMutationResult = Apollo.MutationResult<UpdateAnalyticsDashboardMutation>;
export type UpdateAnalyticsDashboardMutationOptions = Apollo.BaseMutationOptions<UpdateAnalyticsDashboardMutation, UpdateAnalyticsDashboardMutationVariables>;
export const AnalyticsChartTemplatesOptionsDocument = gql`
    query AnalyticsChartTemplatesOptions {
  proposalTemplates {
    id
    name
    lastVersion {
      id
      analyticsPages {
        id
        name
        type
        primaryColumnUUID
        fields {
          id
          name
          fullName
        }
      }
    }
  }
}
    `;

/**
 * __useAnalyticsChartTemplatesOptionsQuery__
 *
 * To run a query within a React component, call `useAnalyticsChartTemplatesOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsChartTemplatesOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsChartTemplatesOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAnalyticsChartTemplatesOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsChartTemplatesOptionsQuery, AnalyticsChartTemplatesOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsChartTemplatesOptionsQuery, AnalyticsChartTemplatesOptionsQueryVariables>(AnalyticsChartTemplatesOptionsDocument, options);
      }
export function useAnalyticsChartTemplatesOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsChartTemplatesOptionsQuery, AnalyticsChartTemplatesOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsChartTemplatesOptionsQuery, AnalyticsChartTemplatesOptionsQueryVariables>(AnalyticsChartTemplatesOptionsDocument, options);
        }
export function useAnalyticsChartTemplatesOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsChartTemplatesOptionsQuery, AnalyticsChartTemplatesOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsChartTemplatesOptionsQuery, AnalyticsChartTemplatesOptionsQueryVariables>(AnalyticsChartTemplatesOptionsDocument, options);
        }
export type AnalyticsChartTemplatesOptionsQueryHookResult = ReturnType<typeof useAnalyticsChartTemplatesOptionsQuery>;
export type AnalyticsChartTemplatesOptionsLazyQueryHookResult = ReturnType<typeof useAnalyticsChartTemplatesOptionsLazyQuery>;
export type AnalyticsChartTemplatesOptionsSuspenseQueryHookResult = ReturnType<typeof useAnalyticsChartTemplatesOptionsSuspenseQuery>;
export type AnalyticsChartTemplatesOptionsQueryResult = Apollo.QueryResult<AnalyticsChartTemplatesOptionsQuery, AnalyticsChartTemplatesOptionsQueryVariables>;
export const AnalyticsPagesByTemplateIdsDocument = gql`
    query AnalyticsPagesByTemplateIds($templateIds: [Int!]!) {
  proposalTemplates(where: {id: {in: $templateIds}}) {
    id
    lastVersion {
      analyticsPages {
        id
        primaryColumnUUID
      }
    }
  }
}
    `;

/**
 * __useAnalyticsPagesByTemplateIdsQuery__
 *
 * To run a query within a React component, call `useAnalyticsPagesByTemplateIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsPagesByTemplateIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsPagesByTemplateIdsQuery({
 *   variables: {
 *      templateIds: // value for 'templateIds'
 *   },
 * });
 */
export function useAnalyticsPagesByTemplateIdsQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsPagesByTemplateIdsQuery, AnalyticsPagesByTemplateIdsQueryVariables> & ({ variables: AnalyticsPagesByTemplateIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsPagesByTemplateIdsQuery, AnalyticsPagesByTemplateIdsQueryVariables>(AnalyticsPagesByTemplateIdsDocument, options);
      }
export function useAnalyticsPagesByTemplateIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsPagesByTemplateIdsQuery, AnalyticsPagesByTemplateIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsPagesByTemplateIdsQuery, AnalyticsPagesByTemplateIdsQueryVariables>(AnalyticsPagesByTemplateIdsDocument, options);
        }
export function useAnalyticsPagesByTemplateIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsPagesByTemplateIdsQuery, AnalyticsPagesByTemplateIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsPagesByTemplateIdsQuery, AnalyticsPagesByTemplateIdsQueryVariables>(AnalyticsPagesByTemplateIdsDocument, options);
        }
export type AnalyticsPagesByTemplateIdsQueryHookResult = ReturnType<typeof useAnalyticsPagesByTemplateIdsQuery>;
export type AnalyticsPagesByTemplateIdsLazyQueryHookResult = ReturnType<typeof useAnalyticsPagesByTemplateIdsLazyQuery>;
export type AnalyticsPagesByTemplateIdsSuspenseQueryHookResult = ReturnType<typeof useAnalyticsPagesByTemplateIdsSuspenseQuery>;
export type AnalyticsPagesByTemplateIdsQueryResult = Apollo.QueryResult<AnalyticsPagesByTemplateIdsQuery, AnalyticsPagesByTemplateIdsQueryVariables>;
export const GetDynamicAnalyticFiltersSourcesDocument = gql`
    query GetDynamicAnalyticFiltersSources($aggregations: [Aggregate!]!, $includeProposalIds: Boolean = false, $includeOwners: Boolean = false) {
  proposalIds: allProposalsIds @include(if: $includeProposalIds)
  owners: proposalVersions(distinct: createdBy) @include(if: $includeOwners) {
    createdBy
  }
  proposalAnalyticFiltersAggregations: proposalAnalytic(aggregate: $aggregations) {
    data
  }
}
    `;

/**
 * __useGetDynamicAnalyticFiltersSourcesQuery__
 *
 * To run a query within a React component, call `useGetDynamicAnalyticFiltersSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDynamicAnalyticFiltersSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDynamicAnalyticFiltersSourcesQuery({
 *   variables: {
 *      aggregations: // value for 'aggregations'
 *      includeProposalIds: // value for 'includeProposalIds'
 *      includeOwners: // value for 'includeOwners'
 *   },
 * });
 */
export function useGetDynamicAnalyticFiltersSourcesQuery(baseOptions: Apollo.QueryHookOptions<GetDynamicAnalyticFiltersSourcesQuery, GetDynamicAnalyticFiltersSourcesQueryVariables> & ({ variables: GetDynamicAnalyticFiltersSourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDynamicAnalyticFiltersSourcesQuery, GetDynamicAnalyticFiltersSourcesQueryVariables>(GetDynamicAnalyticFiltersSourcesDocument, options);
      }
export function useGetDynamicAnalyticFiltersSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDynamicAnalyticFiltersSourcesQuery, GetDynamicAnalyticFiltersSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDynamicAnalyticFiltersSourcesQuery, GetDynamicAnalyticFiltersSourcesQueryVariables>(GetDynamicAnalyticFiltersSourcesDocument, options);
        }
export function useGetDynamicAnalyticFiltersSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDynamicAnalyticFiltersSourcesQuery, GetDynamicAnalyticFiltersSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDynamicAnalyticFiltersSourcesQuery, GetDynamicAnalyticFiltersSourcesQueryVariables>(GetDynamicAnalyticFiltersSourcesDocument, options);
        }
export type GetDynamicAnalyticFiltersSourcesQueryHookResult = ReturnType<typeof useGetDynamicAnalyticFiltersSourcesQuery>;
export type GetDynamicAnalyticFiltersSourcesLazyQueryHookResult = ReturnType<typeof useGetDynamicAnalyticFiltersSourcesLazyQuery>;
export type GetDynamicAnalyticFiltersSourcesSuspenseQueryHookResult = ReturnType<typeof useGetDynamicAnalyticFiltersSourcesSuspenseQuery>;
export type GetDynamicAnalyticFiltersSourcesQueryResult = Apollo.QueryResult<GetDynamicAnalyticFiltersSourcesQuery, GetDynamicAnalyticFiltersSourcesQueryVariables>;
export const RecentProposalsDocument = gql`
    query RecentProposals {
  proposals(
    limit: 20
    orderBy: [{field: "updatedAt", sort: desc}]
    pinnedFirst: false
    search: ""
  ) {
    items {
      id
      name
      createdBy
      dataSourceUsedAt
      latestVersionId
      updatedAt
      lastVersionCreatedBy
      isFinalized
    }
  }
}
    `;

/**
 * __useRecentProposalsQuery__
 *
 * To run a query within a React component, call `useRecentProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentProposalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecentProposalsQuery(baseOptions?: Apollo.QueryHookOptions<RecentProposalsQuery, RecentProposalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentProposalsQuery, RecentProposalsQueryVariables>(RecentProposalsDocument, options);
      }
export function useRecentProposalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentProposalsQuery, RecentProposalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentProposalsQuery, RecentProposalsQueryVariables>(RecentProposalsDocument, options);
        }
export function useRecentProposalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentProposalsQuery, RecentProposalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecentProposalsQuery, RecentProposalsQueryVariables>(RecentProposalsDocument, options);
        }
export type RecentProposalsQueryHookResult = ReturnType<typeof useRecentProposalsQuery>;
export type RecentProposalsLazyQueryHookResult = ReturnType<typeof useRecentProposalsLazyQuery>;
export type RecentProposalsSuspenseQueryHookResult = ReturnType<typeof useRecentProposalsSuspenseQuery>;
export type RecentProposalsQueryResult = Apollo.QueryResult<RecentProposalsQuery, RecentProposalsQueryVariables>;
export const ListLookupsDocument = gql`
    query ListLookups {
  lookups {
    id
    name
    updatedAt
    createdAt
  }
}
    `;

/**
 * __useListLookupsQuery__
 *
 * To run a query within a React component, call `useListLookupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLookupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLookupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListLookupsQuery(baseOptions?: Apollo.QueryHookOptions<ListLookupsQuery, ListLookupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLookupsQuery, ListLookupsQueryVariables>(ListLookupsDocument, options);
      }
export function useListLookupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLookupsQuery, ListLookupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLookupsQuery, ListLookupsQueryVariables>(ListLookupsDocument, options);
        }
export function useListLookupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLookupsQuery, ListLookupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListLookupsQuery, ListLookupsQueryVariables>(ListLookupsDocument, options);
        }
export type ListLookupsQueryHookResult = ReturnType<typeof useListLookupsQuery>;
export type ListLookupsLazyQueryHookResult = ReturnType<typeof useListLookupsLazyQuery>;
export type ListLookupsSuspenseQueryHookResult = ReturnType<typeof useListLookupsSuspenseQuery>;
export type ListLookupsQueryResult = Apollo.QueryResult<ListLookupsQuery, ListLookupsQueryVariables>;
export const GetLookupsByIdDocument = gql`
    query GetLookupsById($ids: [Int!]!) {
  lookups(where: {id: {in: $ids}}) {
    id
    name
    valueKey
    labelKey
    options
    usedAt
  }
}
    `;

/**
 * __useGetLookupsByIdQuery__
 *
 * To run a query within a React component, call `useGetLookupsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLookupsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLookupsByIdQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetLookupsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetLookupsByIdQuery, GetLookupsByIdQueryVariables> & ({ variables: GetLookupsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLookupsByIdQuery, GetLookupsByIdQueryVariables>(GetLookupsByIdDocument, options);
      }
export function useGetLookupsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLookupsByIdQuery, GetLookupsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLookupsByIdQuery, GetLookupsByIdQueryVariables>(GetLookupsByIdDocument, options);
        }
export function useGetLookupsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLookupsByIdQuery, GetLookupsByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLookupsByIdQuery, GetLookupsByIdQueryVariables>(GetLookupsByIdDocument, options);
        }
export type GetLookupsByIdQueryHookResult = ReturnType<typeof useGetLookupsByIdQuery>;
export type GetLookupsByIdLazyQueryHookResult = ReturnType<typeof useGetLookupsByIdLazyQuery>;
export type GetLookupsByIdSuspenseQueryHookResult = ReturnType<typeof useGetLookupsByIdSuspenseQuery>;
export type GetLookupsByIdQueryResult = Apollo.QueryResult<GetLookupsByIdQuery, GetLookupsByIdQueryVariables>;
export const GetLookupDocument = gql`
    query GetLookup($id: Int!) {
  lookup(where: {id: $id}) {
    id
    name
    valueKey
    labelKey
    options
    usedAt
  }
}
    `;

/**
 * __useGetLookupQuery__
 *
 * To run a query within a React component, call `useGetLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLookupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLookupQuery(baseOptions: Apollo.QueryHookOptions<GetLookupQuery, GetLookupQueryVariables> & ({ variables: GetLookupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLookupQuery, GetLookupQueryVariables>(GetLookupDocument, options);
      }
export function useGetLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLookupQuery, GetLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLookupQuery, GetLookupQueryVariables>(GetLookupDocument, options);
        }
export function useGetLookupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLookupQuery, GetLookupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLookupQuery, GetLookupQueryVariables>(GetLookupDocument, options);
        }
export type GetLookupQueryHookResult = ReturnType<typeof useGetLookupQuery>;
export type GetLookupLazyQueryHookResult = ReturnType<typeof useGetLookupLazyQuery>;
export type GetLookupSuspenseQueryHookResult = ReturnType<typeof useGetLookupSuspenseQuery>;
export type GetLookupQueryResult = Apollo.QueryResult<GetLookupQuery, GetLookupQueryVariables>;
export const CreateOneLookupDocument = gql`
    mutation CreateOneLookup($data: LookupCreateInput!) {
  createOneLookup(data: $data) {
    id
  }
}
    `;
export type CreateOneLookupMutationFn = Apollo.MutationFunction<CreateOneLookupMutation, CreateOneLookupMutationVariables>;

/**
 * __useCreateOneLookupMutation__
 *
 * To run a mutation, you first call `useCreateOneLookupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneLookupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneLookupMutation, { data, loading, error }] = useCreateOneLookupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneLookupMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneLookupMutation, CreateOneLookupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneLookupMutation, CreateOneLookupMutationVariables>(CreateOneLookupDocument, options);
      }
export type CreateOneLookupMutationHookResult = ReturnType<typeof useCreateOneLookupMutation>;
export type CreateOneLookupMutationResult = Apollo.MutationResult<CreateOneLookupMutation>;
export type CreateOneLookupMutationOptions = Apollo.BaseMutationOptions<CreateOneLookupMutation, CreateOneLookupMutationVariables>;
export const UpdateOneLookupDocument = gql`
    mutation updateOneLookup($id: Int!, $data: LookupUpdateInput!) {
  updateOneLookup(where: {id: $id}, data: $data) {
    id
  }
}
    `;
export type UpdateOneLookupMutationFn = Apollo.MutationFunction<UpdateOneLookupMutation, UpdateOneLookupMutationVariables>;

/**
 * __useUpdateOneLookupMutation__
 *
 * To run a mutation, you first call `useUpdateOneLookupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneLookupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneLookupMutation, { data, loading, error }] = useUpdateOneLookupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOneLookupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneLookupMutation, UpdateOneLookupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneLookupMutation, UpdateOneLookupMutationVariables>(UpdateOneLookupDocument, options);
      }
export type UpdateOneLookupMutationHookResult = ReturnType<typeof useUpdateOneLookupMutation>;
export type UpdateOneLookupMutationResult = Apollo.MutationResult<UpdateOneLookupMutation>;
export type UpdateOneLookupMutationOptions = Apollo.BaseMutationOptions<UpdateOneLookupMutation, UpdateOneLookupMutationVariables>;
export const DeleteOneLookupDocument = gql`
    mutation DeleteOneLookup($id: Int!) {
  deleteOneLookup(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteOneLookupMutationFn = Apollo.MutationFunction<DeleteOneLookupMutation, DeleteOneLookupMutationVariables>;

/**
 * __useDeleteOneLookupMutation__
 *
 * To run a mutation, you first call `useDeleteOneLookupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneLookupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneLookupMutation, { data, loading, error }] = useDeleteOneLookupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOneLookupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOneLookupMutation, DeleteOneLookupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOneLookupMutation, DeleteOneLookupMutationVariables>(DeleteOneLookupDocument, options);
      }
export type DeleteOneLookupMutationHookResult = ReturnType<typeof useDeleteOneLookupMutation>;
export type DeleteOneLookupMutationResult = Apollo.MutationResult<DeleteOneLookupMutation>;
export type DeleteOneLookupMutationOptions = Apollo.BaseMutationOptions<DeleteOneLookupMutation, DeleteOneLookupMutationVariables>;
export const LookupsOptionsDocument = gql`
    query LookupsOptions {
  lookups {
    id
    name
  }
}
    `;

/**
 * __useLookupsOptionsQuery__
 *
 * To run a query within a React component, call `useLookupsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLookupsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLookupsOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLookupsOptionsQuery(baseOptions?: Apollo.QueryHookOptions<LookupsOptionsQuery, LookupsOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LookupsOptionsQuery, LookupsOptionsQueryVariables>(LookupsOptionsDocument, options);
      }
export function useLookupsOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LookupsOptionsQuery, LookupsOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LookupsOptionsQuery, LookupsOptionsQueryVariables>(LookupsOptionsDocument, options);
        }
export function useLookupsOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LookupsOptionsQuery, LookupsOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LookupsOptionsQuery, LookupsOptionsQueryVariables>(LookupsOptionsDocument, options);
        }
export type LookupsOptionsQueryHookResult = ReturnType<typeof useLookupsOptionsQuery>;
export type LookupsOptionsLazyQueryHookResult = ReturnType<typeof useLookupsOptionsLazyQuery>;
export type LookupsOptionsSuspenseQueryHookResult = ReturnType<typeof useLookupsOptionsSuspenseQuery>;
export type LookupsOptionsQueryResult = Apollo.QueryResult<LookupsOptionsQuery, LookupsOptionsQueryVariables>;
export const ListProposalsDocument = gql`
    query ListProposals($skip: Int, $take: Int, $orderBy: [ProposalsSortItem!], $filter: ProposalsFilter, $search: String, $searchUserEmails: [String!]) {
  proposals(
    offset: $skip
    limit: $take
    orderBy: $orderBy
    filter: $filter
    search: $search
    searchUserEmails: $searchUserEmails
  ) {
    count
    items {
      id
      name
      templateName
      createdBy
      updatedAt
      dataSourceUsedAt
      createdAt
      lastVersionCreatedBy
      latestVersionId
      isFinalized
      isPinned
      fields {
        name
        value
        fieldId
        type
        dateMode
      }
    }
  }
}
    `;

/**
 * __useListProposalsQuery__
 *
 * To run a query within a React component, call `useListProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProposalsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *      searchUserEmails: // value for 'searchUserEmails'
 *   },
 * });
 */
export function useListProposalsQuery(baseOptions?: Apollo.QueryHookOptions<ListProposalsQuery, ListProposalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProposalsQuery, ListProposalsQueryVariables>(ListProposalsDocument, options);
      }
export function useListProposalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProposalsQuery, ListProposalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProposalsQuery, ListProposalsQueryVariables>(ListProposalsDocument, options);
        }
export function useListProposalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProposalsQuery, ListProposalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListProposalsQuery, ListProposalsQueryVariables>(ListProposalsDocument, options);
        }
export type ListProposalsQueryHookResult = ReturnType<typeof useListProposalsQuery>;
export type ListProposalsLazyQueryHookResult = ReturnType<typeof useListProposalsLazyQuery>;
export type ListProposalsSuspenseQueryHookResult = ReturnType<typeof useListProposalsSuspenseQuery>;
export type ListProposalsQueryResult = Apollo.QueryResult<ListProposalsQuery, ListProposalsQueryVariables>;
export const ProposalVersionFreshnessDataSourcesDocument = gql`
    query ProposalVersionFreshnessDataSources($proposalId: Int!, $versionId: Int!) {
  proposal(where: {id: $proposalId}) {
    id
    versions(where: {id: {equals: $versionId}}) {
      id
      dataSourceVersions(
        where: {dataSourceVersion: {is: {dataSource: {is: {includeInFreshness: {equals: true}}}}}}
      ) {
        dataSourceVersion {
          createdAt
          usedAt
          dataSource {
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProposalVersionFreshnessDataSourcesQuery__
 *
 * To run a query within a React component, call `useProposalVersionFreshnessDataSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalVersionFreshnessDataSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalVersionFreshnessDataSourcesQuery({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useProposalVersionFreshnessDataSourcesQuery(baseOptions: Apollo.QueryHookOptions<ProposalVersionFreshnessDataSourcesQuery, ProposalVersionFreshnessDataSourcesQueryVariables> & ({ variables: ProposalVersionFreshnessDataSourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProposalVersionFreshnessDataSourcesQuery, ProposalVersionFreshnessDataSourcesQueryVariables>(ProposalVersionFreshnessDataSourcesDocument, options);
      }
export function useProposalVersionFreshnessDataSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProposalVersionFreshnessDataSourcesQuery, ProposalVersionFreshnessDataSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProposalVersionFreshnessDataSourcesQuery, ProposalVersionFreshnessDataSourcesQueryVariables>(ProposalVersionFreshnessDataSourcesDocument, options);
        }
export function useProposalVersionFreshnessDataSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProposalVersionFreshnessDataSourcesQuery, ProposalVersionFreshnessDataSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProposalVersionFreshnessDataSourcesQuery, ProposalVersionFreshnessDataSourcesQueryVariables>(ProposalVersionFreshnessDataSourcesDocument, options);
        }
export type ProposalVersionFreshnessDataSourcesQueryHookResult = ReturnType<typeof useProposalVersionFreshnessDataSourcesQuery>;
export type ProposalVersionFreshnessDataSourcesLazyQueryHookResult = ReturnType<typeof useProposalVersionFreshnessDataSourcesLazyQuery>;
export type ProposalVersionFreshnessDataSourcesSuspenseQueryHookResult = ReturnType<typeof useProposalVersionFreshnessDataSourcesSuspenseQuery>;
export type ProposalVersionFreshnessDataSourcesQueryResult = Apollo.QueryResult<ProposalVersionFreshnessDataSourcesQuery, ProposalVersionFreshnessDataSourcesQueryVariables>;
export const GetOneProposalDocument = gql`
    query GetOneProposal($id: Int!) {
  proposal(where: {id: $id}) {
    id
    type
    name
    templateVersionId
    isFinalized
    versions(orderBy: [{createdAt: asc}]) {
      id
      createdAt
      createdBy
      dataSourceUsedAt
      sequentialNumber
    }
    lastVersion {
      id
      data
      createdAt
      dataSourceUsedAt
      ...ProposalVersionDsLinks
    }
  }
}
    ${ProposalVersionDsLinksFragmentDoc}`;

/**
 * __useGetOneProposalQuery__
 *
 * To run a query within a React component, call `useGetOneProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneProposalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOneProposalQuery(baseOptions: Apollo.QueryHookOptions<GetOneProposalQuery, GetOneProposalQueryVariables> & ({ variables: GetOneProposalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOneProposalQuery, GetOneProposalQueryVariables>(GetOneProposalDocument, options);
      }
export function useGetOneProposalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOneProposalQuery, GetOneProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOneProposalQuery, GetOneProposalQueryVariables>(GetOneProposalDocument, options);
        }
export function useGetOneProposalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneProposalQuery, GetOneProposalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOneProposalQuery, GetOneProposalQueryVariables>(GetOneProposalDocument, options);
        }
export type GetOneProposalQueryHookResult = ReturnType<typeof useGetOneProposalQuery>;
export type GetOneProposalLazyQueryHookResult = ReturnType<typeof useGetOneProposalLazyQuery>;
export type GetOneProposalSuspenseQueryHookResult = ReturnType<typeof useGetOneProposalSuspenseQuery>;
export type GetOneProposalQueryResult = Apollo.QueryResult<GetOneProposalQuery, GetOneProposalQueryVariables>;
export const GetLastProposalEditorDocument = gql`
    query GetLastProposalEditor($proposalId: Int!) {
  lastEditor(proposalId: $proposalId)
}
    `;

/**
 * __useGetLastProposalEditorQuery__
 *
 * To run a query within a React component, call `useGetLastProposalEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastProposalEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastProposalEditorQuery({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useGetLastProposalEditorQuery(baseOptions: Apollo.QueryHookOptions<GetLastProposalEditorQuery, GetLastProposalEditorQueryVariables> & ({ variables: GetLastProposalEditorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLastProposalEditorQuery, GetLastProposalEditorQueryVariables>(GetLastProposalEditorDocument, options);
      }
export function useGetLastProposalEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLastProposalEditorQuery, GetLastProposalEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLastProposalEditorQuery, GetLastProposalEditorQueryVariables>(GetLastProposalEditorDocument, options);
        }
export function useGetLastProposalEditorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLastProposalEditorQuery, GetLastProposalEditorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLastProposalEditorQuery, GetLastProposalEditorQueryVariables>(GetLastProposalEditorDocument, options);
        }
export type GetLastProposalEditorQueryHookResult = ReturnType<typeof useGetLastProposalEditorQuery>;
export type GetLastProposalEditorLazyQueryHookResult = ReturnType<typeof useGetLastProposalEditorLazyQuery>;
export type GetLastProposalEditorSuspenseQueryHookResult = ReturnType<typeof useGetLastProposalEditorSuspenseQuery>;
export type GetLastProposalEditorQueryResult = Apollo.QueryResult<GetLastProposalEditorQuery, GetLastProposalEditorQueryVariables>;
export const ProposalEditorCheckInOpenedDocument = gql`
    mutation ProposalEditorCheckInOpened($proposalId: Int!) {
  proposalEditorCheckInOpened(proposalId: $proposalId)
}
    `;
export type ProposalEditorCheckInOpenedMutationFn = Apollo.MutationFunction<ProposalEditorCheckInOpenedMutation, ProposalEditorCheckInOpenedMutationVariables>;

/**
 * __useProposalEditorCheckInOpenedMutation__
 *
 * To run a mutation, you first call `useProposalEditorCheckInOpenedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalEditorCheckInOpenedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalEditorCheckInOpenedMutation, { data, loading, error }] = useProposalEditorCheckInOpenedMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useProposalEditorCheckInOpenedMutation(baseOptions?: Apollo.MutationHookOptions<ProposalEditorCheckInOpenedMutation, ProposalEditorCheckInOpenedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProposalEditorCheckInOpenedMutation, ProposalEditorCheckInOpenedMutationVariables>(ProposalEditorCheckInOpenedDocument, options);
      }
export type ProposalEditorCheckInOpenedMutationHookResult = ReturnType<typeof useProposalEditorCheckInOpenedMutation>;
export type ProposalEditorCheckInOpenedMutationResult = Apollo.MutationResult<ProposalEditorCheckInOpenedMutation>;
export type ProposalEditorCheckInOpenedMutationOptions = Apollo.BaseMutationOptions<ProposalEditorCheckInOpenedMutation, ProposalEditorCheckInOpenedMutationVariables>;
export const ProposalEditorCheckInClosedDocument = gql`
    mutation ProposalEditorCheckInClosed($proposalId: Int!) {
  proposalEditorCheckInClosed(proposalId: $proposalId)
}
    `;
export type ProposalEditorCheckInClosedMutationFn = Apollo.MutationFunction<ProposalEditorCheckInClosedMutation, ProposalEditorCheckInClosedMutationVariables>;

/**
 * __useProposalEditorCheckInClosedMutation__
 *
 * To run a mutation, you first call `useProposalEditorCheckInClosedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposalEditorCheckInClosedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposalEditorCheckInClosedMutation, { data, loading, error }] = useProposalEditorCheckInClosedMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useProposalEditorCheckInClosedMutation(baseOptions?: Apollo.MutationHookOptions<ProposalEditorCheckInClosedMutation, ProposalEditorCheckInClosedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProposalEditorCheckInClosedMutation, ProposalEditorCheckInClosedMutationVariables>(ProposalEditorCheckInClosedDocument, options);
      }
export type ProposalEditorCheckInClosedMutationHookResult = ReturnType<typeof useProposalEditorCheckInClosedMutation>;
export type ProposalEditorCheckInClosedMutationResult = Apollo.MutationResult<ProposalEditorCheckInClosedMutation>;
export type ProposalEditorCheckInClosedMutationOptions = Apollo.BaseMutationOptions<ProposalEditorCheckInClosedMutation, ProposalEditorCheckInClosedMutationVariables>;
export const GetOneProposalNameDocument = gql`
    query GetOneProposalName($proposalId: Int!) {
  proposalName(proposalId: $proposalId)
}
    `;

/**
 * __useGetOneProposalNameQuery__
 *
 * To run a query within a React component, call `useGetOneProposalNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneProposalNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneProposalNameQuery({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useGetOneProposalNameQuery(baseOptions: Apollo.QueryHookOptions<GetOneProposalNameQuery, GetOneProposalNameQueryVariables> & ({ variables: GetOneProposalNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOneProposalNameQuery, GetOneProposalNameQueryVariables>(GetOneProposalNameDocument, options);
      }
export function useGetOneProposalNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOneProposalNameQuery, GetOneProposalNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOneProposalNameQuery, GetOneProposalNameQueryVariables>(GetOneProposalNameDocument, options);
        }
export function useGetOneProposalNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneProposalNameQuery, GetOneProposalNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOneProposalNameQuery, GetOneProposalNameQueryVariables>(GetOneProposalNameDocument, options);
        }
export type GetOneProposalNameQueryHookResult = ReturnType<typeof useGetOneProposalNameQuery>;
export type GetOneProposalNameLazyQueryHookResult = ReturnType<typeof useGetOneProposalNameLazyQuery>;
export type GetOneProposalNameSuspenseQueryHookResult = ReturnType<typeof useGetOneProposalNameSuspenseQuery>;
export type GetOneProposalNameQueryResult = Apollo.QueryResult<GetOneProposalNameQuery, GetOneProposalNameQueryVariables>;
export const CreateOneProposalDocument = gql`
    mutation CreateOneProposal($data: ProposalCreateInput!) {
  createOneProposal(data: $data) {
    id
  }
}
    `;
export type CreateOneProposalMutationFn = Apollo.MutationFunction<CreateOneProposalMutation, CreateOneProposalMutationVariables>;

/**
 * __useCreateOneProposalMutation__
 *
 * To run a mutation, you first call `useCreateOneProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneProposalMutation, { data, loading, error }] = useCreateOneProposalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneProposalMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneProposalMutation, CreateOneProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneProposalMutation, CreateOneProposalMutationVariables>(CreateOneProposalDocument, options);
      }
export type CreateOneProposalMutationHookResult = ReturnType<typeof useCreateOneProposalMutation>;
export type CreateOneProposalMutationResult = Apollo.MutationResult<CreateOneProposalMutation>;
export type CreateOneProposalMutationOptions = Apollo.BaseMutationOptions<CreateOneProposalMutation, CreateOneProposalMutationVariables>;
export const UpdateOneProposalDocument = gql`
    mutation UpdateOneProposal($id: Int!, $data: ProposalUpdateInput!) {
  updateOneProposal(where: {id: $id}, data: $data) {
    id
    lastVersion: versions(orderBy: {createdAt: desc}, take: 1) {
      id
    }
  }
}
    `;
export type UpdateOneProposalMutationFn = Apollo.MutationFunction<UpdateOneProposalMutation, UpdateOneProposalMutationVariables>;

/**
 * __useUpdateOneProposalMutation__
 *
 * To run a mutation, you first call `useUpdateOneProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneProposalMutation, { data, loading, error }] = useUpdateOneProposalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOneProposalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOneProposalMutation, UpdateOneProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOneProposalMutation, UpdateOneProposalMutationVariables>(UpdateOneProposalDocument, options);
      }
export type UpdateOneProposalMutationHookResult = ReturnType<typeof useUpdateOneProposalMutation>;
export type UpdateOneProposalMutationResult = Apollo.MutationResult<UpdateOneProposalMutation>;
export type UpdateOneProposalMutationOptions = Apollo.BaseMutationOptions<UpdateOneProposalMutation, UpdateOneProposalMutationVariables>;
export const DeleteOneProposalDocument = gql`
    mutation DeleteOneProposal($id: Int!) {
  deleteOneProposal(where: {id: $id}) {
    id
  }
}
    `;
export type DeleteOneProposalMutationFn = Apollo.MutationFunction<DeleteOneProposalMutation, DeleteOneProposalMutationVariables>;

/**
 * __useDeleteOneProposalMutation__
 *
 * To run a mutation, you first call `useDeleteOneProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneProposalMutation, { data, loading, error }] = useDeleteOneProposalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOneProposalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOneProposalMutation, DeleteOneProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOneProposalMutation, DeleteOneProposalMutationVariables>(DeleteOneProposalDocument, options);
      }
export type DeleteOneProposalMutationHookResult = ReturnType<typeof useDeleteOneProposalMutation>;
export type DeleteOneProposalMutationResult = Apollo.MutationResult<DeleteOneProposalMutation>;
export type DeleteOneProposalMutationOptions = Apollo.BaseMutationOptions<DeleteOneProposalMutation, DeleteOneProposalMutationVariables>;
export const DeleteManyProposalDocument = gql`
    mutation DeleteManyProposal($where: ProposalWhereInput) {
  deleteManyProposal(where: $where) {
    count
  }
}
    `;
export type DeleteManyProposalMutationFn = Apollo.MutationFunction<DeleteManyProposalMutation, DeleteManyProposalMutationVariables>;

/**
 * __useDeleteManyProposalMutation__
 *
 * To run a mutation, you first call `useDeleteManyProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyProposalMutation, { data, loading, error }] = useDeleteManyProposalMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteManyProposalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteManyProposalMutation, DeleteManyProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteManyProposalMutation, DeleteManyProposalMutationVariables>(DeleteManyProposalDocument, options);
      }
export type DeleteManyProposalMutationHookResult = ReturnType<typeof useDeleteManyProposalMutation>;
export type DeleteManyProposalMutationResult = Apollo.MutationResult<DeleteManyProposalMutation>;
export type DeleteManyProposalMutationOptions = Apollo.BaseMutationOptions<DeleteManyProposalMutation, DeleteManyProposalMutationVariables>;
export const ProposalTemplateOptionsDocument = gql`
    query ProposalTemplateOptions($type: TemplateType!) {
  templateOptions(type: $type) {
    id
    name
    isDefault
    isPublished
  }
}
    `;

/**
 * __useProposalTemplateOptionsQuery__
 *
 * To run a query within a React component, call `useProposalTemplateOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalTemplateOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalTemplateOptionsQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useProposalTemplateOptionsQuery(baseOptions: Apollo.QueryHookOptions<ProposalTemplateOptionsQuery, ProposalTemplateOptionsQueryVariables> & ({ variables: ProposalTemplateOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProposalTemplateOptionsQuery, ProposalTemplateOptionsQueryVariables>(ProposalTemplateOptionsDocument, options);
      }
export function useProposalTemplateOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProposalTemplateOptionsQuery, ProposalTemplateOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProposalTemplateOptionsQuery, ProposalTemplateOptionsQueryVariables>(ProposalTemplateOptionsDocument, options);
        }
export function useProposalTemplateOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProposalTemplateOptionsQuery, ProposalTemplateOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProposalTemplateOptionsQuery, ProposalTemplateOptionsQueryVariables>(ProposalTemplateOptionsDocument, options);
        }
export type ProposalTemplateOptionsQueryHookResult = ReturnType<typeof useProposalTemplateOptionsQuery>;
export type ProposalTemplateOptionsLazyQueryHookResult = ReturnType<typeof useProposalTemplateOptionsLazyQuery>;
export type ProposalTemplateOptionsSuspenseQueryHookResult = ReturnType<typeof useProposalTemplateOptionsSuspenseQuery>;
export type ProposalTemplateOptionsQueryResult = Apollo.QueryResult<ProposalTemplateOptionsQuery, ProposalTemplateOptionsQueryVariables>;
export const GetLookupOptionsDocument = gql`
    query GetLookupOptions($id: Int!) {
  lookup(where: {id: $id}) {
    id
    options
    valueKey
    labelKey
  }
}
    `;

/**
 * __useGetLookupOptionsQuery__
 *
 * To run a query within a React component, call `useGetLookupOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLookupOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLookupOptionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLookupOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetLookupOptionsQuery, GetLookupOptionsQueryVariables> & ({ variables: GetLookupOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLookupOptionsQuery, GetLookupOptionsQueryVariables>(GetLookupOptionsDocument, options);
      }
export function useGetLookupOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLookupOptionsQuery, GetLookupOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLookupOptionsQuery, GetLookupOptionsQueryVariables>(GetLookupOptionsDocument, options);
        }
export function useGetLookupOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLookupOptionsQuery, GetLookupOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLookupOptionsQuery, GetLookupOptionsQueryVariables>(GetLookupOptionsDocument, options);
        }
export type GetLookupOptionsQueryHookResult = ReturnType<typeof useGetLookupOptionsQuery>;
export type GetLookupOptionsLazyQueryHookResult = ReturnType<typeof useGetLookupOptionsLazyQuery>;
export type GetLookupOptionsSuspenseQueryHookResult = ReturnType<typeof useGetLookupOptionsSuspenseQuery>;
export type GetLookupOptionsQueryResult = Apollo.QueryResult<GetLookupOptionsQuery, GetLookupOptionsQueryVariables>;
export const ListProposalVersionsDocument = gql`
    query ListProposalVersions($proposalId: Int!) {
  proposal(where: {id: $proposalId}) {
    id
    versions {
      id
      createdAt
      createdBy
      comment
      dataSourceUsedAt
      isSharedWithClient
      sequentialNumber
    }
  }
}
    `;

/**
 * __useListProposalVersionsQuery__
 *
 * To run a query within a React component, call `useListProposalVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProposalVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProposalVersionsQuery({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useListProposalVersionsQuery(baseOptions: Apollo.QueryHookOptions<ListProposalVersionsQuery, ListProposalVersionsQueryVariables> & ({ variables: ListProposalVersionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProposalVersionsQuery, ListProposalVersionsQueryVariables>(ListProposalVersionsDocument, options);
      }
export function useListProposalVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProposalVersionsQuery, ListProposalVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProposalVersionsQuery, ListProposalVersionsQueryVariables>(ListProposalVersionsDocument, options);
        }
export function useListProposalVersionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProposalVersionsQuery, ListProposalVersionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListProposalVersionsQuery, ListProposalVersionsQueryVariables>(ListProposalVersionsDocument, options);
        }
export type ListProposalVersionsQueryHookResult = ReturnType<typeof useListProposalVersionsQuery>;
export type ListProposalVersionsLazyQueryHookResult = ReturnType<typeof useListProposalVersionsLazyQuery>;
export type ListProposalVersionsSuspenseQueryHookResult = ReturnType<typeof useListProposalVersionsSuspenseQuery>;
export type ListProposalVersionsQueryResult = Apollo.QueryResult<ListProposalVersionsQuery, ListProposalVersionsQueryVariables>;
export const ProposalVersionDocument = gql`
    query ProposalVersion($proposalId: Int!, $versionId: Int!) {
  proposal(where: {id: $proposalId}) {
    id
    name
    templateVersionId
    type
    versions(where: {id: {equals: $versionId}}) {
      id
      data
      createdAt
      createdBy
      dataSourceUsedAt
      sequentialNumber
      templateVersionId
      ...ProposalVersionDsLinks
    }
  }
}
    ${ProposalVersionDsLinksFragmentDoc}`;

/**
 * __useProposalVersionQuery__
 *
 * To run a query within a React component, call `useProposalVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalVersionQuery({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useProposalVersionQuery(baseOptions: Apollo.QueryHookOptions<ProposalVersionQuery, ProposalVersionQueryVariables> & ({ variables: ProposalVersionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProposalVersionQuery, ProposalVersionQueryVariables>(ProposalVersionDocument, options);
      }
export function useProposalVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProposalVersionQuery, ProposalVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProposalVersionQuery, ProposalVersionQueryVariables>(ProposalVersionDocument, options);
        }
export function useProposalVersionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProposalVersionQuery, ProposalVersionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProposalVersionQuery, ProposalVersionQueryVariables>(ProposalVersionDocument, options);
        }
export type ProposalVersionQueryHookResult = ReturnType<typeof useProposalVersionQuery>;
export type ProposalVersionLazyQueryHookResult = ReturnType<typeof useProposalVersionLazyQuery>;
export type ProposalVersionSuspenseQueryHookResult = ReturnType<typeof useProposalVersionSuspenseQuery>;
export type ProposalVersionQueryResult = Apollo.QueryResult<ProposalVersionQuery, ProposalVersionQueryVariables>;
export const UpdateProposalAccessesDocument = gql`
    mutation UpdateProposalAccesses($usersDeleteAccess: [String!]!, $usersGiveAccess: [UserProposalAccessCreateManyInput!]!, $proposalId: Int!) {
  deleteManyUserProposalAccess(
    where: {userEmail: {in: $usersDeleteAccess}, proposalId: {equals: $proposalId}}
  ) {
    count
  }
  createManyUserProposalAccess(data: $usersGiveAccess, skipDuplicates: true) {
    count
  }
}
    `;
export type UpdateProposalAccessesMutationFn = Apollo.MutationFunction<UpdateProposalAccessesMutation, UpdateProposalAccessesMutationVariables>;

/**
 * __useUpdateProposalAccessesMutation__
 *
 * To run a mutation, you first call `useUpdateProposalAccessesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalAccessesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalAccessesMutation, { data, loading, error }] = useUpdateProposalAccessesMutation({
 *   variables: {
 *      usersDeleteAccess: // value for 'usersDeleteAccess'
 *      usersGiveAccess: // value for 'usersGiveAccess'
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useUpdateProposalAccessesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalAccessesMutation, UpdateProposalAccessesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalAccessesMutation, UpdateProposalAccessesMutationVariables>(UpdateProposalAccessesDocument, options);
      }
export type UpdateProposalAccessesMutationHookResult = ReturnType<typeof useUpdateProposalAccessesMutation>;
export type UpdateProposalAccessesMutationResult = Apollo.MutationResult<UpdateProposalAccessesMutation>;
export type UpdateProposalAccessesMutationOptions = Apollo.BaseMutationOptions<UpdateProposalAccessesMutation, UpdateProposalAccessesMutationVariables>;
export const ProposalContributorsDocument = gql`
    query ProposalContributors($proposalId: Int!) {
  userProposalAccesses(where: {proposalId: {equals: $proposalId}}) {
    email: userEmail
  }
}
    `;

/**
 * __useProposalContributorsQuery__
 *
 * To run a query within a React component, call `useProposalContributorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalContributorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalContributorsQuery({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useProposalContributorsQuery(baseOptions: Apollo.QueryHookOptions<ProposalContributorsQuery, ProposalContributorsQueryVariables> & ({ variables: ProposalContributorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProposalContributorsQuery, ProposalContributorsQueryVariables>(ProposalContributorsDocument, options);
      }
export function useProposalContributorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProposalContributorsQuery, ProposalContributorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProposalContributorsQuery, ProposalContributorsQueryVariables>(ProposalContributorsDocument, options);
        }
export function useProposalContributorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProposalContributorsQuery, ProposalContributorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProposalContributorsQuery, ProposalContributorsQueryVariables>(ProposalContributorsDocument, options);
        }
export type ProposalContributorsQueryHookResult = ReturnType<typeof useProposalContributorsQuery>;
export type ProposalContributorsLazyQueryHookResult = ReturnType<typeof useProposalContributorsLazyQuery>;
export type ProposalContributorsSuspenseQueryHookResult = ReturnType<typeof useProposalContributorsSuspenseQuery>;
export type ProposalContributorsQueryResult = Apollo.QueryResult<ProposalContributorsQuery, ProposalContributorsQueryVariables>;
export const GetOneProposalWithAllNotesDocument = gql`
    query GetOneProposalWithAllNotes($id: Int!) {
  proposal(where: {id: $id}) {
    id
    name
    isFinalized
    notes(orderBy: {createdAt: desc}) {
      ...note
    }
    templateVersion {
      templateId
    }
  }
}
    ${NoteFragmentDoc}`;

/**
 * __useGetOneProposalWithAllNotesQuery__
 *
 * To run a query within a React component, call `useGetOneProposalWithAllNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneProposalWithAllNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneProposalWithAllNotesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOneProposalWithAllNotesQuery(baseOptions: Apollo.QueryHookOptions<GetOneProposalWithAllNotesQuery, GetOneProposalWithAllNotesQueryVariables> & ({ variables: GetOneProposalWithAllNotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOneProposalWithAllNotesQuery, GetOneProposalWithAllNotesQueryVariables>(GetOneProposalWithAllNotesDocument, options);
      }
export function useGetOneProposalWithAllNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOneProposalWithAllNotesQuery, GetOneProposalWithAllNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOneProposalWithAllNotesQuery, GetOneProposalWithAllNotesQueryVariables>(GetOneProposalWithAllNotesDocument, options);
        }
export function useGetOneProposalWithAllNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneProposalWithAllNotesQuery, GetOneProposalWithAllNotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOneProposalWithAllNotesQuery, GetOneProposalWithAllNotesQueryVariables>(GetOneProposalWithAllNotesDocument, options);
        }
export type GetOneProposalWithAllNotesQueryHookResult = ReturnType<typeof useGetOneProposalWithAllNotesQuery>;
export type GetOneProposalWithAllNotesLazyQueryHookResult = ReturnType<typeof useGetOneProposalWithAllNotesLazyQuery>;
export type GetOneProposalWithAllNotesSuspenseQueryHookResult = ReturnType<typeof useGetOneProposalWithAllNotesSuspenseQuery>;
export type GetOneProposalWithAllNotesQueryResult = Apollo.QueryResult<GetOneProposalWithAllNotesQuery, GetOneProposalWithAllNotesQueryVariables>;
export const NotesDocument = gql`
    query notes($where: NoteWhereInput) {
  notes(where: $where, orderBy: {createdAt: desc}) {
    ...note
  }
}
    ${NoteFragmentDoc}`;

/**
 * __useNotesQuery__
 *
 * To run a query within a React component, call `useNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useNotesQuery(baseOptions?: Apollo.QueryHookOptions<NotesQuery, NotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotesQuery, NotesQueryVariables>(NotesDocument, options);
      }
export function useNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotesQuery, NotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotesQuery, NotesQueryVariables>(NotesDocument, options);
        }
export function useNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotesQuery, NotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotesQuery, NotesQueryVariables>(NotesDocument, options);
        }
export type NotesQueryHookResult = ReturnType<typeof useNotesQuery>;
export type NotesLazyQueryHookResult = ReturnType<typeof useNotesLazyQuery>;
export type NotesSuspenseQueryHookResult = ReturnType<typeof useNotesSuspenseQuery>;
export type NotesQueryResult = Apollo.QueryResult<NotesQuery, NotesQueryVariables>;
export const UpdateNoteDocument = gql`
    mutation UpdateNote($data: NoteUpdateInput!, $where: NoteWhereUniqueInput!) {
  updateOneNote(data: $data, where: $where) {
    ...note
  }
}
    ${NoteFragmentDoc}`;
export type UpdateNoteMutationFn = Apollo.MutationFunction<UpdateNoteMutation, UpdateNoteMutationVariables>;

/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteMutation, { data, loading, error }] = useUpdateNoteMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteMutation, UpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteMutation, UpdateNoteMutationVariables>(UpdateNoteDocument, options);
      }
export type UpdateNoteMutationHookResult = ReturnType<typeof useUpdateNoteMutation>;
export type UpdateNoteMutationResult = Apollo.MutationResult<UpdateNoteMutation>;
export type UpdateNoteMutationOptions = Apollo.BaseMutationOptions<UpdateNoteMutation, UpdateNoteMutationVariables>;
export const CreateNoteDocument = gql`
    mutation CreateNote($data: NoteCreateInput!) {
  createOneNote(data: $data) {
    ...note
  }
}
    ${NoteFragmentDoc}`;
export type CreateNoteMutationFn = Apollo.MutationFunction<CreateNoteMutation, CreateNoteMutationVariables>;

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoteMutation, CreateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNoteMutation, CreateNoteMutationVariables>(CreateNoteDocument, options);
      }
export type CreateNoteMutationHookResult = ReturnType<typeof useCreateNoteMutation>;
export type CreateNoteMutationResult = Apollo.MutationResult<CreateNoteMutation>;
export type CreateNoteMutationOptions = Apollo.BaseMutationOptions<CreateNoteMutation, CreateNoteMutationVariables>;
export const DeleteOneNoteDocument = gql`
    mutation DeleteOneNote($where: NoteWhereUniqueInput!) {
  deleteOneNote(where: $where) {
    id
  }
}
    `;
export type DeleteOneNoteMutationFn = Apollo.MutationFunction<DeleteOneNoteMutation, DeleteOneNoteMutationVariables>;

/**
 * __useDeleteOneNoteMutation__
 *
 * To run a mutation, you first call `useDeleteOneNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneNoteMutation, { data, loading, error }] = useDeleteOneNoteMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteOneNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOneNoteMutation, DeleteOneNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOneNoteMutation, DeleteOneNoteMutationVariables>(DeleteOneNoteDocument, options);
      }
export type DeleteOneNoteMutationHookResult = ReturnType<typeof useDeleteOneNoteMutation>;
export type DeleteOneNoteMutationResult = Apollo.MutationResult<DeleteOneNoteMutation>;
export type DeleteOneNoteMutationOptions = Apollo.BaseMutationOptions<DeleteOneNoteMutation, DeleteOneNoteMutationVariables>;
export const LogAuditEventDocument = gql`
    mutation LogAuditEvent($input: LogAuditEventInput!) {
  logAuditEvent(input: $input)
}
    `;
export type LogAuditEventMutationFn = Apollo.MutationFunction<LogAuditEventMutation, LogAuditEventMutationVariables>;

/**
 * __useLogAuditEventMutation__
 *
 * To run a mutation, you first call `useLogAuditEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogAuditEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logAuditEventMutation, { data, loading, error }] = useLogAuditEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogAuditEventMutation(baseOptions?: Apollo.MutationHookOptions<LogAuditEventMutation, LogAuditEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogAuditEventMutation, LogAuditEventMutationVariables>(LogAuditEventDocument, options);
      }
export type LogAuditEventMutationHookResult = ReturnType<typeof useLogAuditEventMutation>;
export type LogAuditEventMutationResult = Apollo.MutationResult<LogAuditEventMutation>;
export type LogAuditEventMutationOptions = Apollo.BaseMutationOptions<LogAuditEventMutation, LogAuditEventMutationVariables>;
export const SaveProposalMetricsDocument = gql`
    mutation SaveProposalMetrics($proposalId: Int, $metrics: [ProposalMetricSaveInput!]!) {
  saveProposalMetrics(proposalId: $proposalId, metrics: $metrics)
}
    `;
export type SaveProposalMetricsMutationFn = Apollo.MutationFunction<SaveProposalMetricsMutation, SaveProposalMetricsMutationVariables>;

/**
 * __useSaveProposalMetricsMutation__
 *
 * To run a mutation, you first call `useSaveProposalMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProposalMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProposalMetricsMutation, { data, loading, error }] = useSaveProposalMetricsMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *      metrics: // value for 'metrics'
 *   },
 * });
 */
export function useSaveProposalMetricsMutation(baseOptions?: Apollo.MutationHookOptions<SaveProposalMetricsMutation, SaveProposalMetricsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveProposalMetricsMutation, SaveProposalMetricsMutationVariables>(SaveProposalMetricsDocument, options);
      }
export type SaveProposalMetricsMutationHookResult = ReturnType<typeof useSaveProposalMetricsMutation>;
export type SaveProposalMetricsMutationResult = Apollo.MutationResult<SaveProposalMetricsMutation>;
export type SaveProposalMetricsMutationOptions = Apollo.BaseMutationOptions<SaveProposalMetricsMutation, SaveProposalMetricsMutationVariables>;
export const GetProposalRowSummaryDocument = gql`
    query GetProposalRowSummary($versionId: Float!, $pageUuid: String!, $rowUuid: String!) {
  proposalRowSummary(
    versionId: $versionId
    pageUuid: $pageUuid
    rowUuid: $rowUuid
  ) {
    column_uuid
    last_updated_at
  }
}
    `;

/**
 * __useGetProposalRowSummaryQuery__
 *
 * To run a query within a React component, call `useGetProposalRowSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProposalRowSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProposalRowSummaryQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *      pageUuid: // value for 'pageUuid'
 *      rowUuid: // value for 'rowUuid'
 *   },
 * });
 */
export function useGetProposalRowSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetProposalRowSummaryQuery, GetProposalRowSummaryQueryVariables> & ({ variables: GetProposalRowSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProposalRowSummaryQuery, GetProposalRowSummaryQueryVariables>(GetProposalRowSummaryDocument, options);
      }
export function useGetProposalRowSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProposalRowSummaryQuery, GetProposalRowSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProposalRowSummaryQuery, GetProposalRowSummaryQueryVariables>(GetProposalRowSummaryDocument, options);
        }
export function useGetProposalRowSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProposalRowSummaryQuery, GetProposalRowSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProposalRowSummaryQuery, GetProposalRowSummaryQueryVariables>(GetProposalRowSummaryDocument, options);
        }
export type GetProposalRowSummaryQueryHookResult = ReturnType<typeof useGetProposalRowSummaryQuery>;
export type GetProposalRowSummaryLazyQueryHookResult = ReturnType<typeof useGetProposalRowSummaryLazyQuery>;
export type GetProposalRowSummarySuspenseQueryHookResult = ReturnType<typeof useGetProposalRowSummarySuspenseQuery>;
export type GetProposalRowSummaryQueryResult = Apollo.QueryResult<GetProposalRowSummaryQuery, GetProposalRowSummaryQueryVariables>;
export const GetProposalPageDataSourceRowsDocument = gql`
    query GetProposalPageDataSourceRows($proposalId: Int!, $versionId: Int!, $pageUuid: String!) {
  proposalPageDataSourceRows(
    proposalId: $proposalId
    versionId: $versionId
    pageUuid: $pageUuid
  ) {
    columns
    rows
  }
}
    `;

/**
 * __useGetProposalPageDataSourceRowsQuery__
 *
 * To run a query within a React component, call `useGetProposalPageDataSourceRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProposalPageDataSourceRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProposalPageDataSourceRowsQuery({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *      versionId: // value for 'versionId'
 *      pageUuid: // value for 'pageUuid'
 *   },
 * });
 */
export function useGetProposalPageDataSourceRowsQuery(baseOptions: Apollo.QueryHookOptions<GetProposalPageDataSourceRowsQuery, GetProposalPageDataSourceRowsQueryVariables> & ({ variables: GetProposalPageDataSourceRowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProposalPageDataSourceRowsQuery, GetProposalPageDataSourceRowsQueryVariables>(GetProposalPageDataSourceRowsDocument, options);
      }
export function useGetProposalPageDataSourceRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProposalPageDataSourceRowsQuery, GetProposalPageDataSourceRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProposalPageDataSourceRowsQuery, GetProposalPageDataSourceRowsQueryVariables>(GetProposalPageDataSourceRowsDocument, options);
        }
export function useGetProposalPageDataSourceRowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProposalPageDataSourceRowsQuery, GetProposalPageDataSourceRowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProposalPageDataSourceRowsQuery, GetProposalPageDataSourceRowsQueryVariables>(GetProposalPageDataSourceRowsDocument, options);
        }
export type GetProposalPageDataSourceRowsQueryHookResult = ReturnType<typeof useGetProposalPageDataSourceRowsQuery>;
export type GetProposalPageDataSourceRowsLazyQueryHookResult = ReturnType<typeof useGetProposalPageDataSourceRowsLazyQuery>;
export type GetProposalPageDataSourceRowsSuspenseQueryHookResult = ReturnType<typeof useGetProposalPageDataSourceRowsSuspenseQuery>;
export type GetProposalPageDataSourceRowsQueryResult = Apollo.QueryResult<GetProposalPageDataSourceRowsQuery, GetProposalPageDataSourceRowsQueryVariables>;
export const ListInsightTemplatesDocument = gql`
    query ListInsightTemplates {
  proposalTemplates(where: {type: {equals: INSIGHT}}) {
    id
    name
    type
    updatedAt
    createdAt
    isDefault
    isPublished
    lastVersion {
      ...TemplateVersion
      createdAt
    }
  }
}
    ${TemplateVersionFragmentDoc}`;

/**
 * __useListInsightTemplatesQuery__
 *
 * To run a query within a React component, call `useListInsightTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListInsightTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListInsightTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListInsightTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ListInsightTemplatesQuery, ListInsightTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListInsightTemplatesQuery, ListInsightTemplatesQueryVariables>(ListInsightTemplatesDocument, options);
      }
export function useListInsightTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListInsightTemplatesQuery, ListInsightTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListInsightTemplatesQuery, ListInsightTemplatesQueryVariables>(ListInsightTemplatesDocument, options);
        }
export function useListInsightTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListInsightTemplatesQuery, ListInsightTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListInsightTemplatesQuery, ListInsightTemplatesQueryVariables>(ListInsightTemplatesDocument, options);
        }
export type ListInsightTemplatesQueryHookResult = ReturnType<typeof useListInsightTemplatesQuery>;
export type ListInsightTemplatesLazyQueryHookResult = ReturnType<typeof useListInsightTemplatesLazyQuery>;
export type ListInsightTemplatesSuspenseQueryHookResult = ReturnType<typeof useListInsightTemplatesSuspenseQuery>;
export type ListInsightTemplatesQueryResult = Apollo.QueryResult<ListInsightTemplatesQuery, ListInsightTemplatesQueryVariables>;